/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * ZH SP resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "按到期日划分的未解决复核注释",
    reviewNoteTileGraphHeaderAssignedToMe: "已分配给我但尚未完成的复核注释，按到期日排列",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "复核注释",
    overDueCatFirst: "逾期90天以上",
    overDueCatSecond: "逾期31-90天",
    overDueCatThird: "逾期10-30天",
    overDueCatFourth: "逾期小于10天",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "无可用注释",


    //ReviewNoteTiles
    totalOpen: "已打开项目总数",
    totalCleared: "已清理项目总数",
    changeDueDate: "更改到期日",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "固有风险评估",
    controlRiskTypeId: "控制风险评估",
    viewUnRelatedWCGWs: "查看未关联的可能出错项",
    unrelatedWCGWsInstruction: "下列可能出错项未与任何认定关联。应至少将其与一个认定关联或删除。为方便在“将可能出错项与认定关联”模式中搜索这些可能出错项，请从重大交易类别下拉列表中选择\“未关联可能出错项”\。如果可能出错项不再相关或需要编辑，请点击相关页面上的\“识别可能出错项和控制”\链接进行更改。",
    relatedWCGWsInstruction: "将可能出错项与所选认定关联。选择一个重大交易类别以关联特定重大交易类别的可能出错项，或从所有重大交易类别中选择一个选项。请选择\“未关联可能出错项”\，获取需要与认定关联的可能出错项的列表。",
    allScots: " 所有重大交易类别",
    allWCGWs: "所有可能出错项",
    unRelatedWCGWs: " 未关联的可能出错项",
    //CRA Build Step 4 Header Label
    craValue: "综合风险评估",
    incompleteCraValue: "综合风险评估未完成",
    // Panel Headers
    taskCategories: "任务导航",
    taskCategoryExecution: "执行",
    taskList: "任务列表",
    taskDetails: "任务详细信息",
    fullScreen: "全屏",
    exitFullScreen: "退出全屏",
    defaultDropdown: "下拉菜单",
    status: "状态",
    language: "语言",
    channel: "频道",
    header: "标题",
    headerName: "标题名称",
    sectionCustomLabelLabel: "自定义标签",
    sectionNamePlaceHolder: "输入章节标题",
    showRelatedObjectLabel: "显示相关对象",
    errorBanner: "{0} 错误",
    customize: "定制",
    customized: "已定制",
    custom: "定制",
    description: "描述",
    seeDescription: "查看描述",
    section: "章节",
    entities: "实体",
    edit: "编辑",
    delete: "删除",
    collapse: "折叠",
    collapseAll: "收起全部",
    expand: "展开",
    expandAll: "展开全部",
    incompleteResponse: "回复不完整",
    unresolvedComments: "未解决的注释",
    saving: "保存......",
    tasks: "任务",
    requests: "请求",

    //BodyType Placeholder
    numericValuePlaceholder: "输入金额",

    //Modal
    addButton: "添加按钮",
    evidence: "证据",
    temporary: "临时",
    temporaryFiles: "临时文件",
    priorPeriod: "上期",
    externaldocuments: "外部文件",
    eydocuments: "安永文档",
    clientRequestClientAnalytics: "分析工具名称",
    groupdocuments: "集团文档",
    name: "名称",
    reason: "理由",
    browse: "浏览",
    uploadFile: "上传文件",
    uploadDocument: "上传文件",
    duplicateDocumentHeader: "该项目中已经存在一个或多个同名文件（作为证据文件或临时文件）。",
    duplicateDocumentInstruction: "选择“覆盖”以上传文档并替换现有文件，或者选择“放弃”以取消。如现有文件为证据，则文件将被上传至证据。如现有文件为临时文件，则文件将被上传至临时文件。",
    overwriteLabel: "覆盖",
    discardLabel: "放弃",
    discardChangesLabel: "放弃更改",
    note: "注释",
    notes: "注释",
    signOffs: "签署",
    related: "相关",
    attributes: "属性",
    approveChanges: "批准变动",
    nodocumentsAdded: "无可用文档",
    noEntitiesAvailable: "无可用实体",
    noDocumentsUpload: "无正在上传的文件",
    noSections: "无可用的部分",
    noRequestMessage: "该项目中不存在请求或外部任务",
    noResultFound: "未找到结果。",
    noRequestsFound: "未找到请求",
    noTimePhasesFound: "没有可用的时间阶段",
    noEntitiesFound: "无结果",
    relatedEntities: "相关实体",
    noClickableRelatedEntities: "无法为此任务编辑相关实体",
    taskByEntityLabel: "实体任务",
    relEntityLabel: "实体",
    singleEntity: "{0}实体",
    multipleEntity: "{0}实体",
    engagementDeliveryLabel: "项目任务",
    onlyShowRelEntities: "仅显示相关实体",
    engDeliveryDescription: "此任务已关联至项目中的所有实体。",
    relEntitiesDescription: "查看任务的相关实体。只能为其他实质性程序任务和其他标准任务编辑相关实体。",
    relEntitiesPSTorPSPDesc: "查看任务的相关实体。无法为主要标准任务和主要实质性程序任务编辑相关实体。",
    warningRelMsg: "任务必须关联至一个或多个实体。若要将任务设置为项目任务，请点击“实体任务”进行切换。",
    reldetailDescription: "OSP和OST任务默认为项目任务，并且关联至所有实体。设置为“实体任务”后，便可将任务关联至一个或多个实体。",
    results: "结果",
    searchPlaceholder: "搜索",
    searchDocPlaceholder: "搜索文档",
    searchCanvasForms: "搜索Canvas表格",
    searchControlForms: "搜索重大交易类别",
    canvasFormListDescription: "从下面的列表中选择“Canvas表格”以查看已关联“Canvas表格”报告。",
    controlFormListDescription: "选择一个重大交易类别以查看其已关联控制表格。",
    object: "目标",
    relateCollaboration: "关联协作",
    reviewNote: "复核注释",
    reviewNoteSingle: "复核注释",
    documentReviewNotes: "文档注释",
    noEvidenceFilesAssociated: "不存在与该任务相关的证据文件",
    taskReviewNoteWithParenthesess: "任务注释",
    taskNotes: "任务注释",
    documentsNotes: "文档注释",
    addNewDocumentNote: "添加文档注释",
    selectDocument: "选择文件",
    taskReviewNotes: "任务注释",
    showCleared: "显示清除项",
    Replied: "回复：",
    showClosed: "显示关闭项",
    allNotes: "全部注释",
    myNotes: "我的注释",
    noTasksAvailable: "无可用任务",
    noWCGWAvailableForTask: "无可用的ROMM",
    noSubstantiveTasksAvailable: "无相关实质性任务",
    noNotesAssociatedWithDocument: "无与此文档相关联的注释",
    noNotesAssociatedWithTak: "无与此任务相关联的注释",
    otherEngagementNotes: "其他项目注释",
    to: "至",
    deleteReviewNote: "删除",
    missingToUserError: "必填",
    missingReviewNoteTextError: "必须输入复核注释文本",
    invalidReviewNoteTextError: "输入的文本超出字符限制",
    dueDateRequiredTextError: "截止日期为必填",
    saveNoteTextError: "请保存或取消，以继续下一步",
    engagementName: "项目名称:",
    assignmentsCountLabel: "工作分配",
    AssignmentsDays: "天数",
    closedOnTime: "已按时关闭",
    daysToPrepare: "编制天数",
    daysToReview: "复核天数",
    totalAssignments: "任务分配<br>汇总",
    currentlyAssigned: "当前<br>分配",
    UpcomingAssignments: "即将分配",
    authoredByMe: "由我编辑",
    commentsLabel: "复核注释",
    clearedOnTime: "已按时清除",
    daysToClear: "清除天数",
    daysToClose: "关闭天数",
    totalLabel: "注释汇总",

    criticalAndHighRn: "关键和高优先级注释",
    criticalAndHighComments: "关键和高优先级注释",
    lowAndMediumComments: "中等和低优先级注释",
    metricsInstructionalText: "查看下方分配给您的工作和注释的绩效指标。<br>选择一位项目组成员查看其绩效指标，或选择<b>项目视图</b>查看总体绩效指标。",
    metricsNewInstructionalText: "选择一名项目组成员以查看其复核注释和任务分配，或选择<b>项目视图</b>查看项目整体情况。",
    switchToViewPlaceholder: "没有可显示数据。<br>选择其他项目组成员或切换至<b>项目视图。</b>",
    tasksClosedOnTime: "按时关闭的任务",
    daysDetailReview: "详细复核天数",
    daysGeneralReview: "一般复核天数",
    totalDaysReview: "复核总天数",
    metricsInstructionalTextconfiguration: "在下方查看工作和注释的总体绩效指标。",

    //document download
    docSizeMB: "MB",
    docSizeKB: "KB",
    labelForExpiredPackage: "数据包已到期。",
    headerForDocumentDownload: "点击文件名进行下载",
    labelForNoFiles: "所选分类未设定筛选条件。",
    labelForProcessing: "文件处理中。",

    //create dropdown texts
    create: "创建",
    addRequestText: "请求",
    addExternalTaskText: "外部任务",
    addFindingText: "发现",
    show: "显示:",
    riskTypeHeader: "风险类型",
    wcgwHeader: "可能出错项",
    hasNotes: "未关闭备注",
    hasNote: "打开注释",
    noNotes: "(0个未关闭备注)",
    addTemporaryFiles: "添加临时文件",
    addPriorPeriodEvidence: "添加上一期间",
    addExternalDocuments: "添加外部文档",
    //Nav
    navHeaderTasks: "任务",
    quickFilterAllCompletedTasks: "所有完成的任务",
    quickFilterMyCompletedAssignmnets: "我完成的分配工作",
    quickFilterMyUpcomingAssignments: "我即将完成的分配工作",
    navHeaderTaskCategory: "任务类别",
    navFilterBy: "筛选选项",
    navHeaderDocuments: "文件",
    navHeaderCollaboration: "合作",
    navHeaderAssignments: "任务分配",
    navHeaderAutomation: "自动化",
    navHeaderMore: "更多",
    navDashboard: "评估表",
    navReviewnotes: "复核注释",
    navHeaderManageteam: "管理项目组",
    navHeaderMangeteamNew: "管理小组——新建",
    mangeteam: "管理小组",
    postArchive: "发布归档",
    addmember: "添加成员",
    addnewmember: "添加新成员",
    addPriorPeriodMembers: "添加非活跃成员",
    addPriorPeriodUsers: "添加非活跃成员",
    createPackage: "创建数据包",
    engagementrole: "项目角色",
    noPendingPriorPeriodUsers: "没有要邀请的非活跃成员",
    sendPriorPeriodUserInvitesWithCount: "发送({0}) 邀请",
    sendPriorPeriodUserInvitesWithoutCount: "发送邀请",
    priorPeriodMembersModalHeaderMessage: "选择要添加到项目中的非活跃成员。成员重新激活后，将被重新授予以前在项目中拥有的权限。",
    priorPeriodIndependenceModalHeaderMessage: "选择要添加到项目中的非活跃仅独立性成员。",
    disabledPriorPeriodMembersButtonToolTip: "权限不足，无法添加以前的成员。与有适当权力采取此行动的项目团队成员沟通。",
    disabledNewMembersButtonToolTip: "权限不足，无法添加新成员。与有适当权力采取此行动的项目团队成员沟通。",
    disabledNewMembersButtonToolTipThirdpartyuser: "没有足够的权限进行增加第三方新成员。与具有适当权限的项目组成员沟通，进行操作。",
    rbacNoRightsForContentUpdateToolTip: "权限不足，无法执行内容更新。请联系您的项目管理员，并申请启动内容更新的权限。",
    deactivateInternalUsersWithCount: "{0} 选择的成员",
    canvasFormSelectionMessageSingular: "选中{0}个Canvas表格",
    canvasFormSelectionMessagePlural: "选中{0}个Canvas表格",
    pspAccountSelectionMessageSingular: "已选择{0}个账户",
    pspAccountSelectionMessagePlural: "已选择{0}个账户",
    manageTeamGroupLabel: " 组",
    manageTeamGroupsLabel: " 组",
    allAccessGroups: "所有访问组",
    reactivate: "重新激活",
    deactivate: "停用",
    unselect: "全部取消选择",
    deactivateInternalModalTitle: "停用内部成员",
    deactivateInternalModalMessage: "是否确定停用以下项目组成员 ?",
    deactivateInternalUsersSuccessMessage: "{0} 成员已成功停用。",
    deactivateExternalModalTitle: "停用外部成员",
    deactivateExternalModalMessage: "是否确定要从{0}停用以下项目组成员吗？分配的项目将重新分配给相应的访问组。",
    deactivateExternalSuccessMessage: "成员已成功停用。",
    internalMember: "内部成员",
    addinternalmember: "添加内部成员",
    addThirdPartymember: "添加第三方成员",
    missingResponsiblePerson: "未填写负责人",
    sentRequests: "已发送",
    receivedRequests: "已接收",
    syncProfileNotAllowed: "不允许同步配置文件",
    allSyncProfileNotAllowedMessage: "不允许同步配置文档。表格不适用于此配置文档。",
    allCanvasFormsContentUpdateMessage: "无法向共享的EY Canvas FIT促进工具活动提交内容。请删除活动链接以继续内容更新。",
    someFormContentUpdateMessage: "由于某些表格没有内容，因此无法同步到项目配置文件",
    linkedFormContentUpdateMessage: "将不会向共享的EY Canvas FIT促进工具活动提交内容。如需更新其内容，请删除活动链接。",
    leaveUsFeedback: "留下反馈",

    notApplicableLabel: "不适用",
    addThirdPartyMemberDescription: "此功能应仅用于授予第三方复核人访问此EY Canvas项目的权限。应从专业业务部获得适当的批准和授权。",
    hasOverallResponsibilityDescription: "全面负责审计或项目的指导、监督和执行，并负责根据情况得出适当报告和/或跨办事处结论的审计或项目组的成员。",
    partnerInChargeHeader: "审计负责合伙人/审计负责经理",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "无法处理对受限字段的编辑。请刷新并重试。",

    noGroupFound: "本项目中未创建访问组。选择“添加访问组”以创建新的外部成员访问组",
    addGroup: "添加组",
    deleteGroup: "删除访问组",
    deleteGroupMessage: "是否确定删除{0}访问组？",
    addAccessGroup: "添加访问组",
    accessGroupCreated: "已成功创建新的访问组{0}。",
    accessGroupUpdated: "对访问组{0}的更改已成功保存。",
    editAccessGroup: "编辑访问组",
    sharedGroupwarning: "这是一个共享访问组，对它的更改将反映在所有关联的项目中。",
    groups: "组",
    addExternalMembers: "所有外部成员",
    members: "成员",
    externalMember: "外部成员",
    member: "成员",
    role: "角色",
    actions: "操作",
    internalUserEdit: "编辑",
    internalUserDeactivate: "停用",
    usersFilter: "筛选",
    externalUserEdit: "编辑",
    externalUserDeactivate: "停用",
    externalUserGroupLabel: "组",
    externalNoUserInGroup: "本访问组未添加任何成员.",
    externalNoUserInAllGroup: "本项目未添加任何成员.",
    alias: "别名",
    independence: "独立性",
    navManagegroup: "管理集团",
    navCRAsummary: "综合风险评估汇总表",
    navAuditplan: "审计计划",
    navWorkplan: "工作计划",
    navSEM: "实质性评估矩阵",
    nav440GL: "报告日期后改变。",
    navFindings: "发现",
    navCanvasformupdates: "Canvas表格更新",
    navPSPContentUpdates: "PSP内容更新",
    navCopyhubNew: "复制中心-新建副本",
    navCopyhub: "复制中心",
    navArchiveChecklist: "归档核对表",
    navExporthub: "导出中心",
    navReporting: "报告",
    navAccountSummary: "账户汇总",
    navScotSummary: "SCOT汇总表",
    navItSummary: "IT汇总",
    navGroupInstructionSummary: "集团指引",
    navGroupInvolvement: "集团参与",
    navHelixProjects: "EY Helix关联",
    navContentUpdates: "内容更新",
    contentUpdateErrorMsg: "您没有保存更改的权限。联系具有这些权限的其他团队成员进行更改。",
    contentUpdateTitleTip: "权限不足，无法执行内容更新。请与您的项目管理员联系，并请求权限以启动内容更新。",
    noPreviousUpdates: "无之前的更新",
    noContentUpdateResults: "未找到结果",
    noPSPAccountsToUpdate: "没有要更新的账户",
    rbcaUnavailableMsg: "此时，EY Canvas无法保存更改。请重试，如果问题持续，请联系帮助台",
    showErrInProgressMsg: "29007 - 当其他更新正在进行时，无法启动内容更新。请等待当前内容更新完成，或刷新页面并重试。",
    navHelp: "通用帮助",
    validationNavHelp: "验证帮助",
    searchUserText: "搜索用户",
    superModelTitle: "项目对象",
    superModelText: "超级模式",
    independenceOnlyMembers: "仅独立性成员",
    noIndependenceOnlyPriorPeriodUsers: "没有要邀请的非活跃仅独立性成员",

    //Copyright
    copyRight: "Copyright © <year> 版权所有。",

    //Copyhub List labels
    moreRecipient: "更多",
    copyHubPackageName: "数据包名称",
    copyHubSentBy: "发送人",
    copyHubSentTo: "发送至",
    copyHubReceivedBy: "接收人",
    copyHubDate: "日期",
    copyHubRemainingTime: "剩余时间",
    copyHubAvailableFor: "可用于",
    copyHubStatus: "状态",
    noCopyHubSentPackages: "尚未创建数据包副本。选择“创建数据包”，新建一个数据包。",
    noCopyHubReceivedPackages: "没有可用于此项目的数据包副本",
    remainingTimeTooltip: "数据包会在归档后或创建后10天永久删除。",
    copyHubDeleteText: "删除",
    appendDays: " 天数",
    generalInformation: "一般信息",
    copyDocuments: "文档",
    copyFiles: "文件",
    scots: "重大交易类别",
    accounts: "账户",
    copyHubImport: "导入",
    copyHubPackageType: "合并资料包类型：",
    copyHubCreatedModal: "创建人：",
    copyHubRemainingTimeModal: "剩余时间：",
    copyHubAvailableForModal: "可用于：",
    copyHubInstructionModal: "说明：",
    copyHubCategories: "类别",
    copyHubPendingDeletion: "待删除",
    copyHubVersionMismatchCat: "数据包版本不匹配，无法显示类别",
    copyHubVersionMismatchPersonInfo: "数据包版本不匹配，无法显示发送人和接收人",
    copyHubViewLegacyPacakgeDetails: "该数据包为旧版本数据包，无法获得详细信息。",
    associateTasks: "关联任务",
    backToForms: "返回表格",
    noTaskSelected: "至少选择一项任务",
    taskLabel: "任务：",
    taskMessage: "请将任务与导入的表格相关联。",
    importSuccessMessage: "导入请求排队成功",
    taskSelectedText: "已选择任务",
    insufficientPermissionsToImport: "导入数据包副本权限不足。请与你的项目管理员联系，并请求权限以导入数据包副本。",
    cannotImportExpiredPackage: "不可导入过期数据包副本。",
    cannotImportWhileInProgress: "不可导入已处于导入进程中的数据包副本。",
    deletePackageHeader: "删除数据包",
    copyPackageDeleted: "该数据包已删除",
    copyPackageDeleteConfirmation: "是否确认删除此数据包？",
    insufficientPermissionsToDelete: "删除数据包副本权限不足。请与你的项目管理员联系，并请求权限以删除数据包副本。",
    insufficientPermissions: "权限不足",
    GuidedWorkflowsPackageDisplayText: "若选择导入，匹配的工作流指导将从副本中更新到此项目中。该操作不会导入不匹配的工作流指导。",
    copyRequestStatusInQueue: "排队中",
    GuidedWorkflowImportError: "工作流指导导入不适用于多实体项目",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "里程碑将财务信息与相关会计记录进行核对 获取中期财务信息与相关账户记录核对一致的证据。",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "搜索任务",
    taskLayoutHeaderAssignments: "分配工作",
    taskLayoutHeaderAddTask: "新任务",
    wcgwSearchPlaceholder: "搜索可能出错项",
    //TaskListHeader
    taskTypeHeader: "类型",
    taskNameHeader: "名称",
    taskDueDateHeader: "到期日",
    reviewNoteChangeDueDate: "更改到期日",
    taskListHeaderSortByDueDate: "截止日期",
    taskListHeaderSortByTaskName: "任务名称",
    sortBy: "排序：",
    ascending: "升序",
    descending: "降序",
    taskListHeaderSortByKnowledge: "审计计划",
    taskListHeaderDeleteWarning: "是否确认删除选中任务。",
    taskListHeaderSortText: "排序",
    taskListHeaderSortOrderText: "排序顺序",
    taskListHeaderTimePhaseText: "设定时间阶段",
    taskListHeaderBookMarkText: "书签",
    taskListHeaderFavoriteText: "收藏夹",
    taskListHeaderEditText: "编辑任务标题",
    moreMenu: "更多",
    taskListHeaderMoveTaskText: "变更任务分组",
    taskGroupIconHoverText: "变更任务分组",
    taskGroupLabel: "变更分组",
    task: "任务",
    toc: "TOC",
    tenNotes: "10 注释",
    source: "来源",
    nature: "性质",
    assertion: "认定",
    relatedAccounts: "关联账户",
    testOfDetail: "详细测试",
    testOfControl: "控制测试",
    substantiveAnalyticalProcedure: "实质分析性复核程序",
    tod: "TOD",
    sap: "SAP",
    int: "INT",
    ext: "EXT",
    notSel: "未选择",
    internal: "内部",
    external: "外部",
    notSelected: "未选定",
    documentCannotOpen: "无法从“任务详情”中打开此文件。导航到“文档列表”以打开此文件。",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "选择一项任务以查看详细信息",
    multiTaskSelectedMessage: "要启用批量控制，请使用控制键并选择多个任务。\n如果你要处理单个任务，请从任务列表中选择该任务。",
    emptyAndMultiSelectedMessage: "要启用批量控制，请使用复选框选择一项或多项任务。请使用换档键，以立即选择若干任务。如果你要处理单个任务，请从列表中选择该任务。",
    //Evidence
    evidenceDragAndDrop: "拖拽或",
    //Timephases
    noResultTimePhase: "未发现结果。",
    //handoff
    handoff: "移交",
    handoffConfirmButtonText: "移交",
    handoffModalTitle: "移交任务",
    handoffTitle: "移交给下一位项目组成员",
    handoffTextLine2: "如想签署证据文档，请在以下选项进行选择。",
    return: "返回",
    returnDisabledMessage: "无法返回任务，原因如下：（1）你为指定编制人，（2）任务状态不是“复核中”或“已完成”，或（3）没有指定编制人。",
    handOffTitleTip: "移交以进行复核",
    //Mark Complete
    markCompleteTitleTip: "标记完成",
    markCompleteTitle: "标记任务为已完成",
    markCompleteText: "你的签署将被添加至下方与该任务相关的证据。该任务将被标记为已完成。",
    markCompleteTextLine1: "将此任务移交给下一位小组成员。",
    markCompleteTextLine2: "如想签署证据文件，请选择以下选项。如果你已被分配此任务作且已完成该任务，选择<b>是</b>，将该任务关闭。如果此任务需要PIC或EQR签字，请从以下选项中选择。",
    markCompleteConfirm: "标记为已完成",
    signOffAs: "全部签名为：",
    additionalSignOff: "其他必须的签名",
    additionalTaskStatus: "关闭我的分配工作",
    markCompleteModalHeaderTextPart1: "此任务将被标记为已完成。",
    markCompleteModalHeaderTextPart2: "如想签署证据文件，请选择以下选项。如果你已被分配此任务作且已完成该任务，选择<b>是</b>，将该任务关闭。如果此任务需要PIC或EQR签字，请从以下选项中选择。",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "关闭我的分配工作",
    tempMarkCompleteMessage: "任务无法被标记为完成。请刷新页面并重试。如果仍有问题，请联系帮助台。",
    tempMarkCompleteEnable: "标记完成-启用",
    tempMarkCompleteDisable: "标记完成-禁用",
    //TaskDetails
    seeTask: "查看任务",
    NoTasksFound: "没有找到任务",
    taskDetailsAddRelate: "添加/关联",
    taskDetailsDocument: "文件",
    taskDetailsAutomationRequest: "自动化请求",
    taskDetailsExternalTask: "外部任务",
    taskDetailsFinding: "发现",
    taskDetailsRequest: "请求",
    taskDetailsNotes: "备注",
    taskDetailsRelatedTask: "相关任务",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "须签署",
    addTaskGroupLabel: "添加任务组",
    itgcTaskDescription: "对IT一般控制执行我们设计的测试，以获得关于其在整个依赖期间的运营有效性的充分适当的审计证据。",
    //create assignment
    createassignmentheaderLine1: "所选项目组成员没有此任务的分配工作。",
    createassignmentheaderLine2: "在此创建分配工作。如果其他项目组成员已拥有同类型的未完成分配工作，",
    createassignmentheaderLine3: "选择",
    createassignmentheaderLine4: "用此分配工作代替。",
    overwriteIncompleAssignments: "覆盖未完成分配工作",
    //Create Assignment
    createassignmentheader1: "选择的项目组成员没有该任务项下的任务分配。",
    createassignmentheader2: "请在此处创建一项任务分配。",
    //Guidance
    atlasLink: "Atlas链接",
    automationLink: "智能自动化链接",
    otherLink: "其他链接",
    helixLink: "Helix链接",
    relatedAutomations: "相关自动化",
    noSuggestedAutomationLabel: "未建议对此任务执行自动化。",
    noSuggestedItemLabel: "没有对此任务的建议项目。",
    noAutomationRequestLabel: "此任务未被关联至任何自动化。开始前，创建新的自动化或关联至现有自动化。",
    relateAutomation: "关联",
    relateAutomationModelHeader: "关联智能自动化",
    automationSolution: "解决方案",
    automationName: "自动化名称",
    relateAutomationTextLine1: "向此任务关联一项智能自动化。",
    relateAutomationTextLine2: "完成关联后，您可以在项目详细信息中查看此自动化操作，可点击并打开它。",
    noSamrtAutomationForEngagement: "您的项目仍未创建过智能自动化。",
    searchAutomationLabel: "搜索自动化",

    //RelatedItemHeader
    relatedItemsHeader: "相关项目",
    relateButtonText: "关联",
    createButtonText: "创建",
    relatedItemREQ: "请求",
    relatedItemET: "外部任务",
    relatedItemATM: "自动化",
    relatedItemRelatedTask: "已关联任务",
    relateObjectsToTaskTitle: "将对象与此任务相关联",
    relateObjectsToTaskSubTitle: "将一个或多个对象与此任务相关联。此类对象将出现在任务详情的相关项目部分。",
    relateObjectOptionsHeaderPSPOSP: "账户、认定及有限风险账户",
    relateObjectOptionsHeaderITWalkthrough: "IT 流程",
    relateObjectOptionsHeaderITControl: "IT 控制（IT一般控制和ITSP）",
    // SDM Nextwave services
    scheduledServicesText: "已关联服务",
    suggestedServicesText: "建议的服务",
    suggestedServicesDefaultMessage: "建议对此任务执行NextWave服务。点击",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "图标以开始。",
    suggestedServicesPlaceholderMessage: "没有对此任务的建议服务。",
    nextWaveServiceOfferingLabel: "服务",
    nextWaveServiceStatusLabel: "状态",
    nextWaveServiceStartDateLabel: "开始",
    nextWaveServiceDueDateLabel: "到期",
    nextWaveServiceRequestCreate: "创建请求",
    nextWaveServiceRequests: "集中化的服务请求",
    nextWaveServiceGatewayRequests: "服务网关请求",
    onlyShowSelectedTask: "仅显示已选择的任务",
    sdmRestrictAddTaskLabel: "点击继续前往下一步。接受服务后可以进行任务选择，采用GDS流程的项目组经理可与GDS讨论待完成工作。",
    //Links
    linksText: "链接",
    //Forms
    formsText: "表格",
    /*Accounts*/
    associatedTasks: "与可能出错项相关的任务",
    noAssertionsChecked: "选择一个认定以查看相关的可能出错项",
    noAccountsCreated: "未创建账户",
    noDesignationSelected: "未选定指定",
    noRelatedAccounts: "无相关账户",
    manageAccount: "管理账户和披露",
    /*Risks*/
    risk: "风险",
    risks: "风险",
    wcgw: "可能出错项",
    riskWcgw: "风险：可能出错项",
    wcgwTasks: "可能出错项：任务",
    riskWcgwLabel: "将风险与可能出错项（WCGW）关联",
    wcgwTasksLabel: "将可能出错项关联至任务",
    noRiskTypes: "未找到风险类型",
    saveRisk: "保存",
    noRisksFound: "未找到风险",
    haveBeenIdentified: "已被识别",
    noAssertionFound: "无适用于本项目的已关联认定",
    noAssertionApplicable: "未关联适用于本项目的认定",
    noWCGWFound: "没有与此风险相关的WCGW。单击“编辑关联”以关联一个或多个WCGW。",
    noRelatedWCGWs: "无相关可能出错项",
    noRelatedControls: "无相关控制",
    noRelatedRisks: "无相关IT风险",
    noRelatedITGCs: "无相关IT一般控制",
    iTriskVal: "IT风险",
    iTrisksVal: "IT风险",
    iTGCVal: "IT一般控制",
    iTGCsVal: "IT一般控制",
    iTSPVal: "IT实质性程序",
    iTSPsVal: "IT实质性程序",
    iTGCname: "IT一般控制名称",
    iTSPname: "IT实质性程序名称",
    noWCGWAvailable: "所选认定无可用ROMM",
    relevantWcgwCountHint: "对比WCGW的总数，账户名称旁显示的计数应被视为与控制风险评估为不依赖的认定或高风险估计相关的认定有关的WCGW数量，且已与实质性程序相关联。",
    noAccountsFound: "未找到记录",
    selectAssertionToRelateWCGW: "选择认定，以将风险关联至可能出错项",
    significantAccounts: "重大账户",
    riskName: "风险：",
    accountName: "账户：",
    noScotsFound: "无相关重大交易类别",
    relatedwcgw: "相关可能出错项",
    relatedRisks: "关联风险",
    noRelatedAssertionsLabel: "没有为账户选择认定",
    boltIconTitle: "相关风险",
    instructions: "指引",
    expandRisk: "1.展开一个风险",
    selectAssertion: "2.选择一个认定",
    identifyRelatedWCGW: "3.识别与风险相关的WCGW",
    clickAccount: "1.点击一个账户",
    selectWCGW: "2.选择一个可能出错项",
    identifyRelatedTask: "3.识别应对可能出错项的任务",
    information: "信息",
    requiredAssertions: "必要认定",
    wcgwWithoutTasks: "没有关联任务的可能出错项",
    found: "已找到",
    editAssociations: "编辑关联",
    riskWCGW: "风险：可能出错项关系",
    wcgwTask: "可能出错项：任务关系",
    requireTaskToBeRelated: "需要关联一项任务",
    expandCollapse: "单击此处展开/折叠",
    requiredAssertionsInfo: "仅显示控制风险评估为不依赖的认定以及与较高风险估计有关的认定",
    wCGWwithoutTasksInfo: "仅显示与控制风险评估为不依赖的认定以及与较高风险估计有关的认定相关的WCGW，且上述WCGW没有任何相关的实质性任务予以应对",
    noBuildStepsAvailable: "没有可供呈现的创建步骤。",
    accountRiskAssessmentSummary: "账户和披露",
    manageRisk: "管理风险",
    addResponsivePSPOSP: "添加做出应对的主要实质性程序/其他实质性程序",
    assertionlbl: "认定",
    addResponsiveControl: "添加做出应对的控制",
    addResponsiveTOC: "添加做出应对的控制测试",
    showOnlyRelatedItems: "仅显示已关联",
    relatedControlCounter: " {0} 控制",
    relatedControlsCounter: " {0} 控制",
    noControlsAvailableForRelateItem: "无可用控制",
    relateControlName: "控制",
    relateContolsAPIErrorMessage: "控制无法关联至认定。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    relateTasksAPIErrorMessage: "任务无法关联至认定。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    toggleFilterWarningMessage: "仅显示不具有任何实质性程序的账户和披露",
    toggleFilterWarningMessageForRisk: "仅显示没有任何实质性程序或控制/控制测试应对的风险",
    warningIconHoverText: "没有任何实质性程序或控制/控制测试应对的风险",
    filterYes: "是",
    filterNo: "否",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "选择",
    selectAnAccountFromTheDropDown: "1. 从下拉列表中选择一个账户",
    applyAsertionsFilters: "2.应用认定筛选",
    reviewTheTasksThatRespondToTheRisks: "3.复核应对风险的任务",
    riskOfMaterialMisstatement: "重大错报风险",
    expandScot: "1.展开重大交易类别",
    selectWCGWToDisplayTheResponsiveTask: "2.选择重大错报风险以显示响应性任务",
    tasksWithNoRelatedWCGW: "未关联重大错报的任务",
    selected: "已选定",
    clearSelections: "全部取消选择",
    romm: "ROMM",
    selectAccount: "账户",
    selectHeader: "选择标题",
    riskOfMaterialMisstatementsWithoutRelatedTask: "未关联任务的重大错报风险",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "选择一项或多项任务以查看相关的ROMM",
    invalidRelatedEntity: "无法找到相关账户。请刷新页面并重试。如果问题持续，请联系帮助台。",
    scrollUp: "向上滚动",
    scrollDown: "向下滚动",
    duplicate: "复制",
    showIndex: "显示索引",
    noContentAvailable: "无可用内容",
    navigateTo: "前往",
    /*validations */
    semValidation: "SEM验证",
    riskWCGWValidation: "风险可能出错项验证",
    showValidation: "验证",
    wcgwWithNoRelatedTask: "无相关实质性任务的可能出错项",
    riskWithNoRelatedWCGW: "无相关可能出错项的风险",
    noValidationIdentified: "无已识别验证",
    onlyShowScotWithNoControlNoWCGW: "仅显示无关联的可能出错项或控制的重大交易类别",
    /*CRA Badge*/
    ir: "固有风险",
    cr: "控制风险",
    cra: "综合风险评估",
    selectToEdit: "选择进行编辑",
    both: "二者",
    prefix: "前缀",
    suffix: "后缀",
    optional: "（可选）",
    title: "标题",
    charLimitExceeded: "超出字符数限制",
    requiredField: "必填信息栏",
    Lastmodifiedby: "最后修改人",
    fileSize: " | {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "文件大小",
    daysAgo: "几天前",
    weekAgo: "周前",
    weeksAgo: "周前",
    monthAgo: "个月前",
    monthsAgo: "个月前",
    yearAgo: "年前",
    yearsAgo: "年前",
    currentlyBeingModifiedBy: "当前修改人",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "多用户编辑即将结束",
    coEditMode: "多用户编辑",
    checkInInProgressMessage: "正在签入文档。签入文档可能需要20分钟的时间。请刷新以获取最新进度。",
    checkOutInProgressMessage: "正在签出文档。签出文档可能需要20分钟的时间。请刷新以获取最新进度。",
    daasErrorMessage: "此时无法完成操作。请刷新页面并重试。如果问题仍然存在，请联系帮助台",
    coEditModeIsStarting: "正在启动多用户编辑",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "继续",
    openReadOnly: "打开只读",
    takeControlFromTeam: "从当前项目组成员取得控制",
    itapplication: "IT应用程序",
    aggregateITevaluation: "综合IT评估：",
    control: "控制",
    itgcitsp: "IT一般控制/ITSP",
    limitedRisk: "有限风险账户",
    so: "SO",
    itApp: "IT 应用程序",
    itAppType: "IT应用程序",
    deleteTaskModalHeader: "确认删除选中任务",
    deleteTasksModalHeader: "确认删除已选定任务",
    deleteTaskModalMessage: "是否确定删除已选定任务?",
    deleteTaskModalMessage1: "与该项目中任何其他任务不相关的证据将被移入临时文件。与任何其他证据无关的发现或相应任务将被删除。",
    deleteTasksModalMessage: "是否确定删除已选定任务?",
    someTasksCannotBeDeleted: "部分任务无法被删除",
    onlySomeTasksCanBeDeleted: "您选择的任务中仅有部分可以被删除。",
    tasksThatCanBeDeleted: "如选择继续，将从您的项目中<b>删除下列任务</b>。未与其他任务相关联的证据将被移入临时文件。未与其他证据相关联的发现或应对任务也将被删除。",
    tasksThatCannnotBeDeleted: "您的项目中<b>无法删除下列任务</b>，但如有必要，可在“审计计划”中拒绝这些任务。",
    accountHeader: "账户",
    noAccountsIdentified: "没有已识别账户。",
    noRisksIdentified: "没有已识别风险",
    noAssertionsIdentified: "没有已识别认定",
    noWcgwsIdentified: "没有已识别可能出错项",
    // Tasks/TaskDetails/Evidence
    addEvidence: "添加证据",
    relateEvidence: "关联证据",
    relateTemporary: "关联临时文件",
    relatePriorPeriod: "关联上期证据",
    relateExtDoc: "关联外部文档",
    relateFile: "关联文件",
    relateAnalytics: "关联分析工具",
    quickAddButton: "快速添加",
    createPaperProfile: "创建纸质文档",
    paperProfileInformationMessage: "我们以电子形式编制全部文档记录，包括编制和复核签署。仅允许将管理层或第三方以纸质形式向我们提供的无电子副本的文件（例如，实体与第三方之前已签署合同的副本）以纸质文档记录的形式纳入我们的工作底稿。",
    paperProfileName: "纸质文档名称",
    paperProfileAdd: "添加",
    paperProfileError: "请输入有效的纸质档案名",
    otherEngagementsInWorkspace: "该工作区中的其他项目",
    relateDescription: "关联该项目中的文档或该工作区的另一项目中的文档。",
    onlyShowRelatedDocuments: "仅显示已关联文档",
    relateDescriptionTemp: "关联该项目中的文件。",
    added: "添加",
    documentLocation: "文件位置",
    documentIneligibleForSharingMessage: "机密性文档不可共享。",
    confidentialityNotAppropiateForSharing: "您没有发送此文档的适当的机密级别权限。",
    documentIsCheckedOut: "当前文档处于共同编辑模式，无法共享。请退出共同编辑模式以共享文档。",
    addCanvasFormNew: "添加Canvas新表格",
    documentCount: "{0}文档",
    documentsCount: "{0}文档",
    fitDocumentCannotbeSelected: "FIT文档无法在项目之间共享。",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "无可用描述。",
    knowledge: "知识",
    knowledgeDescription: "知识描述",
    descriptionInstructions: "指引中的描述",
    fromInstructions: "来自指引",
    customizeDescription: "定制描述",
    custimizeTaskDescription: "定制任务描述",
    editTaskDescription: "编辑任务描述",
    saveLabel: "保存",
    okLabel: "确认",
    cancelLabel: "取消",
    leaveCommentLabel: "添加批注",
    addLabel: "添加",
    closeLabel: "关闭",
    editText: "编辑",
    enterReply: "输入回复",
    reply: "回复",
    deleteTagDesc: "标签删除后无法撤销，是否继续？",
    requiredText: "必须输入文本",
    descriptionEmptyError: "必须添加描述",
    descriptionMaxLengthError: "描述超过允许的最大字符长度",
    assignmentDueDate: "工作分配到期日",
    navigateToGuidedWorkflow: "前往EY Canvas FIT促进工具",
    openInTasksPage: "在任务中打开",
    copyTaskLink: "复制任务链接",
    copyReviewNoteLink: "复制复核注释链接",
    urlCopiedLabel: "链接复制成功",
    //Related Tasks
    showOnlyRelatedTask: "仅显示已关联",
    noTaskAvailable: "无可用任务",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "在协作中打开",
    copyRequestLink: "复制请求链接",
    requestType2MessageTitleDrawer: "此请求具有其他功能。",
    requestType2MessageSubtitleDrawer1: "请",
    requestType2MessageSubtitleDrawer2: "点击此处",
    requestType2MessageSubtitleDrawer3: "以进入该功能。",

    // SeeMore component
    showMore: "显示更多",
    showLess: "显示更少",
    showMoreEllipsis: "显示更多...",
    showLessEllipsis: "显示更少...",

    // Request Description
    saveAndCloseButtonLabel: "保存并关闭",
    saveButtonLabel: "保存",
    cancelButtonLabel: "关闭",

    // Request Description Modal labels
    discardChangesModalText: "放弃更改",
    inlineSaveUnsavedChanges: "存在未保存的更改，是否要继续？",

    // RelateWCGWModal labels
    wcgwName: "可能出错项名称",
    wcgwByScot: "按重大交易类别划分的可能出错项",
    unrelatedSCOTsHeader: "未关联的重大交易类别",
    unrelatedSCOTPlaceholder: "没有未关联的重大交易类别",
    noWcgwPlaceholder: "尚未创建可能出错项",
    showOnlyUnrelatedWCGW: "仅显示未关联",

    // CharCount component.
    of: "中的",
    characters: "字符",
    fromUserLabel: "从",
    toUserLabel: "至",
    handoffto: "移交给",
    priorityLabel: "优先",
    addNoteLabel: "添加",
    replyNoteLabel: "回复",
    characterCountLabel: "4000个字符中的",
    taskNotePlacehodler: "输入任务注释",
    documentNotePlacehodler: "输入文件注释",
    taskNoteStatusBy: "注释人：",
    addNewReviewNoteButtonText: "新注释",
    fromKnowledge: "来自知识",
    /*day labels*/
    mon: "星期一",
    tues: "星期二",
    wed: "星期三",
    thurs: "星期四",
    fri: "星期五",
    sat: "星期六",
    sun: "星期日",
    /*month labels*/
    jan: "一月",
    feb: "二月",
    march: "三月",
    april: "四月",
    may: "五月",
    june: "六月",
    july: "七月",
    august: "八月",
    sept: "九月",
    oct: "十月",
    nov: "十一月",
    dec: "十二月",
    /*Rename*/
    documentDropdown: "文件下拉列表",
    fileNameRequired: "必须填写文件名",
	invalidCharacters: '文件名中不得含有： */:<>\\?|\"',
    existingFileName: "文件名不唯一。请刷新页面或重命名文件，以删除此信息。",
    unknowError: "发生意外错误。刷新页面以删除此信息。",
    maxLengthExceeded: "文档名称不得超过115个字符。",
    documentNameSyncErrorMessage: "无法将文档名称同步到Canvas客户端。请刷新页面，然后重试。",
    /*Delete*/
    deleteFileTitle: "删除文件",
    deleteFileCloseBtnTitle: "取消",
    deleteFileConfirmBtnTitle: "删除",
    deleteFileCloseTitle: "关闭",
    deleteFileModalMessage: "是否确定删除已选定文档？",
    none: "无",
    /*Unlink*/
    unlinkFileTitle: "取消共享证据的链接",
    unlinkSource: "来源",
    unlinkTarget: "目标",
    unlinkFileCloseBtnTitle: "取消",
    unlinkFileConfirmBtnTitle: "确定",
    unlinkFileCloseTitle: "关闭",
    unlinkFileModalMessage: "是否确认取消此共享证据文件的链接？",
    /*Relate Tasks*/
    relateTasksTitle: "关联任务",
    relateTaskSearchPlaceholder: "输入搜索",
    relateTaskInstructionalText: "添加或删除文档应关联的任务。如果文档是证据，从最后一个任务中删除它将把它移到临时文档中。",
    relatedTaskInstructionalText: "该文档与此次项目中的以下任务有关。点击一个任务名称进行浏览。",
    relateTaskName: "任务名称",
    relateTaskType: "类型",
    relatedTaskCounter: "{0} 任务",
    relatedTasksCounter: "{0} 任务",
    /*Relate Entities*/
    relateEntitiesTitle: "关联实体",
    relateEntitiesSearchPlaceholder: "输入以按名称搜索",
    relateEntitiesName: "实体名称",
    relateEntitiesIndex: "实体标准索引",
    relatedEntitiesCounter: "{0}个实体",
    relatedEntityCounter: "{0}个实体",
    onlyShowRelatedEntities: "仅显示相关实体",
    unableToRemoveSystemAssociatedRelatedEntity: "无法删除文档和实体之间的系统关系",
    /* Finalize document */
    document: "文档",
    finalize: "定稿",
    finalizeDocument: "定稿文档",
    finalizeDocumentTitle: "确认要通知主审小组此文档已定稿吗？",
    finalizeDocumentSubtitle: "发送文档定稿通知即告知主审小组，你不会再发送该文档的其他版本，并已将文档状态更改为<b>已发送终版文档</b>。如果更改了已定稿文档，你仍可将新版文档发送给主审小组。",
    /* Remove From Task */
    removeEvidenceModalTitle: "从任务中删除",
    remove: "删除",
    removeFromTaskModalContent: "是否确定从此任务中删除已选定的文档? 该文档未与此项目的任何其他任务相关联，因此将被移至临时文件。",
    sharedEvidenceRemoveFromTaskModalContent: "是否确定从此任务中删除所选文档? 该文档为共享文档，与本项目其他任务无关。删除后，您的项目不可继续使用该文档。",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "添加至一个或多个任务的证据",
    modalRadioHeading: "将文件关联至一个或多个任务",
    confirm: "确认",
    proceed: "继续",
    modalCheckboxMessage: "选择添加该文件的相关任务。",
    selectedDocument: "已选定的文件",
    modalRadioMessage: "该文档先前已添加到证据或临时文件中。",
    modalRadioMessage1: "再次添加该文件将创建一个副本。选择是关联该文件的现有副本还是创建该文件的新副本。",
    option: "选项",
    option1Message: "将现有文件关联至此任务",
    option2Message: "创建此文件的新副本",
    addToEvidenceSelectAll: "选择全部",
    currentTask: "当前任务：",
    createNewCopy: "创建新副本",
	fileNameMaxLenError: (maxFileLen) => `文件名限制为$ {maxFileLen}个字符。`,
    /* Confidentiality */
    confidentiality: "机密性",
    confidentialityType: "机密性（可选）",
    confidentialityTitle: "文档机密性",
    confidentialityPlaceholder: "选择机密性",
    confidentialityText: "设置打开此文档所需的访问权限等级。项目管理员在管理项目小组页面设置访问权限等级。如果已设置此文档的机密性，只有能够打开此文档的人员才可以进行更改。",
    confidentialityNotOpenable: "您的项目权限不足，无法打开文档。访问权限等级由管理小组的项目管理员设置。",
    confidentialityTargetNotOpenable: "只能从来源项目打开机密性文档。",
    /*Sign-off requirements*/
    signOffRequirements: "签署要求",
    signoffRequirementsModalTitle: "签署要求",
    signoffRequirementsModalDescription1: "调整以下本文件的管理人员签字要求。",
    signoffRequirementsModalDescription2: "由于EY Canvas要求，某些签名要求无法调整。",
    signoffRequirementsModalSaveLabel: "保存",
    signoffRequirementsModalCancelLabel: "取消",
    signoffRequirementsModalCloseLabel: "关闭",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "复核人",
    displaytoc: "显示TOC",
    viewBy: "按..显示",
    substantiveEvaluation: "实质性评估矩阵",
    reviewed: "已复核",
    estimate: "估计",
    /*440GL*/
    FourFortyTitle: "报告日期后修改的证据（{0}）",
    LeftContainerTitle440GL: "变更原因",
    approvals: "批准",
    approveChangesColumnTitle: "批准变动",
    approveChangesButton: "批准变动",
    deleteApproval: "移除批准",
    unauthorizedAction: "行动只能由项目管理人员执行",
    reasonColumnTitle: "原因",
    approvedBy: "批准人:",
    approvedByPeople: "人员",
    noChangeReasonCommentAvailable: "从文档齿轮选项中单击“编辑原因”以输入更改原因。",
    changeReasonModalTitle: "编辑更改原因",
    changeReasonModalText: "选择在报告日期之后对文档进行更改的原因。如果进行了多个管理更改，请从下面的下拉列表中选择最重要的更改。如果同时进行了管理更改和非管理更改，请在下面选择“非管理”。",
    changeReasonUploadModalTitle: "上传文档的原因",
    changeReasonUploadModalText: "选择在报告日期之后对文档进行更改的原因。如果进行了多个管理更改，请从下面的下拉列表中选择最重要的更改。如果同时进行了管理更改和非管理更改，请在下面选择“非管理”。",
    changeReasonModalComboPlaceholder: "选定",
    changeReasonModalAnnotationText: "记录遇到的情况和添加信息的原因；执行新的或其他审计程序，获得审计证据并得出结论以及对我们的审计师报告的影响。",
    changeReasonUploadModalAnnotationText: "记录遇到的情况和添加信息的原因；执行新的或其他审计程序，获得审计证据并得出结论以及对我们的审计师报告的影响。",
    changeReasonModalAnnotationPlaceHolder: "输入更改原因",
    changeReasonModalChangeReasonRequired: "更改保存原因。",
    noDocumentsModifiedAfterReportDate: "报告日后未修改任何文件",
    noReasonSelected: "未选择变更理由",
    fileSizeColumn: "文件大小",
    changePercent: "变动百分比",
    toolTipChangePercent: "使用截至报告日期的文件大小和当前文件大小计算文件大小的变化",
    /*Account Conclusion*/
    AccountConclusion: "账户结论",
    AccountDetails: "详情",
    Conclusions: "结论",
    accountDetailsTab: "详情",
    conclusionsTab: "结论",
    accountConclusionNoContentText: "尚未传递此表格的内容。从“全球导航更多”菜单转到“Canvas表格更新”并手动更新内容",
    validations: "验证",
    /*RelatedFindings*/
    deficiency: "{0} 相关缺陷",
    misstatement: "{0} 相关错报",
    relatedDeficiency: "{0} 相关缺陷",
    relatedMisstatement: "{0} 相关错报",
    deficiencies: "缺陷",
    misstatements: "错报",
    pagingShowtext: "显示",
    documentOpenModelLabel: "当前正在修改的文档",
    openedLabelText: "已开启",
    modelDocumentOpenedText: "该文档当前修改人",
    modelUserOpenedTheDocumentText: "该用户打开了文档",
    modelOpenedDocumentConflictText: "打开文档可能会导致冲突，因此我们建议以只读方式打开。如果你想成为本文档的编辑人，请。",
    clickHereEnabledText: "点击此处。",
    reviewNotesTemporeryFilesTitle: "复核临时文件的注释",
    addNewReviewNoteTitle: "任务注释",
    /*Assignments*/
    assignedTo: "分配给",
    createAssignment: "创建分配工作",
    createAssignments: "创建分配工作",
    editAssignments: "编辑分配工作",
    deleteAssignments: "删除分配工作",
    removeAssignments: "移除分配工作",
    noTimephaseSelected: "未选中",
    unassigned: "未分配",
    unassignedCapitalized: "未分配",
    dueDateBlank: "到期",
    reviewerAssignment: "复核人工作分配",
    manageAssignments: "管理任务分配工作",
    manageTaskAssignments: "创建分配工作",
    selectedTasks: "已选定任务",
    someTasksCannotBeMoved: "部分任务无法被移动",
    onlySomeTaskCanMoveToOtherGroup: "您选择的任务中仅有部分可以被移动至其他任务组。",
    taskThatCanBeMovedToOtherGroup: "如选择继续，<b>下列任务将被移动</b>至您选择的任务组。",
    tasksThatCannotBeMovedToOtherGroup: "<b>下列任务无法被移动</b>至其他任务组。",
    taskGroupSectionNotFound: "未找到结果",
    placeholderForSearch: "搜索",
    taskFilter: "筛选",
    noResultsAvavilable: "未找到结果",
    noTasksAvavilable: "无可用任务",
    clearAll: "清除全部",
    engagementPhase: "审计阶段",
    noOptionAvailable: "无可用选项",
    noTimePhase: "未分配时间段",
    roles: "职能",
    users: "项目小组成员",
    rommAssociatedWNotRelyAssertion: "ROMM与控制风险为不依赖控制的认定或具有较高固有风险的认定相关联（如果账户涉及估计）",
    hasRiskAssociated: "相关风险",
    canvas: "Canvas",
    workingoffline: "离线工作",
    syncinprogress: "正在进行同步",
    prepareoffline: "编制离线数据",
    connectionavilable: "可用连接",
    createAnAssignment: "创建分配工作",
    createAssignmentEnd: "针对此任务，然后开始。",
    // Manage Assignments
    step01: "步骤 01",
    step02: "步骤 02",
    step03: "步骤 03",
    step04: "步骤 04",
    step05: "步骤 05",
    manageAssigmentsStep1: "选择一个操作.",
    manageAssigmentsStep2: "编辑任务分配工作",
    editAssignment: "编辑分配工作",
    deleteAssignment: "删除分配工作",
    manageAssigmentsStep3: "完成分配工作",
    taskAssigmentStatusHeader: "分配工作状态",
    taskAssigmentStatusTileHeader: "任务和分配状态",
    taskAssignmentName: "分配工作",
    dueDateAssigment: "到期",
    editDueDate: "可选: 结束日前编辑天数",
    teamMemberAssigmentLabel: "项目组成员",
    currentAssigmentLabel: "当前",
    handOffToAssigmentLabel: "移交至：",
    priorToEndDateLabel: "早于结束日",
    noTimePhaseAssigmentLabel: "未分配时间段",
    closedByAssigmentLabel: "关闭人",
    onAssingmentLabel: "位置",
    preparerAssigmentOpenTitleTip: "移交此任务，以关闭你的任务分配",
    reviewerAssigmentOpenTitleTip: "标记任务分配为已关闭",
    reviewerAssigmentClosedTitleTip: "标记任务分配为已开启",
    AssigmentLabel: "移交此任务，以关闭你的任务分配",
    noEvidenceReviewerAssigmentTitleTip: "添加证据以将任务分配标记为已关闭",
    noTaskEvidencesHandoffModal: "没有与该任务相关的证据文件。",
    back: "返回",
    savecontinue: "保存&继续",
    finish: "完成",
    save: "保存",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "选择一项操作以继续。",
    createNewTaskAssingment: "创建新的任务分配",
    deleteTaskAssingment: "删除任务分配工作",
    createTaskAssingment: "创建任务分配",
    editExistingTaskAssingment: "编辑现有任务分配",
    editTaskAssingment: "编辑任务分配",
    removeExistingTaskAssingment: "删除现有任务分配",
    warningPopUpPreparerAssignmentTitle: "覆盖现有的编制人分配工作",
    warningPopUpPreparerAssignmentText: "已针对该任务进行编制人分配工作。是否确定覆盖该任务？",
    warningPopUpPreparerAssignmentConfirm: "确认",
    warningPopUpPreparerAssignmentCancel: "取消",
    selectTaskAssingment: "选择任务分配",
    viewHistoryAndConflicts: "查看历史",
    noHistoryAvailable: "无可用历史",
    teamMember: "项目组成员",
    dateEdited: "最后修改",
    viewHistoryHeader: "文件版本历史如下所示。",
    viewHistorySubHeader: "单击小组成员名字以只读模式打开此文件的先前版本。对该先前版本所做的任何更改都不会保存到EY Canvas。",
    docConflictedMessage: "存在与此文件相关的冲突。前往文件的冲突标签页以解决冲突。",
    removeTaskAssingment: "删除任务分配",
    addAssignmentInstructionalText: "在此输入新的任务分配名称（如，详细复核人、一般复核人）",
    addNewAssingmentName: "添加新分配工作名称",
    addTaskAssignmentName: "添加任务分配名称",
    assignmentName: "任务分配名称",
    selectedTask: "已选任务",
    createTaskAssignmentHeading: "在此创建一个新的任务。",
	createTaskAssignmentHeading1: "在下方输入任务分配详情，然后点击“保存并关闭”结束。如想另外创建任务分配，请选择<b>“保存并另外添加”。</b>",
    saveDelete: "保持并删除",
    createTaskAssignmentFinishLabel: "保存并关闭",
    createTaskAssignment: "保存并添加",
    editTaskAssignment: "保存并管理其他项目",
    createTaskAssignmentSaveAndContinueLabel: "保持并管理另一项",
    daysPriorToEndDate: "截止日前的天数",
    daysdue: "到期日",
    daysPriorToEndDateOptional: "结束日前的天数（可选）",
    timephase: "时间段",
    timephasesLabel: "时间阶段",
    manageTimePhase: "管理时间阶段",
    removeTaskAssingmentSingleTaskHeading: "选择您要删除的分配工作。",
    removeTaskAssingmentSingleTaskHeading2: "完成后单击“保存并关闭”，或者，如果要管理其他任务分配工作，请单击“保存并管理另一项”。",
    removeTaskAssingmentMultipleTaskHeading: "如果存在已选定任务的分配和项目组成员组合，则将对该分配工作进行删除。完成选择然后点击<b>保存并关闭</b>。如想另外删除分配工作，点击<b>保存并删除</b>。",
    editTaskAssingnmentStep2Heading: "选择您要编辑的任务分配工作。",
    selectedAssignment: "已选任务分配：",
    editTaskAssingmentBulkHeading: "选择您要编辑的任务。",
    editTaskAssingmentBulkSubHeading1: "如果所选任务已存在任务分配和相应的项目组成员，则该任务将被重新分配。您可以选择编辑<b>到期日前天数</b>。如果编辑此值，则将为所有重新分配的任务更新该值。进行编辑并选择<b>保存并关闭</b>，以完成本步骤。要编辑另一任务分配，请选择<b>保存并管理另一任务分配</b>。",
    noResultInCategory: "该任务类别下没有找到结果",
    searchTaskList: "搜索任务列表",
    searchCanvasFormList: "搜索",
    clearHoverText: "清除",
    filtersWarningMessage: "超出筛选限制.只能同时使用25个筛选.",
    reviewNotesWarningMessage: "检索数据时发生错误。请重试，如问题仍然存在，请联系帮助台。",
    editTaskAssingmentSept3Header: "编辑已选定的分配工作。",
    editTaskAssingmentSept3Header2: "完成后单击“保存并关闭”，或者，如果要管理其他任务分配工作，请单击“保存并管理另一项”。",
    editTaskAssignmentHeaderPart1: "编辑下面的任务分配详情，然后选择<b>保存更改</b>。",
    calculatedDate: "计算日期",
    saveAndAddbtn: "保存并另外添加",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "结束日前天数（必填）",
    dueDateRequired: "到期日（必填）",
    selectDate: "选择日期",
    calculateDate: "计算日期",

    /* Bulk TimePhase*/
    taskText: "任务",
    timephasesetsuccess: "{0}时间段设置成功。",
    timephasessetsuccess: "{0}时间段设置成功。",
    addTimephaseLabel: "添加时间段",
    infoSetTimePhase: "<h3>设置时间段</h3><p>将选择的项目拖放到一个时间段，为这些项目设置为该时间段</p>",
    infoEditTimePhase: "<h3>编辑时间段</h3><p>点击溢出菜单（三个点），选择编辑，以编辑时间段属性。</p>",
    infoAddTimePhase: "<h3>添加时间段</h3><p>点击添加时间段创建新的时间段。</p>",
    infoDeleteTimePhase: "<h3>删除时间段</h3><p>点击溢出菜单（三个点），选择删除，以删除时间段。</p>",
    deletedTimePhaseFilterWarningMessage: "时间阶段已被另一个用户删除。",

    //Set assignment dates modal labels
    setAssignmentTitle: "设置任务分配到期日",
    setAssignmentDesc: "您尚未定义任务分配到期日。请在下方选择任务分配到期日以继续。",
    setAssignmentDesc2: "有一个或多个任务的时间段日期早于您选择的到期日{0}。请调整任务到期日或时间段到期日以继续。",
    timePhaseNameLabel: "时间段",
    timephaseEndDate: "时间段结束日",
	tasksLabel: "任务编号",
    assignmentDateLabel: "任务分配",
    noAssignedTimePhase: "无已分配时间段",
    endDate: "截止日期",
    calendarDateError: "到期日应早于时间段结束日",

    /* Events*/
    addEventLabel: "添加事件",
    sharedWithClient: "已共享",
    noEventsMessage: "没有识别到事件。",
    naLabel: "不适用",
    deleteEventModalTitle: "删除事件",
    deleteEventDescription: " 是否确认删除此事件？",
    showEventeName: "事件",
    eventDateLabel: "日期",
    eventDatesLabel: "日期",
    showEventStartDate: "开始日",
    showEventEndDate: "结束日",
    deleteEventSuccessMessage: "事件已成功删除。",
    eventTypeLabel: "事件类型",
    singleDayEventLabel: "单日",
    multiDayEventLabel: "多日",
    dateRangeEventLabel: "日期范围",
    eventSharedWithClientLabel: "已与客户共享",
    editEventLabel: "编辑事件",
    eventUpdateSuccessMessage: "事件已成功更新。",
    noTimephasesMessage: "尚未确定任何时间阶段。",

    /* Review Notes */
    showAll: "全部",
    reviewNotesLabel: "复核注释",
    athoredByMeLabel: "由我编辑",
    assignedToMe: "分配给我",
    assignedToOpen: "分配至（打开）",
    authoredByCleared: "编写人（已清除）",
    totalOpenReviewLabel: "未完成复核注释总数",
    totalClearedReviewLabel: "已清除的复核注释总数",
    agingLabel: "已过期",
    openLabel: "未完成",
    clearedLabel: "已清除",
    noUsersFoundLabel: "未发现结果",
    chartDataLabel: "无可用数据。",
    noClientDataAvailable: "无可用数据",
    DaysLessThan10: "<10天",
    Days11To30: "<30天",
    Days31To60: "<60天",
    Days61To90: "<90天",
    DaysMoreThan90: ">90天",
    noReviewNotesFound: "未找到复核注释",

    formMaxLength: "文本不能超过{number}个字符。",
    voiceNote: "语音注释",
    microphoneBlockedMessage: "允许浏览器访问您的麦克风以使用语音注释。如已允许，请刷新并重试。",
    microphoneBlockedOnVideoMessage: "允许浏览器访问麦克风，以在录屏时录制语音。如已允许，请刷新并重试。",
    notInMainWindowVoice: "抽屉菜单内不允许录音，请在新的标签页中打开文档以执行操作。",
    notInMainWindowScreen: "抽屉菜单内不允许录屏，请在新的标签页中打开文档以执行操作。",
    screenRecord: "录屏",
    playbackReview: "查看回放",
    recording: "录制中",

    /* Sign Offs */
    preparerHoverText: "以编制人签署",
    reviewerHoverText: "以复核人签署",
    preparerTitle: "编制人签名",
    reviewerTitle: "复核人签名",
    preparerLetter: "编制人",
    reviewerLetter: "复核人",
    deleteHoverText: "删除签名",
    signoffsrequired: "必须签字",
    signoffsOptional: "PIC/EQR可选",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "登录页",
    dashboardPage: "一览表",
    tasksPage: "任务",
    documentsPage: "文件",
    collaborationPage: "合作",
    automationPage: "自动化",
    newContentUpdate: "内容更新",
    contentUpdatesHistory: "历史",
    history: "历史",
    contentUpdateType: "内容更新类型",
    iniciatedBy: "发起人",
    date: "日期",
    clickForOptions: "点击展开更多选项",
    offline: "下线",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "内容更新",
    canvasFormUpdates: "Canvas表格更新",
    syncFormProfile: "同步表格配置文档",
    documentName: "文档名称",
    analyticName: "分析工具名称",
    formType: "表格类型",
    dateOfContent: "内容日期",
    formStatus: "状态",
    formsWarningMessage: "必须选定一个或多个EY Canvas表格进行更新",
    formsUpdateSuccessMessage: "EY Canvas表格更新已提交",
    filterTypeOfFormLabel: "表格类型",
    filterSourceOfFormLabel: "表格来源",
    documentSelectionRequired: "选择要覆盖的文档",
    overwriteForm: "覆盖表格",
    overwriteFormInstructionalText: "选择一个表格，用当前Canvas表格中的数据覆盖回复。请注意，当前Canvas表格将从被移动至临时文件。",
    confirmOverwrite: "确认覆盖",
    confirmOverwriteAreYouSure: "是否确定要将\'{0}\’表格中的内容复制到 \'{1}\’表格?",
    confirmOverwriteDesc: "\'{1}\’表格中的反馈将被覆盖，但相关证据和对象不会被覆盖。请在完成覆盖后将适用的相关证据和对象重新关联至\'{1}\’表格。\'{0}\'表格将保留目前的配置文件/GAM层级。因此，如果表格的配置文件与\'{1}\’表格不同，请复核并清除复制的内容。",
    confirmOverwriteDoNotClose: "在覆盖进程中，不得关闭浏览器或离开页面。完成覆盖流程后，\'{0}\’表格将被移至临时文件夹。此操作无法撤销。",
    sourceDocument: "源文档",
    targetDocument: "目标文档",
    profileLayers: "GAM层级",
    pspAccountWarningMessage: "必须选定一个或多个账户进行更新",
    pspAccountUpdateSuccessMessage: "已提交PSP内容更新",
    pspAccountconfirmUpdateMessage: "更新这些账户可能对内容有重大影响。更新开始后至更新完成前，您无法再执行其他内容更新。",
    est: "涉及估计",
    bookmarkTaskModalHeader: "无法下载已选定的任务",
    bookmarkTaskModalMessage: "无法下载已选定的任务以离线工作。",
    noGuidanceAvailable: "无可用指引",
    next: "下一个",
    previous: "以前",
    guidanceLink: "链接",
    addToEvidenceLabel: "添加至证据",
    otherEngagements: "其他项目",
    navigationView: "导航查看",
    listView: "列表查看",
    detailsView: "详细信息查看",
    closeguidance: "关闭指引",
    reviewNotesModalClose: "关闭",
    gamGuidanceLinkLabel: "GAM指引",
    inProgess: "进行中",
    upcomingReview: "即将进行的复核",
    teamSummaryEmptyTaskDetailsMesage1: "使用项目组汇总表，按状态查看各项目组成员的编制人和复核人的工作分配。要管理您项目的所有工作分配，请选择",
    teamSummaryEmptyTaskDetailsMesage2: "管理工作分配。",
    teamSummaryEmptyTaskDetailsMesage3: "要启用批量控制，请点击复选框选择一项或多项任务。使用shift键同时选中多项任务。如果您要处理单项任务，请在列表中选择此任务。",
    taskSummaryPoint1: "选择“编制”以查看针对每个小组成员的编制人工作分配列表。",
    taskSummaryPoint2: "选择“复核”以查看针对每个小组成员的复核人工作分配列表。",
    taskSummaryPoint3: "分配工作按分配工作状态（未开始、进行中和已完成）排序。",
    noLinksfound: "无此任务可用的链接。",
    noFormsfound: "无此任务可用的表格。",
    workofflinemsg: "这将下载已选定任务的最新版本，并允许您继续离线编辑。您可以稍后通过重新连接来同步您的更改。",
    workonlinemsg: "重新联机将自动同步您的更改。重新连接之前，请确保互联网连接可用。",
    workoffline: "离线办公",
    workonline: "在线办公",
    duplicateFileNames: "重复文件名称",
    training: "培训",
    duplicateFileNameValidationMessage: "你尝试添加到该项目中的文件与该项目中的现有文件具有相同的名称。重命名其中一个文件以继续。",
	documentHelperConnectionIssue: 'EY Canvas文档助手已检测到问题。点击<a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">此处</a>获得解决问题的指引。',
    incompleteCra: "不完整的CRA",
    noteItemCreated: "创建人：",
    NetworkErrorMessage: "应用程序网络出现错误。请刷新页面并重试。如果仍存在错误，请联系帮助台。",
    saveClose: "保存并关闭",
    contentupdatePSPs: "内容更新——主要实质性程序（PSP）",
    /* PAANS */
    paansIsNotReachable: "EY政策编制、审批和通知服务目前不可用。我们无法确认是否已完成所有相关政策。您还未审阅相关政策，请刷新页面重试。如果问题持续存在，请联系帮助台。",

    /* Add New Task */
    standardtask: "标准任务 - OST",
    substantivetask: "实质性任务 - OSP",
    walkthroughtask: "穿行测试任务 - WT",
    controltask: "控制任务 - TOC",
    addnewTask: "添加新任务",
    taskType: "任务类型",
    taskTypeError: "请选择任务类型",
    selectTaskTypeHeader: "选择一个任务类型以继续。",
    selectTaskType: "选择任务类型",
    enterTaskDetails: "输入任务详情",
    assignTask: "分配任务",
    taskGroup: "任务组",
    finishLabel: "保存并关闭",
    addTaskContinueLabel: "保存并分配",
    AssignTaskStepSaveandContinueLabel: "保存并添加另一个",
    addTaskDetailsHeader: "输入任务详情以继续.",
    addTaskAssignmentHeader: "可选：创建针对此任务的工作分配。",
    addTaskDetailsSubHeader: "如果要立即分配此任务，请点击<b>保存并分配</b>；如果要稍后分配此任务，请点击<b>保存并关闭</b>。",
    addTaskAssignmentSubHeader: "在下方输入工作分配详细信息，然后选择保存并关闭以完成。要创建其他工作分配，选择保存并添加。",
    addTaskAssignmentSubHeader1: "在下方输入分配工作详情，然后点击<b>保存并关闭</b>。如想另外创建分配工作，点击<b>保存并添加。</b>",
    addTaskGroup: "在此添加一个新任务组。成功添加后，可在创建新项目时选择此任务组，或将现有的“其他标准任务（OST）”移动至此任务组。",
    relateObjectHeaderAccount: "选择重大账户或披露的一个或多个认定，或选择有限风险账户。",
    relateObjectSubHeaderAccount: "任务只能与一个账户或披露相关。",
    relateObjectHeader: "关联一个或多个对象以继续。",
    limitedRiskAccount: "有限风险账户",
    onlyShowAddedObject: "仅显示添加的对象",
    relateObjectRequiredError: "必须选择一个或多个对象才能继续。",
    invalidSelectionWarning: "任务只能与一个账户或披露相关。移除所选认定或有限风险账户，以将任务与其他账户或披露的认定或其他有限风险账户关联。",
    invalidSelctionCRA: "选择单一对象类型",
    relateObjectOptionsHeaderAccountTask: "认定及有限风险账户。",
    relateObjectOptionsHeaderITWalkthroughTask: "IT/SO流程",
    relateObjectOptionsHeaderITControlTask: "IT一般控制(ITGC)",
    relateObjectOptionsHeaderITSubstantiveTask: "IT实质性程序",
    relateObjectOptionsHeaderSCOTControlTask: "控制",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "重大交易类别",
    StrategyTypeControls: "控制",
    StrategyTypeSubstantive: "实质性",

    //Manage quick filters labels
    manageQuickFilterHeader: "选择已保存或建议使用的筛选作为默认筛选。",
    manageQuickFilterText: "如果选择默认值，在进入到任务列表中时将应用此筛选。",
    noDefaultFilter: "没有默认的筛选条件",
    suggestedFiltersHeading: "建议的筛选条件",
    savedFiltersHeading: "保存的筛选条件",
    manageQuickFilters: "管理快速筛选",
    manageLabel: "管理",


    /* RNH Labels */
    emptyNoteDetailsMessage: "选择注释并查看详情。点击control键或shift键批量选择多个复核注释。如果您要处理单个注释，请从列表中选择该注释。",
    emptyRepliesMessage: "尚未有回复",
    emptyRepliesMessageAlt: "无回复",
    reviewNotes: "复核注释",
    reviewNotesStatus: "复核注释状态",
    reviewNotesStatusAssignedToMe: "分配给我的复核注释的状态",
    reviewNotesStatusAuthoredByMe: "我出具的复核注释的状态",
    comments: "复核注释",
    showHideNotes: "显示/隐藏注释",
    fileType: "文件类型",
    noteType: "类型",
    statusId: "状态",
    rnhPriority: "优先级",
    rnhDueDate: "到期：",
    rnhModifiedDate: "已修改",
    textAreaPlaceholder: "输入注释",
    requiredFieldErrorMessage: "这是必填字段。",
    meLabel: "我",
    editIconHoverText: "编辑",
    deleteIconHoverText: "删除",
    deleteIconModalTitle: "删除附注",
    deleteIconCommentModalTitle: "删除注释",
    deleteReplyIconModalTitle: "删除回复",
    deleteIconModalConfirmMessage: "是否确定删除对此附注的答复?",
    deleteIconModalConfirmMessageParent: "是否确定删除选定的注释?",
    deleteIconModalCommentConfirmMessage: "是否确认删除此回复？",
    deleteIconModalCommentConfirmMessageParent: "是否确认删除此注释？所有对该注释的回复将被同时删除。",
    deleteIconModalAcceptText: "删除",
    replyInputPlaceholder: "回复该注释",
    changeStatus: "变更状态",
    emptyReplyErrorMsg: "添加文本或语音注释以继续",
    lengthReplyErrorMsg: "回复必须少于4000个字符。",
    closeTitle: "关闭",
    closedBy: "关闭人",
    ClearedBy: "清除人",
    ReopenedBy: "重新打开人",
    commentTitle: "注释",
    noteDueDateLabel: "到期",
    reopen: "重新打开",
    noNotesAssociatedWithDocumentLabel: "使用以下输入信息添加注释。将注释分配至用户并指定优先级和到期日。",
    noNotesFound: "未发现注释",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "新注释",
    addNewNoteModalTitle: "添加新注释",
    addNewNoteModalClose: "关闭",
    backButtonLabel: "返回",
    cancelButtonLabel: "取消",
    addNewNoteStep1Title: "选择注释类型",
    addNewNoteStep2Title: "选择文件或任务",
    addNewNoteStep3Title: "输入注释详情",
    editNoteModalTitle: "编辑注释",
    editReplyModelTitle: "编辑回复",
    voiceNoteButtonLabel: "语音注释",
    stopRecordingButtonLabel: "停止",
    enterText: "输入文本",

    /* RNH Review note hub Step 1 */
    step1Title: "选择一个注释类型以继续。",
    step1Subtitle: "您只能在此添加文档和任务注释。Canvas表格批注必须在相应的Canvas表格内添加。",
    step1NoTypeSelectedError: "选择一个注释类型以继续。",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "选择您要添加注释的文档。",
    step2TaskTitle: "选择您要添加注释的任务。",
    step2SearchTitle: "搜索",
    step2SearchClearTitleTip: "清除",
    step2ErrorMessageTop: "选择一个项目以继续。",
    step2ErrorMessageBottom: "完成上述已识别的必填字段，然后继续。",
    step2EmptySearch: "未找到结果",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "为选定的文档或任务输入详细注释信息。",
    step3InstructionalSubTitle: "完成后，请点击<b>保存并关闭</b>，若您希望在所选的文档或任务中添加其他注释，请点击<b>保存并添加其他注释</b> 。",
    step3SelectedDocument: "已选定的文档：",
    step3SelectedTask: "已选定的任务：",
    step3SaveAndContinue: "保存并添加另一个",
    step3SaveAndClose: "保存并关闭",

    /* RNH List Layout Labels*/
    searchReviewNotes: "搜索注释",
    searchReviewNotesResultsNotFound: "在此注释分类中未找到结果",
    searchReviewNotesNotAvailable: "无可用注释",
    notesRepliesNotFound: "未找到对所选择注释的回复。",

    selectValueToContinue: "请选择一个值以继续",
    required: "必要",
    invalidEngagementId: "项目ID无效。请刷新页面并重试。如果仍存在错误，请联系帮助台。",
    accessDenied: "拒绝访问",
    annotationDeletedError: "已删除选定的注释。请刷新页面并重试。",

    /* RNH Filters */
    rnhClearAll: "清除全部",
    rnhShowMore: "更多",
    rnhFilter: "筛选",
    hideFiltersLabel: "隐藏",
    noDocumentChangeTypes: "未找到结果",
    selectatasktype: "选择任务类型",
    importfromknowledge: "从Knowledge中导入",
    assigntaskoptional: "分配任务（可选）",
    relateanobject: "关联一个对象",
    account: "账户",
    userOrRole: "用户或角色",
    userSummary: "用户摘要",
    other: "其他",
    userNotFound: "未找到用户",
    dueOnOrBefore: "在此日期或之前到期",
    dueOnOrAfter: "在此日期或之后到期",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "里程碑",
    scopeAndStrategy: "范围和策略",
    scopeAndStrategyTabLabel: "范围和策略",
    executionTabLabel: "执行",
    conclusionTabLabel: "结论",
    viewAllTabLabel: "查看全部",
    noTaskAssociatedToMilestoneMsg: "此审计阶段没有与里程碑关联的任务。",
    overdueLabel: "逾期",
    upcomingLabel: "即将到期",
    quickLinkText: "快速链接",
    inreviewLabel: "复核中",
    CompleteLabel: "完成",
    completeLabel: "完成",
    startLabel: "开始",
    endLabel: "结束",
    auditPhaseSummary: "审计阶段汇总",
    milestoneView: "里程碑视图",
    timePhaseView: "时间阶段视图",
    localLandingPageHeader: "此页面仅显示此数据中心中存在的EY Canvas项目。",
    localLandingPage: "本地登录页",
    noEngagementsAvailable: "此数据中心中不存在项目",
    engagements: "项目",
    /* Document List */
    docListRelatedTasks: "相关任务",
    temporaryFilesTab: "临时文件",
    priorPeriodEvidenceTab: "前期证据",
    conflictsTab: "冲突",
    recentlyDeletedTab: "最近删除",
    docListSelectedDocument: "已选择{0}个文档",
    docListSelectedDocuments: "已选择{0}个文档",
    shared: "已共享",
    shareStatusOwned: "属于该项目。",
    shareStatusShared: "已共享至该项目。",
    unlinkInprogress: "删除链接中",
    unlinkError: "删除链接错误",
    documentList: "文件",
    restoreModalTitle: "还原为临时文档",
    restoreModalText: "还原将此文档返回至临时文档",
    permanentlyDeleteModalTitle: "永久删除",
    permanentlyDeleteModalText: "永久删除文档会将其从EY Canvas中删除，并且无法撤消。单击永久删除以继续。",
    misstatementsInstructionalText: "该文档与此次项目中的以下错报有关。单击一项错报进行浏览。",
    deficienciesInstructionalText: "该文档与此次项目中的以下缺陷有关。单击一项缺陷进行浏览。",
    referenceId: "ID",
    findingDescription: "描述",
    deficienciesModalTitle: "相关缺陷",
    misstatementsModalTitle: "相关错报",
    startsWith: "开始于",
    contains: "包含",
    documentsWherePICEQRSignOffIsRequired: "需要PIC/EQR签字的文件",
    otherDocuments: "其他文档",
    documentsWherePICSignOffIsRequired: "PIC必须签字的文档",
    documentSignoffRequiredLabel: "需要以下人员签字：",
    timePhaseFilterLabel: "时间阶段",
    drillDownTimePhaseFilterLabel: "按时间段查看",
    auditPhasesLabel: "审计阶段",
    openedLabel: "已打开",

    clientApprovals: "外部签字",
    noTeamsAvailable: "尚未创建项目组。创建项目组并发送关联请求，然后开始。",
    noDocumentRecieved: "没有已收到的文档。",
    team: "项目组",
    pendingEvidence: "待定证据",
    noTimePhasePlaceHolder: "没有时间阶段",

    regionComponentEvidence: "地区和组成部分证据",
    preparersignoffs: "编制人签字",
    reviewersignoffs: "复核人签字",
    receivedon: "接收日期：",
    nosignoffsyet: "尚未签字。",
    noRegionComponentEvidence: "目前没有已收到的文档。点击<b>尚未收到的文档记录</b>，查看目前还未发送文档的地区和组成部分。",
    noComponentEvidence: "尚未收到过文档。",
    assignToRegionOrComponent: "分配给地区或组成部分",
    assignRegionComponentModalText: "选择你想要分配此文档的地区或组成部分。",
    documentAssignedToPGT: "本文档已分配给其他地区或组成部分，因此不可分配。",
    assignedToRegionComponent: "分配的地区或组成部分：",
    noRegionComponentsAvailable: "无可用地区或组成部分",
    documentUnassignedFromComponent: "未分配{1}给{0}。",
    documentUnassigned: "{0}未分配。",
    documentReturnedToComponent: "{0}已退回至{1}。",
    documentReturned: "{0}已退回。",
    regionComponentName: "地区或组成部分名称",
    relatedReviewNoteCount: "来自其他项目的1项未解决注释",
    relatedReviewNotesCount: "来自其他项目的{0}项未解决注释",

    deleteVersion: "删除版本",
    deleteVersionMessage: "选择一个版本以继续。",
    deleteVersionDisabledMessage: "仅项目管理员可从文档的源项目删除历史版本。",
    deleteVersionTitle: "删除文档版本",
    deleteVersionPlaceholder: "是否确认删除该历史版本？此操作无法撤销",

    childDocumentsCountLabel: "现有副本",
    childDocumentsModalTitle: "现有副本",
    childDocumentsModalDescription: "下列文档创建自源文件。",
    childDocumentsModalColumnDocumentName: "文档名称",
    childDocumentsModalColumnDocumentType: "文档类型",
    childDocumentsModalColumnRelatedTasks: "相关联任务",
    childDocumentsModalColumnSignoffs: "签署",

    bulkAddToEvidenceDescription1: "为显示为证据的文档新建副本，或选择现有副本（如有）。",
    bulkAddToEvidenceDescription2: "新创建的文档将会默认添加至与旧文档相关联的所有任务和Canvas表格中。使用“高级选项”手动选择与新文档建立关联的任务和Canvas表格。使用查找和替换功能替换新文档的部分名称（如：年份）；该功能可重复使用。",
    bulkAddToEvidenceDescription3: "如选择的是现有文档，则该文档只能添加至当前任务。如果只有一份现有文档，则该文档已被预先选择；否则请选择要添加的现有副本。",
    bulkAddToEvidenceAdvancedOn: "高级选项",
    bulkAddToEvidenceAdvancedOff: "关闭",
    bulkAddToEvidenceFindText: "查找内容",
    bulkAddToEvidenceFindTextRequired: "请输入有效的查找内容。",
    bulkAddToEvidenceReplaceWith: "替换为",
    bulkAddToEvidenceReplaceSuccess: "将{0}替换为{1}。",
    bulkAddToEvidenceUseExisting: "使用现有的",
    bulkAddToEvidenceCreateNew: "新建",
    bulkAddToEvidenceDocumentName: "文档名称",
    bulkAddToEvidenceExistingDocument: "现有文档",
    bulkAddToEvidenceSelectANewOrExistingCopy: "选择新副本或现有副本",
    bulkAddToEvidenceAssociateToTasks: "关联至任务",
    bulkAddToEvidenceAssociateToCanvasForms: "关联至Canvas表格",
    bulkAddToEvidenceOtherRelatedTasks: "其他关联任务",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "只有新创建的文档才能与任务关联。现有文档将自动关联至当前任务。",
    bulkAddToEvidenceSelectedTask: "{0}关联任务",
    bulkAddToEvidenceSelectedTasks: "{0}关联任务",
    bulkAddToEvidenceSelectedTasksPlaceholder: "没有关联任务",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "只有新创建的文档才能与Canvas表格关联。",
    bulkAddToEvidenceRelatedCanvasForms: "已关联Canvas表格",
    bulkAddToEvidenceSelectedForm: "{0}关联Canvas表格",
    bulkAddToEvidenceSelectedForms: "{0}关联Canvas表格",
    bulkAddToEvidenceSelectedFormsPlaceholder: "没有关联的Canvas表格",
    picRequiredValidation: "PIC必须签字的文档未关联至PIC任务",
    eqrRequiredValidation: "EQR必须签字的文档未关联至EQR任务",
    picEqrRequiredValidation: "PIC/EQR必须签字的文档未关联至PIC/EQR任务",

    viewSwitcherDefault: "默认视图",
    viewSwitcherEntity: "实体视图",
    viewSwitcherAllEntities: "所有实体",
    viewByEntities: "按实体查看",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "是否确定删除选定文档?",
    bulkDeleteFIlesModalMessageSub: "以下为无法删除的文档，这些文档不会被删除。",
    bulkDeleteModalLabel: "删除文档",
    bulkDeleteSuccessMessage: "文档删除成功",
    bulkDeleteValidDocumentsHeader: "将删除下列文档",
    bulkDeleteInvalidDocumentsHeader: "下列文档无法删除",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "调整下方已选定文档的负责人签字要求。部分签字要求是EY Canvas所要求，因此无法调整。",
    bulkSignOffRequirementsResultMessage: "已成功更新{0}个文档的签字要求",


    bulkOpenCountWarning: "选定文档数量超过允许的最大值。将仅打开第一个{0}",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "下列项目组尚未发送任何集团文档。",
    pendingEvidenceDueDate: "到期日",
    searchRegionComponentLabel: "搜索地区和组成部分",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "没有针对所选项目组成员的注释。",
    noUserSelected: "选择一个用户以查看详情.你无法为EY Canvas中的角色分配注释.",
    reviewNotesText: "复核附注",
    assigned: "已分配",
    authored: "已创作",
    overdue: "逾期",
    comingDue: "即将到期",
    cleared: "已清除",
    open: "未开始",
    closed: "已关闭",
    noTaskAssignedToUser: "没有分配给所选项目组成员或角色的任务。",
    preparer: "编制人",
    reviewer: "复核人",
    assignments: "工作分配",
    notStarted: "未开始",
    inProgress: "进行中",
    done: "完成",
    forUpcomingReview: "待进行的",
    noTaskOrNotesAssigned: "所选项目组成员或角色没有任务或注释。",
    fromTo: "从/至",

    /* Collaboration grid */
    overdueCollaboration: "逾期",
    comingDueCollaboration: "即将到期",

    /*Document Conflict*/
    documentConflict: "文档冲突",
    documentConflictModalConfirm: "保留此版本",
    documentConflictModalClose: "取消",
    documentConflictInstruction: "要解决冲突，请选择应保留的文档版本。",
    documentConflictMessage: "单击小组成员名字以只读模式打开此文件的先前版本。对该先前版本所做的任何更改都不会保存到EY Canvas。",
    lastmodifiedDate: "最后修改日期",
    modifiedBy: "修改人",
    documentConflictErrorMessage: "选择一个版本以继续。",
    currentVersion: "当前版本",
    documentConflictError: "文档冲突错误信息",
    documentConflictHeader: "该文件有冲突。",
    viewHistory: "查看历史",
    confirmButtonToolTip: "你必须拥有解决小组文档冲突的权限。请与项目管理员联系，请求获得执行此操作的权限。",
    documentHistoryHeader: "文件版本历史如下所示。",
    documentHistoryMessage: "单击小组成员名字以只读模式打开此文档的先前版本。对该先前版本所做的任何更改都不会保存到EY Canvas。",

    documentHistoryInstruction: "如果以前的版本应该是当前版本，请选择该版本并点击“更新版本”。",
    documentHistoryAdminInstruction: "如果不需要某个版本，选择该版本，点击“删除版本”。",

    documentHistoryModalConfirm: "更新版本",
    documentHistoryModalClose: "关闭",
    documentHistoryErrorMessage: "文档有冲突，请解决后再继续。",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "客户合作",
    nextwaveServices: "集中服务",
    receivedStatusLabel: "已接收",
    acceptedStatusLabel: "已接受",
    outstandingStatusLabel: "未解决",
    collaborationNonUsageMessage1: "使用合作直接在EY Canvas中将请求和外部任务发送给外部团队成员。要激活合作，请首先在EY Canvas Client Portal中登记你的客户。下一步，设置访问组。然后，创建请求和/或分配外部任务。点击",
    collaborationNonUsageMessage2: "就如何开始获取促进工具.",
    collaborationNonUsageMessageHyperlinkText: "此处",
    collaborationNonSentMessage1: "导航至",
    collaborationNonSentMessage2: "并发送初稿以开始.",
    collaborationNonSentMessageHyperlinkText: "合作",
    noBodies: "无主体",
    editResponse: "编辑应对措施",
    unsentDrafts: "未发送的草稿",
    unsentDraft: "未发送草稿",
    noUnsentDrafts: "无未发送的草稿",
    requestsSent: "已发送请求",
    nextWavetotalTasks: "总任务",
    comingDueTimeframe: "时间段",
    otherTimeframeDataAvailableMessage: "选择其他时间段以查看数据",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "项目指标",
    overdueColumnHeader: "逾期",
    comingDueColumnHeader: "即将到期",
    whatsNewColumnHeader: "新资讯",
    placeholderMessageNoContentInSpecifiedTimeframe: "选择其他时间段以查看数据",
    placeholderMessageNoEngagementMetrics: "您的项目没有可用的指标。",
    performanceMetrics: "绩效指标",
    reviewNotesAndAssignments: "复核注释和任务分配",
    /*Dashboard Engagement overview*/
    engagementOverview: "项目概况",
    engagementOverviewInstructionalText: "按照下列审计阶段查看项目进度。",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "里程碑",
    milestoneprogressSubHeader: "选择下方的审计阶段以按里程碑查看任务完成情况。若要按时间阶段查看任务完成情况，请选择<b>按时间阶段查看</b>。若要查看每个里程碑或时间阶段的详细进度，请选择<b>显示详请。</b>",
    tasksStatus: "任务状态",
    preparerAssignments: "编制人工作分配",
    reviewerAssignments: "复核人工作分配",
    openComments: "未解决注释",
    /* Dashboard Profile Page */
    groupAudit: "集团审计",
    groupStatus: "集团状态",
    viewInstructions: "查看指引",
    instructionsInstructionalText: "从主审小组收到如下指引，请点击链接查看。",
    noInstructionsAccepted: "尚未收到任何指引。",

    /* Dashboard SDM Summary */
    nextWaveservices: "集中服务",
    totalTasksLabel: "总任务",
    tasksUsingNextWaveservices: " 使用集中服务的任务",
    tasksSuggestedForNextwaveUse: " 建议使用集中服务的任务",
    outOf: "之外",
    tasksUsing: "任务使用",
    suggestedFor: "建议",
    nextwaveUse: "集中服务",
    draftRequests: "请求草稿",
    draftRequest: "请求草稿",
    createRequests: "创建请求",
    noRequestCreated: "没有已创建请求。创建并发送请求，然后开始。",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "改变优先事项等级",
    rnhBulkAssignPriorityTooltip: "优先事项",
    rnhBulkDueDateTooltip: "到期日",
    rnhBulkAssignPriorityModalHeader: "无法编辑所选的注释",
    rnhBulkAssignPriorityModalContent: "只能对未解决状态下注释的优先级进行更改。重新打开已清除或已关闭状态的注释，以改变其优先级。",
    rnhBulkAssignDueDateModalContent: "只能对未解决状态下注释的到期日进行更改。重新打开已清除或已关闭状态的注释，以改变其到期日。",
    rnhBulkAssignUserTooltip: "重新分配",
    rnhBulkAssignUserSearch: "搜索",
    rnhBulkAssignUserTitle: "无法编辑所选复核注释",
    rnhBulkAssignUserText: "只能对未解决状态的复核注释进行重新分配。重新打开已清除或已关闭状态的复核注释，以进行重新分配。",
    rnhBulkAssignStatusTooltip: "状态",
    rnhBulkAssignUserNoFound: "未找到结果",
    rnhBulkDueDatePlaceholder: "选择日期",
    rnhBulkDeleteTextCorrect: "是否确定删除选定的注释? 复核注释一旦删除，将无法恢复。",
    rnhBulkDeleteTextIncorrect: "只能删除状态为“已关闭”的注释。关闭状态为“打开”或“已清除”的注释，以便删除。",
    rhnBulkDeleteTitleCorrect: "删除所选注释",
    rhnBulkDeleteTitleIncorrect: "无法删除所选注释",
    rnhBulkDeleteTextIncorrectComment: "只能删除状态为“已关闭”的复核注释。关闭状态为“打开”或“已清除”的复核注释，以便删除。",
    rhnBulkDeleteDescriptionAuthorComment: "您只能删除已授权的注释。",
    rnhBulkDeleteEngagementComment: "是否确定删除选定的复核注释? 复核注释一旦删除，将无法恢复。",
    rhnBulkDeleteTitleCorrectEngagementComment: "删除所选注释",
    rhnBulkDeleteTitleCommentCloseStatus: "无法删除所选注释",


    fourFortyFilters: "筛选",
    fourFortySearch: "搜索",

    /* Add External Member Start*/
    addExternalModalTitle: "添加外部成员",
    accessGroupSelection: "访问组选项",
    noRecordinGroups: "未找到结果",
    permission: "权限",
    permissionProjectManagement: "项目管理",
    permissionProjectManagementDesc: "能够在EY CAnvas客户端门户中查看客户请求和外部任务的状态。该外部成员将不能访问客户请求和外部任务的详细信息。",
    permissionInfoTooltip: "所有权限列表",
    groupInfoTooltip: "组列表",
    groupRequired: "请选择组",
    firstnameRequired: "名字为必填项",
    lastnameRequired: "姓氏为必填项",
    initialsRequired: "首字母缩写为必填项",
    roleRequired: "项目职责为必填项",
    confidentialityRequired: "要求的机密水平",
    groupLabel: "访问组",
    firstnameLabel: "名字",
    lastnameLabel: "姓氏",
    initialsLabel: "首字母缩写",
    userinfo: "用户信息",
    userinfoDescription: "输入需要邀请的项目组成员的名字、姓氏或电子邮件地址，然后按回车。",
    inviteAndClose: "邀请并关闭",
    inviteAndAddOther: "邀请并添加其他",
    addAndClose: "邀请&关闭",
    addAndAddOther: "邀请并添加另一个",
    externalUserCreatedSuccessMessage: "你已成功添加",
    accessGroupSelectionMessage: "访问分组功能允许项目组管理外部项目组中可以查看发送到EY Canvas客户端的请求的人员。与您的客户就将有权访问EY Canvas客户端的访问分组和用户列表达成一致。当请求分配给属于该分组的外部用户时，该分组的每个成员都可以看到该请求。",
    accessGroupSectionMessage1: "将外部项目组成员添加到EY Canvas之前，这些成员必须先使用“我的安永”管理员门户进行注册。点击",
    accessGroupSectionMessage2: "访问“我的安永”管理员门户，然后开始。",
    accessGroupMessageHyperlinkText: "此处",
    accessGroupUserMessage1: "有关用户引导的更多信息，请点击以",
    accessGroupUserMessage2: "访问EY Atlas。",
    noRecordForExternalMember1: "无法找到邮件地址。",
    noRecordForExternalMember2: "确保外部项目小组成员已在“我的安永”注册。",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "编辑外部成员",
    editExternalaccessGroupSelection: "访问组选项",
    editExternalGroupInfoTooltip: "组列表",
    editExternalGroupLabel: "访问组",
    editExternalGroupRequired: "请选择组",
    editExternalNoRecordinGroups: "未找到结果",
    editExternalUserinfo: "用户信息",
    editExternalUserinfoDescription: "编辑名字、姓氏或首字母缩写。",
    editExternalEmailLabel: "邮件",
    editExternalFirstnameLabel: "名字",
    editExternalLastnameLabel: "姓氏",
    editExternalInitialsLabel: "首字母缩写",
    editExternalSaveLabel: "保存",
    editExternalUsersSuccessMessage: "对{0} {1}的更改已成功保存",
    editExternalUsersCloseLabel: "关闭",

    /* Edit External Member End*/



    /*access group*/
    groupName: "集团名称",
    groupNameHelp: "必须输入名称才能创建访问组。",
    groupNameHelpOnEdit: "名称是必需的",
    groupNameReq: "集团名称为必填项",
    groupNameInvalidCharacter: "无效字符",
    grpDomainManage: "管理域名",
    grpDomainHelp: "域名限制了可以添加到该访问组的用户。创建一个访问组至少需要一个域名。域名指 @ 符号后的字符。使用 * 表示通配符（例如，*.ey.com）。",
    btnAddNewDomain: "添加新域名",
    btnAddExistingDomain: "添加现有域名",
    domainValidation01: "至少需要一个有效的域名",
    domainValidation02: "选择一个域名",
    domainValidation03: "复式记账",
    domainValidation04: "无效域名",
    domainValidation05: "域名为必填项",
    domainName: "域名",
    emailDomain: "邮箱域名",
    groupDeletionErrorPendingReqMsg: "删除访问组时出错。确保没有分配给该组或该组成员的请求/外部任务，然后重试",
    groupDeletionSuccessMsg: "{0}已成功删除。所有活动成员均已停用。",

    /* uncommon values for internal mem */
    editInternalMember: "编辑内部成员",
    editThirdPartyMember: "编辑第三方成员",
    listOfAllPerm: "所有权限列表",
    internalPermiInviteExt: "邀请内部成员",
    internalPermiInviteInt: "邀请外部成员",
    internalPermiAssignPer: "分配权限",
    internalPermiDeleteEng: "删除项目",
    internalPermiArchEng: "归档项目",
    internalPermiUpdateContet: "更新内容",

    internalPermiInviteExtToolTp: "能够邀请内部项目组成员参与项目",
    internalPermiInviteIntToolTp: "能够邀请外部项目组成员参与项目",
    internalPermiAssignPerToolTp: "能够将这些权限分配给内部和外部项目组成员",
    internalPermiDeleteEngToolTp: "能够删除项目",
    internalPermiArchEngToolTp: "能够归档项目",
    internalPermiUpdateContetToolTp: "能够编辑个人资料并接受内容更新",
    internalMemberInviteSuccessMessage: "你已成功向{0} {1}发出邀请。",
    internalMemberPostArchivalAdditionSuccessMessage: "你已成功添加{0} {1}",
    invitePriorPeriodUsersSuccessMessage: "您已成功向非活跃用户发送邀请",
    editInternalUsersSuccessMessage: "你对{0} {1}的更改已成功保存",
    rbacErrorEditUser: "当前无法保存更改。请重试，如果问题持续，请联系帮助台。",
    universalQueueErrorEditUser: "EY Canvas登陆页面目前无法访问，需要进行编辑。请重试，如果问题持续，请联系帮助台",
    removeExternalUsersSuccessMessage: "{0}{1}已成功删除。",
    reActivateExternalUsersSuccessMessage: "{0}{1}已在以下访问组中重新激活：{2}",

    /*user search component*/
    seachInputRequired: "搜索必填的输入项",
    nameOrEmail: "名称或电子邮箱",
    emailForExternal: "电子邮件",
    noRecord: "未找到结果",
    userSearchPlaceholder: "输入姓名或电子邮件，然后按回车键查看结果。",
    userSearchPlaceholderForExternal: "输入电子邮件，然后按回车键查看结果。",
    clearAllValues: "清除所有值",
    inValidEmail: "请输入有效的电子邮件",

    maxLengthForEditResponse: "包括多格式文本格式标签在内，最大字符数不超过3万个。移除不必要格式并再次尝试",
    clickEditResponseToContinue: "单击编辑应对措施以继续",
    bodyDescriptionFromKnowledge: "来自知识库的主体描述",
    execution: "执行",
    cannotpasteimages: "无法粘贴图片",
    pastingImagesNotAllowed: "不允许粘贴图片。如果需要图片，请作为证据上传并引用。",
    saveResponse: "有未保存的更改，要继续吗?",
    conclusion: "结论",
    referenceDocsPlaceHolder: "在此处添加以快速打开频繁访问的文档",
    referenceDocsTeamPlaceHolder: "此项目中未添加任何审计小组参考文档。点击“添加文档”开始。",
    referenceDocsMyPlaceHolder: "您尚未添加任何索引文档。单击“添加文档”开始。",
    teamDocuments: "固定的项目组",
    myDocuments: "我固定的项目组",
    teamDocumentsModalTitle: "团队文档",
    myDocumentsModalTitle: "我的文档",
    referenceDocuments: "项目组收藏",

    /* PinnedDocument  */
    PinnedDocument: "已固定文档",
    PinnedDocumentSubTite: "将经常访问文档固定到下方，创建一份您或您的项目组经常访问文档列表。您可点击<b>添加文档</b>来修改该列表。",
    PinnedDocPaceholder: "您尚未固定任何文档。<br> 点击<b>添加文档</b>将文档固定至此处。",
    PinnedTeamDocPlaceholder: "您的项目组尚未固定任何文档。<br> 点击<b>添加文档</b>以将文档固定至此处。",
    PinnedDocAddDocHeaderText: "选择证据和临时文件，定制固定文档列表。",
    onlyShowPinnedDocuments: "仅显示已固定文档",
    pinned: "已固定",
    /* Arc Timeline */
    arcTitle: "归档核对表",
    arcCompleted: "已完成",
    arcSubmit: "提交归档",
    arcDescription: "完成清单上的所有项目以存档此项目",
    invalidEngagementCode: "无效项目代码",
    invalidClientCode: "无效客户代码",
    arcCheckBox: "存档越权",
    arcUnlinkEvidenceButtonText: "删除所有链接",
    arcUnlinkEvidenceModalTitle: "删除所有共享证据的链接",
    arcUnlinkEvidenceModalText: "你确定要删除此项目中的所有共享证据与该工作空间中的其他工作的链接吗？完成此操作后，将无法撤消。",
    arcUnlinkEvidenceModalConfirmButton: "删除所有链接",
    arcUnlinkEvidenceModalCancelButton: "取消",
    arcUnlinkEvidenceButtonUnlinkInProgress: "删除链接中",
    arcUnlinkEvidenceButtonUnlinkError: "删除链接错误",
    arcUnlinkGroupEngagementButtonText: "从项目组删除链接",
    arcUnlinkGroupEngagementModalTitle: "从项目组删除该项目链接",
    arcUnlinkGroupEngagementModalText: "你确定要删除此项目与该工作区域中的其他项目的链接吗？完成此操作后，将无法撤消。",
    arcUnlinkGroupEngagementModalConfirmButton: "删除链接",
    arcUnlinkGroupEngagementModalCancelButton: "取消",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "删除链接中",
    arcModalTitle: "现有的存档记录中心（ARC）记录",
    arcProceedWithArchive: "继续存档",
    arcModalBodyText: "您正试图存档已恢复的项目文件。此文件已存在于存档记录中心（ARC）中。是否确认继续？",
    noDataAvailabel: "目前没有可用的数据。请刷新页面并重试。如果错误持续存在，请联系帮助台。",
    reportDateBeforeCurrentDate: "项目报告日期须为当前日期或更早日期。更新报告日期以继续。单击确认关键项目日期的准确性链接，以更新报告日期。",

    /*Helix Projects*/
    linkedProjects: "关联项目",
    suggestedAnalyzers: "建议的分析工具",
    linkSelected: "选定的链接",
    noLinkedProjectsAvailable: "没有关联的项目",
    helixProjectTitle: "EY Helix项目",
    findProjects: "发现项目",
    findProjectsModalTitle: "查找EY Helix项目",
    selectProjectsToLink: "在下方选择一个或多个EY Helix项目，与Canvas项目建立链接。你可以按客户代码手动搜索，以查找其他EY Helix项目。",
    newSearch: "新搜索",
    noResultsFound: "未找到结果",
    enterClientCode: "输入客户代码以再次搜索。",
    enterClientCodeToDisplayAnalizers: "输入客户代码以显示可用分析工具列表。",
    defaultClientCodeIsInvalid: "此项目默认客户代码 {0} 无效。输入有效客户代码以显示可用分析工具列表。",
    mirrorCodesNotAccepted: "注意：不接受镜像编码。",
    helixProjectSearch: "搜索",
    helixProjectsSearchPlaceholderText: "输入客户代码进行搜索",
    helixWizardProjectsSearchPlaceholderText: "按客户代码搜索分析工具",
    selectOneOrMoreProjects: "从列表中选择一个或多个Helix项目进行链接",
    noPermissionLabel: "您必须具有存档权限才能将此项目提交存档",
    linkProject: "关联项目",
    oneAnalyzerMustBeSelected: "必须选择一个分析工具。",
    selectAnAnalyzer: "选择分析工具",
    selectOneAnalyzer: "选择下方EY Helix分析工具，以创建EY Canvas项目链接。您可以通过客户代码手动搜索，以查找EY Helix项目和相关分析工具。",
    selectAnalyzerModalTitle: "选择分析工具用于",
    selectAnalyzerModalBodyText: "选择EY Helix分析工具，以与您的EY Canvas项目进行关联",
    selectAnalyzerModalSubmitButtonLabel: "关联项目",
    projectCanNotBeLikedTootip: "此EY Helix项目不可用，因为其位置与EY Canvas项目的位置不匹配。",
    unlinkProjectConfirmationModalTitle: "警告-取消链接项目",
    unlinkProjectConfirmationModalBodyText: "正在取消链接的EY Helix分析工具具有与此项目关联的客户书签。取消链接此分析工具将导致这些书签不再可用。此操作无法撤消。是否要继续？",
    defineConnectionSettings: "定义连接设置",

    helixConnectionPageTitle: "EY Helix关联",
    helixConnectionPageSubtitle: "已关联EY Helix分析工具、其导入的数据以及已匹配到安永账户的总账账户百分比。点击匹配的百分比以调整匹配。关联和导入数据的匹配百分比可能不同。例如，如果匹配发生在导入之后。请重新导入数据以获取最新的匹配。",
    helixIntegrationPageNoConnectedAnalyzerLabel: "未关联的分析工具",
    helixIntegrationPageTitle: "EY Helix整合",
    helixIntegrationPageSubtitle: "将一个或多个EY Helix分析工具与EY Canvas项目关联。",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "无相关分析工具。若要关联新分析工具，",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " 请单击此处。",
    helixIntegrationPageColumnConnectionName: "连接名称",
    helixIntegrationPageColumnConnectionType: "连接类型",
    helixIntegrationPageColumnAnalysisPeriod: "分析日期",
    helixIntegrationPageColumnAnalyzerName: "EY Helix分析工具名称",
    helixIntegrationPageColumnLastConnectedBy: "上次连接人员",
    connectAnalyzer: "关联分析工具",
    dataImportModalTitle: "导入确认",
    dataImportModalBodyLabel: "此项目中已存在“范围和策略”导入数据。每个项目仅允许导入一份“范围和策略”数据。如导入此数据，当前的“范围和策略”导入数据将被替换。是否继续？此操作无法撤销。",
    dataImportModalBodyLabelMest: "已存在此实体的“范围和策略”导入数据。每个实体仅允许有一个“范围和策略”导入数据。导入此数据将替换现有的“范围和策略”导入数据。是否继续？此操作无法撤销。",
    dataImportModalCancelButtonLabel: "取消",
    dataImportModalCloseButtonLabel: "关闭",
    dataImportModalConfirmButtonLabel: "导入",
    dataImportModalImportError: "发生与关联的EY Helix分析工具相关的错误。数据无法导入。请刷新页面并重试。如问题仍然存在，请联系帮助台。",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "安永Helix项目",
    helixProjectPageSubtitle: "链接与此EY Canvas项目相关的EY Helix项目。当链接多个EY Helix项目时，请将一个项目选为主项目，以便将数据整合到EY Canvas中。只有主项目可以整合到EY Canvas中，因此，该项目必须包含与项目相关日期的所有记账分录活动。",
    helixProjectPageNoHelixProjectLinkedLabel1: "目前没有与该项目关联的EY Helix项目。",
    helixProjectPageNoHelixProjectLinkedLabel2: "添加新的EY Helix项目",
    helixProjectPageNoHelixProjectLinkedLabel3: " 然后开始。",
    helixProjectPageNoHelixProjectLinkedLabel4: "点击",
    linkToHelixProject: "在EY Helix打开",
    addNewEYHelixProject: "添加新的EY Helix项目",
    eyHelixSetup: "整合EY Helix数据",
    existingConnectionDetectedModalTitle: "检测到现有连接",
    existingConnectionDetectedDescription: "所选分析工具之前已连接到此EY Canvas项目。您可以创建新连接，也可以在下方选择现有连接。",
    selectExistingConnection: "选择现有连接",
    selectCreateNewConnection: "创建新连接",
    connectionNoRecords: "未找到连接",
    selectOneOfTheOptionsToProceed: "选择其中一个选项，继续下一步。",
    saveHelixProjectErrorMessage: "无法保存所选分析工具。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    noResultFoundForAnalyzerSelection: "请确保您要搜索的分析工具处于有效状态，并且您已被授予访问该分析工具的权限。有关详细信息，请联系EY Helix管理员。输入客户代码重新搜索。",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "连接",
    reConnectButtonLabel: "重新连接",
    demoteFromFinancialStatementsOptionLabel: "从财务报表中降级",
    promoteToFinancialStatementsOptionLabel: "升级至财务报表中",
    deleteOptionLabel: "删除",
    projectAndAnalyzerDetailsSectionTitle: "项目和分析工具详细信息",
    projectNameLabel: "项目名称",
    clientCodeLabel: "客户代码",
    analyzerNameLabel: "分析工具名称",
    periodEndDateLabel: "日期结束日期",
    analysisDateLabel: "分析日期",
    lastConnectedByLabel: "上次连接操作人",
    connectionSettingsSectionTitle: "连接设置",
    connectionTypesLabel: "连接类型",
    currencyTypeLabel: "货币类型",
    currencyLabel: "货币",
    currencyCodeLabel: "货币代码",
    businessUnitsLabel: "业务单元",
    entitiesLabel: "实体",
    analysisPeriodLabel: "分析日期",
    comparativePeriod1Label: "比较日期1",
    comparativePeriod2Label: "比较日期2",
    manageAccountMappingSectionTitle: "管理账户匹配",
    manageAccountMappingButtonLabel: "管理账户匹配",
    mappedGLAccountsLabel: "总账账户匹配百分比：",
    updateSettingsButtonLabel: "更新设置",
    deleteConnection: "删除关联",
    deleteConnectionQuestion: "是否确实要删除所选关联？与此关联相关的所有以前集成的数据都将被删除。此操作无法撤销。",
    deleteConnectionWithAnalyticsQuestion: "是否确实要删除所选关联？与此关联相关的所有以前集成的数据都将被删除。此外，所选关联具有与此项目关联的客户书签。删除关联将导致这些书签不再可用。此操作无法撤销。",

    /*Helix Projects Table*/
    tableShowing: "显示以下对象搜索结果：",
    tableClientCode: "客户编码",
    tableEngagementCode: "项目代码",
    tableEngagementCodeName: "项目名称",
    tableProjectID: "项目ID",
    tableProjectName: "项目名称",
    tableAnalyzerName: "分析工具名称",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "结束日期",
    tableAnalysisDate: "分析日期",
    tableEYHelixAnalysisDate: "分析日期",
    tableAssignedPartner: "指定合伙人",
    tableProjectLinked: "已关联项目",
    tableTooltipAnalizerIsDeleted: "分析工具已在EY Helix中删除。若要永久删除连接，点击以打开详细信息抽屉。请考虑是否应连接其他分析工具。",
    tableTooltipAnalizerIsUnavailable: "EY Helix中无法使用分析工具。有关详细信息，请联系EY Helix管理员。若要永久删除连接，点击以打开详细信息抽屉。请考虑是否应连接其他分析工具。",
    tableTooltipNotValidUser: "您不是所选分析工具的授权项目组成员。请联系EY Helix项目管理员以获取访问权限，然后重试。",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "关联",
    cardAnalyzerHelixLabel: "EY Helix分析工具",
    cardAnalyzerMappedGLAccountsLabel: "已匹配总账账户",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "管理账户匹配",
    cardAnalyzerSectionScopeAndStrategy: "范围和策略",
    cardAnalyzerSectionFinancialStatements: "财务报表",
    cardAnalyzerSectionButtonLink: "此处",
    cardAnalyzerSectionButtonDisconnect: "断开分析工具关联",
	cardAnalyzerSectionScopeAndStrategyNoBalance: "范围和策略数据用于列报范围和策略活动中的余额，例如重要性水平。点击{0}导入范围和策略数据。",
    cardAnalyzerSectionFinancialStatementsNoBalance: "您可以在EY Canvas导入财务报表，以将财务报表的向下钻取提供至EY Canvas项目中已执行工作的位置。点击{0}导入财务报表。",
    cardAnalyzerSectionAnotherAnalyzerType: "关联该分析工具是为了方便EY Canvas、EY Helix和/或安永智能抽样工具之间的整合。点击{0}可断开此分析工具的关联。",
    cardAnalyzerSectionButtonLinkDisableTooltip: "您不是所链接分析工具的授权项目组成员。请联系EY Helix项目管理员获取访问权限。",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: "您没有导入此数据所需的权限。请确保您拥有在此Canvas项目中“导入EY Helix数据”的权限，然后重试。",
    cardAnalyzerTrialBalanceAnalisysPeriod: "分析日期",
    cardAnalyzerTrialBalanceComparativePeriod: "比较日期",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "第二个比较日",
    cardAnalyzerTrialBalanceLastImportDate: "上次导入日期",
    cardAnalyzerTrialBalanceCurrency: "货币",
    cardAnalyzerTrialBalanceBusinessUnits: "业务单元",
    cardAnalyzerTrialBalanceMapedGLAccounts: "已映射总账账户",
    cardAnalyzerTrialBalanceImportStatus: "导入状态",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "记账本位币",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "报告货币",
    cardAnalyzerTrialBalanceImportData: "导入数据",
    cardAnalyzerTrialBalanceAdjustmentModule: "调整模块",
    cardAnalyzerTrialBalanceReImport: "重新导入",
    cardAnalyzerTrialBalanceRemove: "移除",
    cardAnalyzerTrialBalanceImportStatusInProgress: "进行中",
    cardAnalyzerTrialBalanceImportStatusImported: "已导入",
    cardAnalyzerTrialBalanceImportStatusError: "错误",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "已断开关联",
    cardAnalyzerTrialBalanceImportModalTitle: "导入数据",
    cardAnalyzerTrialBalanceImportModalDescription: "选择导入属性，点击“导入”进行导入",
    cardAnalyzerTrialBalanceImportModalButton: "导入",
    cardAnalyzerTrialBalanceReImportModalTitle: "重新导入数据",
    cardAnalyzerTrialBalanceReImportModalDescription: "选择导入的属性，然后点击“重新导入”以重新导入。",
    cardAnalyzerTrialBalanceReImportModalButton: "重新导入",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "导入正在进行中。该过程可能需要几分钟的时间。",
    cardAnalyzerTrialBalanceImportEntityTooltip: "无法在重新导入期间更改实体。请创建新导入以选择其他实体。",
    cardAnalyzerTrialBalanceImportMestEntity: "此选择是在上一步骤中进行的。如想编辑，必须返回到上一步。",
    cardAnalyzerTrialBalanceMestBusinessUnit: "该选择基于以上实体完成。如想编辑实体与业务单元的关系，请访问相关汇总页面上的“实体映射”。",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "首先选择“货币类型”以启用此字段。",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "首先选择“货币”以启用此字段。",

    /*Helis Linked Projects Cards*/
    analysisDate: "分析日期：",
    unlinkProject: "取消链接项目",
    editAnalyzer: "编辑分析工具",
    deleteProject: "删除项目",
    projectDeleted: "项目已删除。",
    loadingProjectDataLinked: "从EY Helix加载数据",
    projectMarkPrimaryConfirmationHeader: "更改EY Helix主要项目",
    projectMarkPrimaryConfirmationMsg: "是否确定更改EY Helix主要项目？",
    projectPrimaryEYHexliProject: "EY Helix主要项目",
    helixProjectUnlink: "取消关联",
    helixProjectDelete: "删除",
    analyzersLabel: "分析工具：",


    /*Helix Import List*/
    importHelixList: "Helix导入列表",
    importDocumentName: "文档名称",
    importDocumentID: "文档ID",
    importFileSize: "文件大小（KB）",
    importDownload: "下载",
    importNoRecords: "未找到文档",
    importInvalidDocumentID: "文档ID的搜索条件为全字匹配。请确保您填入的为完整的文档ID",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "客户：",
    addConnectionNameLabel: "添加关联名称",
    connectionNamePlaceholder: "关联名称",
    connectionNameRequired: "必填",
    connectAnalyzerModalTitle: "关联分析工具",
    connectAnalyzerDescription: "请选择下方的分析工具，以创建其与此EY Canvas项目的关联。按客户代码搜索，以查找EY Helix项目和相关分析工具。",
    analyzerLocationIncompatibleErrorMessage: "无法关联分析工具，因为分析工具的数据存储位置与EY Canvas项目的位置不兼容。",
    analyzerMaxConnectionReachedErrorMessage: "所选分析工具关联数已达上限。请选择另一个分析工具以继续。",
    helixAnalyzerErrorMessage: "关联EY Helix分析工具时出错。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    helixAnalyzerGLAConnectionErrorMessage: "关联到EY Helix分析工具以获取映射的账户数量时出现一个或多个错误。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    helixReImportErrorMessage: "从EY Helix导入数据时出错。请刷新页面并重试。如问题仍然存在，请联系帮助台。",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "选择实体",
    noEntitiesMappedToBusiness: "没有实体映射到业务单元。",
    noEntitiesMappedToBusinessFirst: "点击",
    noEntitiesMappedToBusinessLink: "此处",
    noEntitiesMappedToBusinessLinkText: " 然后开始。",
    searchEntityPlaceholder: "搜索实体",
    entityListHeader: "实体",
    selectEntityErrorMessage: "选择一个实体然后继续。",
    entityAlreadyConnectedToScopeAndStrategy: "已存在此实体的“范围和策略”导入数据。每个实体仅允许有一个“范围和策略”导入数据。删除现有导入以启用此选择。",
    selectEntityNoEntitiesFound: "未找到结果",
    selectEntityModalDescription: "选择要为其导入数据的实体。",

    /*Manage Account Mapping*/
    manageAccountMapping: "管理账户匹配",
    manageAccountMappingErrorMessage: "无法关联至EY Helix。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    helixViewerLoader: "正在加载Helix查看器……",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "删除导入数据",
    removeImportRemoveButtonLabel: "删除",
    removeImportDescription: "是否确认删除以下导入数据？",
    removeImportActionUndoneDescription1: "是否确认删除以下导入数据？",
    removeImportActionUndoneDescription2: "此操作无法撤销。",
    removeImportErrorMessage: "您打开此界面后，导入的数据发生变动。如想继续删除，请刷新页面然后重试。",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "断开分析工具的关联",
    disconnectAnalyzerDisconnectButtonLabel: "断开关联",
    disconnectAnalyzerDescription: "是否确定断开与选定分析工具的关联?",
    disconnectAnalyzerImportsExistErrorMessage: "您打开此界面后，已向该关联导入数据。只有删除所有关联的导入数据，才能断开关联。请刷新页面并重试。",

    /*Content Update */
    quote: '"',
    performContentUpdate: "执行内容更新",
    contentupdate: "内容更新",
    btnContentUpdate: "更新",
    btnContentUpdateSelected: "更新",
    updateSuccessMessage: "已提交内容更新",
    msgContentUpdate: "选择下面的一个或多个类别以更新内容。如果已经完成了大量工作，请与项目管理人员讨论内容更新是否合适。无法撤消内容更新。",
    msgIndependance: "更新独立性可能导致需要再次完成的独立性确认。",
    msgProfile: "更新配置文档可能对项目内容产生重大影响。在提交新的配置文档之前，用户可能失去对项目的访问权限。此操作无法撤销。",
    msgHistoryContentUpdate: "以前进行的内容更新及其状态。",
    msgWarningTitle: "警告",
    btnProceedContentUpdate: "继续",
    btnCancelContentUpdate: "取消",
    confirmationMessageP1: "你将完成选定内容类别的内容更新。选定",
    confirmationMessageP2: "继续或选定",
    confirmationMessageP3: "如果你不希望此时完成内容更新。",
    warningMessage: "必须选定一种或多种内容类型进行更新",
    groupReportingFormsSent: "分组报告<b>表格已发送</b>",
    groupReportingFromStatus: "集团报告表格状态",
    primaryTeamReviewStatus: "主审小组复核状态",
    reportingStatus: "报告状态",
    taskStatusLabel: "任务状态",
    primaryTeam: "主审小组",
    componentTeam: "组成部分审计小组",
    groupTasksReceived: "集团审计<b>已收到任务</b>",
    group: "集团",
    regionalTeam: "地区小组",
    unlinkedLabel: "删除链接",
    linkedLabel: "已关联",
    unlinkedTasks: "<b>未关联任务</b>",
    unlinkedTask: "<b>未关联任务</b>",
    primaryTeamGroupTaskPlaceholder: "在此处创建组成部分并发送集团指引以监控进度。",
    componentTeamGroupTaskPlaceholder: "承接主要审计小组的组成部分集团任务，以在此处查看进程汇总。",
    confirmUpdateMessage1: "更新这些表格可能会对内容产生重大影响。更新开始后，暂无法对内容进行其他更新，直至更新完成。",
    confirmUpdateMessage2: "请选择“下一步”继续更新。如不希望此时完成内容更新，请选择“取消”。",
    updateSelectedTitle: "更新所选批注",
    statusCodeForbidden: 403,
    pspAccountHeader: "账户",
    pspAccountDateHeader: "内容日期",
    pspAccountStatus: "状态",
    pspAccountSelected: "已选定",

    /*Preapre for Arc*/
    YearEndDate: "年末日期：",
    PeriodEndDate: "涵盖期间结束日：",
    ReportDate: "报告日：",
    ArcDeadlineDate: "存档截止日：",
    ClientCode: "客户编码",
    PrimaryEngCode: "主要项目代码：",
    SecondaryEngCode: "次要项目代码：",
    ReportType: "报告是否在任何方面有所保留和/或是否有强调事项?:",
    ProtectedDocuments: "注：受保护的文档不应保留在项目文件中，除非确有必要",
    noObjectsAvailable: "无可用目标",
    CurrentlyUnavailable: "当前不可用",
    showMoreToggle: "显示更多",
    showLessToggle: "显示减少",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>没有可用的文档<br/>―<br/>您可以拖放一个或多个文档，也可以点击<button class="motif-button motif-text-alt-button motif-button-small">添加临时文档</button></center>',
    uploadEvidencePlaceholder: "拖放一个或多个文件或者点击<a>添加证据</a>",
    uploadTemporaryPlaceholder: "拖放一个或多个文件或者点击<a>添加临时文件</a>",

    processing: "处理中",
    uploading: "上传中",
    uploadComplete: "处理中",
    downloading: "下载",
    downloadComplete: "下载完成",
    loading: "正在加载",

    //#region Filter

    filter: "筛选",
    noFiltersAvailable: "没有可用的筛选工具",
    pickADate: "选择日期",
    filterYes: "是",
    filterNo: "否",

    //#region Document list filters
    filterGroupDocumentsLabel: "文档记录",
    filterDocumentContentLabel: "文档内容",
    filterSharedEvidenceLabel: "共享证据",
    filterFileExtensionLabel: "文件扩展名",
    filterDocumentConflictLabel: "冲突",
    filterDuplicateFileNameLabel: "重复文件名称",
    filterCanvasFormsLabel: "Canvas表格",

    filterGroupModificationsLabel: "修改",
    filterLastModifyUserLabel: "最后修改者",
    filterModifyAfterReviwerSignoffLabel: "自复核人签署以来已修改",
    filterModifiedAfterLabel: "修改后",

    filterGroupReviewNotesLabel: "复核注释",
    filterReviewNoteStatusLabel: "状态",
    filterReviewNoteAssignedToLabel: "被分配人",
    filterReviewNoteAuthoredByLabel: "编辑人",
    filterReviewNoteOtherEngagementLabel: "来自其他项目",

    filterGroupSignOffsLabel: "签署",
    filterSignOffMissingLabel: "缺少签名",
    filterSignedOffByUserLabel: "签署者",
    filterNotSignedOffByUserLabel: "尚未签署",
    filterSignOffRequirementsLabel: "签署要求",

    filterGroupOtherLabel: "其他",
    documentLink: "文档链接",
    filterByCopyLinkDocument: "按复制链接文档筛选",
    filterGroupAuditComponentLabel: "地区/组成部分项目小组",
    noGroupAuditComponents: "未创建组成部分",
    filterFindingsLabel: "发现",
    filterGroupInstruction: "集团指引",
    noGroupInstruction: "尚未创建指引",

    documentSearchPlaceholderLabel: "搜索文档",
    analyticSearchPlaceholderLabel: "搜索分析工具",
    //#endregion

    //#endregion

    pendingResponseLabel: "待回应",
    receivedLabel: "已接收",
    dueToPrimaryTeam: "应发送至主审小组",
    sentToPrimaryTeam: "已发送至主审小组",
    documentationPending: "待完成文档记录",
    documentationComplete: "已完成文档记录",
    viewBytimephaseTextLabel: "按时间段查看",
    showDetails: "显示详情",
    referenceDocAddDocHeaderText: "将相关证据或临时文档关联起来，以便从指示板进行访问。",
    addDocsToTeam: "添加文档至项目组文档",
    addDocsToMy: "添加文档至我的文档",
    addDocument: "添加文档",
    externalUserRemove: "移除",

    // Internal user roles abbr
    adminRole: "管理员",
    readOnlyRoleForThirdPartyUser: "只读",
    legacy: "不受限制",
    permissionLabel: "权限",
    displayPermissionErrorText: "当前无法显示权限。请重试，如果问题持续，请联系帮助台。",
    onlyShowRelatedTasks: "仅显示相关任务",

    softwareUpdate: "软件更新",
    updateNow: "立即更新",
    updateMsg: "EY Canvas的软件更新已可供随时操作使用。现在选择立即更新，下载并安装更新。页面将被刷新。",

    processingError: "处理错误",

    //Create tag modal labels
    createtags: "创建多个标签",
    reportDate: "报告日期：",
    managetags: "管理标签",
    savechanges: "保存变更",
    manageTagGroupCreate: "创建",
    manageTagGroupDiscard: "丢弃",
    manageTagGroupCreateTooltip: "标签组",
    deletetag: "删除标签",
    deletetaggroup: "删除标签组",
    createTagGroup: "创建标签组",
    manageTagGroupName: "标签组",
    countOftasksAssigned: "已分配任务数量",
    createTagGroupMessage: "创建标记组和标记以开始。单击 {0} 创建标记组。",
    tagsContnetSearchPlaceholder: "搜索标签",
    deleteTagHoverText: "一旦保存，任何被删除的标签或标签组都无法恢复。",
    deleteTagGroupHoverText: "此标签将从您的项目中的所有任务中移除。",
    tagSaveChangesInfoText: "该组中的所有标签将被删除，并从您项目的所有任务中移除。",
    tagConfirmModalTitleText: "一旦保存，就会申请更改。",
    tagConfirmModalPrimaryMessage: "是否确认要保存这些变更？",
    tagConfirmModalSecondaryMessage: "您确定要保存这些更改吗？",
    tagDeleteModalSecondaryMessage: "保存后，已删除的标签不可恢复。",
    createNewTag: "创建新标签",
    tagWillBeRemovedFromRequests: "将从你项目的所有请求中删除此标签。",
    eyTags: "安永标签",
    clientTags: "客户标签",
    allTags: "所有标签",
    // Add canvas form
    addCanvasForm: "添加Canvas表格",
    addCanvasFormName: "文档名称",
    addCanvasFormNameBlankMessage: "文档名称是必填字段",
	addCanvasFormNameInvalidCharacterMessage: '名称不能包含以下任一字符：*/:<br>\\?|”',
    addCanvasFormDigital: "数字化",
    addCanvasFormCore: "核心",
    addCanvasFormNonComplex: "非复杂",
    addCanvasFormComplex: "复杂",
    addCanvasFormListed: "已上市",
    addCanvasFormGroupAudit: "集团审计",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "准则",
    addCanvasFormStandardsNotSelectedMessage: "准则为必填项",
    addCanvasFormLanguage: "语言",
    addCanvasFormLanguageNotSelectedMessage: "语言为必填项",
    addCanvasFormNoResultFound: "未找到结果",
    addCanvasFormManageTasks: "管理任务",
    addCanvasFormAvailableTasks: "任务名称",
    addCanvasFormAvailableTaskType: "类型",
    addCanvasFormTypeOfForm: "表格类型",
    addCanvasFormSubServiceLine: "子业务线",
    addCanvasFormTypeOfFormNotSelectedMessage: "表格类型为必填项",
    addCanvasFormSelectedTasks: "选定的任务",
	addCanvasFormNoTaskDataAvailable: "没有选定任务。选择至少一个任务来创建一个表格.",
    addCanvasFormCreateForm: "创建表格",
    addCanvasFormCancel: "取消",
    addCanvasFormSuccessMessage: "{0}已成功创建。交付该内容需要10分钟。",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "管理{0}",
    addCanvasFormAvailableObjects: "{0}名称 //",
    addCanvasFormSelectedObjects: "已选定{0}",
    addCanvasFormClickHereToOpenManageTab: "点击此处，打开管理{0}标签页",
    addCanvasFormNoObjectsDataAvailableRequired: "未选中{0} 。选中至少一个，创建表格",
	addCanvasFormNoObjectsDataAvailableOptional: "未选中{0}.",
    addCanvasFormObjectNotDefinedMessage: "对于本表格，无可用的对象",
    addCanvasFormOptional: "（可选）",
    addCanvasFormObjects: "对象",
    addCanvasFormObject: "对象",
    addCanvasFormSCOT: "重大交易类别",
    addCanvasFormSCOTs: "重大交易类别",
    addCanvasFormITProcess: "IT流程",
    addCanvasFormITProcesses: "IT流程",
    addCanvasFormControl: "控制",
    addCanvasFormControls: "控制",
    addCanvasFormITControl: "IT控制",
    addCanvasFormITControls: "IT控制",
    addCanvasFormITApplication: "IT应用程序",
    addCanvasFormITApplications: "IT应用程序",
    addCanvasFormSignoffRequirements: "需要的签字：",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "IT流程和相关ITGC/ITSP",
    taskTitle: "了解并记录IT流程：{0}",
    taskDescription: "记录我们对IT流程的了解。附上用于支持我们对IT流程的了解的证据的相关表格。<br>当任务属性中出现IT一般控制（ITGC）时，对ITGC执行穿行测试程序，以确认我们对ITGC的了解和评估其设计与实施情况。附上我们执行穿行测试程序的证据。",
    addCanvasFormAccounts: "账户",
    addCanvasFormAccount: "账户",
    addCanvasFormErrorMessage: "本表格只能关联一个账户",
    addCanvasFormValidationMessage: "必须选择一项",
    addCanvasFormEstimates: "估计",
    addCanvasFormEstimate: "估计",
    addEstimateCanvasFormErrorMessage: "本表格只能关联至一个估计",
    addControlCanvasFormErrorMessage: "本表格只能关联一个控制",
    addScotCanvasFormErrorMessage: "本表格只能关联一个重大交易类别",

    //Independence Confirmation
    sortOrderIndependence: "排序",
    confirmationStatus: "确认状态",
    confirmationDate: "确认日期",
    independenceConfirmationSearch: "搜索项目成员",
    editTemplate: "编辑模板",
    viewTemplate: "查看模板",
    confirmedBy: "经确认",
    overriddenBy: "被覆盖",
    grantedBy: "访问授权人",
    deniedBy: "访问拒绝人",
    list: "列表",
    paginationShow: "显示",
    options: "选项",
    removeTeamMemberModalText: "请确定是否从您的项目中移除该此项目组成员？",
    removeTeamMemberModalTitle: "移除项目组成员",
    overrideRemovedBy: "覆盖移除人",

    // Custom instructions
    addCustomInstruction: "添加定制指引",
    editCustomInstruction: "编辑定制指引",
    customInstructionInstructionalText: "在此添加或编辑定制指引。这些指引将呈现在项目组成员的个人独立性确认中，提供有关如何回答客户特定问题的指引。",
    customInstructionPermissionTooltip: "你必须拥有<b>管理项目</b>权限才能执行该操作。如请求权限，请联系<b>项目管理员</b>。",
    customInstructionMaxLengthExceeded: "文本超出允许的最大长度",

    //Independence Confirmation Details
    details: "详细",
    question: "问题",
    answer: "答案",
    countTeamMembers: "项目组成员人数",
    executiveApproval: "行政批准",
    yes: "是",
    no: "否",
    independenceModalText: "在此您可以看到在个人独立确认上选择此答案的项目组成员。",
    notApplicable: "不适用",
    readMore: "阅读更多",
    readLess: "阅读更少",
    teamMembsersTitle: "项目组成员详情",

    tasksSelected: "选定的多项任务",
    taskSelected: "选定的任务",
    unselectAll: "全部取消选择",
    addForm: "新增表格",
    addFormName: "名称",
    addFormDigital: "数字化",
    addFormCore: "核心",
    addFormNonComplex: "非复杂",
    addFormComplex: "复杂",
    addFormListed: "已上市",
    addFormGroupAudit: "集团审计",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "准则",
    addFormLanguage: "语言",
    addFormManageTasks: "管理任务",
    addFormManageObjects: "管理对象",
    addFormAvailableTasks: "可用任务",
    addFormAvailableObjects: "可用对象",
    addFormTypeOfForm: "表格类型",
    addFormSelectedTasks: "选定的任务",
    addFormSelectedObjects: "选定的对象",
    addFormCreateForm: "创建表格",
    addFormCancel: "取消",
    createtag: "创建标签",
    tagsLabel: "标签",

    //Group instruction summary
    sInstruction: "范围",
    iInstruction: "单个",

    //CGT and CGT Unlinked related labels
    cgtSend: "发送",
    cgtDueDate: "到期日",
    cgtFrom: "来自",

    notesSelected: "选定注释",
    noteSelected: "选定注释",
    cgtUnlinkedLabel: "未链接",
    cgtUnlinkedInformationMessage: "此任务不再与其他集团项目相关联，如果不再需要，可以删除。",
    sendtoPrimaryTeam: "发送至主审小组",
    sendtoPrimaryTeamdisableBtn: "此任务必须包含至少一个编制人和复核人签名的证据，才能发送给主审小组",
	cgtSendModalHeader: '选择一个或以上文档发送给主审小组。<span class="modal-instruction-text">Canvas表格将以PDF格式发送。可在临时文件中查看已发送至主审小组的PDF格式Canvas表格记录。</span>',
    cgtNotifyCheck: "通知主审小组不要再发送任何文档。",
    cgtCanvasFormValidation: "此Canvas表格中有尚未解决的验证。考虑是否应在将Canvas表格发送给主审小组前解决这些验证。",
    finalVersionLabel: "最终版",
    draftVersionLabel: "初稿",
    otherEvidence: "其他证据",
    selectAtLeastOneDocument: "选择至少一个文档以继续。",
	cgtsendmodelinstructionheader: '选择一个或以上文档发送给主审小组。<span class="modal-instruction-text">将文档标记为<b>初稿</b>即告知主审小组该文档仍在处理中，可能会继续发送其他版本。将文档标记为<b>终稿</b>即告知主审小组你已完成对该文档的处理，预计不会再发送其他版本的文档。</span>',
    //Independence confirmation
    undefined: "未定义",
    incomplete: "不完整",
    nomattersidentified: "未识别事项",
    matteridentifiedpendingaction: "已识别事项——待采取行动",
    matterresolveddeniedaccess: "已解决事项——拒绝访问",
    matterresolvedgrantedaccess: "已解决事项——授权访问",
    notapplicable: "不适用",
    restored: "已恢复",
    overriden: "已覆盖",
    override: "覆盖",
    priornomattersidentified: "之前——无已识别事项",
    priormatteridentifiedpendingaction: "之前——已识别事项——待采取行动",
    priormatterresolvedgrantedaccess: "之前——已解决事项——授权访问",
    priormatterresolveddeniedaccess: "之前——已解决事项——拒绝访问",
    addTagsLabelForTaskList: "添加标签",
    addTagLabelForTaskDetails: "+ 添加标签",
    manageTagsColorInputLabel: "颜色",
    manageTagsTagNameInputLabel: "标签名称",
    addTagRequiredMessage: "需要",
    addNewTagLinkText: "添加新标签",
    manageTagsLabel: "管理标签",
    manageTagGroupHeader: "在此处创建新的标签和组。您还可以编辑和删除现有标签和组。标记任务可以改善项目的组织和项目管理。",
    //add tag color dropdown
    addTagRedColorText: "红色",
    addTagOrangeColorText: "橙色",
    addTagTealColorText: "青色",
    addTagBlueColorText: "蓝色",
    addTagPurpleColorText: "紫色",
    addTagGreenColorText: "绿色",
    deleteAssignmentConfirmationMessage: "是否确定删除该任务？",

    // Return label for Returned document
    recieved: "已接收",

    selectServiceOffering: "选择提供的服务",
    selectTasks: "选择任务",
    reviewSuggestedTasks: "复核建议的任务",
    reviewAvailableTasks: "复核可用任务",
    setDueDate: "设置到期日",
    schedulerCreateRequestStep4TabText: "操作和沟通协议",
    createWorkRequestHeadingpart1: "给服务请求命名并选择提供的服务，然后开始。",
    createWorkRequestHeadingpart2: "以下所列示的是基于你项目的文档设置以及你所在地区可用服务生成的服务清单。费用按所实际分配到的人员级别和服务内容的复杂程度而有所不同。",
    createWorkRequestHeadingpart3: "Engagement를 roll-forward한 경우, 전기에 사용된 서비스 제공은 전기 배지 레이블이 붙습니다",
    createWorkRequestHeadingpart4: "上一期间",
    createWorkRequestHeadingpart5: "标记。",
    createWorkRequestStep2Headingpart1: "复核对xxx可用的所有任务",
    createWorkRequestStep2Headingpart2: " 提供的服务。",
    createWorkRequestStep2Headingpart3: "<u>对于参与Wave 2集中化试运行的项目组</u>，请根据以下标准选择集中化项目组成员可以执行的相关任务: (1)客观审计程序（即，需要项目组进行较少判断或不需要进行判断的程序），(2)主观程序（即，需要项目组进行判断的程序），仅适用较低风险评估或相关认定固有风险较低的任务。已包含在另外集中化服务请求中的任务被标记为",
    createWorkRequestStep2Headingpart4: "。如果你之前使用过该服务，包含在你上一期间请求中的任务将被标记为",
    createWorkRequestStep2Headingpart5: "上一期间。",
    requestName: "请求名称",
    submittedBy: "提交人",

    // Next wave labels
    totalTasks: "任务",
    noServiceRequest: "尚未创建服务请求。创建并提交服务请求，然后开始。",
    eyContact: "安永联系人",
    requestStatusText: "请求状态",
    requestsByStatusText: "按状态查看请求",
    serviceRequest: "服务请求",
    serviceGateway: "服务网关",
    centralizedServices: "请求服务",
    serviceRequestDueDate: "到期",
    NA: "不适用",
    more: "更多",
    eycontacts: "安永联系人",
    addEYContact: "添加安永联系人",
    editEYContacts: "编辑安永联系人",
    addEYContactInstructions: "为此请求添加或删除安永联系人。更新后的安永联系人将发送给资源经理和分配的资源。",
    editEYContactDisabledInstructions: "你必须拥有<b>请求服务</b>权限才能执行该操作。请与项目管理员沟通获取访问权限。",
    emptyEYContactsPlaceholder: "添加至少一个安永联系人以继续。",
    estimatedHours: "预计完成时间（工时）",
    resourceManagers: "资源经理",
    nextWaveServices: "集中服务",
    centralizedservices: "集中服务",
    onlyShowAccepetedRequests: "仅显示已接受的请求",
    showSelectedOnly: "仅显示已选择",
    emptyEngCodeMessage: "您的项目无有效代码。",
    primary: "主要",
    estimatedCosts: "预计成本",
    assignedResources: "已分配资源",
    generalAuditTasks: "一般审计任务",
    generalInfo: "一般信息",
    requestID: "请求ID",
    createdDate: "已创建",
    startDate: "开始",
    serviceRequestDue: "到期",
    comingDueIn: "日内即将到期",
    comingDueTodayLabel: "今日到期",
    daysLabel: "天数",
    dayLabel: "天数",
    createByLabel: "创建人",
    notProvidedLabel: "未提供",
    editLabel: "编辑",
    serviceRequestNoHistoryLabel: "无该请求的历史记录。",
    serviceRequestHistoryLabel: "历史记录",
    serviceRequestTasks: "服务请求任务",
    suggestedRequestTasks: "建议的请求任务",
    estimatedCost: "预计成本",
    addinstructionsAndRelatedFiles: "针对此请求添加其他操作和沟通协议。",
    instructionText: "如果您将项目后推至明年，有关该请求的证据将包含在该请求中并进行归档。如果您将项目后推，临时文件夹不会归档，也不会包含在该请求中。",
    instructionPlaceHolder: "其他操作和沟通协议",
    warningText: "证据将与该请求一同归档，但临时文件夹不会归档。",
    availableDocuments: "可用文件",
    noDocumentsAvailable: "无可用文档",
    selectAll: "选择全部",
    deselectAll: "取消选择所有",
    documentsSelected: "已选定的文件",
    selectedDocuments: "已选定的文件",
    noDocumentSelected: "尚未选定文件。选择文件，然后开始（可选）。",
    TaskName: "任务名称",
    AssignmentsLabel: "工作分配",
    noTaskAssociatedToServiceRequest: "没有与该请求相关的任务。",
    requestServices: "请求服务",

    serviceNotEditable1: "如需修改此请求中包含的任务，请选择",
    serviceNotEditable2: "编辑",
    serviceNotEditable3: "关于",
    serviceNotEditable4: "任务",
    serviceNotEditable5: "选项卡。如希望新增或取消该服务请求，那么",
    serviceNotEditable6: "联系人员管理部经理",
    serviceNotEditable7: "（如已分配）。",

    serviceReqMarkComplete: "将集中服务请求标记为已完成，能告知服务提供商不需要其他工作，以及你已经完成了复核。将服务请求标记为已完成后，不可撤销。",
    serviceReqMarkCompleted: "已完成",
    editServiceRequestTasks1: "请对此服务请求所选择的任务进行复核。",
    editServiceRequestTasks2: "对此服务建议的所有任务",
    editServiceRequestTasks3: "已列示于此。如想添加一项任务，请从下表选择任务。如想删除一项任务，请取消勾选该任务。",

    submitServiceRequestConfirmation1: "是否确认提交此服务请求？",
    submitServiceRequestConfirmation2: "你已选择针对你的项目已提交的提供的服务。",
    alreadyScheduledHeader: "已预定提供的服务",

    createServiceRequestPermission1: "你必须拥有创建服务请求权限才可继续。",
    createServiceRequestPermission: "你必须拥有<b>管理服务请求</b>权限才能执行该操作。请与项目管理员沟通获取访问权限。",
    schedulerRequestSubmissionError: "发生错误，无法向调度人提交该请求。选择<b>重新提交</b>以重试。如错误仍然存在，请联系帮助台。",
    resubmit: "重新提交",
    noServiceManager: "此请求尚未分配人员管理部经理。",
    noAssignedResource: "此请求尚未分配人员。",
    noMileStoneSetForService: "尚未对此请求设置里程碑起止日期。",
    isEngagementNominnatedForCentralizeService: "你所在地区是否已选择或确认让你的项目参与到GDS集中化试运行中？",
    needApprovalForSericeRequestCreation: "请联系地区审计主管合伙人，获得继续此服务请求的适当批准。",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "PIC/EQR文档未与任务关联",
    filterRelatedToRisksLabel: "已关联风险",
    filterGroupTasksLabel: "任务",
    filterGroupAssignmentsLabel: "工作分配",
    filterGroupDocumentsignoffsLabel: "文档签字",
    filterGroupProjectManagementLabel: "项目管理",
    filterAssignmentTypeLabel: "分配工作类型",
    filterTaskStatusLabel: "任务状态",
    filterTaskTypeLabel: "任务类型",
    filterAssignedToLabel: "被分配人",
    filterAssignmentStatusLabel: "分配工作状态",
    filterTaskReviewNoteStatusLabel: "注释状态",
    filterTaskCommentStatusLabel: "注释状态",
    filterTaskReviewNoteAssignedToLabel: "被分配人",
    filterTaskReviewNoteAuthoredByLabel: "创建人",
    filterPICDocumentsAssociated: "相关PIC文档",
    filterEQRDocumentsAssociated: "相关EQR文档",
    missingSignOffs: "文档未签字",
    signedOffBy: "签字人",
    notSignedOffBy: "缺少该人员签字",
    filterTimePhaseLabel: "时间段",
    filterMilestoneLabel: "里程碑",
    filterAuditPhaseLabel: "审计阶段",
    filterEngagementPhaseLabel: "项目阶段",
    filterDocumentConflictsLabel: "文件冲突",
    filterEntitiesLabel: "实体",
    missingEntityDocuments: "缺少实体文档",
    filterDownloadedForOfflineLabel: "离线下载",
    filterNextwaveServicesLabel: "集中化的服务",
    filterServiceGateway: "服务网关",
    filterScheduledServicesLabel: "已关联服务",
    filterSuggestedServicesLabel: "建议的服务",
    NoDocumentSignedOffLabel: "截至以下日期，尚无该已签署文档",
    SomeDocumentSignedOffLabel: "截至以下日期，已有部分文档得到签署",
    AllDocumentSignedOffLabel: "截至以下日期，所有文档均已签署",
    usersLabel: "项目组成员",
    serviceRequests: "集中化的服务",
    backToMainPage: "返回主页",
    suggestedNextwaveRequests: "建议的集中化请求",
    /* Component Send Status */
    deliveredDate: "已交付：{0}",
    sentDate: "已发送：{0}",
    sentFailure: "交付失败，请重试。如仍有问题，请联系帮助台。",
    chooseTaskInstructionLabel: "选择包含该请求的任务",
    createSRstep2InstructionalTextPart1: "将已纳入另一请求的任务标记为",
    createSRstep2InstructionalTextPart2: "。如果您之前使用过该服务，包含在您上一期间请求中的任务将被标记为",
    createSRstep2InstructionalTextPart3: "通过下列切换功能，仅显示建议的任务。",
    availableTasksLabel: "可用任务",
    guidance: "Atlas指引",
    helixAnalyzers: "Helix分析工具",
    eyHelix: "EY Helix",
    smartAutomationLinks: "智能自动化",
    createAutomation: "创建自动化",
    noProjectTitle: "与Helix项目链接",
    multipleProjectsTitle: "选择已链接的Helix项目",
    noProjectMessage: "将Helix项目与该项目链接，然后在该Helix分析工具中开始。",
    multipleProjectsMessage: "该项目与多个Helix项目链接。从以下列表中选择Helix项目以继续。",

    automationGuidanceHeader: "建议的自动化",
    helixAnalyzersHeader: "建议的分析工具",
    linkToHelixLabel: "与Helix链接",
    noSelectedTasksText: "尚未选定任务。选择任务，然后开始。",
    selectedTasksLabel: "已选定的任务",
    serviceOffering: "提供的服务",
    submitRequest: "提交请求",
    scheduleYourRequest: "预定您的请求。",
    serviceRequestStep3HeaderText: "选择您希望指派的人员开始处理这些任务的起始日。然后选择这些任务的完成日。",
    serviceRequestMilestoneDueDateHeaderText1: "选择",
    startanddue: "各里程碑的",
    eachmilestone: "每个里程碑",
    serviceRequestMilestoneDueDateHeaderText2: " 您项目组对所有交付的工作负最终责任。因此，在选择到期日时要保证您的项目组有充分的时间来对待交付工作进行复核。",
    serviceRequestMilestoneDueDateHeaderText3: "估计的完成时间应仅包括您预计服务提供商产生的时间。",
    schedulerBudgetMainQuestion: "您的项目组是否：",
    schedulerBudgetFirstQuestion: "在您的财务、定价和计划流程中安排了应对请求的所有工作？",
    schedulerBudgetSecondQuestion: "就此请求通知了您的国内体验经理？",
    schedulerBudgetThirdQuestion: "相应调整了国内项目组的工时？",
    timetocompleteinfo1: "估计完成时间应仅包括",
    timetocompleteinfo2: "你预计服务提供商发生的时间。",
    serviceRequestStartDate: "开始",
    saveDraft: "保存草稿",
    step3ValidationError: "到期日必须晚于起始日",
    scheduledLabel: "预定的",
    suggestedLabel: "建议的",
    searchTasksLabel: "搜索任务",
    submit: "提交",
    selectTaskRequiredErrorMessage: "您必须选择至少一项任务以继续。",
    moveToCompleted: "跳转至已完成",
    requestResubmitMessagePart1: "重新提交此请求会将状态重置为",
    requestResubmitMessagePart2: "未完成。",
    requestResubmitMessagePart3: "任何变更将被调度人复核",
    showSuggestedTaskToggle: "仅显示建议的任务",

    // Assignments
    addAssignmentName: "添加分配工作名称",
    editAssignmentName: "编辑分配工作名称",
    deleteAssignmentName: "删除分配工作名称",
    deleteAssignmentNameInstructionalTextHeader: "是否确认删除此分配工作名称？",
    deleteAssignmentNameInstructionalText: "一旦删除，将从你的项目的所有小组成员和角色中移除该分配工作。",
    assignmentType: "工作分配类型",
    assignmentTypeInstructionalText: "选择分配工作类型并在下方输入名称。完成后，点击<b>添加</b>。",
    assignmentEditInstructionalText: "编辑下文分配工作的类型和名称。完成后，点击<b>保存更改</b>。",
    noSuggestedTaskLabel: "该分类下没有建议的任务。",
    manageAssignmentsLabel: "管理分配工作",
    myAssignmentsLabel: "我的分配",
    myAssignedTasks: "我的分配任务",
    currentlyAssignedTasks: "当前已分配任务",
    assignmentModalInstructionalText1: "如想将已分配给项目组成员或角色的任务重新分配或删除，在下方选择这些项目组成员或角色的姓名。你还可使用<b>删除</b>图标删除分配给项目组成员或角色的所有工作。如想编辑或删除分配工作的名称，点击 <b>更多</b>菜单。",
    unassignedTasks: "未分配任务",
    assignedTasks: "分配任务",
    type: "类型",
    priorperiodservicerequests: "之前期间服务请求",
    unmarkcomplete: "取消已完成标记",
    taskAttributes: "任务属性",
    engagementTeam: "项目组",
    assignTo: "分配至",
    reAssignTo: "重新分配至",
    assign: "分配",
    reAssign: "重新分配",
    reAssignWarningLabel: "选择一项或多项待重新分配的任务。",
    assignWarningLabel: "选择一项或多项待分配任务。",
    searchByTaskName: "按任务名称搜索",
    searchByTimePhaseName: "按时间段名称搜索",
    assignment: "分配工作",
    noMembersWithThisAssignment: "项目组成员或角色没有此分配工作。",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "将从您项目的所有任务中移除此工作分配。",
    noTaskAttributes: "目前仍没有对此任务设置属性。选择“创建”或“关联”后开始。",
    assignmentWithoutAssignedUser: "此工作分配名称目前未使用",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "正在收集配置文件信息，请稍等",
    v2ProfileDocumentIdDeletedMessage: "未找到配置文件信息。请刷新页面，然后重试。如果仍有错误，请联系帮助台。",
    accountAndRelatedAssertions: "账户及相关认定",
    risks: "风险",
    scotName: "重大交易类别名称",
    strategy: "策略",
    transactionType: "交易类型",
    notSelectedText: "未选中",
    relatedBy: "关联方",
    collaboration: "合作",
    controlsLabel: "控制",
    scotAndRelatedControls: "重大交易类别及相关控制",
    scotAndRelatedRisks: "重大交易类别以及相关重大错报风险",
    frequencyLabel: "频率",
    operatingEffectively: "运行有效",
    designedEffectively: "设计有效",
    timeToCompleteHours: "完成时间（小时）",
    completeRequiredFieldValidationError: "请完成所有必填字段以继续。",
    itgcsAndItsps: "IT一般控制(ITGC)和IT战略规划（ITSP）",
    itprocessItgcsAndItsps: "IT流程和ITGC/ITSP",
    approachLabel: "方法",
    typeLabel: "类型",
    itProcessName: "IT流程名称",
    processEvaluation: "流程评估",
    unrelatedControls: "不相关控制",
    disableNextwavePlaceholder: "目前您所在的国家仍不可使用集中化的服务。刷新页面并重试。如错误提示仍然存在，请联系帮助服务中心。",
    disableNextwavePlaceholderDataCenter: "目前您本地数据中心不可使用集中服务。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    dataPrivacyInviteMessage: "邀请前，是否充分考虑了由于数据隐私规定可能对工作底稿实施的访问权限限制？",
    //Session Timeout
    sessionTimerMsg: "由于长时间未操作，您当前的工作会话即将过期。为了您的安全起见，EY Canvas会话在无操作时间到达30分钟后自动结束。当前会话将在{0}分钟后过期。如果您希望保持登录状态，请点击继续。",
    logout: "注销",
    sessionPopupTitle: "为保护您账户的使用安全，系统将自动退出登录",
    allSuggestedTasks: "任务",
    viewByAccount: "按账户查看",
    viewBySCOT: "按重大交易类别查看",
    noServiceOfferingsAvailable: "目前没有可供您的项目使用的服务。请刷新页面并重试。如该问题仍然存在，请联系帮助服务中心。",

    //Collaboration
    myRequests: "我的请求",
    allRequests: "所有请求",
    calendar: "日历",
    calendarTodayButton: "今日",
    requestsListButton: "请求列表",
    eventsButton: "事件",
    analyticsButton: "分析工具",
    showAssignedToMe: "显示我的请求",
    selectRequestsTitle: "选择请求以查看详细信息",
    selectRequestsSub1: "要启用批量控制，请勾选复选框或按住",
    selectRequestsSub2: "shift或control键选择多个请求。",
    noTagMessage: "尚未创建标签。点击<b>此处<b>创建。",
    tagAs: "标签为：",
    addTag: "添加标签",
    searchTag: "搜索标签",
    documentsAttached: "已添加文档",
    editDraftRequest: "编辑请求草稿",
    deleteRequest: "删除请求",
    deleteLabel: "删除",
    deleteLabelDisabled: "权限不足，无法批量删除。请与您的项目管理员联系，请求获取批量删除权限。",
    DeleteRequestConfirmMsg1: "是否确认删除此请求？",
    DeleteRequestConfirmMsg2: "此操作不可撤销。",
    deleteRequestSuccess: "请求已删除",
    DeleteRequestsConfirmMsg1: "是否确认删除所有{0}个请求？",
    dueDateCollabLabel: "到期日",
    requestLabel: "请求",
    statusLabel: "状态",
    inValidRequestTitleLabel: "下列请求在当前状态下无法删除",
    bulkSendButton: "发送",
    bulkDeleteButton: "删除",
    commentSyncFailedRetry: "批注不能提交至EY Canvas客户端。",
    commentSyncFailedRetrySendAgain: "请重新发送。",
    commentDeleted: "此消息已被删除。",
    CommmentDeletionSyncFailed: "批注不能从EY Canvas客户端删除",
    clickLabel: "点击",
    toRetry: "以重试。",
    replySyncFailedRetry: "回复不能提交至EY Canvas客户端。",
    quickFilterPriority: "优先级",
    quickFilterErrorCounterTooltip: "一个或多个请求存在错误，请注意。",

    eyContactNoResultsFound: "未找到用户",
    eyContactClear: "清除",
    eyContactSearch: "查询",
    eyContactCollaboration: "安永联系人",
    eyParticipantsCollaboration: "安永参与人员",
    externalParticipantsCollaboration: "外部参与人员",
    syncInProgressEYContact: "同步进行中",
    syncErrorEyContact: "同步错误。请重试。",
    noAssignedContact: "无指定联系人",
    noAssignedParticipant: "未添加参与人员",

    commentsTooltipLabel: "批注",
    recordingVirusScanInProgress1: "正在进行病毒扫描。完成后即可使用语音注释。",
    screenrecordVirusScanInProgress1: "正在进行病毒扫描。完成后即可开始录屏。",
    recordingVirusScanInProgress2: "请刷新页面并重试。",
    confidentialDocumentsModalTitle: "机密文件",
    confidentialDocumentsModalMsg1: "以下机密文件已添加至请求。",
    confidentialDocumentsModalMsg2: "点击继续，即确认您具有将此文件发送至EY Canvas客户端的适当保密级别，并且您已复核了请求的分配。",
    confidentialDocumentsModalMsg3: "您没有适当的保密级别，无法将其中一个或多个文件发送至EY Canvas客户端。请删除您无法访问的所有机密文件以继续。",
    confidentialityLevel: "保密级别",
    voiceNoteUploadError: "获取文档详情时出错。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    requestEventTitle: "事件",
    noTaskDescription: "无任务描述",

    newRequestLabel: "新请求",
    newEventLabel: "新事件",

    //Analytics Tab
    analyticsCreateDateLabel: "创建日期：",
    createdByLabel: "创建人：",
    expirationDateLabel: "有效期：",
    sharedWithLabel1: "共享人",
    sharedWithLabel2: "请求",
    sharedWithLabel3: "请求",
    analyticsTabTitle: "分析工具",
    analyticsTabSubtitle: "与关联EY Helix项目的客户共享分析工具。在...的书签面板中创建客户询问以开始",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "未选择分析工具",
    noActiveAnalyticsSubtitleLabel1: "未创建分析工具。点击",
    noActiveAnalyticsSubtitleLabel2: "此处",
    noActiveAnalyticsSubtitleLabel3: " 然后开始。",
    noActiveAnalyticsSubtitleLabel4: "在EY Helix关联项目并保存书签后，可返回至此页面预览可共享至EY Canvas客户端的分析工具。",
    selectAnalyticsLabel: "选择分析工具",
    analyticsNoPrimaryHelixProjectsMessage: "此项目未与Helix主项目关联。",
    selectAnalyticsModal: {
        closeTitleTip: "关闭",
        modalTitle: "选择分析工具",
        modalHeader: "选择与外部项目组成员共享的分析工具",
        selectAnalyticPlaceholder: "选择分析工具",
        selectAnalyticError: "分析工具为必选",
        analyticNamePlaceholder: "输入分析工具名称（必填）",
        analyticNameError: "分析工具名称为必填",
        cancel: "取消",
        viewPreview: "查看分析工具",
        noPreviewAvailable: "没有可以查看的预览",
        noPreviewDescription: "请选择分析工具以进行预览",
        clickPreviewAnalytic: "单击预览所选分析工具",
        documentObservation: {
            label: "记录有关所选分析工具的所有观察或查询结果",
            placeHolderLabel: "输入观察或查询结果（可选填）"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "关闭",
        observationFieldPlaceholder: "关于所选分析的所有观察或查询",
        noObservationField: "没有针对此分析的观察或查询。",
        appliedFiltersLabel: "应用的筛选条件",
        appliedFilters: [{
                id: '1',
                label: "分析币种"
            },
            {
                id: '2',
                label: "货币编码"
            },
            {
                id: '3',
                label: "数值取整"
            },
            {
                id: '4',
                label: "业务单元组"
            },
            {
                id: '5',
                label: "业务单元"
            },
            {
                id: '6',
                label: "一级账户类型"
            },
            {
                id: '7',
                label: "一级账户子类型"
            },
            {
                id: '8',
                label: "一级账户类别"
            },
            {
                id: '9',
                label: "一级账户子类别"
            },
            {
                id: '10',
                label: "一级账户名称"
            },
            {
                id: '11',
                label: "一级安永账户指定"
            },
            {
                id: '12',
                label: "一级安永账户"
            },
            {
                id: '13',
                label: "业务单元"
            },
            {
                id: '14',
                label: "分析日期"
            },
            {
                id: '15',
                label: "比较日期"
            },
            {
                id: '16',
                label: "分部01组"
            },
            {
                id: '17',
                label: "分部02组"
            },
            {
                id: '18',
                label: "分部03组"
            },
            {
                id: '19',
                label: "分部04组"
            },
            {
                id: '20',
                label: "分部05组"
            }
        ],
        save: "保存",
        cancel: "取消",
        disabledEdit: "无法编辑观察，因为请求已发送到EY Canvas客户端门户。请撤回请求以完成此操作。",
        errors: {
            unautorizedUser: "您不是关联的EY Helix项目的授权项目组成员。请联系EY Helix项目管理员获取访问权限，然后重试。",
            bookmarkNotFound: "所选分析已删除。请进入EY Helix以管理已删除分析或新建分析。",
            unautorizedAccessToBookmark: "您无权访问请求的EY Helix书签。请与EY Helix项目管理员联系以获取访问权限，然后重试。",
            authenticationError: "身份验证错误。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
            genericError: "请刷新页面并重试。如仍有错误，请联系帮助台。",
            defaultError: " {0} 请刷新页面并重试。如仍有错误，请联系帮助台。"
        }
    },
    deleteAnalyticModal: {
        modalTitle: "删除分析",
        modalHeader: "是否确实要删除此分析？EY Canvas将不再提供该分析。"
    },
    // activity feed
    search: "搜索",
    searchTeams: "搜索项目组",
    clear: "清空",
    groupActivityLabel: "小组活动",
    documents: "文档",
    documentLabel: "文档",
    linkRequests: "关联请求",
    received: "已接收",
    returned: "已退回",
    rejected: "已拒绝",
    accepted: "已接受",
    sent: "已发送",
    unlinked: "未连接",
    finalized: "已完成",
    groupActivityFeed: "分组活动信息",
    component: "组成部分",
    noExternalApprovalsMessage: "没有外部批准",
    noFileSelectedMessage: "选择文档以查看详细信息",
    noInstructionSelectedMessage: "选择一个项目以查看详细信息。",
    noLinkRequestSelectedMessage: "选择一个项目以查看详细信息。",
    noItemSelectedMessage: "选择一个项目以查看详细信息",
    viewGroupActivity: "查看分组活动",
    pointOfContact: "联系人",
    currentStatus: "当前状态",
    resolved: "已解决",
    viewVersion: "查看版本",

    // activity feed right pane headings
    scope: "范围",
    groupRole: "分组角色",
    linkRequestStatus: "关联请求状态",
    instructionStatus: "说明状态",
    linkStatus: "关联状态",
    today: "今日",
    yesterday: "昨日",
    thisWeek: "本周",
    lastWeek: "上周",
    twoWeeksAgo: "两周前",
    threeWeeksAgo: "三周前",
    lastMonth: "上月",
    older: "更早",
    actionsDateNote: "所有日期和时间均按格林威治时间报告。",
    noActionsMessage: "没有可显示数据。",
    noManageRequestPermissionMessagePart1: "你必须拥有<b>管理服务请求</b>权限来才能执行该操作。",
    guidedWorkflow: "EY Canvas FIT促进工具",
    navExecution: "执行",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "EY Canvas监督",
    navConclusion: "结论",
    navTeamMemberIndependence: "项目组成员独立性",
    navGroupAudit: "集团管理层",
    navGroupActivityFeed: "分组活动信息",
    navPrimaryStatus: "主审小组状态",
    navComponentStatus: "组成部分项目小组状态",
    navGroupStatus: "集团状态",
    navEngagementManagement: "项目管理",
    navProfile: "配置文件",
    navGroupStructureSummary: "集团结构",
    OpenGuidedWorkflowDocument: "通过EY Canvas FIT促进工具打开此文档。",
    navNotApplicable: "不适用",
    canvasForms: "Canvas表格",
    eYCanvasEconomics: "EY Canvas经济",
    overDueAssignments: "逾期工作分配",
    comingDueAssignments: "即将到期工作分配",
    overDueReviewNotes: "逾期复核注释",
    comingDueReviewNotes: "即将到期复核注释",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "按状况分列的报告表格",
    ReportingStatusSubTitle: "查看下列分配给组成部分项目小组的集团任务，以及按状态列出的已接收集团文档汇总。<br/>你可以选择按项目组或按集团任务查看详细进度。",

    Total: "合计",
    Returned: "已退回",
    Overdue: "逾期",
    PendingResponse: "待回复",
    Received: "已收到",
    ReadyForReview: "准备进行复核",
    messageNoDocument: "没有已收到文档。",
    byTeam: "按照项目组",
    byGroupTask: "按照集团任务",
    groupStructureLabel: "集团结构",
    instructionPending: "待接收的说明",
    linkRequestPending: "待处理的关联请求",
    notusingeycanvas: "不使用EY Canvas",
    pendingLabel: "待处理",
    teams: "项目组",
    NoDocumentReceiced: "没有已收到文档。",
    selectTeamToSeeData: "无可用数据。选择一个项目组，在此处查看数据。",
    noDataAvailable: "无可用数据。",
    prepared: "已编制",
    tasksAssigned: "分配的任务",
    taskAssigned: "分配的任务",
    instructionNotSent: "指引尚未发送",
	assignedTeamNotProvidedDocForTasks: "\{0}\个项目组尚未发送这些任务的文档| 预计会收到\{1}\份文档",
	documentRecievedOutOfAssignedTasks: "收到的文档 <br><b>\{0}\</b> 不属于\{1}\分配的任务",
	documentRecievedOutOfAssignedTeams: "收到的文档 <br><b>\{0}\</b> 不属于\{1}\被分配任务的项目组",

	groupStatusSubTitle: "查看下列主审小组分配的集团任务以及按状态列出的集团文档汇总。<br/>你可以选择按任务或按文档状态筛选集团任务。",
    notSent: "未发送",
    draftsent: "已发送草稿",
    finalsent: "已发送终稿",
    noTaskForComponent: "没有可用数据。<p>主审小组发送的集团任务被接受后会显示在此处。</p>",
    noTaskForComponentWithStatus: "没有可用数据。<p>选择一个或以上状态选项，在此查看数据。</p>",

    //Dashboard V2 - activity feed
	activityFeedSubHeadingText: "选择活动类型，查看过去10天的相关项目活动。<br/>点击特定项的<b>活动</b>图标，查看该项所有活动。<br/>你还可以使用切换功能来优化视图。",
    activityFeedSubHeadingGroupAudit: "选择活动类型，查看过去10天的相关项目活动。<br/>点击特定项的<b>活动</b>图标，以查看该项所有活动。<br/>你还可以使用切换功能来优化视图。",
    teamHistoryInstructionalText: "查看该项目组过去10天的活动。",
    teamHistory: "项目组活动历史",
    onlySeeMyActivity: "仅查看我的活动",

    taskAddedBy: "添加任务的人员",
    taskMarkedCompleteBy: "标记任务为完成的人员",
    taskUnmarkedCompleteBy: "取消标记任务为完成的人员",
    taskHandedOffBy: "交接任务的人员",
    assignmentAddedBy: "添加任务分配的人员",
    assignmentEditedBy: "编辑任务分配的人员",
    assignmentClosedBy: "关闭任务分配的人员",
    assignmentReOpenedBy: "重新开放任务分配的人员",
    assignmentDeletedBy: "删除任务分配的人员",
    noteAddedBy: "注释添加人",
    noteClearedBy: "注释清除人",
    noteClosedBy: "注释关闭人",
    noteReopenedBy: "注释重新打开人",

    linkRequestSent: "发送链接请求的人员",
    instructionSentBy: "发送指令的人员",
    linkRequestAcceptedBy: "接受链接请求的人员",
    engagementUnlinkedBy: "取消项目链接的人员",
    instructionAcceptedBy: "接受指令的人员",
    instructionReturnedBy: "返回指令的人员，",
    labelTo: "至",
    instructionReceivedFrom: "接受的指令来自",
    filtersLabel: "筛选",
    advanceOptions: "批量操作",
    advanceOptionsLabel: "批量操作",
    relatedScots: "相关重大交易类别",
    noRelatedScots: "无相关重大交易类别",
    materialityLabel: "重要性水平",
    currentPeriod: "当前日期",
    previousPeriod: "上一日期",
    showCurrentPeriod: "显示当前日期",
    showPriorPeriod: "显示上一日期",
    planningMateriality: "计划重要性水平",
    tolerableError: "可容忍误差",
    sadNominalAmount: "SAD名义金额",
    pmLabel: "计划重要性水平",
    teLabel: "可容忍误差",
    sadLabel: "SAD",
    accountBalance: "账户余额",
    mapAccountBalances: "匹配账户余额",
    connectToHelixProject: "连接至Helix项目",
    connectToImportBalances: " 导出余额",
    helixMultiple: "多个",
    selectMESTentity: "选择一个实体查看详情",
    relatedWCGWAndControls: "相关的可能出错项和控制",
    relateAtLeastOneWCGW: "每个控制风险为依赖的认定必须至少有一个关联的可能出错项。",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "相关的IT流程",
    noRelatedITProcesses: "无相关IT流程",
    relatedITRiskITGCs: "相关IT风险、IT一般控制和IT实质性程序",
    relatedITRisks: "相关的IT风险",
    ALRAHigherRiskCode: "H",
    materialityMestSelectEntity: "选择一个实体查看详情",
    OARCurrentPeriod: "分析日期",
    OARComparative1Period: "比较日期1",
    xTELabel: "xTE",
    priorPeriodDesignation: "上期指定：",
    priorPeriodEstimate: "上期估计：",
    notApplicableAbbreviation: "不适用",
    accountDetails: "账户详情",
    launchGuidedWorkflow: "启动工作流指导",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "查看账户余额",
    viewAccountBalaceForEntity: "选择实体以查看账户余额",
    mainActivities: "主要活动",
    oversightProjectTile: {
        typeOversight: "监督",
        createProject: "创建项目",
        oversightProjectengagementNotConnectedMessage1: "EY Canvas监督应用程序可对已关联项目的里程碑、项目管理和集团审计进度进行汇总。使用该应用程序确保你的集团审计或项目组合正常进展。",
        oversightProjectengagementNotConnectedMessage2: "你的项目没有关联至任何EY Canvas监督项目。",
        click: "点击",
        togetstarted: "然后开始。",
        clickProjectmessage: "点击<b>+创建项目</b>，然后开始。",
        lblclient: "客户：",
        lblEngagementCount: "项目：",
        lblTaskscompleted: "已完成任务：",
        lblMore: "更多",
        myProject: "我的项目",
        OtherProject: "其他项目",
        oversightNoProjectConnectedMessage: "你不是与你项目关联的任何EY Canvas监督项目的成员。",
        oversightOtherProjectNotConnectedMessage: "你是与你项目关联的所有EY Canvas监督项目的成员。",
        draft: "草稿",
        allTask: "所有任务",
        totalTask: "任务汇总"
    },

    economicsProjectTile: {
        typeEconomics: "经济性",
        economicsProjectengagementNotConnectedMessage1: "EY Canvas经济性应用程序汇总了财务工作进展以及EY Canvas进展。使用该程序管理你项目组合的经济性。",
        economicsProjectengagementNotConnectedMessage2: "你的项目未与任何EY Canvas经济项目关联。",
        clickProjectmessage: "点击<b>+创建项目</b>，然后开始。",
        economicsNoProjectConnectedMessage: "你不是与你项目关联的任何EY Canvas经济项目的成员。",
        lblForecasted: "预测：",
        lblActual: "实际：",
        lblETC: "预计完成时间:",
        lblVariance: "变动"
    },
    leftNavigation: {

        engagementOverview: "项目概况",
        myProgress: "我的进度",
        executiveTasks: "重点领域",
        integration: "整合",
        groupAudit: "集团状态",
        pinnedDocuments: "已固定文档",
        Validations: "验证",
        activityFeed: "活动信息",
        primaryStatus: "主审状态",
        componentStatus: "组成部分状态",
        picProgress: "PIC进度",
        picEQRProgress: "PIC/EQR进度",
        drillDown: "获取明细",
        maps: "映射",
        financialStatement: "财务报表"
    },
    nowRowOverlayClientRequest: {
        createNew: "点击添加请求创建新请求",
        all: "尚未创建请求",
        draft: "没有草稿状态的请求",
        pending: "没有待回应状态的请求",
        received: "没有已收到请求",
        accepted: "没有已接受请求",
        customFilter: "未找到匹配项。请重试。"
    },

    clientRequestPrefixes: {
        draft: "草稿",
        returned: "已退回",
        recalled: "已召回",
        withdrawn: "已撤销"
    },

    clientRequestsTabHeader: {
        all: "全部",
        draft: "草稿",
        pending: "待处理",
        received: "已接收",
        accepted: "已接受"
    },

    clientRequestsPriorityFilters: {
        all: "全部",
        normal: "正常",
        high: "高",
        critical: "关键",
        highAndCritical: "高+关键"
    },

    requestTableHeader: {
        requestId: "请求ID",
        title: "标题",
        receivedDate: "接收日",
        dueDate: "到期日",
        sentDate: "发送日",
        acceptedDate: "接受日",
        assignedTo: "分配至",
        group: "集团",
        status: "状态",
        priorityType: "优先级",
        tags: "标签"
    },

    dropdownColumnsFilter: {
        1: "分配至",
        2: "集团",
        3: "到期日",
        4: "发送日期",
        5: "接收日期",
        6: "接受日期",
        7: "状态",
        8: "优先级",
        9: "标签"
    },

    requestTableDropdownFilter: {
        customizeTable: "自定义表格",
        selectInfo: "最多选择4项",
        selectInfoTooltip: "最多选择4列。请取消选择一个或多个选项以继续。"
    },

    ClientStatus: {
        1: "初稿",
        2: "草稿——无联系人",
        3: "已发送",
        4: "系统错误",
        5: "无效的客户联系人",
        6: "待回复",
        7: "已接收",
        8: "已接受",
        9: "已退回",
        10: "已撤回",
        11: "正在发送",
        12: "正在接受",
        13: "正在撤回",
        14: "正在删除",
        15: "正在退回",
        16: "正在回复",
        17: "已删除",
        18: "无效的客户联系人",
        19: "待完成召回",
        20: "已召回",
        21: "正在完成",
        22: "正在召回"
    },

    analyticStatus: {
        1: "草稿",
        2: "待批准",
        3: "已批准",
        4: "已到期"
    },

    paginationControl: {
        firstPage: "首页",
        lastPage: "最后一页",
        previousPage: "上一页",
        nextPage: "下一页",
        show: "显示"
    },

    auditPlanFilterLabels: {
        showMore: "更多",
        filterTypeOfScots: "重大交易类别",
        noScotsAvailable: "无可用的重大交易类别",
        filterTypeOfITProcess: "IT流程",
        noITProcessAvailable: "无可用的IT​流程"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "重大交易类别",
            noScotsAvailable: "无可用的重大交易类别"
        },
        testing: {
            filterTypeOfTesting: "测试",
            noTestingAvailable: "无可用的测试"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "设计有效性",
            noDesignEffectivenessAvailable: " 无可用的设计有效性"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "分配至",
        filterAttachmentsLabel: "附件类型",
        filterCreatedByLabel: "创建人",
        filterStatusLabel: "状态",
        filterDueAfterLabel: "后到期",
        filterDueBeforeLabel: "前到期",
        filterErrorsLabel: "错误",
        filterOverdueLabel: "逾期",
        filterTagLabel: "标签",
        filterTimePhaseLabel: "时间段",
        filterTypeLabel: "类型",
        filterPriorityLabel: "优先级",
        searchMembers: "搜索成员",
        noTags: "未创建标签",
        noTimephase: "无时间段",
        clearAll: "清除全部",
        clearHoverText: "清空",
        noResultsFound: "未发现结果",
        yes: "是",
        no: "否",
        showMore: "显示更多",
        // Check this
        filterNoMatchesFound: "未找到匹配项。请重试。",
        filter: "筛选",
        title: "筛选条件",
        noRelatedTask: "无关联任务"
    },
    //Dashboard - integration

	collaborationInstruction: "在下方按状态查看协作请求。<br/>点击数字查看经筛选后的请求列表。",
    noValidationsAvailable: "此审计阶段没有验证。",
    individualView: "人员视图",
    engagementView: "项目视图",
    centralizedServiceInstruction: "在下方查看利用集中服务的任务比率，不同状态的请求。<section >点击<b>请求服务</b>创建新请求。</section>",
    // Dashboard - todo list
    todoList: "待办事项列表",
    todoListInProgress: "当前分配",
    todoListOpen: "即将分配",
    todoListClosed: "已完成",
    todoListInstruction: "按照状态查看即将到期的任务和复核注释。<br />选择时间范围或类别来优化视图。<br />如想打开一个项目，请点击任务或复核注释名称。",
    noOpenAssignments: "你没有任何未开始分配工作。",
    noInProgressAssignments: "你没有任何正在进行的分配工作。",
    noClosedAssignments: "你没有任何已结束分配任务。",
    allLabel: "全部",
    dueLabel: "到期",
    noAssignments: "你没有任何分配工作。",
    executiveReview: "主管人员复核",
    epTasksStatusSignOffWithoutDetails: "查看下方PIC状态汇总表。",
    epTasksStatusSignOff: "查看下方PIC状态汇总表。点击<b>查看详情</b>了解详细信息。",
    epeqrTasksStatusSignOffWithoutDetails: "查看下方PIC和EQR状态汇总表。",
    epeqrTasksStatusSignOff: "请查看下方PIC和EQR状态汇总。想要了解详细情况，请选择 <b>查看详情</b>。",
    eqrDefaultMessage: "此项目不需要设置EQR。",
    selectPartners: "选择一位合伙人",
    noPartnersInEng: "你的项目中没有合伙人。",
    epTasks: "PIC任务",
    eqrTasks: "项目质量复核人任务",
    viewDetails: "查看详情",
    picReview: "PIC复核",
    eqrReview: "EQR复核",
    eqrtasksWithSignOff: "未完成的带有EQR<br/>签字的任务",
    eqrdocumentsWithSignOff: "未完成的带有EQR<br/>签字的文档",
    pictasksWithSignOff: "未完成的带有PIC<br/>签字的任务",
    picdocumentsWithSignOff: "未完成的带有PIC<br/>签字的文档",
    partnerSignoffs: "合伙人签字",
    epTaskswithpartnersignoffs: "点击数字查看经筛选后的请求列表。",
    allDocssignedoff: "所有文档均<br/>已签署",
    someDocssignedoff: "部分文档<br/>已签署",
    noDocssignedoff: "没有<br/>已签署文档",
    partnernotinvited: "未邀请合伙人",
    noEQRsinyourengagement: "你的项目没有项目质量复核人。",
    selectEQRs: "选择一位项目质量复核人",
    eqrNotinvited: "未邀请项目质量复核人",
    eqrsignoffs: "项目质量复核人签字",
    eqrtaskswithpartnersignoffs: "点击数字查看经筛选后的请求列表。",
    allpartners: "所有合伙人",
    allEQRs: "所有项目质量复核人",
    reviewComments: "复核注释",
    noOpenReviewComments: "您没有任何未解决复核注释。",
    noClearedReviewComments: "您没有任何已清除复核注释。",
    noClosedReviewComments: "您没有任何已关闭复核注释。",
    noReviewCommentsForSelectedTime: "您选定的时间范围内没有任何复核注释。请选择其他时间范围以继续。",
    picTasksSomeDocSignOff: "部分文档已得到PIC签字的任务",
    picTasksNoDocSignOff: "没有PIC已签字文档的任务",
    eqrTasksSomeDocSignOff: "部分文档已得到EQR签字的任务",
    eqrTasksNoDocSignOff: "没有EQR已签字文档的任务",
    picNotIdentified: "没有识别到PIC",
    eqrNotIndentified: "没有识别到EQR",
    todoReviewNote: "复核注释",

    // Dashboard - Executive Tasks
    executiveTasks: "重点领域",
	executiveTasksInstruction: "在下方选择按风险或账户查看任务。< br/>做出选择后，将鼠标悬停在数字上可查看更多详细信息；或点击任务，前往特定页面查看详细信息。",
    byRisk: "按照风险",
    byAccount: "按照账户",
    responsiveTasks: "已关联任务",
    openNotes: "未解决注释",
    lowLabel: "低",
    mediumLabel: "中等",
    highLabel: "高",
    criticalLabel: "重要",
    epRequired: "PIC为必选项",
    eqrRequired: "项目质量复核人为必选",
    noDocumentsSignedOff: "无已签字文档",
    someDocumentsSignedOff: "部分文档已签字",
    allDocumentsSignedOff: "所有文档已签字",
    completedAssignments: "已完成分配工作",
    designation: "指定",
    significantAccount: "重大账户",
    epSignOff: "PIC签字",
    eqrSignOff: "项目质量复核人签字",
    someLabel: "一些",
    riskNoDataLabel: "所有任务均不涉及该风险。",
    accountNoDataLabel: "该账户和认定未与任何任务关联。",
    NoDataLabel: "所选折叠面板无可用数据",
    // Manage tags
    manageTagsInstructionalText: "`在此创建新标签。你也可以编辑和删除已有标签。为请求添加标签有助于优化项目组织和项目管理。`,",
    noTagsAdded: "未添加标签。创建标签，然后开始。",

    // Client Request Comments
    noCommentsCreatedYet: "尚未创建任何批注。",
    addCommentTitleTip: "添加批注",
    addReplyTitleTip: "添加回复",
    addAComment: "添加批注……",
    addAReply: "添加回复",
    deleteCommentConfirmationModalTitle: "删除批注",
    deleteCommentConfirmationModalMessage: "是否确认删除此批注？对该批注的所有回复将被同时删除。",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "语音注释",
    voiceNoteCommentStopLabel: "停止",
    voiceNoteCommentPlayLabel: "播放",
    voiceNoteCommentDeleteLabel: "删除",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "已成功提交请求",
    BulkSendRequestSuccess: "{0}个请求发送成功",
    BulkSendOneRequestSuccess: "已成功发送1个请求",
    SendInProgress: "发送中",
    AcceptInProgress: "正在接受",
    CompleteInProgress: "正在完成",
    HasErrorState: "无法发送请求，请重试。",
    WithdrawRequestSuccess: "已撤销请求",
    WithdrawInProgress: "撤销中",
    WithdrawRequestError: "无法撤销请求，请重试。",
    DeleteRequestError: "请求无法删除。请刷新页面并重试。",
    AcceptRequestError: "无法接受请求，请重试。",
    CompleteRequestError: "无法完成请求，请重试。",
    InvalidClientContact: "无效的客户联系人。",
    BulkSendInvalid: "一个或以上选定请求无法发送，需要采取进一步行动。请检查并重试。",
    returnInProgress: "退回中",
    returnRequestError: "请求无法退回，请重试",

    //Client Withdraw Request
    WithdrawRequest: "撤销请求",
    WithdrawReuestConfirmMsg: "是否确认撤销此请求？撤销后客户将无法查看该请求。撤销完成后，请求将移至草稿列表",
    WithdrawMenuOption: "撤销",
    MoreOptions: "更多选项",
    Complete: "完成",
    WithdrawLabel: "已撤销",
    CompleteInstructionalText: "如客户已提供信息，请点击“完成”。",

    //Client Complete Request
    CompleteRequestConfirmMsg: "完成一项请求会将该请求从客户端的待办事项清单中删除，并将客户端的状态更新为“已发送”。该请求将被移动到EY Canvas中的“已接收”列表中。例如，当已经通过其他方式接收到所请求的信息时，可以使用该功能。",
    CompleteRequest: "完成请求",
    CompleteRequestSuccess: "请求已完成",

    //Client Accept Return Request
    AcceptLabel: "接受",
    ReturnLabel: "退回",
    ReturnRequest: "返回请求",
    acceptRequest: "接受请求",
    acceptRequestWithoutTask: "你确定要接受所选请求吗？",
    acceptRequestWithTask: "<b>是否确认接受所选请求？</b>文档附件可从{0}相关任务的外部文档标签页获得。",
    acceptRequestSuccess: "已接受请求",
    returnedRequestSuccess: "请求已退回 -",

    // Client Request Relate Files modal
    noRecordsFound: "未发现记录",
    relateSelected: "关联已选择项",
    relateFilesModalHeader: "如想将现有文档关联至此请求，选择欲添加文档并点击关联已选择项。",
    relateAnalyticModalHeader: "若要将现有分析工具与此请求关联，请在相应的分析工具前进行勾选。若要预览其他可用分析工具，请点击",
    relateAnalyticHereModalHeader: "此处",
    noAnalyticsRecordsFound: "没有可供分享的分析工具。点击",
    noAnalyticsRecordsFoundGetStarted: "然后开始。",
    associateExistingDocumentsSelected: "已添加文件",
    associateExistingDocumentSelected: "已添加文件",

    // Client Request Details Header
    timePhaseLabel: "时间段：",
    receivedDateLabel: "已接收：",
    dueDateLabel: "到期：",
    sentDateLabel: "已发送：",
    acceptedDateLabel: "已接受：",
    clientRequestSyncLabel: "正将更新发送至EY Canvas客户端",
    editDescriptionLabel: "编辑描述",
    createdDateLabel: "创建人：",

    //Client Advance Search
    advancedSearch: "高级搜索",
    advancedSearchRefereceNumberCheck: "索引#",
    advancedSearchTitleCheck: "标题",
    advancedSearchDocumentsCheck: "文档",
    advancedSearchCommentsCheck: "批注",
    advancedSearchApplyButton: "应用",
    searchRequest: "搜索",
    clearSearch: "清空搜索",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "货币类型",
        currencyCode: "货币代码",
        businessUnit: "业务单元",
        all: "全部",
        moduleName: "调整模块",
        financialStatement: "财务报表",
        viewByTrialBalanceType: "按试算平衡表类型查看",
        multiEntry: "多实体",
        balanceSheet: "资产负债表",
        incomeStatement: "利润表",
        currentperiodUnadjusted: "Analysis date",
        unadjusted: "（未调整）",
        currentperiodAdjusted: "Analysis date",
        adjusted: "（已调整）",
        adjustment: "调整",
        newAdjustment: "新调整",
        noRecordsFound: "未发现记录",
        periodEnded: " 截止日期",
        periodsEnded: " 截止日期",
        noResultsFound: "未找到结果",
        notApplicableAbbreviation: "不适用",
        noAdjustmentCreated: "未创建调整。",
        createAdjustment: "创建 {0} 。",
        next: "下一页",
        previous: "上一页",
        reclassification: "重新分类",
        manageAdjustment: "管理调整",
        lastPage: "尾页",
        firstPage: "首页",
        filterYes: "是",
        filterNo: "否",
        showOnlyAdjustedAccountClasses: "仅显示已调整的账户类别",
        noneAvailable: "无可用项",
        noImportedTrialbalanceAvailable: "没有导入的试算表。",
        trialBalanceRequired: "试算表",
        comparativeperiodUnadjusted: "比较日期",
        comparativeperiodAdjusted: "比较日期",
        multityEntityRequired: "多实体",
        placeHolderMessageWhenHelixMappingIsTrue: "没有导入的试算表。点击{0}关联新分析工具。",
        placeHolderMessageWhenHelixMappingIsFalse: "无法与EY Helix集成。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
        eyHelixIntegrationLinkText: "EY Helix关联",
        noEntitiesAvailablePlaceholder: "没有创建实体。请创建实体以开始。",
        search: "搜索",
        viewAdjustmentWithValidations: "查看带有验证的调整（{0}）",
    },

    misstatementLabels: {
        name: "名称",
        notes: "注释",
        signOffs: "签署",
        open: "打开",
        openReadOnly: "以只读方式打开",
        delete: "删除",
        rename: "重命名",
        signOffRequirements: "签署要求",
        confidentiality: "机密性",
        unlink: "取消链接",
        removeFromAdjustment: "从调整中删除"
    },

    allControls: "所有控制",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "外部",
        taskDocuments: "文档",
        deletedDocuments: "已删除",
        priorPeriodDocuments: "上一年度",
        priorPeriodInfoMessage: "无法下载这些文档",
        uploadedBy: "上传人",
        deletedBy: "删除人",
        lastModifiedBy: "最后修改人",
        eyBadge: "已从文档中删除",
        externalBadge: "已从外部删除",
        uploadInProgress: "上传中",
        refreshdocuments: "刷新文档",
        disabledDocument: "不允许对此类型的文档执行批量操作。",
        menuOptions: {
            delete: "删除",
            open: "打开",
            openr: "打开只读文件",
            restore: "恢复",
            remove: "删除",
            rename: "重命名",
            editInHelix: "在EY Helix中编辑"
        },
        externalPriorPeriod: "客户",
        eyPriorPeriod: "安永",
        uploadedByEY: "安永"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "已分配用户或小组无效。更新工作分配以继续。点击",
    clientRequestAssignedToErrorLabelEnd: "以编辑外部项目小组成员。",
    clickHereLabel: "此处",
    clientRequestAssignedToIconErrorLabel: "已分配小组没有活跃成员。将请求分配给活跃用户/小组或将成员添加至小组以继续。",
    clientRequestDueDateErrorLabel: "到期日是必填项。请更新到期日以继续。",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "未添加外部文档"
        },
        {
            id: 'taskDocuments',
            label: "拖放一个或多个文档或者点击添加文档"
        },
        {
            id: 'deletedDocuments',
            label: "没有已删除文档"
        },
        {
            id: 'searchRequestDocuments',
            label: "未发现匹配项，请重试"
        },
        {
            id: 'priorPeriodDocuments',
            label: "没有可用的前期文档"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "已创建注解",
        "ey.at.hercules.annotation.edited": "已编辑注解",
        "ey.at.hercules.annotation.replied": "已回复注释",
        "ey.at.hercules.contentupdate.updated": "内容已更新",
        "ey.at.hercules.contentupdate.failed": "内容更新失败"
    },

    //Assign to
    usersOption: "用户",
    externalUsersOption: "外部用户",
    groupsOption: "分组",
    lblassignedto: "被分配至",
    searchGroup: "搜索集团",
    requiredAssignedTo: "被分配人为必填",
    rdSubmitRequest: "提交请求",

    closeDrawer: "关闭并取消全选",
    requestSelected: "已选定请求",
    requestsSelected: "已选定请求",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "项目范围与定制子范围",
    defineGroupScopes: "确定集团范围",
    gaScopeIntro: "此处默认添加的是EY GAM规定的项目范围。如果您需要为同一范围内的项目组定制集团任务与指引，请考虑创建子范围。在发送指引时，您可以将不同版本发送至各子范围。",
    addSubScope: "添加子范围",
    customSubScope: "定制子范围",
    noCustomSubscopes1: "该项目范围无定制子范围。",
    noCustomSubscopes2: "选择<b>添加子范围<b>以开始。",
    subScopeName: "子范围名称",
    addDescription: "添加描述",
    textExceedsLength500: "文本不得超过500个字符。",
    manageGroupPermission: "你必须拥有<b>管理集团</b>权限才能执行该操作。请联系<b>项目管理员</b>申请权限。",
    deleteCustomSubScope: "删除定制子范围",
    areYouSureDeleteCustomSubScope: "是否确认删除此定制子范围？",

    //GA Component labels
    newTeam: "新项目组",
    teamName: "项目组名称",
    legalEntityName: "法人实体名称",
    parentTeam: "主管项目组",
    isReferenceOnly: "仅作参考",
    isNotUsingCanvas: "没使用EY Canvas的项目组",

    referenceOnlyTooltip: "被指定为<b>仅供参考</b>的该项目组不接收关联请求、说明或任务。这类项目组仅用于建立组织结构。",

    canvasFormNotOwnedByEng: "无法将不属于该项目的Canvas共享表格发送至EY Canvas客户端。如果你需要发送(或从来源项目发送）该项目的表格，请先复制该表格。",
    canvasFormNotAllowedInCtry: "你所在国家禁止与客户共享Canvas表格。",
    on: "开启",
    sendRequest: "发送请求",
    selectUserOrGroup: "选择用户或集团",
    canvasFormShowAttachments: "显示{0}附件",
    canvasFormShowOneAttachment: "显示1附件",
    canvasFormHideAttachments: "隐藏{0}附件",
    canvasFormHideOneAttachment: "隐藏1附件",

    //GA Components
    createGroupStructure: "创建集团结构",
    componentText: "为通过EY Canvas发送可交付成果的各项目组创建地区和组成部分。如果项目组不通过EY Canvas发送可交付成果，您可以选择将其指定为<b>不使用EY Canvas</b>。为了便于组织，您还可以创建项目组，并将其指定为<b>仅供参考</b>。这些项目组不会收到关联请求、指引或任务。完成后，请选择<b>发送关联请求</b>。",
    addTeam: "添加项目组",
    sendLinkRequests: "发送关联请求",
    noComponents: "尚未创建任何项目组。  点击<b>添加项目组</b>开始。",
    editTeam: "编辑项目组",
    deleteTeam: "删除项目组",
    deleteInstructional: "是否确认删除此项目组？<br/><br/>将断开与此项目组的关联，您的项目将无法与该项目组分享文档记录。此外，分配给此项目组的所有定制指引和任务将被同时删除。",
    linkRequestHasBeenSent: "你不能编辑此小组的范围或指定，因为已发送链接请求，或已设置指定。",
    selectScopes: "选择范围",
    searchScopes: "查询范围",
    selectTeams: "选择小组",
	sendLinkRequestsDescription: "选择你要与项目进行关联的范围或项目组。<br> 关联请求将发送至各项目组联系人。接受关联请求后， 联系人将通过EY Canvas接收集团指引和任务。",
    sendVersionsDescription: "请选择您想要发送最新版集团指引和任务的范围或项目组。<br>项目组必须与您的项目相关联才能收到集团指引和任务。项目组接收最新版指引后可在项目内使用。",
    notSentYet: "尚未发送任何版本",
    notLinkedYet: "关联请求未发送",
    cardView: "卡片视图",
    noItemsPlaceholder: "尚没有已发布版本。发布一版集团指引与任务，以在此查看数据。",

    //GA Instructions
    customizeGroupInstructions: "定制集团指引",
	gaInstructionsIntro: "默认添加EY GAM规定的集团指引，仅供参考。这些指引旨在向地区和组成部分项目小组提供关键信息、 工作范围和集中执行的程序。 对EY GAM提供的指引加以调整， 需要时补充额外的指引， 并指定是否应将每个指引分配到范围或项目组。 完成后， 发布您的指引， 以便将其发送给分配的范围或项目组。",
    addInstruction: "添加指引",
    instruction: "指引",
    groupTaskSelected: "集团任务",
    assignScopes: "分配至范围",
    assignTeams: "分配至小组",
    maxLengthMessage: "文本不能超过<b>500<b>个字符。",
    addScope: "添加范围",
    editInstruction: "编辑定制指引",
    editKnowledgeInstruction: "编辑资料库指引",
    editKnowledgeTask: "编辑资料库任务",
    editCustomTask: "编辑定制任务",
    saveChangesInstruction: "保存变更",
    updatedOnInstruction: "上次更新日期：",
    knowledgeDescriptionInstruction: "资料库描述",
    editDisabledTitle: "你必须拥有<b>管理集团</b>权限才能执行该操作。如请求权限，请联系<b>项目管理员</b>。",
    deleteCustomInstruction: "删除指引",
    deleteGroupTask: "删除集团任务",
    areYouSureDeleteCustomInstruction: "是否确定删除该定制指引？",
    areYouSureDeleteCustomTask: "是否确定删除该定制任务?",
    publishAfterDelete: "如删除该指引，请发布你的变动，然后将新发布的指引重新发送至分配的范围或项目组。",
    publishAfterDeleteGroupTask: "如删除该集团任务，请发布你的变动，然后将新发布的任务重新发送至分配的范围或项目组。",
    resendPublishInformation: "你可以在此步骤发布所做的变动。你可以在汇总部分重新发送新发布的指引。",
    resendPublishInformationGroupTask: "你可以在此步骤发布所做的变动。你可以在汇总部分重新发送新发布的任务。",
    compareVersionsNoVersionSelectedTitle: "尚未选择要比较的版本！",
    compareVersionsNoVersionSelectedSubtitle: "请从下拉列表中选择要与最新版本进行比较的版本",

    //Add Section
    addSection: "添加小节",
    addSectionInstructionalText: "添加小节，以整理您的定制指引。",
    addSectionPlaceholder: "小节名称",

    //Edit Section
    editSection: "编辑章节名称",
    editSectionInstructionalText: "更改此定制章节的名称。<br>完成后, 请发布您的更改，以将更新版发送至所选范围或项目组。",
    editSectionSave: "保存变更",

    //Delete Section
    deleteCustomSection: "删除章节",
    areYouSureDeleteCustomSection: "您是否确认要删除此章节？<br>此章节中的所有指引将被删除。完成后, 请发布您的更改，以将更新版发送至所选范围或项目组。",
    customSection: "章节",

    //Publish Changes
    publishChanges: 'Publish changes',
    publishChangesInstructional: "是否确认发布对当前指引和任务的变动？<br><br>先前的指引和任务将被覆盖。变动发布后，你可以在汇总部分发布更新后的指引和任务。",
    publishChangesNotAvailable: "暂不可用",

    //GA Tasks
    costomizeGroupTasks: "定制集团任务",
    gaTasksIntro: "默认添加EY GAM规定的集团任务，这些任务发送至关联的项目。对EY GAM规定的任务加以调整，需要时补充额外任务，并指定是否应将每个任务分配到范围或项目组。完成后，发布您的任务，以便将其发送给分配的范围或项目组。",
    addCustomTask: "添加定制任务",
    groupTask: "集团任务",
    gaTasks: "任务",
    attachments: "附件",
    notAvailable: "不可用",
    gaDocument: "文档",
    gaDocuments: "文档",
    gaScope: "范围",
    gaScopes: "范围",
    gaScopesCapitalized: "范围",
    gaTeam: "项目组",
    gaTeams: "项目组",
    gaUnassignedScopeTeam: "未分配",
    hideDetails: "隐藏详情",
    gaAssignedScopes: "分配的范围",
    gaAssignedTeams: "分配的项目组",
    addTask: "新任务",
    due: "到期",
    noAttachments: "未添加附件。",

    // Chip component
    chipMore: "更多",

    // GS Group Summary labels
    assignedTeam: "分配的项目组",
    lastPublished: "上次发布日期",
    versionStatus: "版本状态",
    lastSent: "上次发送日期",
    lastSentTooltip: "该日期为上次将某一版本的指引和任务发送给各项目组的日期。点击日期可查看发送给项目组的版本。",
    lastSentBeforeTooltip: "<b><<范围名称>><b>有可以使用的新版指引和任务。请考虑是否需要将最新版本发送给该项目组。",
    groupSummary: "集团汇总",
    summarySubTitle: "查看分配给以下每个范围和项目组的最新版指引和任务。若要将此版本发送给分配的范围和项目组，请选择<b>发送版本</b>。<br/>您还可以选择相关发送日期，以查看发送给特定项目组的版本。",
    compareVersions: "比较版本",
    sendVersion: "发送版本",
    compareVersionsInstructional: "将已发布指引和任务的最新版本与发送给项目组的版本进行比较。如有差异，请评估是否需要将最新版发送给项目组。",
    publishedVersion: "已发布版本",
    sentVersion: "已发送版本",
    emptyPublishedVersion: "无可用范围。<br/>此处为分配给组成部分项目小组的任务。",
    emptySentVersion: "无可用项目组。",
    selectPublishedVersion: "选择一个已发布版本查看数据。",
    selectSentVersion: "选择一个已发送版本查看数据。",
    dueDate: "到期日",
    emptyPublishedSnapshot: "选定的范围没有公布的指引和可用任务。<br/>在此处公布指引以查看数据。",
    emptySentSnapshot: "指引和任务尚未发送至选定的项目组。<br/>在此处公布并发送指引和任务至此项目组以查看数据。",
    update: "更新",
    updates: "更新",
    noTeamsPlaceholder: "无项目组占位符",
    noTeamSelected: "请至少选择一个范围或项目组以继续。",
    latestVersionAlreadySent: "尚未创建项目组。请创建一个或多个项目组以发布某一版本的说明和任务。",
    latestHasBeenSended: "最新版指引与任务已发送至此项目组",
    noNewVersionToSend: "所选的范围或项目组已经收到最新版说明和任务。没有可以发送的更新。",
    notSelectedTask: "未选中",
    assignedTeams: "分配的项目组",
    noTeamsCreatedYet: "尚未创建项目组。请创建一个或多个项目组以发布某一版本的说明和任务。",
    newersTeamsSended: "最新版指引与任务已发送至相关范围或项目组。",
    LinkRequestNotSent: "关联请求未发送",
    lastVersionSentInstructionalText: "下面显示了在<b>{sentDate}</b>发送到<b>{teamName}</b>的任务和指引的版本。这是发送到此项目组的最新版本。",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "{versionType}分组说明和任务版本",
    receiveInstructionsInstructional: "{primaryEng}于{sentDate}发送的分组说明和任务版本{versionType}请查看此版本并选择接受还是退回。您可以使用<b>比较版本</b>选项对当前版本和以往版本进行比较。",
    fromLabel: "从",
    assignedScope: "分配的范围",
    dateSent: "发送日期",
    acceptVersion: "接受版本",
    returnVersion: "退回版本",
    returnPrimaryButton: "退回",
    returnVersionDescription: "是否确定将该版说明和任务退回给主审小组？ <br>该版本不会导入至您的项目中。请添加注释，向主审小组说明您的退回理由。",
    noContent: "目前没有可用说明，请稍后重试或联系帮助台",
    editorPlaceHolder: "注释",
    receiveCompareVersionInstructional: "将选定的从{primaryEng}收到的指引和任务版本与收到的早期版本进行比较，以确定差异。",
    latestReceiveCompareVersionInstructional: "将从{primaryEng}收到的最新版本的指引和任务与收到的早期版本进行比较，以确定差异。",
    latestVersion: "最新版本",
    earlierVersion: "上一版本",
    earlierVersionEmpty: "没有可以用来对比的早期版本。",
    selectEarlierVersion: "选择一个早期版本，以在此查看数据。",
    pstName: "复核集团项目指引",
    pstDescription: "复核集团审计指示。完成“执行-一般”中的小组任务。在接受集团审计指示后，这些任务已添加到任务列表中。",
    selectedVersion: "选定的版本",
    issuingEngagement: "发布项目",
    accountsAndDisclosureLink: "账户和披露",
    openRiskAssessmentDocuments: "打开风险评估文档",
    openRiskAssessmentDocument: "打开风险评估文档",

    //Client engagement name labels
    successQueueMessage: "已在EY Canvas客户端中成功更新项目显示名称。",
    clientEngagementInstructionalText: "在此处添加或编辑定制项目显示名称。在EY Canvas客户端访问该项目的外部项目组成员可看到该名称。",
    clientEngagementPlaceholder: "项目显示名称",
    clientEngagementModalTitle: "EY Canvas客户端中的项目显示名称",
    clientDisplayName: "客户显示名称",
    textExceedsLength: "文本不得超过100个字符。",

    // Manage client access locations
    location: "位置",
    locationName: "位置名称",
    accessLocations: "访问位置",
    inputType: "输入类型",
    ipAddress: "IP地址",
    ipAddresses: "IP地址",
    startOfIpRange: "起始IP地址",
    endOfIpRange: "终点IP地址",
    cidrNotation: "CIDR标识",
    manageClientAccessLocationsLink: "添加位置",
    manageClientAccessLocationsModalTitle: "管理客户访问位置",
    manageClientAccessLocationsInstructionalText: "将IP地址添加到下面的列表中，以启用对EY Canvas客户端基于位置的访问权限。<br>如果启用了客户访问位置，则只有具有此处列出的IP地址的外部小组成员才能访问此项目。如果未添加IP地址，则外部小组成员将能够从任何位置访问此项目。<br>点击<b>此处<b>了解更多信息。",
    manageClientAccessLocationsNoResultFound: "暂未针对此项目添加IP地址。内部和外部项目组成员可从任何位置访问此项目。",
    deleteAccessLocations: "删除访问位置",
    deleteAccessLocationsInstructionalText: "是否确定删除所选定的访问位置？<b>如果外部项目组成员试图从此位置访问EY Canvas客户端，则他们将无法继续访问此项目。",
    locationLengthError: "位置描述不得超过100个字符。",
    oneOrMoreIpAddressFormatError: "提供的一项或多项IP地址无效。",
    ipAddressFormatError: "提供的IP地址无效。",
    ipSuffixError: "IP地址的CIDR后缀必须为≥1且≤32的十进制数。",
    ipRangeStartSmallerThanEnd: "起始IP不得超过终点IP。",
    ipInputTypeInfo: "选择IP地址，输入单个地址或地址列表。仅支持IPv4地址。<br>选择IP范围，输入具有相同网络前缀（即地址的前三个字段）的IP地址范围。<br>选择CIDR地址块，输入带有CIDR标识的IP地址范围。仅支持CIDR地址。",
    ipAddressInfo: "你可以将IP地址逐个输入列表，并以逗号分隔，也可以将每个IP地址单独列为一行。<br>有效的IPv4地址由0到255之间的四个整数构成，整数之间以句号分隔",
    ipCidrInfo: "输入表示能够访问此项目的IP地址范围的CIDR记法。<br>有效的CIDR记法包含一个有效的IPv4地址、斜线（/）字符以及≥1且≤32的十进制后缀。",
    ipAddressEg: "例如192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "例如192.XXX.X.1",
    ipRangeEndEg: "例如192.XXX.X.2",
    ipCidrEg: "例如192.XXX.X.1/22",
    searchIpPlaceholder: "检查IP地址",
    ipNotAddedMessage: "暂未被添加至准许的IP列表。",
    ipIsAllowedMessage: "IP地址已得到准许。",
    importAccessLocationsLink: "导入访问位置",
    importAccessLocationsInstructionalText: "访问位置可以从你以前的项目中导入。<br>你确定要导入访问位置吗？",
    importAccessLocationsCloseButton: "关闭",
    importAccessLocationsCancelButton: "取消",

    // Export Requests
    exportRequests: "导出请求",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "新请求",
        titleTipAddButton: "新增",
        closeTitleTip: "关闭",
        modalTitle: "新请求",
        returnModalTitle: "退回请求",
        modalHeader: "添加新请求并发送到EY Canvas客户端",
        requiredAssignedTo: "（必填）",
        assignToError: "被分配人为必填",
        dueDate: "截止日期（必填）",
        dueDateError: "截止日期为必填",
        titlePlaceholder: "标题（必填）",
        titleError: "标题为必填",
        description: "描述",
        descriptionplaceholder: "输入描述",
        descriptionError: "请求描述超出最大长度，（4,000字符）",
        associateDocuments: "关联文档",
        emptyAssociatedDocumentsList: "拖放一个或多个文档或者点击添加文档",
        addDocumentButton: "添加文档",
        signOffCheckbox: "上传EY Canvas客户端的文档需要签字。",
        sendRequest: "发送请求",
        returnRequest: "返回请求",
        saveAsDraft: "保存为草稿",
        cancel: "取消",
        copyTitleAndDescription: "从任务中复制标题和描述",
        copyAssociatedDocuments: "从任务中复制文档",
        priority: "请求优先级",
        addNewRequestButton: "添加新请求",
        addExistingRequestButton: "添加现有请求"
    },
    addCustomEventModal: {
        titleTip: "新事件",
        closeTitleTip: "关闭",
        modalTitle: "新事件",
        eventDate: "事件日期",
        eventDateError: "日期为必填项",
        titlePlaceholder: "标题",
        titleError: "标题为必填",
        description: "描述（选填）",
        descriptionplaceholder: "输入描述",
        descriptionError: "事件描述超出最大长度，（4,000字符）",
        sendEvent: "发送事件",
        saveAsDraft: "将事件保存为草稿",
        cancel: "取消",
        eyParticipantsCollaborationError: "至少需要添加一位安永参与人。",
        externalParticipantsCollaborationError: "至少需要添加一位外部参与人。"
    },
	eyHelixInstructionText: "查看下列已关联EY Helix项目和建议使用的分析工具。<br/>点击任何项目或分析工具，以前往特定EY Helix页面。",
	smartAutomationInstrText: "在下方查看你当前正在使用的智能自动化解决方案。<br/>点击解决方案前往智能自动化中心。",
    smartAutomationSolutionsNotAvailable: "你的项目目前没有可用的智能自动化解决方案。",
    noSmartAutomationAvailable: "您的项目暂无可用智能自动化解决方案。",
    availableSolutions: "可用的解决方案",
    useOfSuggestedSolutions: "使用建议的解决方案",
    useOfOtherSolutions: "使用其他解决方案",
    suggestedSolutions: "建议的解决方案",
    otherSolutions: "其他解决方案",
	currentlyusing: "当前正在使用",
    suggested: "建议的",
    primaryProject: "主审项目",
    noLinkedProjects: "您的项目暂无关联的项目。",
    noSuggestedAnalyzers: "您的项目暂无建议的分析工具。",
    eyHelixNotAvailable: "EY Helix不可用",
    helixNotAvailableMessage: "您的项目目前暂不可使用EY Helix。",

    noGroupTaskCreatedYet: "尚未创建集团任务。",
    noInstructionsCreatedYet: "尚未创建指引。",
    documentsReceived: "收到的文档",
    documentsPending: "待完成文档",

    teamLabel: "小组",
    scopeLabel: "范围",

    documentSignOffby: "签署文件的人员",
    documentAddedBy: "添加文件的人员",
    documentModifiedBy: "修改文件的人员",
    documentDeletedBy: "删除文件的人员",
    commentAddedBy: "注释添加人",
    commentClearedBy: "注释清除人",
    commentClosedBy: "注释关闭人",
    commentReopenedBy: "注释重新打开人",

    documentAssignedTo: "分配文件至",
    draftDocReceivedFrom: "接收的初版文件来自",
    finalDocReceivedFrom: "接收的终版文件来自",
    documentReturnedBy: "返回文件的人员",
    returnedDocumentClearedBy: "清除返回文件的人员",
    documentConflictResolvedBy: "解决文件冲突的人员",
    draftDocumentSentBy: "发送初版文件的人员",
    documentReturnedFrom: "返回的文件来自",
    finalDocumentSentBy: "发送终版文件的人员",
    noActivityAvailable: "没有可用活动。",
    allEngagementFilterLabel: "所有其他项目",
    otherEngagementComments: "其他项目注释",
    engagements: "项目",
    engagement: "项目",
    view: "查看",
    notesModalInstructionalText: "查看和回复以下所选{0}的注释。",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "未找到匹配项。请重试。",

    //New collaboration Related tasks
    relatedTasksLabel: "相关任务",
    selectRelatedTasks: "选择任务",
    searchAndPressEnter: "选择并点击回车",
    noRelatedTasksSelected: "没有选择相关任务",
    relatedTasksCount: "相关任务",
    notFoundTasks: "未发现任务",
    dueDateDetailLabel: "到期日",
    requestType2MessageTitle: "将在新标签页打开此请求",
    requestType2MessageSubtitle: "刷新页面以查看任何已有更新。",
    requestType2InTrnasitMessageTitle: "此请求仍在传输中，无法打开。",
    requestType2InTrnasitMessageSubtitle: "请等待同步完成并刷新页面重试。",

    //New collaboration Time Phase
    selectTimePhase: "请选择时间阶段",
    timePhaseNotFound: "找不到时间阶段",

    understandITProcess: "了解IT流程",

    //New collaboration Access Location
    accessLocationLabel: "已启用访问位置",
    accessLocationTitle: "只有通过获授权的网络位置建立连接的用户有权通过EY Canvas客户端访问此项目。可以从选项菜单中的“访问位置”管理允许的位置。",

    // Reporting Labels
    summaryScreenLabel: "汇总界面",
    dataExportLabel: "数据导出",
    projectManagementLabel: "项目管理",
    reportingHeaderName: "报告",
    repAllTasks: "所有任务",
    repDeletedTasks: "已删除任务",
    repMultiEntityTasks: "多实体任务",
    repAllAuditPlan: "审计计划",
    repITAppSOSummary: "IT App/SO汇总表",
    repITProcessScotControls: "IT流程、重大交易类别（SCOT）和控制",
    repTaskAssignments: "任务分配",
    repTaskDetails: "任务详细信息",
    repTaskAnalysis: "任务分析",
    repTaskSummary: "任务汇总（试运行）",
    repExportToExcel: "导出数据",
    repExportDate: "导出日期",
    repEngInfo: "项目信息",
    repNoRecordMessage: "没有要显示的记录",
    dateInUTC: "UTC中",
    repSCOTsControls: "重大交易类别与控制",
    repITProcessSummary: "IT流程汇总表",
    repCanvasForms: "Canvas表格",
    repControlForms: "控制表格",
    projectInsight: "项目洞察",
    archiveForm: "归档表格",
    archive: "归档",
    repCanvasFormResponse: "Canvas表格回复",
    repCanvasFormRelatedComments: "相关注释",
    repControlFormResponse: "控制表格回答",
    repNoRecordFound: "未发现记录",
    repCanvasFormsIncomplete: "回复未完成",
    repCanvasFormRelatedObjects: "相关对象",
    voiceNoteLabel: "语音注释",
    repComponentTeamGroup: "组成部分小组",
    componentTeamCanvasFormExport: "导出Canvas表格",

    // Reporting Tasks
    repTaskTitle: "任务名称",
    repTaskDescription: "任务描述",
    repTaskSource: "任务来源",
    repTaskNature: "任务性质",
    repTaskCloseEarly: "提前",
    repTaskCloseLate: "逾期",

    // Reporting Documents
    repAllDocuments: "所有文档",
    repSignOffs: "签字",
    repDocumentsModified: "RRD之后修改的文档",

    //Reporting Collaboration
    repRequestsAndTasks: "请求和任务",
    repRequestsTasksComments: "请求和任务批注",

    SCOTSummaryReportHeader: "重大交易类别汇总表",
    GroupReportHeader: "集团报告",
    SCOTSummaryEffective: "有效",
    GroupInstructionSummary: "集团指引概述",
    GroupActivity: "组成部分账户匹配记录",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "集团组成部分账户匹配",
    AccountDisclosuresReportHeader: "账户和披露",

    //Reporting Collaboation Details
    collaborationDetails: "合作详情",
    collaborationSummary: "汇总表",
    collaborationActivity: "活动详情",
    ReviewNotesReportHeader: "复核注释",

    GroupStructureSummary: "集团结构概述",

    //Reporting CRT Summary
    wcgwSummary: "可能出错项汇总表",
    crtlabel: "控制复核工具（CRT）",
    assertionSummary: "认定汇总表",
    scotSummary: "重大交易类别汇总表",
    noRecordsToExport: "没有要导出的记录",
    statisticsSummary: "统计数据",
    qualityChecks: "质量检查",
    controlSummary: "控制汇总表",
    filterBySCOT: "按重大交易类别筛选",

    //Reporting manage team
    independenceSummaryReportTabName: "独立性汇总表",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "查看所有风险类型和认定",
    riskRelatedToAssertion: "认定相关风险",
    higherRiskRelatedToAssertion: "认定相关较高风险",
    noRisksAvailable: "无可用风险",
    relatedEstimates: "相关估计",
    viewAllAssertions: "查看所有认定",
    wcgwRelatedToAssertion: "与认定相关的可能出错项",
    noWcgwsAvailable: "无可用的可能出错项",
    goTo: "前往",
    allItems: "所有项目",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "添加时间阶段",
        modalDescription: "添加属性，点击保存并关闭或保存并添加。",
        timephaseNameLabel: "时间阶段名称",
        milestoneSelectLabel: "里程碑",
        timephaseLabel: "时间阶段",
        startDateLabel: "开始",
        endDateLabel: "结束日",
        startDateErrorMessage: "开始日为必填项。",
        endDateErrorMessage: "结束日为必填项。",
        timephaseNameErrorMessage: "姓名为必填。",
        milestoneErrorMessage: "里程碑为必填项。",
        isKeyEvent: "关键事项",
        timephaseDescription: "描述（可选填）",
        addSuccessMessage: "时间阶段添加成功。"
    },

    AccountListHeaderLabels: {
        pspAndosp: "主要实质性程序/其他实质性程序",
        limitRiskAssertionLabel: "有限风险账户",
        heading: "账户和披露及已关联",
        accountsOrDisclosure: "账户和披露",
        psps: "主要实质性程序",
        rejected: "拒绝",
        remove: "删除",
        risks: "风险",
        assertions: "认定",
        noRecordsFound: "无可用账户或披露",
        noResultsFound: "未发现结果",
        responsiveHeading: "做出应对的",
        rejectedPspsHeading: "被拒绝的主要实质性程序",
        importPsps: "导入主要实质性程序",
        importOsps: "导入其他实质性程序",
        addOsps: "添加其他实质性程序",
        pspEnded: "开始。",
        noPspsandOsps: "没有可用的 {0} 。",
        allAreRejected: "所有主要实质性程序均已被拒绝。",
        rejectButton: "拒绝",
        acceptButton: "接受",
        additionalInfo: "理由：",
        noAssertionsAvailableLabel: "没有可用的认定",
        noAssertionAvailableTooltip: "无可用认定。请点击<strong>管理账户和披露</strong>添加认定。",
        importFromKnowledge: "从知识库导入",
        disabledAddOspTooltip: "必须至少有一个认定可用于添加实质性任务。请点击<strong>管理账户和披露</strong>添加认定。",
        noPsps: "无可用的主要实质性程序。{0}才可以开始。",
        noOspsPsps: "无可用的主要实质性程序/其他实质性程序。{0}、{1}或{2}才可以开始。",
        acceptErrorMsg: "无法接受被拒绝的任务。请刷新页面重试。如问题仍然存在，请联系帮助台。",
        build7NoPspOrOspAttachedToAssertion: "每一项认定都必须至少有一个做出应对的实质性程序。以下认定无任何做出应对的主要实质性程序/其他实质性程序：<b>{orphanAssertions}</b>. {0} 、{1}，或添加{2}以应对账户的所有认定，或点击对账户做出应对的已有主要实质性程序/其他实质性程序的编辑图标，将这些程序与其他认定关联。",
        build7NoPspOrOsp: "每一项认定都必须至少有一个做出应对的实质性程序。认定均无做出应对的主要实质性程序/其他实质性程序。 {0} 、{1}，或创建{2}以应对账户的所有认定。",
        build7NoOspsAndAllPspAreRejected: "每一项认定都必须至少有一个做出应对的实质性程序。已拒绝所有主要实质性程序，认定均无做出应对的主要实质性程序/其他实质性程序。 {0} 或创建{1}以应对账户的所有认定。",
        build6And7NoAssertions: "每个重大账户或重大披露都必须至少有一个关联认定可用于添加实质性程序。点击 {0} 添加认定。",
        build7LimitedAccountNoPspOsp: "每个有限风险账户都必须至少有一个做出应对的实质性程序。 {0} 或创建{1}以应对账户的风险。",
        manageAccountAndDisclosures: "管理账户和披露"
    },

    AddTaskLabels: {
        accountLabel: "账户：",
        taskSectionLabel: "任务章节：",
        ospModelTitle: "新建其他实质性程序",
        ostModelTitle: "新建其他实质性测试",
        saveAndClose: "保存",
        saveAndCreate: "保存并新建",
        cancel: "取消",
        prefix: "前缀",
        title: "标题",
        suffix: "后缀",
        timePhase: "时间阶段",
        description: "自定义描述",
        descriptionPlaceholder: "自定义任务描述（必填）",
        assertions: "认定",
        optional: "（可选）",
        required: "必填",
        noResultFound: "未找到结果",
        of: "的",
        characters: "个字符",
        descriptionMaxLengthError: "描述长度超过了允许的最大长度",
        noteDiscriptionErrorMessage: "回复包含 {0} 个字符，超过了{1}个字符的最大值。请通过删减文本或设置格式调整描述，然后重试。如果问题仍然存在，请联系帮助台。",
        customizeDescription: "自定义任务描述（必填）",
        errorMsg: "添加其他实质性程序失败。请刷新页面重试。如问题仍然存在，请联系帮助台。",
        customizeTaskDescription: "自定义任务描述"
    },

    RemoveTaskLabels: {
        modelOspTitle: "删除其他实质性程序",
        modelOstTitle: "删除其他标准任务",
        deleteBtn: "删除",
        cancel: "取消",
        confimationOspMsg: "是否要删除选定的其他实质性程序？",
        confimationOstMsg: "是否要删除选定的其他标准任务？",
        warning1Msg: "与本项目中的所有其他任务均无关的相关证据将被移至临时文件夹。",
        warning2Msg: "与所有其他证据均无关的发现和应对任务将被删除。"
    },

    TaskReportHeaderLabels: {
        Tasktype: "任务类型",
        Taskstatus: "任务状态",
        Taskassignedto: "任务分配至",
        Tasktitleprefix: "任务名称前缀",
        Tasktitle: "任务名称",
        Tasktitlesuffix: "任务名称后缀",
        Taskdescription: "任务描述",
        Knowledgetasktitle: "Knowledge任务名称",
        Knowledgetaskdescription: "Knowledge任务描述",
        Oldtaskname: "旧的任务名称",
        Oldtaskdetail: "旧的任务详情",
        Rejected: "已拒绝",
        Rationalforrejection: "拒绝理由",
        Auditphase: "审计阶段",
        Timephasetype: "里程碑",
        Timephase: "时间阶段",
        Timephasestartdate: "时间阶段开始日期",
        Timephaseduedate: "时间阶段结束日期",
        Keyevent: "关键事件",
        Tasksource: "任务来源",
        Tasknature: "任务性质",
        Lasttaskstatuschangedate: "任务状态上次变更日期",
        Taggroup: "标签分组",
        Tags: "标签",
        RelatedMESTentities: "相关MEST实体",
        Schedulednextwaveservices: "预定的NextWave服务",
        Priority: "优先",
        Taskid: "任务ID",
        Roleid: "角色ID",
        Tasktypeid: "任务类型ID",
        Taskstatusid: "任务状态ID",
        Auditphaseid: "审计阶段ID",
        Timephasetypeid: "里程碑ID",
        Tasksourceid: "任务资源ID",
        Tasknatureid: "任务性质ID"
    },

    glAccountDocumentLabels: {
        modelTitle: "总账账户",
        modelName: "关联证据",
        documentName: "文档名称",
        documentCounter: "{0}文档",
        documentsCounter: "{0}文档",
        btnCancel: "取消",
        btnSave: "保存",
        errorMessage: "选择要继续的文档",
        noResultsFound: "未发现结果",
        newTickMark: "新标记",
        bulkModePlaceholder: "选择要关联的证据，然后点击<strong>\’保存’</strong>以完成。"
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "编辑时间阶段",
        modalDescription: "编辑属性并点击<b>保存。</b>",
        editSuccessMessage: "时间阶段更新成功。"
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "删除时间段",
        deleteDescription: "是否确定删除该时间段？",
        showTimePhaseName: "时间段",
        showMileStone: "里程碑",
        showStartDate: "开始日",
        showEndDate: "结束日",
        showDescription: "描述：",
        showAssignedTasks: "任务分配数量",
        showAssignedAssignments: "工作分配数量",
        deleteSuccessMessage: "时间阶段删除成功。"
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "添加标签组",
        modalDescription: "输入名称，点击保存并关闭或保存并添加以继续。",
        tagGroupNameLabel: "标签组",
        tagGroupNameErrorMessage: "标签组为必填",
        saveAndClose: "保存并关闭",
        saveAndAdd: "保存并添加",
        addSuccessMessage: "标签组添加成功。"
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "无可用标签",
        deleteTag: "删除标签",
        deleteDescription: "标签删除后无法撤销，是否继续？",
        showDeleteTagName: "标签",
        showDeleteTagGroupName: "标签组",
        showAssignedTasks: "已分配任务",
        deleteSuccessMessage: "已成功删除标签。",
        task: "任务",
        tasks: "任务",
        addTagGrouplabels: "添加标签组",
        addTag: "添加标签",
        action: "操作",
        addTagDesc: "<h3>添加标签</h3><p>点击“添加标签组”创建可用以添加标签的新标签组。</p>",
        assignTagDesc: "<h3>分配标签</h3><p>将所选项拖放至标签组下您想要放置的标签中。</p>",
        editTagDesc: "<h3>编辑标签</h3><p>点击溢出菜单（…) , 选择“编辑”，以编辑标签属性。 </p>",
        deleteTagDesc: "<h3>删除标签</h3><p>点击溢出菜单（...) , 选择“删除”，以删除标签。 </p>",
        removeTagDesc: "<h3>移除标签</h3><p>若要移除标签, 请将当前带有该标签的一个或多个项目拖放至标签组下关联标签的名称中。</p>",
        expand: "展开",
        collapse: "折叠",
        TagName: "标签名称",
        TagGroupName: "标签组名称",
        addTagSuccessMessage: "标签添加成功。",
        editTagSuccessMessage: "标签更新成功。",
        addTagModalTitle: "添加标签至",
        editTagModalTitle: "编辑标签",
        addTagModalDescription: "创建新标签，点击保存并关闭或保存并添加以继续。",
        editTagModalDescription: "编辑属性并点击<b>保存。</b>",
        tagSetSuccessMessage: "标签设置成功。",
        tagsSetSuccessMessage: "标签设置成功。",
        tagRemoveSuccessMessage: "标签移除成功。",
        tagsRemoveSuccessMessage: "标签移除成功。",
        tagRemovedSuccessfully: "标签移除成功。"
    },

    relateEvidenceHeader: "关联提供有关调整信息的证据。",
    relatedDocumentCounter: " {0} 文档",
    relatedDocumentsCounter: " {0} 文档",
    documentsLocationLabel: "文档位置",
    relateTemporaryFilesHeader: "关联此项目的临时文档。",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "添加工作分配",
        modalDescription: "输入名称，完成后点击保存。",
        assignmentNameLabel: "工作分配名称",
        assignmentNameErrorMessage: "任务分配名称不得为空",
        saveAndClose: "保存并关闭",
        saveAndAdd: "保存并添加",
        addSuccessMessage: "任务分配添加成功。"
    },
    addUserOrRoleLabelto: "添加用户或角色至",
    addUserOrRoleheader: "搜索您要添加的项目组成员或角色。",
    saveAndAdd: "保存并添加",

    // Bulk Assignment
    BulkActionsLabel: "批量操作",
    BulkAssignmentAction: "操作",
    BulkShow: "显示",
    BulkActionsInstructionalText: "使用拖放对任务分组执行批量操作。要查看任务分组中的任务，请将鼠标悬停在任务分组处并点击箭头图标。",
    bulkOperationsModalDescription: "对任务执行批量操作。如要查看任务组的各项任务，请将鼠标悬停在任务组上，然后点击箭头图标。",
    selectRequest: "选择要发送的请求。",
    replaceLabel: "替换",
    labelStaff: "审计员—",
    addModeLabel: "添加",
    replaceModeLabel: "替换",
    dueDateModeLabel: "更新到期天数",
    searchByAssignmentName: "搜索",
    addTeamMemberLabel: "添加项目组成员",
    noTeamMembersFound: "没有可添加的项目组成员",
    addMemberSuccessMessage: "项目小组成员添加成功。",
    addAssignmentLabel: "添加工作分配",
    addAssignmentNameLabel: "添加工作分配名称",
    noAvailableAssignmentsMessage: "没有可用的工作分配",
    showDuplicateError: "不能重复向所选项目组成员或角色分配所选任务中的同一任务分配。请选择其他任务分配、项目组成员或角色以继续。",
    infoBulkAssignments: "批量工作分配",
    infoBulkAssignmentDesc: "选择一组或多组任务，创建新的工作分配或替换现有工作分配。当创建或编辑工作分配时，当前分配到任务的项目组成员是工作分配到期日最早的项目组成员。",
    infoAssignmentsDueDate: "设置任务分配到期日",
    infoAssignmentsDueDateDesc: "使用“选择日期/计算日期”切换按钮来设置任务分配到期日。切换按钮可用于为任务设置一个具体的到期日，或者显示距离时间阶段结束日期前的天数。",
    infoAddAssignmentExisting: "向现有项目组成员添加任务分配",
    infoAddAssignmentExistingDesc: "添加任务分配时需要设置到期前天数。或者可使用日历控制设置确切的到期日。完成后，拖放选定项以创建新一批任务分配。",
    infoAddAssignmentNew: "为新的项目组成员添加工作分配",
    infoAddAssignmentNewDesc: "如果给定的工作分配没有显示项目组成员或角色，请点击“添加项目组成员”查看可用的项目组成员和角色列表。选中后的项目组成员将出现在列表最下方，可将其拖放进行工作分配。",
    infoRemove: "移除任务分配",
    infoRemoveDesc: "若要移除任务分配，将一个或多个项目拖放至任务分配名称下的项目组成员上。该项目组成员所有的未完成任务分配将被移除。已完成任务分配不会被移除。",
    infoReplace: "替换工作分配",
    infoReplaceDesc: "替换工作分配时，请将某一工作分配名称下的一个或多个项目拖放至某一项目组成员。与该工作分配名称相同的当前所有工作分配将会重新分配给所选的项目组成员。如果多个项目组成员都拥有以该名称命名的工作分配，则所有工作分配都将归置所选用户。使用替换工作分配功能时，不强制要求设定到期前天数。如果到期前天数未设置，则使用目前的到期前天数。",
    infoUpdateDueDate: "更新到期日",
    infoUpdateDueDateDesc: "使用“选择日期”或“计算日期”设置新“到期日”，然后拖放到您想要更改到期日的项目组成员上。该项目组成员的未开始任务和正在进行的任务将更新到期日。已完成的任务将不会被更改到期日。",
    infoDelete: "删除工作分配",
    infoDeleteDesc: "点击右侧的任务分配，会出现删除该组任务分配的选项。",
    infoExecutive: "审计负责人工作分配",
    infoExecutiveDesc: "使用筛选和搜索功能筛选出适用于审计负责人的任务，以便快速完成工作分配。",
    infoSpecificTask: "特定任务的分配",
    infoSpecificTaskDesc: "如果需要设置某个任务层面的分配，则将鼠标悬停在左侧的组合上，点击选项查看各项子任务。该操作将显示出该组合的各个子任务并启用颗粒度分配。",
    unassignedLabel: "未分配",
    replaceSignleSuccessMessage: "任务更新成功。",
    replaceMultipleSuccessMessage: "任务更新成功。",
    dueDateSingleSuccessMessage: "任务分配更新成功。",
    dueDateMultipleSuccessMessage: "任务分配更新成功。",
    invalidAssignmentUpdate: "将任务分配给同一名成员以继续更新到期日。",
    removeSuccessMessage: "任务分配更新成功。",
    colorCode: "颜色代码",
    removeSuccessSingleMessage: "任务分配更新成功。",
    removeSuccessMultipleMessage: "任务分配更新成功。",
    assignmentRemovedSuccessfully: "已成功移除任务分配。",

    // Bulk Task
    itemsSelected: "选定的任务",
    itemSelected: "选定的任务",
    dragAndDrop: "拖放",
    currentApplication: "当前应用",
    allAssignmentsClosed: "所有工作分配均已关闭",
    allAssignmentsCompleted: "已完成所有任务分配",

    onOrBeforeCurrentDate: "不晚于当前日期",
    withInCurrentWeek: "本周",
    quickFilter: "快速筛选",
    suggestedFilters: "建议的筛选条件",
    showXMore: "显示{0}更多",

    // Task due date Events
    addEventlabels: {
        modalTitle: "添加事件",
        startDateLabel: "开始",
        modalDescription: "添加属性，点击保存并关闭或保存并添加。",
        eventNameLabel: "事件名称",
        eventType: "事件类型",
        singleDay: "一天内",
        dateRange: "日期范围",
        eventDate: "事件日期",
        eventDescription: "描述（可选填）",
        isEvent: "与客户共享事件",
        EventNameErrorMessage: "事件名称为必填项。",
        eventDateErrorMessage: "事件日期为必填项。",
        addSuccessMessage: "事件添加成功。"
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>你选择的注释中只有一部分处于关闭状态并且可以删除。</b><br /> 如果选择继续，将删除下列注释。",
    DeleteSomeNotesAreNotClosed: "无法删除下列注释，因为它们尚未关闭。",
    DeleteDontHaveClosedNotes: "无法删除下列注释，因为它们尚未关闭。",
    someNotesAreOpen: "<b>你选择的注释中只有一部分处于未开始状态。</b><br/>如果选择继续，将更新下列注释。",
    someNotesAreNotOpen: "下列注释不会更新，因为它们已被清除或关闭。",
    dontHaveOpenNotes: "无法更新下列注释，因为它们已被清除或关闭。",
    ShowNumberMore: "显示{0}更多",

    // Drag and Drop
    assignmentLabel: "工作分配",
    assignmentsLabel: "工作分配",
    singleAssignmentCreatedMessage: "任务分配创建成功。",
    multipleAssignmentCreatedMessage: "任务分配创建成功。",
    daysPriorWarning: "创建工作分配前设置结束日期前天数",



    // Related Tasks - Engagement selector
    selectEngagement: "选择项目",
    thisEngagement: "此项目",
    noResultsFoundLabel: "没有找到结果",
    taskLocationLabel: "任务位置",

    // Delete Assginment
    deleteDescription: "删除任务分配的操作无法撤消，是否要继续？",
    deleteAssignmentModalTitle: "删除工作分配",
    deleteSingleSuccessMessage: "任务分配删除成功。",
    deleteMultipleSuccessMessage: "任务分配删除成功。",
    teamMemberLabel: "项目组成员",
    assignedTasksCountLable: "分配任务",
    deleteAssignmentLabel: "工作分配",
    selectengagement: "选择项目",

    //Due Days
    dueDateTitle: "输入到期天数",
    dueDatedescription: "输入应完成工作分配的时间段到期日之前的天数。",
    dueDateAssign: "工作分配",
    dueDateSelect: "选择",
    dueDateCalculate: "计算",

    // Tasklist - bulk markcomplete
    markComplete: "标记完成",
    markCompleteMessgae1: "是否确定<b>完成所选任务</b>? <br />如果您对所选任务有任何未完成的工作分配，这些工作分配将被关闭。",
    markCompleteMessgae2: "您选择的任务中仅有一部分可以标记为完成。<br />如选择继续，<b>下面列出的任务将标记为完成</b>。如果您有任何未完成的工作分配，这些工作分配将被关闭。",
    markCompleteMessgae3: "<b>下面列出的任务不会被标记为完成</b>，因为这些任务没有关联的证据或关联的证据没有签字。",
    markCompleteMessgae4: "<b>下面列出的任务不能被标记为完成</b>，因为这些任务没有关联的证据或关联的证据没有签字。",

    // Tasklist - bulk handoff
    handOffLabel: "移交",
    confirmHandOff: "确认移交",
    handOffMessgae1: "是否确认<b>将选定的任务</b>移交给下一位分配的项目组成员？<br />如果您对所选任务有任何未完成的工作分配，这些工作分配将被关闭。",
    handOffMessgae2: "您选择的任务中仅有一部分有其他已分配项目组成员。<br />如继续，<b>将移交以下任务给其他已分配的项目组成员</b>。如果您对所选任务有任何未完成的工作分配，这些工作分配将被关闭。",
    handOffMessgae3: "<b>下列任务不会被移交</b>，因为它们并没有未完成的任务。",
    handOffMessgae4: "<b>下列任务不能被移交</b>，因为它们并没有未完成的任务。",
    closeMyAssignments: "关闭我的任务分配",

    saveQuickFilter: "保存快速筛选",
    saveQuickFilterModalHeader: "将应用的筛选条件保存为快速筛选。",
    saveQuickFilterModalText: "选择已保存和建议使用的快速筛选，以便在您再次访问此项目时节省时间。每个项目最多可以创建五个已保存的快速筛选。",
    quickfiltername: "快速筛选名称",
    taskCategory: "任务类别",

    cannotsavefilter: "不能自定义快速筛选",
    cannotsavefiltermodalheadertext: "<b>每个项目只能保存5个自定义快速筛选。</b><br />如果继续，请删除一个现有的自定义快速筛，然后重试。",
    savedFilters: "保存的筛选",
    taskassignedto: "任务分配至",
    noteassignedto: "附注分配至",
    taskPrefix: "任务前缀",
    taskSuffix: "任务后缀",

    // Mark complete/HandOff Evidences category
    noSignOffs: "没有签字",
    noSignOffsByMe: "没有我的签名",
    myPreparerSignOffs: "我的编制人签字",
    myReviewerSignOffs: "我的复核人签字",
    myPreparerAndReviewerSignOffs: "我的编制人和复核人签字",

    notificationDownErrorMessage: "通知功能暂不可用。请刷新页面并重试。如果此消息仍然存在，请联系帮助台。",
    notificationUpbutSomeLoadingErrorMessage: "通知中心暂时不可用。请刷新页面并重试——片刻后即可使用。",

    timeTrackerErrorFallBackMessage: "时间跟踪功能暂时不可用。请刷新页面并重试。如果此消息仍然存在，请联系帮助台。",
    timeTrackerLoadingFallbackMessage: "时间跟踪功能暂时不可用。片刻后即可使用。",

    signOffOnAllAs: "全部以该名字签名：",
    accountType: "账户类型",

    openDocumentInstructionalText: "此文档将自动打开。<b>您无需点击。</b><br>打开文档后，您可以关闭此标签页。",
    closeTab: "关闭标签页",

    // Build Step - Add Due Date
    milestones: "里程碑",
    events: "事件",
    noTimePhasesHaveBeenIdentified: "未识别到时间阶段。",

    wcgws: "可能出错项",
    relatedControls: "相关控制",
    relatedControlsWCGWsRatio: "相关控制/可能出错项",
    wcgwsToControlsRatio: "可能出错项与控制的比率",
    controlsToWCGWsRatio: "控制与可能出错项的比率",
    testedControls: "已测试控制",

    // Collaboration request to Task relation
    CollaborationModalTitle: "将请求与任务关联",
    CollaborationModalDescription: "如想将请求与任务关联，请将一个或多个请求拖放到下面的任务。",
    noDataFound: "未找到数据",
    taskName: "任务",
    showMessage: "选择一个类别和任务组，开始操作",
    showCategory: "类别",
    showTaskGroup: "任务组",
    optionITProcesses: "IT流程",
    optionExecutionGeneral: "执行 - 一般",
    relatedRequestsLabel: "相关请求",
    relatedRequestsFormatted: "{0}相关请求",
    relatedRequestFormatted: "{0}相关请求",
    relatedRequests: "相关请求",
    relatedTasks: "相关任务",
    relatedSuccessSingleMessage: "{0}请求已成功关联至任务。",
    relatedSuccessMultipleMessage: "{0}请求已成功关联至任务。",
    showUnrelated: "显示{0}不相关",
    unrelate: "不相关",
    noRequestsMessage: "无可用请求",
    requestNumber: "请求编号",
    sortAscending: "升序排列",
    sortDescending: "降序排列",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "分组方式",
    allTasks: "全部任务",
    iTSOs: "IT/SOs",
    generalExecution: "总体执行情况",
    PICSignOff: "PIC签字",
    EQRSignOff: "EQR签字",
    completed: "已完成",
    allAssigned: "全部分配",
    picTaskAssignmentLabel: "您的请求分配",
    assignReadyForReview: "当期",
    assignUpcomingForReview: "即将分配",
    assignReadyForReviewTasks: "目前任务分配",
    assignUpcomingForReviewTasks: "即将收到的任务分配",
    picTaskSignoffInComplete: "<b>PIC</b>未签字的任务",
    picDocSignoffInComplete: "<b>PIC</b>未签字的文件",
    eqrTaskSignoffInComplete: "<b>EQR</b>未签字的任务",
    eqrDocSignoffInComplete: "<b>EQR</b>未签字的文件",
    collapseCards: "折叠卡片",
    expandCards: "展开卡片",
    noUserSelectedPlaceholder1: "未确认或邀请{0}加入项目。",
    noUserSelectedPlaceholder2: "点击此处",
    noUserSelectedPlaceholder3: "以确认或邀请{0}。",
    notInvitedLabel: "未邀请",
    noTasksPlaceholder: "没有与<br/>此审计阶段里程碑关联的任务。",
    noTasksTilesPlaceholder: "没有分配给所选用户的任务",
    noAssignmentPlaceholder: "未找到工作分配",
    dueDateAssignmentPlaceholder: "按到期日划分的工作分配",
    countAssignmentPlaceholder: "工作分配数量",
    OverduetPlaceholder: "逾期",
    TodayPlaceholder: "今天",
    tasksView: "任务视图",
    documentsView: "文档视图",
    picAndEqr: "PIC和EQR",
    ResponsiveToSR: "关联至⚡特别风险",
    responsiveToFR: "关联至⚡财务风险",
    relatedTasksFormatted: "{0}个相关任务",
    relatedTaskFormatted: "{0}个相关任务",
    autoAssignWarning2: "请点击此处",
    toAssign: "分配",
    taskAssignWarning: "未分配具有{0}签署要求的任务，",
    tasksAssignWarning: "未分配具有{0}签署要求的任务，",
    taskAdditionalFuncText1: "<b>此任务具有其他功能。请</b>",
    taskAdditionalFuncText2: "<b>进入该功能。</b><p>构建任务不需要关联证据即可标记完成，除非该任务需要审计负责合伙人/项目质量复核人复核。</p>",
    taskadditionalfunctionality: "<b>此任务具有其他功能。请</b>{0}<b>以进入该功能。</b><p>构建任务不需要关联证据即可标记完成，除非该任务需要审计负责合伙人/项目质量复核人复核。</p>",
    taskclickhere: "请点击此处",
    taskAutoAssignModalTitle: "自动分配",
    taskAutoAssignModalDescription: "有{0}个有项目质量复核人签字要求的任务未被分配给{1}。点击“分配”，为{1}创建项目质量复核人任务分配。",
    tasksAutoAssignModalDescription: "有{0}个有项目质量复核人签字要求的任务未被分配给{1}。点击“分配”，为{1}创建项目质量复核任务分配。",
    picTaskAutoAssignSuccessMessage: "有审计负责合伙人签字要求的任务分配给",
    picTasksAutoAssignSuccessMessage: "有审计负责合伙人签字要求的任务分配给",
    eqrTaskAutoAssignSuccessMessage: "有项目质量复核人签字要求的任务分配给",
    eqrTasksAutoAssignSuccessMessage: "有项目质量复核人签字要求的任务分配给",
    taskEntityDocumentValidationMsg: "此任务中存在没有任何对应证据的实体。请切换到按实体查看，以确认哪些实体需要补充文档记录。",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "此任务需要PIC签字，但是没有相关的PIC文档。至少添加一个符合此要求的文档。",
    eqrSignOffValidationMsg: "此任务需要EQR签字，但是没有相关的EQR文档。至少添加一个符合此要求的文档。",
    picAndEQRSignOffValidationMsg: "此任务需要PIC/EQR签字，但是没有相关的PIC/EQR文档。至少添加一个符合此要求的文档。",
    updateDataOnPicEqrDashboardBannerMessage: "所做更改尚未在下方更新。请{0}以刷新页面。",
    showMissingSignOffByLabel: "显示缺少{0}签字的文档",

    FindingsReportName: "发现",
    FindingsDeficiencyReportTabName: "缺陷",
    FindingsMisstatementReportTabName: "错报",
    FindingsDeficiencyITReportTabName: "缺陷-IT",
    auditPlanRelatedEvidenceReporLabel: "具有相关证据的审计计划",
    groupStructureSummaryReportReportLabel: "集团结构概述",
    auditPlanReportLabel: "审计计划报告",
    itAppSOSummaryReportLabel: "IT应用程序和SO汇总表",
    craSummaryReportLabel: "综合风险评估汇总表",
    teamMembersLabel: "项目组成员",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "验证检查",
    trialBalanceReportLabel: "试算表",
    trialBalanceReportTabLabel: "试算表报告",
    reportLabelYes: "是",
    reportLabelNo: "否",
    assignedBy: "分配人",
    openInReviewNotesHub: "在复核注释中心打开",
    nextNote: "下一步",
    previousNote: "上一步",

    //component team group tab names
    accountInfoCanvasFormExport: "账户信息",

    //project insight tab names
    projectInsightCanvasFormExport: "Canvas表格导出",
    projectInsightSCOTToWCGWToControl: "重大交易类别到可能出错项到控制",
    projectInsightControlToITApplication: "控制到IT应用程序",
    projectInsightControlToAssertion: "控制到认定",
    projectInsightRiskToWCGW: "可能出错项的相关风险",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "里程碑报告",
    unmappedTasks: "未匹配任务",

    // Effective
    isEffective: "有效",
    inEffective: "无效",
    nonEffective: "非有效",

    clientRequests: "客户请求",
    externalTasks: "外部任务",
    requestPriority: "请求优先级",
    scot: "重大交易类别",
    assertionR: "认定",
    wcgwToControlMappingTotal: "可能出错项与控制匹配个数总计",

    //CRA build step
    buildStep2EntityHeaderText: "重大账户和披露、认定、已关联可能出错项和控制",
    buildStep4EntityHeaderText: "重大账户、披露和已关联认定",
    accountNameHeader: "重大账户和披露",
    noAssertionsLabel: "无已关联认定。点击<a>管理账户和披露</a>开始。",
    noAssertionsBuildStep2text1: "必须至少有一个认定与此账户相关联。请点击",
    accountWithoutAssertionsBuildStep2text1: "每个重大账户或披露必须至少有一个相关联的认定。点击",
    noAssertionsBuildStep2text2: "管理账户和披露",
	noAccountsLabel: '未创建重大账户或披露。点击<span class="bold-text">管理账户和披露</span>以开始。',
	noAccountsLabelPlaceHolder: '未创建重大账户或披露。<span class="bold-text">开始管理账户和披露</span>。',
    noAccountsOrDiscloserPreText: "未创建重大账户或披露。",
    noAccountsOrDiscloserText: "管理账户和披露",
    noAccountsOrDiscloserPostText: " 开始。",
    noAssertionsBuildStep1text1: "必须至少有一个认定与此风险相关联。请点击",
    noAssertionsBuildStep1text1Msg: "每个风险必须至少有一个关联的认定。",
    noAssertionsBuildStep1text2: "关联认定",
    noAssertionsBuildStep1text3: " 然后开始。",
    editRisk: "编辑风险",
    deleteRisk: "删除风险",
    noControlsRelatedWWCGW: "无相关控制。",
    noControlsRelatedWCGW: "对于与控制风险为依赖的认定相关的每个可能出错项，必须选择至少一个控制进行测试。创建",
    noControlsRelatedWCGWNewCont: " 新控制",
    noControlsRelatedWCGWor: "或",
    noControlsRelatedWCGWRelateCont: " 关联现有控制",
    noControlsForWCGW: "具有不依赖控制风险的认定不需要识别控制。",
    noControlsRelatedWCGWFooter: "然后开始。",
    relateWCGWs: "<a>关联可能出错项</a>",
    noWCGWs: "没有关联的可能出错项。",
    noWCGWsClick: " 点击",
    noWCGWsFooter: " 然后开始。",
    showOnlyRisksWithNoAssertion: "仅显示不具有任何关联认定的风险",
    showIncomplete: "仅显示综合风险评估不完整的认定",
    showOnlyInvalidBuildStep2: "仅显示缺少必要详细信息的账户",
    noTestedControlsWithRelyAssertion: "与具有依赖控制风险的认定相关联的每个可能出错项，必须至少选择一个控制进行测试。",

    // Account build step
    accountOrDisclosure: "账户/披露",
    relatedAssertions: "相关认定",
    relatedAccountsAndAssertions: "相关账户及认定",
    pspIndexTitle: "PSP索引",
    statementTypeTitle: "报表类型",
    significantAccountLabel: "特别风险",
    limitedRiskLabel: "有限风险",
    insignificant: "不重大",
    significantDiscloure: "重大披露",
    accountAddedMessage: "成功创建“##”账户",
    accounHeaderText: "账户和披露",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "账户/披露及相关认定",
    addAccountsDisclosures: "添加账户/披露",
    editAccountsDisclosures: "编辑账户/披露",
    accountNameLabel: "账户名称（必填）",
    accountDesignationLabel: "指定（必填）",
    accountEstimateLabel: "含估计的账户",
    accountStatementTypeLabel: "报表类型（必填）",
    pspIndexDropdownLabel: "PSP索引（必填）",
    removePSPIndexLabel: "移除PSP索引",
    assertionsLabel: "认定（必填）",
    noAccounsMessage: "未发现账户。添加账户以开始。",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "删除账户/披露",
    deleteAcConfirmMessage: "是否确认删除账户/披露{0}？所有相关认定将被删除。任何仅与所选账户/披露相关的任务也将被删除。",

    true: "正确",
    false: "错误",
    taskSummaryReportEngagementInfo: "多个项目",
    viewPriority: "查看优先级",
    priorityRequestsSent: "已发送优先级请求",

    //reactive frame
    maxTabsLocked: "已达到允许的最大标签页数量。请取消固定一个标签页并关闭，以打开一个新标签页。",
    openInNewTab: "在新标签页中打开",
    copyLink: "复制链接",
    copySuccess: "链接已复制到剪贴板",
    copyFailure: "无法将链接复制到剪贴板",
    minimize: "最小化",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "无可用认定",
        SignificanceNotSelectedLabel: "未选择重大性",
        InsignificantLabel: "非重大"
    },

    lockTab: "固定标签页",
    keyDocuments: "重要文件",
    suggestedDocuments: "建议使用的文档",
    noSuggestedDocuments: "无建议使用的文档",
    exitBulkMode: "退出批量模式",
    bulkLabel: "批量",

    me: "我",
    viewByUser: "按用户查看",
    unsentDraftCapitalized: "未发送的草稿",
    picSignoffInComplete: " 项目负责合伙人未签字",
    eqrSignOffIncomplete: "项目质量复核人未签字",

    tableView: "表格视图",
    noRelatedAssertions: "无已关联认定。",

    multiEntityTileMessage1: "点击",
    multiEntityTileMessage2: "此处",
    multiEntityTileMessage3: " 按照实体查看状态",
    allItemsMessage: " 查看所有项目",

    EntitySelector: "选择一个实体然后开始",
    allEntities: "所有实体",
    multiEntity: "多实体",
    ungrouped: "未分组",
    numberSelected: "已选中{0}",
    allTimePhases: "全部",
    timePhases: "时间段",
    noTimePhaseFound: "未发现时间阶段",
    unrelatedAssignments: "非相关任务分配",
    unrelatedRequests: "未关联的请求",
    relateRequests: "关联请求",
    taskWithoutAnyAssignments: "任务没有进行任务分配",
    privacyNotice: "隐私声明",
    lastPublishedAndSent: "最后发布和发送",
    drafts: "草稿",
    allEntitiesTask: "这是与所有实体相关的项目任务",
    noRelatedEntities: "无相关实体",
    clickNewRisk: "开始。",
    relatedAccountsDisclosuresAndAssertions: "已关联重大账户、披露和认定",
    relateAssertion: "关联认定",
    taskByEntity: "按实体列出的任务",
    engagementWideTask: "项目范围内的任务",
    componentEngagementPill: "组成部分项目小组",
    primaryAndComponentEngagementPill: "主审小组/组成部分项目小组",
    // Scot build steps
    scotHeader: "重大交易类别",
    searchScot: "搜索",
    manageScots: "管理重大交易类别",
    superModelStep1ScotMessage: "重大账户和披露以及已关联重大交易类别",
    scotRelatedITApplicationServiceOrg: "重大交易类别和已关联IT应用程序及服务机构",
    noScotsAvailable: "未找到结果",
    searchScotPlaceholder: "搜索",
    searchScotClearHoverText: "清除",
    showOnlyUnrelatedScotToggleSwitch: "仅显示未关联",
    newScot: "新重大交易类别",
    importFromKnowledgeScot: "导入重大交易类别",
    importAccountsAndDisclosures: "导入账户和披露",
    showOnlyAccountRelatedScot: "仅显示无任何已关联重大账户和披露的重大交易类别",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "每个估计重大交易类别必须至少与一个具有估计的重大账户或重大披露关联。将此重大交易类别拖放至相关重大账户或重大披露。",
    warningMessageScotNotAssociatedWithAccount: "每个重大交易类别必须至少与一个重大账户或重大披露关联。将此重大交易类别拖放至相关重大账户或重大披露。",
    showvalidations: "显示验证",

    scotRelatedWCGWandControls: "重大交易类别和已关联可能出错项及控制",
    newWcgw: "新建可能出错项",
    manageWCGWs: "管理可能出错项",
    manageControl: "管理控制",
    importWCGWs: "导入可能出错项",
    relateWCGWs: "关联可能出错项",
    newControl: "新建控制",
    importControl: "导入控制",
    importControls: "导入控制",
    relateControl: "关联控制",
    scotStrategyIsControlMessage: "没有为该可能出错项识别控制。未定义重大交易类别策略。",
    scotStrategyIsWCGWMessage: "没有为该重大交易类别识别任何可能出错项。未定义重大交易类别策略。",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "每个重大交易类别必须至少与一个可能出错项关联。新建",
    controlsPlaceholderWithNoRelatedControlsMessage: "每个可能出错项必须至少与一个控制关联。新建",
    noITApplicationSOMessage: "没有为该重大交易类别识别任何IT应用程序或服务机构。点击",
    relatedItAppSOHeaderMessage: "相关IT应用程序和服务机构",
    substantivePlaceholderWithNoRelatedControlsMessage: "没有为此重大交易类别识别控制。对于采用实质性策略的重大交易类别，无需识别控制。",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "没有为此重大交易类别识别可能出错项。对于采用实质性策略的重大交易类别，需要识别可能出错项。",
    noITApplicationSOMessageText: "在必要时进行关联。",
    notSelected: "未选择",
    or: "或者",

    //WCGWControls
    showOnlyWCGWRelatedControls: "仅显示相关",

    createorRelateControl: "请创建新控制或关联现有控制",

    //Accounts Scot build steps
    accountHeader: "账户",
    searchAccount: "搜索账户",
    searchAccountPlaceholder: "搜索",
    manageAccounts: " 管理账户和披露",
    showOnlyUnrelatedAccountToggleSwitch: "仅显示未关联",
    searchAccountClearHoverText: "清除",
    noAccountsAvailable: "未找到结果",
    showOnlyScotRelatedAccount: "仅显示无任何已关联重大交易类别的重大账户和披露",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "每个具有估计的重大账户或披露必须至少与一个估计重大交易类别关联。将现有相关重大交易类别拖放到此重大账户或重大披露中",
    warningMessageAccountNotAssociatedWithScot: "每个重大账户或披露必须至少与一个重大交易类别关联。将现有相关重大交易类别拖放到此重大账户或重大披露中",
    significantAccountsAndDisclosures: "重大账户和披露",
    // Independence Only

    independenceOnlyStatus: "仅独立性",

    //Controls
    controlDesignEffectivenessWarningValidation: "控制必须选择设计有效性",
    controlHeader: "重大交易类别和相关控制",
    manageControls: "管理控制",
    manageITApplications: "管理IT应用程序",
    searchControlClearHoverText: "清除",
    searchControlPlaceholder: "搜索",
    noControlsAvailable: "未找到结果",
    controlName: "控制名称",
    frequency: "频率",
    type: "类型",
    newSO: "新SO",
    designEffectiveness: "设计有效性",
    testing: "测试",
    strategyTypeName: "重大交易类别策略",
    controlTestingYes: "是",
    controlTestingNo: "否",
    effective: "有效",
    ineffective: "无效",
    noControlsResult: "未找到结果",
    noControlsLabel: "未找到结果",
    relatedControl: "关联的控制",
    relateControls: "关联控制",
    controlTypeValues: {
        itApplication: "IT应用程序控制",
        itDependentManual: "依赖IT的手动控制",
        manualPrevent: "手动预防",
        manualDetect: "手动发现"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "每日多次",
        daily: "每日",
        weekly: "每周",
        monthly: "每月",
        quarterly: "每季度",
        annually: "每年",
        iTApplicationControl: "IT应用程序控制",
        other: "其他"
    },
    filterTypeOfScots: "重大交易类别",
    noScotsAvailable: "未找到结果",


    onlyShowControlsWithNoDesignEffectiveness: "仅显示未选择设计有效性的控制",

    // control Tasks
    controlCount: " {0} 控制",

    //Create and Edit WCGW
    wcgwInputName: "可能出错项名称",
    editWCGW: "编辑可能出错项",
    createNewWCGW: "创建新的可能出错项",
    editTheWCGW: "编辑可能出错项",
    createEditWCGWSave: "保存",
    createEditWCGWClose: "取消",
    createEditWCGWModelScot: "重大交易类别",
    newWCGWTitel: "新的可能出错项",
    wcgwNameIsRequired: "可能出错项名称为必填",
    deleteWCGW: "删除可能出错项",


    //Audit Plan
    importPSPButtonText: "导入主要实质性程序",
    commonContentUpdateSuccessMessage: "正在进行内容更新，这可能需要15分钟完成。请刷新页面以查看新导入的主要实质性程序。",
    responsivetoRisks: "应对风险",
    procedures: "程序",
    toc: "TOC",
    significantandFraudRisksHeading: "特别风险和舞弊风险及其应对程序和控制",
    risksBeingRespondedToByComponentTeam: "组成部分项目小组正在应对风险。",
    responsivecontrolsandTOCs: "做出应对的控制和控制测试",
    ResponsivePSPOSP: "做出应对的主要实质性程序/其他实质性程序",
    responsivePSPsOSPs: "做出应对的主要实质性程序/其他实质性程序",
    responsiveTOC: "做出应对的控制测试",
    responsiveControl: "做出应对的控制",
    responsivePSPOPSMessage: "至少应识别一个应对这一风险的此项认定的实质性程序。请点击{0}以识别做出应对的实质性程序。",
    responsiveControlMessage: "至少应确定一个应对这一风险和认定的控制（已完成设计有效性评估）。点击 {0} 识别做出应对的控制。点击{1}设置设计有效性或测试策略。",
    responsiveTOCMessage: "认定的控制风险为依赖控制，必须至少有一个针对控制风险的控制测试，且（1）控制未被指定为较低风险，以及（2）控制的设计有效性评估已完成。请点击<a>做出应对的控制测试</a>以识别做出应对的控制测试。",
    notcompleted: "未完成",
    noResponsiveTOCAvailable: "未为此控制识别出做出应对的控制测试。",
    refresh: "刷新数据",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "尚未选择此控制进行测试。使用<b>管理控制</b>更改测试选择。",
    noresponsiveTOCIdentified: "未识别出做出应对的控制测试。",
    taskAssertionnotModified: "任务认定尚未修改。编辑认定关系，继续下一步，或点击“取消”，退出操作。",
    failedToEditRelatedAssertions: "无法编辑与任务相关的认定。请刷新页面重试。如仍有问题，请联系帮助台。",
    assertionCannotEdited: "勾选框被禁用的认定按照安永方法进行了设置，无法编辑。",
    editAssertionInfoMessage: "添加或删除任务的认定。必须至少选择一个认定。",
    editRelatedAssertions: "编辑相关认定",
    loweRiskHeader: "较低风险",
    placeholderWhenControlTestingHasNotCompleted: "此控制未选择进行测试。使用 {0} 更改测试选择。",
    pspandOSP: "主要实质性程序/其他实质性程序",
    tocs: "控制测试",
    norelatedAssertionPlaceHolder: "每个特别风险或舞弊风险必须至少有一个认定确认与该风险关联。点击 {0} 识别已关联认定。",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "每个认定必须至少有一个被确认对该风险做出应对的、已完成设计有效性评估的控制。点击 {0} 识别做出应对的控制。",
    controlRiskRelyNotLowerRisk: "每个具有依赖控制风险的认定必须至少具有一个具备以下特征的控制：（1）未被指定为较低风险控制、（2）设计有效、（3）被选择进行测试。点击 {0} 识别做出应对的控制。",
    controlRiskRelyWithDesignEffectively: "每个具有依赖控制风险的认定必须至少有一个控制（1）设计有效，且（2）被选择进行测试。点击 {0} 识别做出应对的控制。",

    assertionWithControlRiskNotRely: "不依赖控制风险的认定不需要识别控制测试。",
    thisControlNotSelectedForTesting: "此项控制未被选择执行测试。点击 {0} 更改测试选择。",
    testControlRelatedToControlAsLowerRisk: "与被指定为较低风险的控制关联的控制测试不会应对该认定的风险。",
    testControlWithoutCompleteDE: "在控制未完成设计有效性评估的情况下，与此控制相关的控制测试不会应对该认定的风险。请点击{0}设置设计有效性。",
    testControlrelatedToineffective: "与设计有效性评估结果为无效的控制相关的控制测试不会应对该认定的风险。请点击{0}更改设计有效性。",
    anotherTestControlIdentified: "已识别另一个控制测试来应对该认定的风险，无需识别进一步控制测试。没有为该控制识别做出应对的控制测试。",
    eachControlMustHaveOneToc: "每个具有依赖控制风险的认定必须至少有一项控制测试对以下控制的风险做出应对（1）未被指定为较低风险控制、（2）设计有效，且（3）被选择进行测试。没有为该控制识别做出应对的控制测试。点击 {0} 识别做出应对的控制测试。",
    eachAssertionControlHaveAtleasetOneTOC: "每个具有依赖控制风险的认定必须至少有一项控制测试对以下控制的风险做出应对（1）设计有效，且（2）被选择进行测试。没有为该控制识别做出应对的控制测试。点击 {0} 识别做出应对的控制测试。",
    norepsonsivePSPOSPplaceholder: "每个认定必须至少有一个被确认对该风险做出应对的实质性程序。点击 {0} 识别做出应对的实质性程序。",

    //Reject Task
    rejectPspModalTitle: "拒绝主要实质性程序",
    rationaleRequired: "必填",
    rationaleTextEditorLabel: "拒绝主要实质性程序的理由",
    rejectTaskErrorMessage: "无法拒绝任务。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    rejectTaskModalHeader: "是否确定拒绝选定的主要实质性程序?",
    rejectTaskModaWarningText: "与本项目中的任何其他任务无关联的相关证据将被移动到临时文件中。",
    rejectTaskRationaleLabel: "理由（必填）",

    // Adobe Analytics
    aaCookieConsentTitle: "欢迎访问",
    aaCookieContentPrompt: "是否允许使用cookie？",
	aaCookieConsentExplanation: '<p>除了运营本网站所需的cookie外，我们还使用以下类型的cookie来改善您的用户体验和我们的服务：<strong>功能cookie</strong>，提升用户体验（如记住设置），<strong>性能cookie</strong>，监测网站性能，改善用户体验，<strong>广告/定向cookie</strong>，由第三方设置，我们与该第三方共同执行广告活动，为您提供与您相关的广告信息。</p> <p>您可以查阅我们的<a target=“_blank”href=“https://www.ey.com/en_us/cookie-policy“>cookie政策</a>了解更多信息。</p>',
	aaCookieConsentExplanationWithDoNotTrack: '<p>除了运营本网站所需的Cookie外，我们还使用以下类型的cookie来改善您的用户体验和我们的服务：<strong>功能cookie</strong>，提升用户体验（如记住设置），<strong>性能cookie</strong>，监测网站性能，改善用户体验，<strong>广告/定向cookie</strong>，由第三方设置，我们与该第三方共同执行广告活动，为您提供与您相关的广告信息。</p> <p>我们已检测到您的浏览器开启了“请勿追踪”的设置；因此，广告/定向cookie将自动禁用。</p><p>您可以查阅我们的<a target=“_blank”href=“https://www.ey.com/en_us/cookie-policy“>cookie政策</a>了解更多信息。</p>',
    aaCookieConsentDeclineOptionalAction: "我拒绝可选cookie",
    aaCookieConsentAcceptAllAction: "我接受所有cookie",
    aaCookieConsentCustomizeAction: "自定义cookie",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "任务组和相关任务",
        manageTaskSections: "管理任务组",
        taskSectionsAccordionHeader: "任务组",
        phaseAccordionHeader: "阶段",
        tasksAccordionHeader: "任务",
        rejectedAccordionHeader: "已拒绝",
        noRelatedTasksMessage: "无可用主要实质性任务/其他实质性任务。创建{0}，然后开始。",
        taskSectionTaskHeader: "任务",
        newOSTButtonText: "新的其他标准任务",
        cutomTaskSectionBadgeText: "自定义",
        rejectedTasksLabel: "拒绝的主要实质性任务",
        additionalInfo: "理由",
        rejectButton: "拒绝",
        acceptButton: "接受",
        removeButton: "删除",
        addButton: " 添加",
        allPSTsRejectedMessage: "已拒绝所有主要标准任务。",
        rejectModalTitle: "拒绝主要标准任务",
        rationaleTextEditorLabel: "拒绝主要标准任务的理由",
        rejectTaskModalHeader: "是否要拒绝选定的主要标准任务？",
        noResultsMessage: "未找到结果",
        noTaskSetionsAvailableMessage: "无可用任务章节",
        rejectTaskModaWarningText: "项目中未与任何其他任务关联的证据将被移入临时文件。无法拒绝有EY Canvas交付文档的主要实质性任务。",
        rejectTaskRationaleLabel: "理由（必填）"
    },

    // Cookie Settings
    cookieSettings: {
        title: "cookie设置",
        explanation: "请您在ey.com和“我的安永”平台上提供cookie使用许可。请选择下面列出的一种或多种cookie类型，然后点击保存。有关cookie类型及其用途的详细信息，请参阅下面的列表。",
        emptyCookieListNotice: "此应用程序中未使用此类别的Cookie",
        nameTableHeader: "cookie名称",
        providerTableHeader: "cookie提供商",
        purposeTableHeader: "cookie用途",
        typeTableHeader: "cookie类型",
        durationTableHeader: "cookie有效期",
        formSubmit: "保存我的选择",
        requiredCookieListTitle: "必需Cookie",
        functionalCookieListTitle: "功能Cookie",
        functionalCookieAcceptance: "我接受以下功能cookie",
        functionalCookieExplanation: "功能cookie，可以帮助我们增强您的用户体验（例如，通过记住您选择的任何设置）。",
        performanceCookieListTitle: "性能cookie",
        performanceCookieAcceptance: "我接受以下性能cookie",
        performanceCookieExplanation: "性能Cookie，可以帮助我们监测网站的性能并改善您的用户体验。在使用性能cookie时，我们不存储任何个人数据，仅使用通过这些cookie以汇总和匿名形式收集的信息。",
        advertisingCookieListTitle: "定向cookie",
        advertisingCookieAcceptance: "我接受以下广告/定向cookie",
        advertisingCookieExplanation: "广告/定向cookie，可以帮助我们跟踪用户活动和会话，以便提供更个性化的服务。（在广告cookie的情况下）cookie由第三方设置，我们与该第三方共同执行广告活动，为您提供与您相关的广告信息。",
        doNotTrackNotice: "我们已检测到您的浏览器开启了“请勿追踪”的设置；因此，广告/定向cookie将自动禁用。",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "任务部分和相关任务",
    manageTaskSections: "管理任务部分",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "财务报表",
        trialBalance: "试算平衡表",
        okButton: "确认",
        leadSheet: "引导表",
        balanceSheet: "资产负债表",
        incomeStatement: "利润表",
        eyreferences: "索引",
        currenPeriod: "分析日期",
        comparativePeriod: "比较日期",
        changeFrom: "变化",
        percentageChangeFrom: "变化率",
        notesColumn: "注释",
        viewTrialBalanceType: "按试算平衡表类型查看",
        multiEntity: "多实体",
        placeHolderText: "搜索账户类别",
        currencyType: "货币类型",
        currencyCode: "货币代码",
        businessUnit: "业务单元",
        periodEnded: "截止日期",
        periodsEnded: "截止日期",
        searchGLAccountPlaceholder: "搜索总账账户",
        eyReferenceDocuments: "{0}文档",
        relatedNotes: "相关注释",
        notAvailable: "不可用",
        significantDisclosures: "重大披露",
        noResultFound: "未找到结果",
        openEYHelixProjects: "打开EY Helix项目",
        openAdjustmentModule: "打开调整模块",
        goToSubstantiveProcedureLink: "进入实质性程序",
        cancel: "取消",
        remove: "删除"
    },

    financialStatementsClassView: {
        bulk: "批量",
        eyAccount: "安永账户",
        placeHolderText: "搜索总账账户",
        noAccountDesignation: "尚未设置账户指定。",
        insignificantLeadSheetMessage: "未针对非重大账户列报引导表",
        unmappedGLAccounts: "未列出未匹配账户的引导表",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "资产"
        },
        {
            id: 4,
            label: "负债"
        },
        {
            id: 7,
            label: "权益"
        },
        {
            id: 8,
            label: "收入"
        },
        {
            id: 9,
            label: "费用"
        },
        {
            id: 17,
            label: "净利润"
        }
    ],
    copyrightMessage: "版权©<year>版权所有",
    createNotes: {
        notesPlaceholderText: "通过点击 {0} 或{1}添加注释。",
        newNote: "添加注释",
        relateNote: "关联注释",
        addNewNotesHeader: "在下方输入注释详情，然后点击<b>\’保存并关闭\'</b>结束。如想另外创建注释，请选择<b>\'保存并新建\'</b>。",
        noteIndex: "索引",
        noteIndexRequired: "索引（必填）",
        noteDescription: "描述",
        noteDescriptionRequired: "描述（必填）",
        saveAndClose: "保存并关闭",
        newTickmarkDescription: "请选择不存在引用到此总账账户的证据的原因。",
        newTickmarkBulkModalDescription: " 选择没有证据索引到所选总账账户的原因。"
    },
    deleteNotes: {
        deleteNote: "删除注释",
        deleteNoteTitle: "是否确定删除已选定注释?",
        delete: "删除",
        cancel: "取消"
    },
    editNotes: {
        editNote: "编辑注释",
        editNotesHeader: "编辑下方注释详细信息，然后选择<b>\’保存并关闭\'</b>完成。",
        edit: "编辑",
        cancel: "取消"
    },
    notesListLabels: {
        actions: "操作",
        noteCount: " {0} 注释",
        notesCount: " {0} 注释"
    },
    relateNotes: {
        relateNoteLabel: "关联注释",
        searchPlaceholder: "搜索",
        accountLabel: "账户",
        indexLabel: "索引",
        descriptionLabel: "描述",
        addedLabel: "已添加",
        showOnlyRelatedLabel: "仅显示已关联",
        noResultsFoundMessage: "未找到结果",
        noteCount: " {0} 注释",
        notesCount: " {0} 注释",
        closeBtnTitle: "关闭"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "点击{0}、{1}添加证据，或者点击{2}指定不需要证据。",
        newEvidence: "新证据",
        relateEvidence: "关联证据",
        newTickMark: "新标记",
        relateTasks: 'Relate task',
        noTasksSeleted: "选择要继续的任务。",
        relateTaskPlaceholder: "新的索引必须至少与一个任务相关联。选择一个任务，将此文档作为证据添加到其中。",
        confirmButtonTitle: "继续",
        closeButtonTitle: "取消",
        noResultsFound: "未发现结果",
        taskType: "类型",
        taskName: "任务名称",
        taskCount: "{0}任务",
        tasksCount: " {0} 任务",
        title: "索引",
        removeReference: "删除索引"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "无可用注释。选择总账账户以创建注释。",
        notes: "注释",
        relatedGlAccountPlaceholder: "关联的总账账户"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "关联证据",
        selectedCountGLAccount: "已选择{0}个总账账户",
        selectedCountGLAccounts: "已选择{0}个总账账户",
        selectAll: "全选",
        deselectAll: "取消全选",
        exitBulkMode: "退出批量模式",
        noGLAccountsSelectedValidationMessageEvidence: "至少选择一个总账账户以关联证据或点击退出批量模式。",
        noGLAccountsSelectedValidationMessageTickmark: "至少选择一个总账账户以新建标记，或点击“退出批量模式”。",
        noGLAccountsSelectedValidationMessageRemoveReference: "至少选择一个要删除索引的总账账户，或点击“退出批量模式”。",
        relateTickmarkLabel: "新标记",
        removeReferenceLabel: "删除索引",
        removeReferenceConfirmationMsg: "确认是否要删除所有选定总账账户的索引。"

    },
    financialStatementsFilters: {
        referenceFilterKey: "总账账户未引用",
        accountFilterKey: "总账账户未映射",
        noResultsPlaceholder: "未找到结果",
        trialBalance: "试算表",
        noneAvailable: "无可用项",
        search: "搜索",
        multityEntity: "多实体",
        placeHolderMessageWhenHelixMappingIsTrue: "没有导入的试算表。点击{0}关联新分析工具。",
        placeHolderMessageWhenHelixMappingIsFalse: "无法与EY Helix集成。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
        eyHelixIntegrationLinkText: 'EY Helix integration',
        noEntitiesAvailablePlaceholder: "未创建实体。请创建实体以开始。"
    },
    //Group instructions
    assertionTabButton: "认定",
    inherentRiskFactorButton: "固有风险因素",
    accountsAndDisclosure: "账户/披露",
    assertions: "认定",
    assertionC: "完整性",
    assertionEO: "存在/发生",
    assertionMV: "计量/计价",
    assertionRO: "权利和义务",
    assertionPO: "列报和披露",

    complexity: "复杂性",
    subjUncertainty: "主观性 不确定性",
    fraudOrError: "舞弊或错误",
    change: "变化",
    natureOfAccount: "账户性质",
    relatedParties: "关联方",
    higherInherentRiskLabel: "较高固有风险",
    lowerInherentRiskLabel: "较低固有风险",
    relevantLabel: "相关风险",
    relevantContributeLabel: "导致较高固有风险的相关风险",
    incompleteInherentRiskTooltip: "固有风险未完成",
    estimateLabel: "估计",
    riskAssociatedLabel: "相关风险",
    greaterExtentLabel: "较大范围",
    lesserExtentLabel: "较小范围",
    accordionNoRiskLabel: "无与此账户认定相关的风险。",
    accordionNoRiskAccountLabel: "无与此账户相关的风险",
    accordionNoAssertionsLabel: "无与此账户相关的认定。",
    accordionLimitedRiskLabel: "该账户已被确定为有限风险。",

    maps: "示图",
    financialStatements: "财务报表",
    serviceGatewayAutomation: "服务网关和自动化",
    manageTaskGroups: "管理任务组",
    openAssignmentsLabel: "未完成任务分配",
    inProgressAssignmentsLabel: "进行中任务分配",
    // My Progress collaboration view.
	calendarDays: [
		"星期日",
		"星期一",
		"星期二",
		"星期三",
		"星期四",
		"星期五",
		"星期六"
	],
	calendarMonths: [
		"一月",
		"二月",
		"三月",
		"四月",
		"五月",
		"六月",
		"七月",
		"八月",
		"九月",
		"十月",
		"十一月",
		"十二月"
	],
    myProgressToday: "今天",
    noDueDateAssignedGroup: "未分配到期日",
    myProgressStatusTile: {
        yourRequests: "您的请求",
        totalCount: "总数",
        requestStatus: "请求状态",
        draft: "草稿",
        pending: "待处理",
        received: "已接收",
        accepted: "已接受",
        overdue: "逾期",
        noRelatedTasks: "{0}没有相关任务",
        oneNoRelatedTask: "1没有相关任务",
        addRequest: "新请求",

        //Requests dues tile 2
        pendingRequestsByDueDate: "待解决请求（按到期日）",
        requestsYAxisLabel: "请求",
        requestsXAxisLabel: "天数",
        tooltipDaysLabel: "天数",
        tooltipTotalLabel: "合计：",
        normalLabel: "正常",
        highLabel: "高",
        criticalLabel: "关键",
        overdueLabel: "逾期",
        overDueCatFirst: "逾期90天以上",
        overDueCatSecond: "逾期31-90天",
        overDueCatThird: "逾期10-30天",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "未找到请求",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "名称",
        notes: "注释",
        signOffs: "签署",
        tasks: "关联任务",
        open: "打开",
        openReadOnly: "以只读方式打开",
        delete: "删除",
        rename: "重命名",
        signOffRequirements: "签署要求",
        confidentiality: "机密性",
        unlink: "取消链接",
        relateTasks: "关联任务"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "选择到期日",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "目前仍缺少充足的人员角色来编辑内容。请与项目管理员协助申请获取足够的权限。"
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "连接中断。重新连接并重试。如果问题持续，请联系帮助台。",
    101: "无效项目状态。",
    102: "找不到有效的项目用户。",
    103: "缺少项目用户独立性合规。",
    104: "缺少必需的Azure AD范围",
    105: "获取项目权限时出错。请刷新页面并重试。如果问题仍然存在，请联系帮助台",
    106: "你没有执行此操作所需的权限。",
    107: "找不到有效的项目用户。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    108: "项目的文档设置不完整。请前往登录页面并完成项目文档的设置。",
    303: "当前正在上传具有相同名称的文件。",
    401: "无法完成操作。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    403: "是不受支持的文档格式，尚未上传。重新以有效的文档格式保存文档，然后重试。如果问题持续存在，请联系帮助台。",
    410: "此文档已被删除，无法打开。",
    411: "不允许使用空文档。",
    412: "该项目中已经存在同名文件。",
    413: "文档大小超过上限（250mb），无法上传。请缩小文件大小，然后重试。",
    500: "连接中断。重新连接并重试。如果问题持续，请联系帮助台。",
    414: "名称超过最大长度（{0}个字符）。",
    600: "该操作此时无法完成。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    601: "存在同名文档。",
    602: "文档已在协作中",
    603: "未找到文档。",
    'zip': "无法上传.zip文件，因为它包含一种或多种不受支持的文件类型，或者包含的嵌入.zip文件数量超过最大数量.",
    401000: "检测到网络更改，请重新加载页面以继续",

    /*Accounts*/
    1001: "创建账户指令失败",
    1002: "账户名称缺失。",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "未找到结果。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    1005: "项目ID无效",
    1006: "账户类型无效。",
    1007: "报表类型无效",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "按ID获取账户指令失败",
    1010: "按项目ID获取账户指令失败",
    1011: "由于请求无效，获取账户ID的SEM汇总表指令失败。",
    1012: "汇总表类型无效。",
    1013: "创建账户复核指令失败",
    1014: "删除账户复核指令失败",
    1015: "无效的账户复核创建请求。",
    1016: "无效的账户复核ID。",
    1017: "账户不属于此项目或已删除。",
    1018: "账户复核是由另一个用户创建。",
    1019: "账户已被其他用户删除。请刷新页面，然后重试。",
    1020: "账户需要主要实质性程序以更新",
    1024: "账户名称超过500个字符。",
    1025: "无法估计有限风险或不重大账户",
    1026: "账户不能有重复的认定",
    1027: "认定id无效",
    1037: "PSP索引不能重复",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "账户的执行类型无效。",
    1053: "账户有关联的风险或估计，不能设置为有限风险账户或非重大账户。",
    1054: "待删除的认定有关联的风险或估计",
    1065: "您不能修改具有相关特别风险、舞弊风险或重大错报风险或估计相关的认定。请先删除关联。",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "创建请求无效。",
    2002: "认定名称缺失。",
    2003: "认定缺失。",
    2004: "获取认定指令失败。",
    2005: "项目ID无效",
    2006: "按ID获取认定指令失败",
    2007: "获取认定可能出错项指令失败。",
    2050: "未找到认定。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    /*Tags*/
    5120: "未找到标签ID。",
    5121: "标签ID缺失。",
    5123: "重复的标签关联。",
    5124: "未发现标签关联。",


    /*Risks*/
    4001: "目前不能完成操作。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    4002: "风险名称缺失。",
    4003: "风险缺失。",
    4004: "获取风险指令失败。",
    4005: "项目ID无效。",
    4006: "按ID获取风险指令失败。",
    4007: "查询请求无效。",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "更新请求无效。",
    4010: "已经分配至该风险的特定可能出错项",
    4011: "可能出错项列表不能为空。",
    4012: "无法获取风险类型。",
    4013: "创建请求无效。",
    4014: "相关认定无效。请刷新页面并重试。如果错误持续，请联系帮助台。",
    4015: "可能出错项无效。请刷新页面并重试。如果错误持续，请联系帮助台。",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "认定对该风险无效。请刷新页面并重试。如果错误持续，请联系帮助台。",
    4018: "传递的风险类型ID无效。",
    4019: "风险名称无效。",
    4020: "文档ID无效。",
    4021: "风险名称不得超过500个字符。",
    4023: "认定Id列表不能为空。",
    4024: "由于出现错误，无法创建有限风险文档表格。请刷新页面，然后重试。如问题仍然存在，请联系帮助台。",
    4025: "账户id无效。",
    4026: "认定id无效。",
    4027: "认定风险模型不能为空",
    4031: "风险或表格主体选项无效。",

    4035: "无法将“特别风险”或“舞弊风险”编辑为“较高风险”。",
    4036: "如果未传入认定Id，则知识库认定Id不能为空。知识库认定Id必须在enums中",
    4037: "此账户的知识库认定Id已存在。",
    4038: "风险类型ID与可用选项不匹配。",
    4040: "此操作无法执行。请刷新页面并重试。如问题仍然存在，请联系帮助台。",

    /*TASK*/
    5001: "获取失败。",
    5002: "此任务在该项目中不可用.",
    5003: "获取任务文档失败。请求参数无效。",
    5004: "获取已关联任务文档失败。请求参数无效。",
    5005: "按Id获取任务失败。",
    5006: "获取任务类别指令失败。",
    5007: "获取任务子类别指令失败。",
    5008: "获取任务描述指令失败。",
    5009: "获取任务客户请求指令失败。",
    5010: "保存任务客户请求指令失败。",
    5011: "试图关联项的任务已被删除或拒绝。",
    5012: "试图关联的项已被删除。",
    5013: "试图关联项的任务已被删除或拒绝。",
    5014: "试图关联的文档已被删除。",
    5015: "获取任务证据指令失败。",
    5016: "获取可能出错项任务指令失败。",
    5017: "项目ID应大于零。",
    5018: "此操作无法执行。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5019: "任务说明为空",
    5020: "已选定任务已被删除或拒绝。因此，此操作无法在此时完成。",
    5021: "来源项目ID缺失。",
    5022: "保存注释失败",
    5023: "未发现项目用户。",
    5024: "删除任务指令失败",
    5025: "删除任务指令失败",
    5026: "任务列表为空",
    5027: "未发现复核。",
    5028: "文件名称为必填。",
    5029: "文件扩展名为必填。",
	5030: '文件名称不得包括： */:<>\\?|\"',
    5031: "更新文档名称时出错。",
    5032: "文档ID无效。",
    5033: "未找到操作类型。",
    5034: "更改任务状态失败",
    5035: "你尝试执行的操作目前无法完成。请稍后重试。如果仍存在错误，请联系帮助台。",
    5036: "主体在指令中不能为空。",
    5037: "请求在指令中不能为空。",
    5038: "输入唯一的文件名以继续。",
    5039: "文件名称为必填。",
    5040: "文件名限制在100个字符以内。",
	5041: '文件名称不得包括：*/:<>\\?|\"',
    5042: "已选定任务被拒绝。",
    5043: "该任务是一个构建步骤任务。",
    5044: "该任务是一个里程碑任务。",
    5045: "该任务不是PSP或OSP类型。",
    5046: "超出字符限制。",
    5047: "超出字符限制。",
    5048: "必填信息栏。",
    5049: "无法从该任务中删除已选定文档。请刷新页面并重试。如果问题持续，请联系帮助台。",
    5050: "任务组ID不应为零或无效",
    5051: "任务部分ID不应为零或无效",
    5052: "尝试将此文档添加到当前任务时出错。指令失败。",
    5053: "尝试在当前任务中更新此文档时出错。指令失败。",
    5054: "尝试在当前任务中添加此文档的副本时出错。指令失败。",
    5055: "尝试重命名文档时出错。指令失败。",
    5056: "无法编辑知识或小组任务的任务标题",
    5057: "任务类型应为Ost类型",
    5058: "无法从任务中删除此文档，因为它与系统关联。",
    5059: "时间段值无效。",
    5060: "添加到证据错误。指令失败",
    5061: "另一个用户已更新所列报的信息。请刷新页面并重试。如果错误持续，请联系帮助台。",
    5062: "所请求的文档不适用于你的项目在EY Atlas中选择的频道。请联系帮助台，以便将信息提供给内容编辑人，供将来使用。",
    5063: "补丁操作无效。",
    5064: "已选定任务已被删除或拒绝。因此，此操作无法完成。",
    5065: "无法更新任务来源类型。请求无效。",
    5066: "获取指引错误。指令失败。",
    5067: "无法更新任务性质类型。请求无效。",
    5068: "无法更新任务性质类型。请求无效。",
    5069: "删除任务分配指令失败。",
    5070: "一项或多项选定任务已删除。请重试，如错误仍然存在，请联系帮助台。",
    5071: "无法更新任务分配。请求无效。",
    5072: "未找到编制人。请求无效。",
    5073: "未找到任务分配。",
    5074: "保存任务分配工作失败",
    5075: "所选项目组成员或角色不能有所选任务的重复分配工作。选择不同的分配工作、项目组成员或角色以继续。如仍有错误，请联系帮助台。",
    5076: "选择的项目组成员不是该项目的活跃成员。请重试，如错误仍然存在，请联系帮助台。",
    5077: "有一项或以上选定任务已删除。请重试，如问题仍然存在，请联系帮助台。",
    5078: "所选分配任务已被删除。请重试。如果错误仍然存在，请联系帮助台。",
    5079: "一个或多个已选定的任务已被删除。如果错误持续存在，请重试或联系帮助台。",
    5080: "文档版本记录不存在。",
    5081: "当前被分配至此任务的用户无法被重新分配为编制人。如果错误仍然存在，请重试或联系帮助台。",
    5082: "更新失败。项目的文档名称应具有唯一性。刷新页面以删除此消息。",
    5083: "超过了“任务详情”字符限制。",
    5084: "任务文件创建指令失败。",
    5085: "任务文件删除指令失败。",
    5086: "任务移交指令失败。",
    5087: "任务补丁指令失败。",
    5088: "此任务必须包含要移交的证据。重试或联系帮助台。",
    5089: "与此任务相关的所有证据（纸质文档除外）必须至少有一名编制人和复核人来标记完成。请重试，如果仍存在错误，请联系帮助台。",
    5091: "纸质文档名称已存在于项目中。",
    5092: "名称不能包含以下任何字符： */:<>\\?|\\",
    5093: "纸质文档名称超出最大长度（100个字符）。",
    5101: "创建任务失败。",
    5102: "缺少任务描述。",
    5103: "缺少任务标题。",
    5104: "缺少任务时间阶段。",
    5105: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5106: "审计阶段无效。",
    5107: "审计阶段应为'范围和策略’或'执行’。",
    5108: "任务描述过长。",
    5109: "角色类型参数无效。",
    5110: "任务分配ID必须大于零。",
    5111: "您试图关联任务的项目已被删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    5112: "您试图关联任务的项目已被删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    5113: "您试图关联任务的项目已被删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    5116: "文档类型无效。",
    5119: "一项或多项选定任务的任务状态未更新。刷新页面，然后重试。如果错误仍然存在，请与帮助台联系。",
    5127: "无法完成关联。请刷新页面重试。如问题仍然存在，请联系帮助台。",
    5129: "无法完成关联。请刷新页面重试。如果问题仍然存在，请联系帮助台。",
    5133: "无法完成关联。请刷新页面重试。如果问题仍然存在，请联系帮助台。",
    5137: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5138: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5140: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5146: "要将任务标记为完成，所有相关证据（底稿情况除外）必须至少有一个编制人和复核人签字。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
    5150: "当前阶段有一个或以上自动化操作尚无法关联至选定的任务。请刷新页面并重试。如错误提示仍然存在，请联系帮助服务中心。",
    5156: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5157: "无法编辑任务关系。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5159: "共享文档类型无效。",
    5160: "尝试链接文档时出错。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    5174: "任务必须关联至一个或多个实体。若要将任务设置为项目任务，请点击“实体任务”进行切换。",
    5184: "任务类型不是主要标准任务或主要实质性程序任务。",
    5185: "无法拒绝有EY Canvas交付文档的任务。",
    5188: "无效文档或正在取消链接。",
    5189: "任务有作为已链接证据或已链接回答的文档。",
    5190: "任务应至少有一项认定。",
    5191: "无法完成关联。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    5192: "您试图关联任务的项目已被删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    5193: "所选项目已被删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",


    /*WCGW*/
    6001: "创建可能出错项失败。",
    6002: "可能出错项名称缺失。",
    6003: "可能出错项缺失。",
    6004: "获取可能出错项指令失败。",
    6005: "项目ID无效。",
    6006: "无法完成要求的操作，因为认定ID无效或已被删除。请刷新页面并重试。",
    6007: "按ID获取可能出错项指令失败。",
    6008: "请求无效。",
    6009: "无法完成要求的操作，因为可能出错项ID无效或已被删除。请刷新页面并重试。",
    6010: "该任务无法与可能出错项关联。",
    6011: "所选可能出错项被删除。",
    6012: "任务和可能出错项不属于同一个认定。",
    6013: "选定的任务不属于同一项目。",
    6014: "该任务无法与可能出错项解除关联。",
    6015: "该任务无法与可能出错项关联。",
    6016: "该任务被拒绝，无法与可能出错项关联。",
    6017: "该任务不是里程碑任务，不能与可能出错项关联。",
    6018: "该任务不是生成步骤任务，不能与可能出错项关联。",
    6019: "该任务不是PSP或OSP，并且不能与可能出错项关联。",
    6020: "任务和可能出错项关联到相同的认定，并且不能关联到可能出错项。",
    6027: "无效的可能出错项Id或控制Id。",
    6028: "无法完成关联。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    6029: "无法完成移除。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",

    /*Engagement*/
    7001: "未找到按ID获取。",
    7002: "按工作区ID获取项目指令失败。",
    7003: "获取全部项目实体指令失败。",
    7004: "按ID获取项目指令失败。",
    7005: "获取全部项目用户指令失败。",
    7006: "姓氏不得超过250个字符。",
    7007: "无效 用户 类型 错误。",
    7008: "名字不得超过250个字符。",
    7009: "用户GUI不得为空。",
    7010: "无效 用户 状态 错误。",
    7011: "创建项目用户指令失败。",
    7012: "{0}{1}不能被邀请，因为他/她已经是一个活跃或待定的项目组成员。",
    7013: "首字母不得超过3个字符。",
    7014: "EY Canvas登陆页目前无法访问。再次尝试且如果问题持续，请联系帮助台。",
    7015: "{0} {1}无法作为以下访问组被邀请：{2}已从项目中删除。刷新并重试。",
    7016: "{0} {1} 无法被邀请，该用户已为下列访问组的活跃成员：{2}",
    7017: "所选组不允许使用域名：{0}",
    7018: "电子邮件地址不能为空。",
    7019: "名字不能为空。",
    7020: "姓氏不能为空。",
    7021: "用户姓名首字母缩写不能为空。",
    7022: "用户主审办公室不能为空。",
    7023: "用户登录名不能为空。",
    7024: "用户安永角色不能为空。",
    7025: "用户项目角色不能为空。",
    7026: "无法完成操作。请重试，如果问题持续，请联系帮助台。",
    7027: "无效邮件地址",
    7028: "补丁项目用户指令失败。",
    7029: "项目用户——无效项目用户状态ID。",
    7030: "项目用户——无效项目用户职责ID。",
    7031: "未找到一个或多个项目用户ID。",
    7032: "电子邮件不得超过250个字符。",
    7033: "被请求的用户不能为零。",
    7034: "通用消息处理工具队列失败。",
    7035: "首字母不得超过3个字符。",
    7036: "名字不得超过250个字符。",
    7037: "姓氏不得超过250个字符。",
    7038: "创建外部用户指令失败。",
    7039: "一个或多个用户不能被邀请，因为他们已经是活跃或待定的项目组成员。请刷新页面并重试，如果还有问题，请联系帮助台。",
    7040: "名字不得超过250个字符。",
    7041: "姓氏不得超过250个字符。",
    7042: "首字母不得超过3个字符。",
    7043: "GPN不得超过250个字符。",
    7044: "GUI不得超过250个字符。",
    7045: "通过ID获取外部用户失败。",
    7046: "用户不能为空。",
    7047: "当前无法保存更改。请重试，如果问题持续，请联系帮助台。",
    7048: "EY Canvas登陆页面目前无法访问，需要进行编辑。请重试，如果问题持续，请联系帮助台。",
    7049: "更新项目用户指令失败。",
    7050: "成员不能被停用。项目必须有至少一个有权限管理项目的成员。更新你的选择并再次尝试。如果问题持续，请联系帮助台。",
    7051: "通过ID获取内部用户失败。",
    7052: "未找到用户",
    7053: "未找到按ID获取。",
    7054: "按项目ID指令获取快速链接失败。",
    7055: "无权限添加以前的成员。与有适当权限项目成员的沟通来采取此行动。",
    7056: "此时，EY Canvas无法保存更改。请重试，如果问题持续，请联系帮助台。",
    7057: "无权限添加新成员。与有适当权限项目成员的沟通来采取此行动。",
    7058: "用户状态已更改。请刷新页面并重试。如果问题持续存在，请联系帮助台。",
    7062: "EY Canvas客户端目前无法访问，需要更新现有成员信息。请重试，如果问题持续，请联系帮助台。",
    7063: "无法停用外部成员。请刷新页面并重试。如果问题持续，请联系帮助台。",
    7064: "修补程序操作无效。",
    7065: "无法在一个或多个访问组中激活{0}{1}。所选组不允许使用域名：{2}。",
    7066: "{0}不是有效用户。",
    7067: "创建外部用户指令失败。",
    7068: "EY Canvas客户端目前无法访问，需要更新现有成员信息。请重试，如果问题持续，请联系帮助台。",
    7069: "选定的访问组未处于活动状态：{0}。移除并重试。",
    7072: "取消链接项目过程中出错。请刷新页面并重试。如果错误持续存在，请联系帮助台。",
    7074: "无法保存更改。项目必须至少具有一位活跃成员，该成员具有管理项目权限并已经解决了独立性。如果问题持续，请联系帮助台。",
    7075: "{0}{1}不能被邀请，因为他/她已经是一个活跃的项目组成员。",
    7077: "Il n’est pas possible de désactiver un ou plusieurs utilisateurs. Actualisez la page et réessayez. Si le problème persiste veuillez communiquer avec le Service de dépannage.",
    7079: "域名无权限请重试，如果问题仍然存在，请联系帮助台。",
    7080: "你没有权限邀请第三方成员。刷新页面，然后重试。如果问题持续，请联系帮助台以获得权限（如适当）。",
    7094: "特定项目组成员已签署本项目文档，无法删除文档。",
    7100: "无法处理对受限字段的编辑。请刷新并重试。",

    /*SCOT*/
    8001: "创建重大交易类别指令失败。",
    8002: "重大交易类别名称缺失。",
    8003: "重大交易类别缺失。",
    8004: "获取重大交易类别指令失败。",
    8005: "项目ID无效。",
    8006: "认定ID无效。",
    8007: "按ID获取重大交易类别指令失败。",
    8008: "请求无效。",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "未找到登录的用户首选项。",
    10002: "用户获取全部指令失败。",
    10003: "用户首选项获取指令失败。",

    /*Risk Type*/
    11001: "创建请求无效。",
    11002: "风险类型名称缺失。",
    11003: "风险类型缺失。",
    11004: "获取风险类型指令失败。",
    11005: "项目ID无效。",

    /* Annotation Errors*/
    12001: "无效请求参数。",
    12002: "创建注解指令失败。",
    12003: "获取注解失败。",
    12004: "无效项目ID。",
    12005: "ID集合必须大于零。",
    12006: "ID集合不得为空。",
    12007: "无效任务ID。",
    12008: "无效文件ID。",
    12009: "必须包含有效的文档Id或任务Id或财务报表Id。",
    12010: "需要上级答复。",
    12011: "无效状态ID。",
    12012: "文件类型应该为440GL。",
    12013: "无效注解类型。",
    12014: "无效项目用户。",
    12015: "此文件已被另一个用户删除。",
    12016: "更新注解指令失败。",
    12017: "您当前尝试回复的注释已被项目组其他成员删除。请刷新页面并重试。",
    12018: "注解更改操作类型不应为空。",
    12019: "复核注释已删除.",
    12020: "拟执行操作无效.",
    12021: "用户不是注解编辑人.",
    12022: "缺少创作用户.",
    12023: "创作用户不存在或不属于本项目.",
    12024: "分配的用户为必填项.",
    12025: "分配的用户不存在或不属于本项目.",
    12026: "无效注释。",
    12027: "注释内容不得为空。",
    12028: "截止日期为必填项.",
    12029: "有效优先级为必填项.",
    12030: "该附录状态已改变。不能再编辑或应对该附注。请关闭并重新打开窗口以查看更新的数据并继续编辑。",
    12031: "注解必须为最高级别.",
    12032: "注解不得为最高级别.",
    12033: "以下值中至少一个不得为空：优先级类型、截止日期、状态或分配的用户.",
    12034: "注释超过了最大长度（4,000个字符）。",
    12035: "搜索字符串超过最大长度（500个字符）",
    12036: "只能接受任务ID或文件ID，两者都不允许.",
    12037: "无效的补丁操作.",
    12038: "你正在对已不存在的附注尝试编辑。请刷新页面并重试。",
    12039: "你和其他团队成员正在尝试编辑相同的注释.请刷新页面并重试.",
    12040: "获取注解用户指令失败.",
    12041: "获取注解用户失败.无效查询值.",
    12042: "文件类型无效，无法创建注释.",
    12043: "你正在尝试为不再存在的任务或文件添加注释.请刷新页面并重试.",
    12044: "你正在对已不存在的附注尝试编辑回复。请刷新页面并重试。",
    12045: "未找到复核附注。",
    12046: "你正尝试删除已经被其他项目组成员删除的附注。请刷新页面并重试。",
    12047: "你只能删除处于打开状态的附注的回复。请刷新页面并重试。",
    12048: "你正在对已不存在的附注尝试更改状态。请刷新页面并重试。",
    12049: "您尝试删除的注释回复已被其他项目组成员删除。请刷新页面并重试。",
    12050: "你只能删除处于关闭状态的附注。",
    12059: "复核注释只能由创建注释的用户删除。",
    12066: "只能回复开放注释。",
    12067: "您正在尝试删除已经被其他项目组成员删除的批注的回复。请刷新页面并重试。",
    12068: "无法添加批注。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    12070: "每个财务报表只能添加一条批注。请在已有批注上编辑。",
    12071: "无法删除信息。请重试。如果问题仍然存在，请联系帮助台。",

    /*Configuration*/
    13001: "未找到配置。",
    13002: "获取配置ID指令失败。",

    /*Documents*/
    14001: "由于请求为空，因此无法执行指令。",
    14002: "未找到文档。指令失败。",
    14003: "项目ID应大于零。",
    14004: "文档ID不应为空。",
    14005: "试图获取关联任务时出错。指令失败。",
    14006: "已选定文档无法被删除。请稍后重试。如果问题持续，请联系帮助台。",
    14007: "发生意外错误。",
    14008: "签名期间发生意外错误。",
    14009: "添加签名时发生错误。",
    14010: "批准ID应大于零。",
    14011: "删除签名时发生错误。",
    14012: "主体不得为空。",
    14013: "选定的文档无法取消链接。请重试。如果问题持续存在，请联系帮助台。",
    14014: "按文档ID指令获取账户失败。",
    14015: "无效的相关实体。",
    14016: "获取文件批准指令失败。",
    14017: "获取全部文件发现指令失败。",
    14018: "获取全部文件指令失败。",
    14019: "未找到签署。",
    14020: "无效操作值.",
    14021: "无效发现类型.",
    14022: "该文件不属于本项目.",
    14023: "该文件变更类型无效.",
    14024: "获取全部文件指令失败.参数无效.",
    14025: "创建文档复核时发生错误。API指令失败。",
    14026: "删除文档复核时出错API指令失败。",
    14027: "项目ID不应该为零或空。",
    14028: "用户 ID 无效。",
    14029: "用户未获授权执行此操作。",
    14030: "在此项目中没有找到具有通过的ID的文档",
    14031: "文档复核ID无效。",
    14032: "文档复核未发现。",
    14033: "文档已经获得批准。",
    14034: "工作区中的另一项项目正在进行删除链接流程，或者该文档已经被删除链接。请刷新页面并重试。如果问题持续，请联系帮助台。",
    14035: "该文档不与给定的项目共享。",
    14036: "版本号应大于零。",
    14037: "此时无法完成操作。请刷新页面并重试。如果问题持续存在，请联系帮助台",
    14038: "获取文档更改原因失败。",
    14039: "按ID获取文档更改原因失败。",
    14040: "更新更改原因失败。",
    14041: "无效的更改原因。",
    14042: "更新更改原因失败。",
    14043: "创建更改原因失败。",
    14044: "删除更改原因失败。",
    14045: "无效的更改原因ID。",
    14046: "文档不能用。请刷新页面并重试。如果问题持续，请联系帮助台。",
    14047: "文档已经分配了更改原因。",
    14048: "文档有冲突，请先解决再继续。",
    14049: "检查文件是否被添加到团队或用户时数据无效。",
    14050: "删除索引文档时出现错误。",
    14051: "删除所有共享证据链接核对表未找到",
    14052: "搜索文本超过最大允许长度（500个字符）",
    14053: "由于请求为空，因此无法执行指令。",
    14054: "修补程序操作无效。",
    14055: "解析文档历史记录指令失败。",
    14056: "尝试将消息排列时出错。",
    14057: "该项目中已经存在同名文件。",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "此文档已被另一个项目组成员取消关联。请刷新页面，如果错误仍然存在，请联系帮助台。",
    14070: "无效文件类型。",
    14071: "选择的文档版本不再可用。请关闭后重新打开该窗口，查看文档的历史版本。",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "未找到源文档的关联Canvas表格。",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "此文件已被删除，无法打开。",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "书签观察无效。",
    14090: "请求状态已改变。必要时，请刷新页面重试。如问题仍然存在，请联系帮助台。",
    14091: "此请求已被删除。请刷新页面查看更新后的数据。如仍有问题，请联系帮助台。",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "由于请求无效，获取账户ID的SEM汇总表指令失败。",
    15002: "账户ID无效",
    15003: "项目ID无效。",
    15004: "汇总表类型无效。",
    15005: "无法找到相关账户。请刷新页面并重试。如果问题持续，请联系帮助台。",

    /*Timephase*/
    16001: "获取时间段失败。",
    16002: "项目必须大于零。",
    16003: "时间段必须大于零。",
    16004: "无效任务ID值。",
    16005: "无效时间段值。",

    /*Validations*/
    17001: "构建步骤ID或文档类型ID缺失。",

    /*TaskGroupSection*/
    18001: "获取全部任务组组指令失败。",
    18005: "此任务组在此项目中不再可用。",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "任务组只有在没有关联任务的情况下才能删除。请删除或移动关联任务，然后重试。",
    18019: "您尝试更新的任务组已被删除。",

    /*Assignments*/
    19001: "创建分配指令失败。",
    19002: "获取分配指令失败。",
    19003: "分配工作名称必须唯一。",
    19004: "分配工作名称无效",
    19005: "分配工作名称长度超过100个字符。",
    19006: "无效分配工作类型",
    19007: "搜索名称长度超过500个字符的分配工作。",
    19008: "本项目名称被其他项目组成员删除。刷新页面，然后重试。",

    19012: "任务ID不能重复。",
    19013: "角色ID和用户ID字段不能同时有值。",
    19014: "用户ID不能是默认值。",
    19016: "审计负责合伙人用户无效，或审计负责合伙人用户未被邀请。",
    19017: "项目质量复核人用户无效，或项目质量复核人用户未被邀请。",
    19018: "到期天数必须在0至1000之间。",
    19019: "创建任务自动分配指令失败。",

    /*Client Request*/
    21001: "无法将请求发送至EY Canvas客户端。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    21002: "此请求已被删除。请刷新页面以查看更新数据。如果问题仍然存在，请联系帮助台",
    21009: "删除客户请求文档指令失败。",
    21010: "你当前回复的批注已被其他项目组成员删除。请刷新页面并重试。",
    21011: "客户请求文档已被删除。",
    21012: "未发现客户请求文档。",
    21013: "文档请求为空。",
    21014: "文档ID为空。",
    21015: "客户请求ID为空。",
    21016: "创建客户请求文档指令失败。",
    21017: "已从项目中删除一个或多个关联文档。请从此请求中移除已删除文档，或刷新页面并重试。",
    21018: "未找到文档。",
    21019: "客户请求状态已更改。",
    21030: "客户集团ID不匹配。",
    21031: "请求状态已更改。如需要，请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    21032: "客户集团联系人用户不活跃。",
    21033: "客户集团不活跃。",
    21034: "客户集团有不活跃用户。",
    21045: "请求状态已更改。请刷新页面查看最新变更。",
    21046: "无法将请求发送至EY Canvas客户端。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    21050: "请求无法删除。请刷新页面并重试。如果问题仍然存在，请联系帮助台",
    21053: "项目任务不再可用。刷新页面以更新列表。",
    21057: "无法分配安永联系人。请刷新页面并重试。",
    21028: "到期日为必填项。",
    21036: "找不到时间阶段",
    21064: "任务无法关联至请求。请求至多可关联25个任务。请移除一个或多个关联任务，以关联新任务。",
    21065: "一个或多个机密文件已添加至请求。您没有适当的保密级别，无法将其中一个或多个文件发送至EY Canvas客户端。请删除您无法访问的任何机密文件以继续。",
    21066: "检索数据时出现错误。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    21067: "无法更新优先级。请刷新页面并重试。如果问题仍然存在，请联系帮助台",
    21035: "未找到客户请求。",
    21074: "收到的请求不允许更改“标题”、“描述”和“优先等级”。",
    21075: "已接受请求不允许更改“标题”、“描述”、“分配给（分组）”、“分配给（用户）”、“截止日期”、“优先等级”。",
    21077: "处于“已收到”和“待处理”状态的客户请求必须填写截止日期。",
    21039: "找不到“客户分组ID”。",
    21078: "更新“分配给分组”或“分配给用户”时，“分组”和“用户”都是必填项。",
    21079: "日期格式无效。",
    21027: "请求标题是必填项。",
    21041: "请求标题长度超过了允许的最大字符数。",
    21042: "请求描述长度超过了允许的最大字符数。",
    21060: "“客户用户ID”为空。",
    21076: "不允许使用“优先等级类型”。",

    /* Group Components*/
    22001: "获取相关组成部分指令失败。",
    22002: "获取集团组成部分指令失败。",
    22003: "创建账户组成部分指令失败。",
    22004: "无效的上级组成部分ID，你指定的上级组成部分不存在。",
    22005: "项目组名称已超过了最大长度。",
    22006: "项目组法定名称已超过了最大长度。",
    22008: "你指定的范围不存在。",
    22009: "组成部分简称无效。",
    22010: "组成部分法定名称无效。",
    22011: "组成部分范围ID无效。",
    22012: "如果提供了联系人邮箱，则联系人GUID不应为零或空。",
    22013: "如果提供了联系人邮箱，则联系人描述不应为零或空。",
    22016: "此项目组已被另一个项目组成员删除。请刷新页面并重试。",
    22022: "项目组名称已存在于此项目。",
    22043: "发送指引指令失败。",

    /*User Presence*/
    23001: "未找到登录的用户首选项。",
    23002: "用户首选项获取指令失败。",
    23003: "用户首选项文件验证失败。",
    23004: "用户首选项删除指令失败。",
    23005: "文档不再被任何其他用户打开。请刷新页面并重试。如果问题持续，请联系帮助台。",

    /* Forms */
    24001: "获取表格指令失败.",
    24002: "无效项目ID.",
    24003: "文件ID不能为零或空.",
    24004: "无效文件ID.",
    24005: "无效表格标题ID.",
    24006: "无效表格部分ID.",
    24007: "无效请求参数.",
    24008: "标题ID不能为零或空.",
    24009: "部分ID不能为零或空.",
    24010: "表格主体部分回复更新操作失败.",
    24011: "表格主体部分回复更新请求无效.",
    24012: "无效主体部分ID.",
    24013: "无效表格主体部分选项ID.",
    24014: "无效表格主体部分类型ID.",
    24015: "给定主体部分类型ID的无效请求主体部分.",
    24016: "给定主体部分类型ID的无效自由文本.",
    24017: "包括多格式文本格式标签在内的最大字符数。缩短长度或移除不必要格式并再次尝试。",
    24018: "对于给定的主体类型ID，回复是不允许的",
    24019: "主体ID不应该为零或空。",
    24020: "无效请求主体",
    24021: "主体已被删除",
    24038: "文件无效或不存在。",
    24049: "所选对象已删除。刷新页面，然后重试。如果仍有错误，请联系帮助台。",
    24057: "文件“表格配置”验证失败。",
    24063: "项目ID无效。",
    24064: "语言ID无效。",

    /*Document Change Types*/
    25001: "获取文档更改类型指令失败",
    25002: "无效项目ID。",
    25003: "无效请求。",

    /* Manage team */
    26001: "客户用户组获取全部指令失败。",
    26002: "创建新客户组/电子邮件域名指令失败。",
    26003: "集团名称不应为空。",
    26004: "电子邮件域名不应为空。",
    26005: "{0}电子邮件域名标签不得超过63个字符。",
    26006: "{0}电子邮件域名不得超过263个字符。",
    26007: "{0} 电子邮件域名的第一部分可以是*或字母数字，其他特殊字符不允许。",
    26008: "{0}如果第一部分是通配符，则后面必须有2个或2个以上的部分。",
    26009: "{0} 第一部分可以是*或字母数字，其他域名部分不允许使用特殊字符。",
    26010: "电子邮件域名应该是唯一。",
    26011: "客户访问组ID无效。",
    26012: "删除访问组时出错。确保没有分配给该组或该组成员的请求/外部任务，然后重试",
    26013: "访问组已被删除，请刷新页面以获取最新数据。",
    26014: "至少需要一个电子邮件域名。",
    26015: "EY Canvas客户端目前无法访问，需要更新现有成员信息。请重试，如果问题持续，请联系帮助台。",
    26016: "删除操作期间出错。",
    26017: "获取数据操作失败。",
    26018: "并发问题，访问组不再活跃。刷新页面，然后重试。",
    26019: "保存操作失败。",
    26020: "分配了活动用户的电子邮件域无法被删除。更改尚未保存。",


    /* TimePhaseTypes - Milestones */
    27001: "获取里程碑详情失败。",

    /*Client Request Counts*/
    28001: "获取客户请求信息指令没有获取任何结果。",

    /*Content updates Error messages*/
    29001: "未找到按ID获取。",
    29002: "未找到措施类型。",
    29003: "未找到内容ID。",
    29004: "内容更新API指令失败。",
    29005: "内容更新进行中。再次尝试且如果问题持续，请联系帮助台。",
    29006: "无效请求参数。",
    29010: "内容刷新中。请稍后再试。如问题长时间未解决，请联系IT帮助台。",
    29012: "项目没有适用的准则配置问题。请联系IT帮助台。",
    29013: "如果有共享的EY Canvas FIT促进工具活动，则不允许进行主要标准任务（PST）和配置文件内容更新。如需更新PST或配置文件内容，请删除这些活动的链接。如果选择了多个内容更新类型，请取消选择主要标准任务（PST）和/或配置文件，然后重新启动更新。",
    /*IT Process*/
    30001: "获取全部IT流程失败。",
    30002: "获取全部IT流程——无效的项目ID。",
    30003: "IT流程名称不得为空。",
    30004: "IT流程名称不应超过500个字符。",
    30005: "IT流程ID无效。",
    30006: "按ID获取IT流程指令失败。",
    30007: "无效的请求。",
    30008: "IT流程无效。",
    30009: "未找到文档。",
    30010: "IT流程删除失败。",
    30012: "无效的IT风险。",

    /*Checklist*/
    31001: "获取全部核对表指令失败。",
    31002: "放置核对表指令失败。",
    31003: "无效核对表参数。",
    31004: "无效项目错误。",
    31005: "无效请求参数错误。",
    31006: "无效已检查请求参数错误。",

    /*Archive*/
    32001: "项目状态为无效。请解决验证问题，然后重试归档流程。如果错误仍然存在，请联系帮助台。",
    32002: "更新表格正文显示状态时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32003: "更新项目状态时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32004: "项目缓存无效化时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32005: "内容更新进行中。在内容更新完成之前，你无法归档此项目。如果错误仍然存在，请稍后再试并联系帮助台。",
    32006: "此项目中有未解决的验证。请刷新页面，解决验证问题，然后再次尝试归档流程。如果错误仍然存在，请联系帮助台。",
    32007: "建立归档请求模型时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32008: "获得归档API路径时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32009: "建立归档API指令时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32010: "因归档API应答缺少数据，造成归档失败。请重试。如错误仍然存在，请联系帮助台。",
    32011: "保存归档表格详细信息时失败，请重试。如果错误仍然存在，请联系帮助台。",
    32012: "更新项目状态以重试时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32013: "排队归档消息时归档失败，请重试。如果错误仍然存在，请联系帮助台。",
    32014: "归档成功，但排列全球状态更新消息时出错。如果错误仍然存在，请联系帮助台。",
    32015: "归档成功，但排列CCP状态更新消息时出错。如果错误仍然存在，请联系帮助台。",
    32016: "项目状态应为归档错误，重试归档流程。",
    32017: "未发现项目，请重试。如果错误仍然存在，请联系帮助台。",
    32019: "我们目前无法处理您的请求。请重试。如果问题仍然存在，请联系安永支持部门。",
    32020: "未配置归档路径（ARC URL），请重试。如果错误仍然存在，请联系帮助台。",
    32200: "此项目中有尚未解决的验证。从报告中运行验证检查报告，或参见“更多”菜单中的“验证帮助”链接，了解更多详情。如果仍有错误，请联系帮助台。",
    32400: "与ARC系统沟通时发生以下错误。请联系帮助台，并向其展示此错误消息以继续。",

    /*RBAC*/
    33001: "未找到项目ID。",
    33002: "未找到用户ID。",

    /*Helix Linked Projects*/
    34001: "EY Helix项目已取消关联，请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    34002: "项目ID不应该为零或空。",
    34003: "指令中主体不应为零或空。",
    34004: "项目ID不可为零或空。",
    34005: "项目名称不可为零或空。",
    34006: "EY Helix项目已关联，请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    34007: "获取全部Helix项目指令失败。",
    34008: "项目ID应大于零。",
    34009: "操作无法完成。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    34020: "无法链接Helix项目。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    34024: "无法向Helix发送通知。缺少项目的地区信息。",
    34029: "项目未建立关联，因为其位置与EY Canvas项目的位置不匹配。",
    34030: "无法链接分析工具。您不是所选分析工具的授权项目组成员。请联系EY Helix项目管理员获取访问权限，然后重试。",
    34031: "您以前没有访问过EY Helix应用程序。",
    34038: "选择的分析工具不再可用。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    34043: "`选定的EY Helix项目不再可用。请点击“链接项目”链接其他项目。",
    34044: "选择的EY Helix项目已被标记为待删除。请点击“链接项目”链接其他项目。",
    34045: "选择的EY Helix项目标记为待存储。请点击“链接项目”链接其他项目。",
    34046: "`EY Helix中的分析工具无效或缺失。请刷新页面，然后重试。如问题仍然存在，请联系帮助台。",
    34047: "`所选分析工具在EY Helix中不可用。请刷新页面，然后重试。如问题仍然存在，请联系帮助台。",
    34048: "`分析在链接项目中不可用。请转到EY Helix并完成数据和分析处理步骤以继续。",
    34080: "项目Helix关联数已达上限。",

    /* PAANS */
    35001: "目前无法使用安永政策授权、批准和通知服务。我们无法确认所有相关政策是否已经完成。如果您尚未复核相关政策，请刷新页面并再次尝试。如果问题仍然存在，请联系帮助台。",

    /*Engagement Comments*/
    38001: "创建项目批注指令失败",
    38002: "获取全部项目批注指令失败",
    38003: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38004: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38005: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38006: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38007: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38008: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38009: "该操作无法完成。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38010: "正文不能为零",
    38011: "批注文本不能为零或空",
    38012: "实体不存在于指定项目中",
    38013: "项目批注状态ID应大于零",
    38014: "母公司项目批注状态ID应大于零",
    38015: "无匹配特定标准的Canvas表格正文",
    38016: "您当前尝试回复的注释已被项目组其他成员删除。请刷新页面并重试。",
    38017: "提供的母公司项目批注已清除",
    38018: "提供的母公司项目批注本身即回复",
    38019: "提供的批注文本不能少于1个字符，不能多于4000个字符",
    38020: "提供的实体UID无效",
    38021: "提供的母公司实体UID无效",
    38022: "删除项目批注指令失败",
    38023: "批注ID不能为空",
    38024: "该操作应为有效操作",
    38025: "注释状态已更改。请刷新页面并重试。",
    38026: "复核注释只能由创建注释的用户删除。",
    38027: "您正尝试编辑一个已不存在的批注。请刷新页面并重试。",
    38028: "不允许更新已清除批注",
    38029: "仅批注者可以更改批注\’文本",
    38030: "项目批注ID无效",
    38031: "批注状态ID不能为空",
    38032: "被请求的用户和项目之间没有关系记录。请刷新页面并重试。如错误仍然存在，请联系帮助台",
    38033: "更新操作无效",
    38034: "被请求的批注ID正在被另一条批注使用",
    38035: "提供的批注ID无效",
    38036: "文档ID不能为零或空",
    38037: "将分配批注的用户ID不能为零",
    38038: "批注在打开或关闭时不能重新分配",
    38039: "您当前尝试删除的回复所对应的注释已被删除。请刷新页面并重试。",
    38040: "回复不能设置到期日",
    38041: "回复不能设置优先级",
    38042: "批注应设置到期日",
    38043: "批注应设置优先级",
    38044: "您当前尝试编辑的回复所对应的批注已不存在。请刷新页面并重试。",
    38045: "不允许编辑已分配至用户的项目状态ID及其内容或优先级",
    38046: "更新项目批注指令失败",
    38047: "您只能回复未解决状态的注释",

    /*Tags*/
    39004: "您正在编辑的标签组已被另一个项目组成员删除。请刷新页面并重试。",
    40003: "所选标签组已被另一个项目组成员删除。选择另一个标签组以继续。",
    40007: "已删除一个或多个所选注释。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "标签颜色编码无效。请刷新页面并重试。",
    40014: "包含您正在编辑的标签的标签组已被另一个项目组成员删除。请刷新页面并重试。",
    40016: "无法将标签添加到你选择的一个或多个任务中或从其中删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    40019: "你正在编辑的一个或多个标签已被其他项目组成员删除。请刷新页面并重试。",
    40020: "有一个或多个标签当前无法同步。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    40021: "所选标签中有一个或多个已被删除。请刷新页面并重试。",
    40022: "为此项目添加一个或多个外部项目组成员，然后重试该操作。如果错误仍然存在，请联系帮助台。",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "没有与该服务请求相关的任务。刷新页面并选择一个或多个未删除的任务以继续。如果错误仍然存在，请与帮助台联系。",
    70024: "目前您的项目不可使用集中服务。请刷新页面并重试。如错误提示仍然存在，请联系帮助服务中心。",
    70025: "目前您所在的国家不可使用集中化的服务。请刷新页面并重试。如错误提示仍然存在，请联系帮助服务中心。",

    /* TaskDocumnet */
    80001: "任务文件关联创建失败。",
    80002: "请求应至少包含一项任务。",
    80003: "文档ID为必填。",
    80004: "所选任务已删除。请刷新页面并重试。如果仍有错误，请联系帮助台。",
    80005: "文件ID无效。",
    80006: "用户权限不足，无法执行此操作。",
    80007: "任务文件关联失败。",
    80008: "任务文件关联后，任务状态变更失败。",
    80011: "机密性文档不可共享。",
    80012: "请求有效负载无效或为空。",
    80013: "任务数量超出限制。一次性选择的项目数应不超过300个。",
    80014: "尝试链接文档时出错。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",

    /* ITApplication / SO */
    81001: "获取全部IT应用程序失败。",
    81002: "获取全部IT应用程序——无效的项目ID。",
    81003: "所选IT应用程序均已删除。关闭此模式以查看更新的列表。",
    81004: "名称不应为空。",
    81005: "名称不应超过500个字符。",
    81006: "无效的策略类型ID。",
    81007: "无效的文档ID。",
    81008: "按ID获取IT应用程序失败。",
    81009: "无效的分类。",
    81010: "无效的重大交易类别。",
    81011: "无效的控制。",
    81012: "IT应用程序ID不应为零或空。",
    81013: "未找到IT应用程序。",
    81014: "删除IT应用程序IT流程指令失败。",
    81015: "IT应用程序IT流程ID不应为空。",
    81016: "无效的IT应用程序IT流程ID。",
    81017: "未找到IT应用程序IT流程。",
    81018: "创建IT应用程序IT流程指令失败。",
    81019: "取代IT应用程序的合格服务机构。",

    /* Controls */
    83001: "无法获取控制。",
    83002: "此操作无法执行。请刷新页面并重试。如问题仍然存在，请联系帮助台。",
    83003: "控制ID为空。",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "文档ID无效。",
    83006: "缺少控制名称。",
    83007: "控制名称长度无效。",
    83008: "请求无效。",
    83009: "控制频率ID无效。",
    83010: "控制类型ID无效。",
    83011: "控制IT应用程序无效。",
    83012: "控制设计有效性类型ID无效。",
    83013: "无效的IT应用程序。",
    83014: "如果控制类型为手动预防或手动发现，仅允许服务机构类型的IT应用程序。",
    83015: "只有依赖IT的手动控制可以选择手动IPE测试。",
    83016: "对有此配置文件的项目不允许较低风险控制。",
    83017: "FilterSCOT重复",
    83018: "控制名称超过500个字符。",
    83019: "可能出错项ID无效。",
    83020: "不允许可能出错项ID重复。",
    83021: "不允许IT应用程序ID重复。",
    83023: "当前页面无效。",
    83024: "页面大小无效。",
    83025: "搜索字符串不得超过100个字符。",
    83026: "没有服务机构的IT应用程序只能关联到依赖IT的手动控制或IT应用程序两类控制。",
    83027: "FilterWCGW重复。",
    83028: "知识库控制ID无效",

    /* ITControl */
    84001: "获取IT控制失败。",
    84002: "按ID获取IT控制失败。",
    84003: "IT控制ID为零或空。",
    84004: "无效的IT控制ID。",
    84005: "文档ID无效。",
    84006: "缺少IT控制名称。",
    84007: "无效的IT控制名称长度。",
    84008: "无效的IT控制频率ID。",
    84009: "无效的IT控制方法类型ID。",
    84010: "无效的IT控制设计有效性类型ID。",
    84011: "无效的IT控制测试值。",
    84012: "无效的IT控制运行有效性类型ID。",
    84013: "缺少IT控制频率。",
    84014: "删除IT控制失败。",
    84015: "搜索字符不应超过100个字符。",

    /*GroupTasks*/
    85001: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85002: "目前所选操作无法完成。刷新页面，然后重试。如仍有错误，请联系帮助台。",
    85003: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85004: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85005: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85006: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85007: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85008: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85009: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85010: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85011: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85012: "所选择文档已分配给其他地区或组成部分，因此不可分配。请刷新页面并重试。",
    85013: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85014: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85015: "目前无法完成选定的操作。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
    85016: "项目ID应大于零。",
    85017: "此任务在此项目中不再可用。",
    85018: "文档ID无效。",
    85019: "您没有适当的机密级别来发送这些文档。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    85020: "您正在尝试发送的文档中有一个或多个文档不再可用。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    85021: "不可发送至主审小组的表格。",
    85022: "一个或多个文档发送失败。请刷新页面并重试。如错误仍然存在，请联系帮助台。",

    /* ITRisk */
    86001: "IT风险名称不得为空。",
    86002: "IT风险名称不应超过500个字符。",
    86003: "无效的IT风险ID。",
    86004: "按ID获取IT风险指令失败。",
    86005: "未找到IT风险。",
    86006: "创建IT风险IT控制指令失败。",
    86007: "无效的IT控制ID。",
    86008: "删除IT风险IT控制指令失败。",
    86009: "无效的IT风险IT控制ID。",
    86010: "删除IT风险失败。",


    /*Copyhub*/
    88017: "导出流程服务已关闭-部分数据包创建成功",
    88018: "发送数据包选择的用户无效（邮箱、Gui或全名无效）",
    88033: "要导入的副本包状态无效。",
    88042: "你没有批量导出权限。",
    88045: "你没有创建模板项目权限。",
    88048: "副本包正由其他用户导入。请稍后重试。",
    88049: "副本包不存在。请刷新页面。",
    88050: "另一个项目副本正在创建中。",
    88051: "该项目存在过多创建中的副本。请待所有副本创建完成后，再开始创建新的副本。",
    88056: "操作无法完成。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    88057: "选定的某些文档包含活跃的多用户编辑模式下的相关证据。请签入相关证据以继续。如果错误仍然存在，请联系帮助台。",

    /* Group Scopes */
    92001: "获取所有集团范围指令失败。",
    92002: "创建集团范围指令失败。",
    92003: "集团范围更新请求无效。",
    92004: "范围名称无效。",
    92005: "主体范围ID无效。",
    92006: "主体范围不存在。",
    92007: "范围描述无效。",
    92008: "集团范围名称长度超过100个字符。",
    92009: "集团范围描述长度超过500个字符。",
    92010: "删除集团范围指令失败。",
    92011: "你正在编辑的定制子范围已被其他项目组成员删除。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
    92012: "指定的范围ID无效。",
    92013: "此定制子范围已被分配至一个或多个项目组，因此无法删除。",
    92014: "你试图删除的定制子范围已被项目组其他成员删除。请刷新页面并重试。",
    92015: "该用户没有执行此操作的权限。",
    92016: "范围名称已存在于此项目中",
    92017: "按ID获取分组范围指令失败。",

    /* Group Sections */
    101001: "创建小组分区指令失败。",
    101002: "小组名称不能为空或无效。",
    101003: "小组分区名称长度超过100个字符。",
    101004: "本项目中已存在此分区名称。",
    101005: "编辑小组分区指令失败。",
    101006: "无效分区ID。",
    101007: "小组分区不存在。",
    101008: "无效项目ID。",
    101009: "小组认知分区无效。",

    /* Group Documents */
    110001: "无效的项目ID。",
    110002: "无效的指示状态。",
    110003: "按ID获取项目指令失败。",

    /* ClientEngagement */
    93001: "未找到客户项目描述。",
    93002: "客户项目描述不得超过100个字符。",
    93003: "客户项目请求为空。",
    93004: "客户项目获取指令失败。",
    93005: "客户项目更新指令失败。",
    93006: "目前不能更新项目显示名称。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",

    /*IP FIltering */
    96005: "{0}暂未被添加至被允许列表。",
    96015: "没有可用于从源头项目导入的访问位置。",
    96016: "没有可用于从源头项目导入的访问位置。",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "您没有权限请求服务。请与项目管理员联系，申请获取执行此操作的权限。",

    /* GroupInstructions */
    98001: "获取集团指令调用失败。",
    98002: "一个或以上资料指引部分ID无效。",
    98003: "创建集团指令调用失败。",
    98004: "指令名称不能为空。",
    98005: "指引名称不得超过500个字符。",
    98006: "指令说明不能为空。",
    98007: "说明描述不能超过4,000个字符。",
    98008: "指令应分配给范围或小组。",
    98009: "指引名称与该项目中已存在的指引名称重合。",
    98011: "此集团指引已被另一个项目组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    98012: "此集团指引已被另一个项目组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    98016: "你正在编辑的集团指引已被其他项目小组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    98017: "此集团任务已被另一个项目组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    98018: "此集团任务已被另一个项目组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    98019: "实体未找到",

    /* Group Snapshots */
    102001: "创建分组说明截图指令失败。",
    102002: "无效请求参数错误。",
    102003: "无效项目错误。",
    102004: "获取所有分组截图指令失败。",
    102005: "按ID获取分组截图指令失败。",
    102006: "未找到截图。",
    102007: "选择的截图无效。",

    /* Group Links - Send link request */
    106001: "创建分组链接指令失败。",
    106002: "项目组列表不能为空。",
    106003: "选择的项目组中有一个或多个无效。",
    106004: "分组链接消息排列失败。",
    106005: "项目组不能重复选择。",
    106006: "并发令牌不能重复。",

    /* GroupInstructions - Send Version request */
    22019: "项目组已删除。",
    22023: "发送说明指令失败。",
    22024: "您尝试向其发送说明的组成部分不可用或已被删除。",
    22025: "项目ID不得为空。",
    22026: "组成部分ID不得为空。",
    22027: "集团说明未提及到期日。",
    22028: "尚未给组成部分发送范围说明。",
    22029: "没有需要发送给组成部分的新说明。",
    22030: "这一版指引与任务已被另一项目组成员接受。请刷新页面并重试。如错误仍然存在，请联系帮助台。",

    22031: "集团版本指令失败。",

    /* GroupVersion */
    22032: "说明不存在。",

    22034: "按ID获取集团版本指令失败。",
    22035: "指引设置ID不能为空。",

    /* Return instruction concurrency scenario*/
    22036: "有可用的新版指引与任务。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    22037: "这一版指引与任务已被另一项目组成员接受。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    22038: "这一版指引与任务已被另一项目组成员退回。请刷新页面并重试。如错误仍然存在，请联系帮助台。",

    37018: "此总账账户不再可用。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
    37019: "无法编辑文档关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    37030: "此总账账户不再可用。请刷新页面并重试。如仍有错误，请联系帮助台。",
    37032: "无法编辑文档关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    37033: "无法编辑文档关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    37034: "无法编辑文档关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    37037: "此调整不再可用。请刷新页面并重试。如仍有错误，请联系帮助台。",

    /* EngagementReports */
    111001: "按报告类型获取报告指令失败。",
    113015: "试算表不可用。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    113025: "无法继续,需要筛选账户类别id或筛选账户id。",
    113050: "试算表或财务报表不属于此项目，或者可能已被删除，无法继续。",

    /*Information Security */
    200001: "安永信息安全部禁止采取上述行动。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",

    /*GL account concurrency scenario*/
    113043: "此调节账户不再可用。请刷新页面并重试。如仍有错误，请联系帮助台。",
    113019: "此调节账户不再可用。请刷新页面并重试。如仍有错误，请联系帮助台。",
    113022: "无法完成操作。请刷新页面并重试。如仍有问题，请联系帮助台。",
    113039: "索引已与此总账账户关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "索引已与此总账账户关联。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    113020: "此证据不再可用。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    113037: "此总账账户不再可用。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
    40029: "此总账账户不再可用。请刷新页面并重试。如错误仍然存在，请联系帮助台。",

    /*Trial balance*/
    113060: "MEST项目需要多实体。",
    113061: "非MEST项目不需要多实体。",
    113057: "未找到项目Helix。",
    113094: "要更新的试算表的Planning和IstrialBalance必须为真。",
    113095: "当财务类型为试算表时，要更新的试算表的Planning和IstrialBalance不应为真。",
    113069: "项目的范围和策略已存在。",
    113009: "试算表id无效，无法继续。",
    113092: "试算表既是Planning也是财务报表。无法继续进行软删除。",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "依赖"
    },
    {
        id: 2,
        name: "不依赖"
    },
    {
        id: 3,
        name: "测试管理程序"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "更新中"
    },
    {
        id: 3,
        value: "错误"
    },
    {
        id: 5,
        value: "更新中"
    },
    {
        id: 6,
        value: "错误"
    }
];

export const riskTypes = [{
        id: 1,
        name: "特别风险",
        abbrev: "SR",
        title: "特别风险"
    },
    {
        id: 2,
        name: "舞弊风险",
        abbrev: "FR",
        title: "舞弊风险"
    },
    {
        id: 3,
        name: "重大错报风险",
        abbrev: "R",
        title: "重大错报风险/固有风险"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "特别风险",
        abbrev: 'SR',
        label: "特别",
        title: "特别风险"
    },
    {
        id: 2,
        name: "舞弊风险",
        abbrev: "FR",
        label: "舞弊",
        title: "舞弊风险"
    },
    {
        id: 3,
        name: "重大错报风险",
        abbrev: "R",
        label: "重大错报风险",
        title: "重大错报风险"
    }
];

export const risksTypes = [{
        id: 1,
        name: "特别风险",
        abbrev: "SR",
        title: "特别风险"
    },
    {
        id: 2,
        name: "舞弊风险",
        abbrev: "FR",
        title: "舞弊风险"
    },
    {
        id: 3,
        name: "重大错报风险",
        abbrev: "R",
        title: "重大错报风险"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "没有识别到特别风险"
    },
    {
        id: 2,
        label: "没有识别到舞弊风险"
    },
    {
        id: 3,
        label: "未识别重大错报风险"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "依赖"
    },
    {
        id: 2,
        name: "不依赖"
    },
    {
        id: 3,
        name: "测试管理程序"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "较高"
    },
    {
        id: 2,
        name: "较低"
    }
];
export const CRAStrings = {
    Minimal: "最低",
    Low: "低",
    'Low +SC': "低+SC",
    Moderate: "中等",
    High: "高",
    'High +SC': "高+SC"
};
export const priorityType = [{
        id: 1,
        name: "低",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "中等",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "高",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "关键",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "全部"
    },
    {
        value: 1,
        label: "打开"
    },
    {
        value: 2,
        label: "已清"
    },
    {
        value: 3,
        label: "已关闭"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "打开"
    },
    {
        id: 2,
        name: "已清"
    },
    {
        id: 3,
        name: "已关闭"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "清理"
    },
    {
        value: 3,
        label: "关闭"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "重新打开"
    },
    {
        value: 3,
        label: "关闭"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "重新打开"
    },
    {
        value: 2,
        label: "清除"
    },
    {
        value: 3,
        label: "关闭"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "重新打开"
}];
export const signOffTypes = [{
        value: 0,
        label: "编制人"
    },
    {
        value: 1,
        label: "复核人"
    },
    {
        value: 2,
        label: "无"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "打开"
    },
    {
        value: 2,
        label: "已关闭"
    },
    {
        value: 3,
        label: "已清除"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "完整性",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "存在性",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "计价",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "权利和义务",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "列报和披露",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "完整性",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "发生",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "计量",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "列报和披露",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "完整性",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "存在性/发生",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "计量/计价",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "权利和义务",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "列报和披露",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "低"
    },
    {
        value: 2,
        label: "中等"
    },
    {
        value: 3,
        label: "高"
    },
    {
        value: 4,
        label: "关键"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "打开",
    'Start Co-edit mode': "开始多用户编辑",
    'End Co-edit mode': "结束多用户编辑",
    'Open read-only': "打开只读",
    'View history': "查看历史",
    CopyLink: "复制链接",
    Rename: "重命名",
    Delete: "删除",
    'Remove from task': "从任务中删除",
    Remove: "删除",
    Unlink: "删除链接",
    RelateTasks: "关联任务",
    RelateEntities: "关联实体",
    Restore: "重置",
    PermanentlyDelete: "永久删除",
    ChangeReason: "编辑原因",
    Confidentiality: "机密性",
    SignoffRequirements: "签字要求",
    AssignRegionComponent: "分配给地区或组成部分",
    UnassignRegionComponent: "未分配给地区或组成部分",
    ReturnToRegionComponent: "返回至地区或组成部分",
    ClearReturnToRegionComponent: "清除返回至地区或组成部分",
    OverwriteForm: "覆盖表格",
    Finalize: "定稿文档"
};

export const pagingSvgHoverText = {
    first: "第一页",
    previous: "上一页",
    next: "下一页",
    last: "最后一页"
};
export const controlFrequencyType = {
    1: "每天很多次",
    2: "每天",
    3: "每周",
    4: "每月",
    5: "每季",
    6: "每年",
    7: "IT应用程序控制",
    8: "其他"
};
export const itApproachType = {
    1: "控制",
    2: "实质性"
};
export const controlType = {
    1: "IT应用程序",
    2: "依赖IT的手动",
    3: "手动预防",
    4: "手动检测"
};
export const aggregateITEvaluationType = {
    1: "支持",
    2: "不支持",
    3: "支持财务报表和财务报告内部控制",
    4: "仅支持财务报表"
};
export const entityType = {
    'ENTITY3': "账户",
    'ENTITY4': "重大交易类别",
    'ENTITY5': "IT流程",
    'ENTITY7': "风险",
    'ENTITY18': "可能出错项",
    'ENTITY19': "控制",
    'ENTITY20': "ITSO应用程序",
    'ENTITY24': "认定",
    'ENTITY34': "IT控制",
    'ENTITY35': "IT风险"
};
export const trueFalseToYesNo = {
    'true': "是",
    'false': "否"
}
export const trueFalseToYesOnly = {
    'true': "是"
}
export const yesNoLocalized = {
    'Yes': "是",
    'No': "否"
}
export const iTProcessEvaluationType = {
    1: "有效",
    2: "无效",
    3: "可依赖",
    4: "未测试"
};

export const strategyType = {
    1: "控制",
    2: "实质性",
    3: "依赖",
    4: "不依赖"
};
export const accountType = {
    1: "重大账户",
    2: "有限风险账户"
};

export const scotTypes = {
    1: "常规",
    2: "非常规",
    3: "估计"
};
export const taskNavigation = {
    1: " 我的任务",
    2: " 全部任务",
    3: " 范围和策略",
    4: " 重大交易类别",
    5: " IT/SOs",
    6: " 账户",
    7: " 一般执行",
    8: " 结论",
    9: " 项目组总结",
    10: "风险"
};
export const subCategoty = {
    1: "显示全部",
    2: "编制",
    3: "复核"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "显示全部",
        label: "显示全部"
    },
    ToPrepare: {
        id: 2,
        title: "编制",
        label: "编制"
    },
    ToReview: {
        id: 3,
        title: "复核",
        label: "复核"
    },
    Preparers: {
        id: 2,
        title: "编制人",
        label: "编制人"
    },
    Reviewers: {
        id: 3,
        title: "复核人",
        label: "复核人"
    }
};
/*Task Types*/
export const taskType = {
    1: "标准任务",
    2: "主要标准任务",
    3: "穿行测试任务",
    4: "控制任务",
    5: "实质性任务",
    6: "主要实质性程序任务",
    7: "应对任务",
    8: "集团任务"
};

export const taskTypesForAddTask = {
    importfromknowledge: "从Knowledge中导入",
    custom: "定制",
    account: "账户",
    itsubstantive: "IT实质性程序",
    scotwalkthroughtask: "重大交易类别穿行测试",
    scotcontroltask: "重大交易类别控制",
    itwalkthroughtask: "IT穿行测试",
    itcontroltask: "IT控制"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "范围&策略",
    2: "执行",
    3: "结论"
};
export const ProfileActionType = {
    1: "提交配置文件——第一次",
    2: "提交配置文件——前推",
    3: "配置文件编辑",
    4: "全球内容更新",
    5: "导入PSP",
    6: "导入PSP",
    7: "Canvas表格内容更新",
    8: "导入GA说明",
    9: "添加人工表格",
    10: "提交配置文档",
    11: "强制内容更新",
    12: "Canvas表格文档设置同步"
};

export const taskGroup = {
    1: "执行其他计划程序",
    2: "账户流",
    3: "重大交易类别 (SCOT) 流",
    4: "IT 应用程序与服务机构流",
    5: "综合风险评估 (CRA) 流",
    6: "审计计划流",
    7: "执行总结程序",
    8: "审计差异汇总表 (SAD)",
    9: "评估审计结果",
    10: "执行其他审计程序",
    11: "集团审计结构",
    12: "集团审计指引",
    13: "主要集团任务",
    14: "组成部分集团任务",
    15: "工作计划",
    16: "Accounts Flow - MEST",
    17: "执行复核程序",
    18: "完成初步业务活动",
    19: "建立审计小组",
    20: "根据数据启动项目",
    21: "执行风险评估分析程序并确定重要性水平",
    22: "Identify significant accounts - MEST",
    23: "为我们的风险评估提供信息的其他程序",
    24: "识别来源",
    25: "识别重大账户",
    26: "识别并了解重大交易类别",
    27: "识别并了解IT流程和服务机构",
    28: "确认策略和综合风险评估",
    29: "执行其他所须的风险识别程序",
    30: "考虑使用内部审计",
    31: "应对风险评估",
    32: "最终确定策略",
    33: "项目质量复核程序",
    34: "设计程序",
    35: "根据审计证据评估并得出结论",
    36: "发布沟通和可交付成果",
    37: "项目质量复核程序",
    38: "编制并出具审计报告",
    39: "定稿文档记录并归档",
    40: "测试实体整体层面内部控制",
    41: "评估自动化技术中使用的数据",
    42: "执行所须的舞弊程序",
    43: "执行内部审计和专家程序",
    44: "评估IT流程",
    45: "会议记录、合同和诉讼复核",
    46: "执行财务报表程序",
    47: "执行关联方交易、持续经营以及法律法规程序",
    48: "讨论审计策略修改",
    49: "执行结论",
    50: "项目质量复核程序",
    51: "完成范围和策略质量活动",
    52: "执行首次审计程序",
    53: "执行风险评估程序",
    54: "确定服务机构",
    55: "数字化——任务组5",
    56: "识别并了解IT流程",
    57: "执行计划程序",
    58: "集团结构、指引和参与",
    59: "识别重大披露",
    60: "识别和了解重大报告流程",
    61: "数字-任务组11",
    62: "数字化——任务组12",
    63: "数字化——任务组13",
    64: "数字化——任务组14",
    65: "数字化——任务组15",
    66: "数字化——任务组16",
    67: "数字化——任务组17",
    68: "完成中期审计后项目管理活动",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "执行实质性程序-其他",
    74: "评估他人的工作",
    75: "数字化——任务组25",
    76: "数字化——任务组26",
    77: "数字化——任务组27",
    78: "数字化——任务组28",
    79: "数字化——任务组29",
    80: "数字化——任务组30",
    81: "数字化——任务组31",
    82: "数字化——任务组32",
    83: "数字化——任务组33",
    84: "数字化——任务组34",
    85: "根据复核证据评估并得出结论",
    86: "执行一般鉴证程序",
    87: "评估和总结证据",
    88: "数字化——任务组38",
    89: "数字化——任务组39",
    90: "数字化——任务组40",
    91: "数字化——任务组41",
    92: "数字化——任务组42",
    93: "数字化——任务组43",
    94: "数字化——任务组44",
    95: "数字化——任务组45",
    96: "数字化——任务组46",
    97: "数字化——任务组47",
    98: "数字化——任务组48",
    99: "数字化——任务组49",
    100: "数字化——任务组50"
};
export const AutomationHubRequestStatus = {
    Draft: "草案",
    Submitted: "已提交",
    Sent: "发送中",
    InProgress: "处理中",
    Failed: "处理错误",
    Completed: "已完成",
    FailedToSendToBP: "处理错误",
    QueueingFailed: "提交失败",
    ActionRequired: "需要进行的操作"
};
export const milestonesLabels = {
    1: "范围",
    2: "策略",
    3: "穿行测试",
    4: "中期控制测试",
    5: "中期实质性测试",
    6: "穿行测试（年终流程）",
    7: "年终控制测试",
    8: "年终实质性测试",
    9: "结论",
    10: "不适用",
    11: "执行",
    12: "范围和策略质量活动",
    13: "其他范围和策略",
    14: "综合风险评估",
    15: "风险评估和重要性",
    16: "最终确定范围和策略",
    17: "中期审计后项目管理"
};

export const TasksFilterGroups = {
    Tasks: "任务",
    Assignments: "工作分配",
    ReviewNotes: "复核注释",
    ProjectManagement: "项目管理",
    Other: "其他"
};

export const TasksFilterTypes = {
    TaskStatus: "任务状态",
    TaskType: "任务类型",
    AssignedTo: "被分配人",
    OpenAssignments: "打开任务",
    ReviewNotesStatus: "复核附注状态",
    ReviewNotesAssignedTo: "复核附注被分配人",
    ReviewNotesCreatedBy: "复核附注创建人",
    TimePhase: "时间段",
    Milestone: "里程碑",
    AuditPhase: "审计阶段",
    DocumentConflict: "文档冲突",
    Findings: "发现",
    Entity: "实体",
    IsBookmarked: "离线下载"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "打开"
    },
    {
        value: '2',
        label: "进行中"
    },
    {
        value: '3',
        label: "复核中"
    },
    {
        value: '4',
        label: "完成"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "打开"
    },
    {
        value: '2',
        label: "进行中"
    },
    {
        value: '3',
        label: "已关闭"
    },
    {
        value: '4',
        label: "未分配"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"协作",
	// 'Control Forms',
	"文档",
	"任务",
	"SCOT汇总表",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "归档表格",
    'Canvas Forms': "Canvas表格报告",
    'Collaboration': "协作",
    'Control Forms': "控制报告",
    'Documents': "所有文件报告",
    'Tasks': "所有任务报告",
    'Team Members': "项目组成员",
    'Trial Balance': "数据报告"
};
export const projectManagement = [
	"协作详细信息",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "客户合作展示板",
    'Milestones': "里程碑报告",
    'Review Notes': "复核注释报告",
    'Validation Checks': "验证检查报告"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "待准备的任务",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "待复核的任务",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "所有已分配的任务",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "逾期的任务",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "本周即将到期的任务",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "没有默认的筛选条件"
};

export const taskTypes = [{
        id: '1',
        label: "控制任务"
    },
    {
        id: '2',
        label: "控制任务 - 控制"
    },
    {
        id: '3',
        label: "控制任务 - 企业整体层面内部控制"
    },
    {
        id: '4',
        label: "控制任务 - IT/SO"
    },
    {
        id: '5',
        label: "控制任务 - MP"
    },
    {
        id: '6',
        label: "控制任务 - SO"
    },
    {
        id: '7',
        label: "应对任务"
    },
    {
        id: '8',
        label: "现金流量错报应对任务"
    },
    {
        id: '9',
        label: "缺陷应对任务"
    },
    {
        id: '10',
        label: "披露错报应对任务"
    },
    {
        id: '11',
        label: "错报应对任务"
    },
    {
        id: '12',
        label: "标准任务"
    },
    {
        id: '13',
        label: "其他标准任务"
    },
    {
        id: '14',
        label: "主要标准任务"
    },
    {
        id: '15',
        label: "实质性任务 "
    },
    {
        id: '16',
        label: "其他实质性程序任务"
    },
    {
        id: '17',
        label: "主要实质性程序任务"
    },
    {
        id: '18',
        label: "穿行测试任务"
    },
    {
        id: '19',
        label: "穿行测试任务 - IT/SO"
    },
    {
        id: '20',
        label: "穿行测试任务 - 重大交易类别"
    },
    {
        id: '21',
        label: "待办事项"
    },
    {
        id: '22',
        label: "账户结论任务"
    },
    {
        id: '23',
        label: "集团任务"
    },
    {
        id: '24',
        label: "主要集团任务"
    },
    {
        id: '25',
        label: "组成部分集团任务"
    },
    {
        id: '26',
        label: "IT/SO其他实质性程序任务"
    },
    {
        id: '27',
        label: "组成部分集团未关联"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "编制人"
    },
    {
        value: '2',
        label: "详细复核人"
    },
    {
        value: '3',
        label: "一般复核人"
    },
    {
        value: '4',
        label: "合伙人"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "其他"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "打开"
    },
    {
        value: '2',
        label: "进行中"
    },
    {
        value: '3',
        label: "复核中"
    },
    {
        value: '4',
        label: "完成"
    },
    {
        value: '5',
        label: "无证据"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "未开始"
    },
    {
        value: '2',
        label: "进行中"
    },
    {
        value: '3',
        label: "已关闭"
    },
    {
        value: '4',
        label: "未分配"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "控制任务"
    },
    {
        value: '7',
        label: "响应任务"
    },
    {
        value: '13',
        label: "其他标准任务"
    },
    {
        value: '14',
        label: "主要标准任务"
    },
    {
        value: '16',
        label: "其他实质性程序任务"
    },
    {
        value: '17',
        label: "主要实质性程序任务"
    },
    {
        value: '18',
        label: "穿行测试/UDP任务"
    },
    {
        value: '22',
        label: "账户结论任务"
    },
    {
        value: '999',
        label: "必须由PIC签字"
    },
    {
        value: '1000',
        label: "必须项目质量复核人签字"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "控制任务"
    },
    {
        value: '7',
        label: "响应任务"
    },
    {
        value: '13',
        label: "其他标准任务"
    },
    {
        value: '14',
        label: "主要标准任务"
    },
    {
        value: '16',
        label: "其他实质性程序任务"
    },
    {
        value: '17',
        label: "主要实质性程序任务"
    },
    {
        value: '18',
        label: "穿行测试/UDP任务"
    },
    {
        value: '22',
        label: "账户结论任务"
    },
    {
        value: '23',
        label: "集团任务"
    },
    {
        value: '999',
        label: "必须由PIC签字"
    },
    {
        value: '1000',
        label: "必须项目质量复核人签字"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "主要标准任务"
    },
    {
        value: '13',
        label: "其他标准任务"
    },
    {
        value: '23',
        label: "集团任务"
    },
    {
        value: '999',
        label: "必须由PIC签字"
    },
    {
        value: '1000',
        label: "必须项目质量复核人签字"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "范围",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "策略",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "范围和策略质量活动"
    },
    {
        value: '13',
        label: "其他范围和策略"
    },
    {
        value: '14',
        label: "综合风险评估"
    },
    {
        value: '15',
        label: "风险评估和重要性"
    },
    {
        value: '16',
        label: "最终确定范围和策略"
    },
    {
        value: '17',
        label: "预审后项目管理"
    },
    {
        value: '3',
        label: "穿行测试"
    },
    {
        value: '4',
        label: "中期控制测试"
    },
    {
        value: '5',
        label: "中期实质性测试"
    },
    {
        value: '6',
        label: "穿行测试（年末流程）"
    },
    {
        value: '7',
        label: "年末控制测试"
    },
    {
        value: '8',
        label: "年末实质性测试"
    },
    {
        value: '11',
        label: "执行"
    },
    {
        value: '9',
        label: "结论"
    },
    {
        value: '10',
        label: "不适用"
    },
    {
        value: '0',
        label: "无里程碑"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "范围"
    },
    {
        value: '12',
        label: "范围和策略项目管理"
    },
    {
        value: '13',
        label: "其他范围和策略"
    },
    {
        value: '2',
        label: "策略"
    },
    {
        value: '14',
        label: "综合风险评估"
    },
    {
        value: '15',
        label: "风险评估和重要性水平"
    },
    {
        value: '16',
        label: "最终确定范围和策略"
    },
    {
        value: '17',
        label: "预审后项目管理"
    },
    {
        value: '3',
        label: "穿行测试"
    },
    {
        value: '4',
        label: "中期控制测试"
    },
    {
        value: '5',
        label: "中期实质性测试"
    },
    {
        value: '6',
        label: "穿行测试（年末流程）"
    },
    {
        value: '7',
        label: "年末控制测试"
    },
    {
        value: '8',
        label: "年末实质性测试"
    },
    {
        value: '11',
        label: "执行"
    },
    {
        value: '9',
        label: "结论"
    },
    {
        value: '10',
        label: "不适用"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "范围和策略"
    },
    {
        value: '2',
        label: "执行"
    },
    {
        value: '3',
        label: "结论"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "已打开"
    },
    {
        value: 5,
        label: "已清理"
    },
    {
        value: 2,
        label: "已关闭"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "是"
}, {
    value: '0',
    label: "否"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "是"
}, {
    value: '2',
    label: "否"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "是"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "缺陷"
    },
    {
        value: '2',
        label: "错报"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "默认"
    },
    {
        id: 2,
        Name: "低"
    },
    {
        id: 3,
        Name: "中等"
    },
    {
        id: 4,
        Name: "高"
    },
    {
        id: 5,
        Name: "机密"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "审计负责合伙人",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "项目合伙人",
        roleAbbreviation: "项目合伙人",
        displayOrder: 8
    },
    {
        id: 3,
        role: "执行总监",
        roleAbbreviation: "执行总监",
        displayOrder: 5
    },
    {
        id: 4,
        role: "负责人",
        roleAbbreviation: "负责人",
        displayOrder: 6
    },
    {
        id: 5,
        role: "高级审计经理",
        roleAbbreviation: "高级审计经理",
        displayOrder: 4
    },
    {
        id: 6,
        role: "审计经理",
        roleAbbreviation: "审计经理",
        displayOrder: 3
    },
    {
        id: 7,
        role: "高级审计师",
        roleAbbreviation: "高级审计员",
        displayOrder: 2
    },
    {
        id: 8,
        role: "审计员",
        roleAbbreviation: "审计员",
        displayOrder: 1
    },
    {
        id: 9,
        role: "实习生",
        roleAbbreviation: "实习生"
    },
    {
        id: 10,
        role: "项目质量复核人",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "其他合伙人",
        roleAbbreviation: "其他合伙人",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - 审计员",
        roleAbbreviation: "GDS审计员",
        displayOrder: 13
    },
    {
        id: 13,
        role: "咨询(信息技术风险咨询、交易咨询服务、人力资源或其他)",
        roleAbbreviation: "咨询"
    },
    {
        id: 14,
        role: "税务",
        roleAbbreviation: "税务"
    },
    {
        id: 15,
        role: "管理支持服务",
        roleAbbreviation: "管理支持服务"
    },
    {
        id: 16,
        role: "法律顾问",
        roleAbbreviation: "法律顾问办公室",
        displayOrder: 12
    },
    {
        id: 17,
        role: "审计质量复核人",
        roleAbbreviation: "审计质量复核人",
        displayOrder: 11
    },
    {
        id: 18,
        role: "ML组成部分审计小组",
        roleAbbreviation: "ML组成部分审计小组"
    },
    {
        id: 19,
        role: "客户主管",
        roleAbbreviation: "客户主管’"
    },
    {
        id: 20,
        role: "客户助理",
        roleAbbreviation: "客户助理"
    },
    {
        id: 21,
        role: "内部审计主管",
        roleAbbreviation: "内部审计主管"
    },
    {
        id: 22,
        role: "内部审计助理",
        roleAbbreviation: "内部审计员"
    },
    {
        id: 23,
        role: "监管机构",
        roleAbbreviation: "监管机构"
    },
    {
        id: 24,
        role: "其他(例如：尽职调查复核)",
        roleAbbreviation: "其他"
    },
    {
        id: 25,
        role: "办公室",
        roleAbbreviation: "办公室"
    },
    {
        id: 26,
        role: "区域",
        roleAbbreviation: "区域"
    },
    {
        id: 27,
        role: "行业",
        roleAbbreviation: "行业"
    },
    {
        id: 28,
        role: "国家",
        roleAbbreviation: "国家"
    },
    {
        id: 29,
        role: "全球",
        roleAbbreviation: "全球"
    },
    {
        id: 30,
        role: "GDS - 高级审计员",
        roleAbbreviation: "GDS-高级审计员",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - 经理",
        roleAbbreviation: "GDS-经理",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "审计",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "诈骗审查及纠纷协调服务",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "财务会计咨询服务",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "气候变化与可持续发展服务",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "企业税务服务",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "人力资本",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "法律",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "间接税",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "全球合规及报告",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "交易税务",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "国际税务服务",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "总法律顾问办公室",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "业务咨询",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "技术咨询",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "交易和公司金融",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "其他",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "技术风险",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "GDS经理"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "请求经理"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "打开"
    },
    {
        id: 2,
        label: "正在进行"
    },
    {
        id: 3,
        label: "正在复核"
    },
    {
        id: 4,
        label: "完成"
    },
    {
        id: 5,
        label: "已移除"
    },
    {
        id: 6,
        label: "审计负责合伙人/项目质量复核人签字完成"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "未发送"
    },
    {
        id: 2,
        label: "进行中"
    },
    {
        id: 3,
        label: "已发送"
    },
    {
        id: 4,
        label: "已退回"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "打开"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "已收到"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "已提交"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "已退回"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "已编制"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "已复核"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "已驳回"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "退回中"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "退回错误"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "打开"
    },
    {
        id: 2,
        label: "进行中"
    },
    {
        id: 3,
        label: "已关闭"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "打开"
    },
    {
        id: 2,
        label: "进行中"
    },
    {
        id: 3,
        label: "已关闭"
    }
];

export const DocumentHelper = {
    401: "无法完成此操作。刷新页面，然后重试。如问题仍然存在，请联系帮助台。",
    413: "文件大小超过最大限制（250mb），无法上传。请缩小文件大小并重试。",
    412: "文档名称与该项目中已存在的文档名称重合",
    414: "名称超过最大长度（{0}个字符）。",
    410: "此文档已被删除，无法下载。",
    411: "文档不得为空。"
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "全部注释"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "文档注释"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "任务注释"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Canvas表格批注"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "打开"
    },
    {
        value: '2',
        label: "已清除"
    },
    {
        value: '3',
        label: "已关闭"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "文档注释"
    },
    {
        id: 2,
        type: 'task',
        label: "任务注释"
    }
];

export const accountConclusionTabs = {
    details: "详细",
    conclusions: "结论"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "注释状态ID",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "编辑人",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "分配至",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "优先级",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "低"
        }, {
            id: "2",
            label: "中等"
        }, {
            id: "3",
            label: "高"
        }, {
            id: "4",
            label: "重要"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "到期日当天或之前",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "在此日期或之后到期",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "到期"
    },
    {
        id: 'Priority',
        label: "优先级"
    },
    {
        id: 'Status',
        label: "状态"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "一般"
    },
    {
        id: 2,
        value: "低"
    },
    {
        id: 3,
        value: "中等"
    },
    {
        id: 4,
        value: "高"
    },
    {
        id: 5,
        value: "受限制"
    },
    {
        id: 6,
        value: "机密"
    }
];

export const externalUserStatus = {
    active: "活跃",
    inactive: "不活跃"
};

export const engagementStatus = {
    1: "活跃",
    2: "待定",
    3: "已拒绝",
    4: "不活跃的",
    13: "预定的——不活跃的"
};

export const copyRequestStatus = {
    0: "已逾期",
    1: "已就绪",
    2: "已发送",
    3: "已接收",
    4: "导出中",
    5: "导出成功",
    6: "导出错误",
    7: "导入中",
    8: "导入成功",
    9: "导入错误",
    10: "已拒绝",
    11: "复制中",
    13: "草稿",
    14: "发送中",
    15: "交付中",
    16: "交付错误"
}

export const copyObjectGrouptype = {
    21: "项目",
    22: "账户",
    23: "重大交易类别",
    20: "证据",
    24: "自当前执行后推",
    25: "模板",
    26: "批量导出",
    27: "外部文档",
    28: "引导式工作流程",
    29: "按实体划分的项目"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "范围",
    2: "策略",
    3: "穿行测试",
    4: "中期控制测试",
    5: "中期实质性测试",
    6: "穿行测试（年末流程）",
    7: "年末控制测试",
    8: "年末实质性测试",
    9: "结论",
    10: "不适用",
    11: "执行",
    12: "范围和策略质量活动",
    13: "其他范围和策略",
    14: "CRA",
    15: "风险评估和重要性",
    16: "最终确定其他范围和策略",
    17: "中期后项目管理"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "明天"
    },
    {
        value: 3,
        label: "未来3天"
    },
    {
        value: 5,
        label: "未来5天",
        isDefault: true
    },
    {
        value: 10,
        label: "未来10天"
    },
    {
        value: 30,
        label: "未来30天",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "昨天"
    },
    {
        value: 3,
        label: "过去3天"
    },
    {
        value: 5,
        label: "过去5天",
        isDefault: true
    },
    {
        value: 10,
        label: "过去10天",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "编制",
    forMyReview: "复核",
    upcomingReview: "即将进行复核",
    reviewNotesAssigned: "出具给我的附注",
    reviewNotesAuthored: "我出具的附注",
    partnerTasks: "合伙人任务",
    eqrTasks: "项目质量复核任务",
    timephases: "时间段",
    groupTasks: "集团任务",
    groupDeliverables: "集团交付成果",
    automation: "自动化",
    requests: "请求"
};

export const quickLinks = {
    linkAccountSummary: "账户汇总",
    linkScotSummary: "SCOT汇总",
    linkITSummary: "IT汇总",
    linkCRASummary: "CRA汇总",
    linkGAStructureSummary: "集团结构汇总",
    linkGAInstrcutionSummary: "集团指引汇总",
    linkSEM: "实质性评估矩阵",
    linkAuditPlan: "审计计划",
    linkWorkPlan: "工作计划",
    linkITProcessEvaluation: "IT评估",

    linkGeneral: "一般",
    linkScots: "SCOT",
    linkITSO: "IT/SO",
    linkAccounts: "账户",
    linkResponseTask: "回复任务",
    linkWrapupEngagement: "总结项目",
    linkArchive: "归档核对表"
};

export const customKeyEvents = {
    reportDate: "报告日",
    endDatePeriodCovered: "涵盖期间结束日",
    archiveDeadlineDate: "存档截止日"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "打开"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "已清除"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "已关闭"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Canvas表格"
    },
    {
        value: filters.fileExtension.email,
        label: "电子邮件"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "纸质档案"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
		label: "智能自动化"
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "其他"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "追踪修订"
    },
    {
        value: filters.documentContent.comments,
        label: "批注"
    },
    {
        value: filters.documentContent.formulaError,
        label: "公式错误（仅Excel文件）"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "高亮（仅限Word文件）"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "隐藏的工作表"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "嵌入文件"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "受保护"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "文档内容不可用"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "多用户编辑模式下的文档"
    }
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "来源"
    },
    {
        value: filters.sharedEvidence.target,
        label: "目标"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "错报"
    },
    {
        value: filters.findings.deficiency,
        label: "缺陷"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "必须有PIC"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "分配的PIC小组"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "必须有EQR"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "分配的EQR小组"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "特别风险"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "舞弊风险"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "较高固有风险"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "必须由PIC签字"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "必须由EQR签字"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "回复不完整"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "未解决的注释"
    }
];

export const documentChangeTypes = {
    0: "未选择变动原因",
    1: "非行政变动",
    2: "接受使用追踪修订功能进行的修订",
    3: "对已经存在的证据添加额外的交叉索引",
    4: "添加先前通过传真或电子邮件收到的原始函证回复",
    5: "表面修改",
    6: "完成表格AP和重大角色评估",
    7: "删除或丢弃已被取代的文档记录",
    8: "编制管理建议书",
    9: "签发关于归档流程的完成检查清单",
    10: "分类、整理和交叉索引最终文档",
    11: "调整为当地时区后，在报告日或之前进行修改（仅适用于美国）"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "非管理性变更"
    },
    {
        value: 2,
        label: "使用此类功能时接受修订/批注"
    },
    {
        value: 3,
        label: "对已经存在的证据添加额外的交叉索引"
    },
    {
        value: 4,
        label: "添加先前通过传真或电子邮件收到的原始函证回复"
    },
    {
        value: 5,
        label: "表面修改"
    },
    {
        value: 6,
        label: "完成表格AP和重大角色评估"
    },
    {
        value: 7,
        label: "删除或丢弃不继续构成审计证据的文档记录"
    },
    {
        value: 8,
        label: "编制或添加不支持我们意见的文档"
    },
    {
        value: 9,
        label: "签发关于归档流程的完成检查清单"
    },
    {
        value: 10,
        label: "分类、整理和交叉索引最终文档"
    },
    {
        value: 12,
        label: "仅适用于MEST：修改与报告日期晚于EY Canvas中报告日期的实体有关的证据。"
    },
    {
        value: 11,
        label: "调整为当地时区后，在报告日或之前进行修改（仅适用于美国）"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "快速筛选",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "任务状态",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "任务类型",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "被分配人",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "打开任务",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "打开任务",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "复核附注状态",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "复核附注被分配人",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "复核附注创建人",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: " 时间段",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "里程碑",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "审计阶段",
        altName: "项目阶段",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "文件冲突",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "发现",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "实体",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "离线下载",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "建立步骤29？？？"
    },
    {
        id: 2,
        label: "建立步骤30？？？"
    },
    {
        id: 3,
        label: "SEM（评估矩阵）？？？"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "最终确定证据"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "完成剩余任务"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "解决剩余验证"
    },
    {
        id: 7,
        label: "编制归档"
    },
    {
        id: 8,
        label: "项目仪表板"
    },
    {
        id: 9,
        label: "Canvas表格（单独）"
    },
    {
        id: 10,
        label: "Canvas表格（全部）"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "最终确定纸质文档和文件夹"
    },
    {
        id: 13,
        label: "确认关键项目日期的准确性"
    },
    {
        id: 14,
        label: "确认项目代码的准确性"
    },
    {
        id: 15,
        label: "确认客户代码的准确性"
    },
    {
        id: 10,
        label: "从该集团删除该项目的链接"
    },
    {
        id: 16,
        label: "验证报告类型"
    },
    {
        id: 17,
        label: "复核报告发布日期之后修改的临时文件"
    },
    {
        id: 18,
        label: "复核报告发布日期之后修改的删除文件"
    },
    {
        id: 19,
        label: "确保已提交对项目配置文档的更改"
    },
    {
        id: 20,
        label: "复核受保护的文档"
    },
    {
        id: 95,
        label: "指定总体负责人"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "解决剩余的文档冲突"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "多用户编辑中的文档"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "复核受保护的文档"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "文档内容不可用"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "关闭所有未解决的复核附注"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "从证据中移除追踪修订"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "确定智能自动化证据文档"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "完成所有PIC签字要求"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "完成所有EQR签字要求"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "将审计负责合伙人文档关联至审计负责合伙人任务"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "将项目质量复核人文档关联至项目质量复核人任务"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "签署所有的证据"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "解决Canvas表格注释"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "删除共享证据的链接"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "为打开的任务添加证据"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "请确认所有审计负责合伙人任务均包含审计负责合伙人文档"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "请确认所有项目质量复核人任务均包含项目质量复核人文档"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "将证据与实体任务关联"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "标记任务完成"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "账户汇总"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "重大交易类别汇总"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "综合风险评估汇总"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "IT汇总"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "确认审计师报告数据的准确性"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "完成归档表格"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "完成归档任务"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "删除集团共享证据的链接"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "审计计划"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "不相关发现"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "独立性合规"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "最终确定未完成的Canvas表格回复"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "实质性评估矩阵"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "IT评估"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "报告发布日期后修改的文档"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "重命名具有重复文件名的证据文件"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "IT流程"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "调整"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "查看没有内容的Canvas表格"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "负责人"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "复核有编制人和复核人签字的临时文件，确定哪些文件应纳入证据，哪些文件应删除"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "复核有PIC标签的临时文档，确定哪些文档应纳入证据，哪些标签应删除"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "复核有EQR标签的临时文档，确定哪些文档应纳入证据，哪些标签应删除"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "复核有PIC标签的已删除文档，确定哪些文档应纳入证据，哪些标签应删除"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "复核有EQR标签的已删除文档，确定哪些文档应纳入证据，哪些标签应删除"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "与项目中不再可用的对象相关的文档"
    }
];

export const ArchiveErrors = {
    32204: "项目有未添加证据的任务。",
    32209: "项目有回复不完整的Canvas表格。",
    32210: "项目有未开始核注释。",
    32212: "项目有未完成的任务。",

    32402: "归档ID无效或为空。",
    32403: "文件GUID无效或为空。",
    32404: "ARC FileStoreHost无效或为空。",
    32424: "主审项目代码缺失或无效。",
    32425: "报告发布日不能为未来日期。",
    32426: "报告发布日必须在项目结束日之后。",
    32427: "必须邀请合伙人参与项目。",
    32428: "ARC中与工作底稿类型相关的数据缺失。",
    32429: "需要在归档表格上选择报告类型。",
    32430: "需要在归档表格上选择保留意见报告。",
    32431: "由于与ARC整合，在归档过程中发生错误。请联系帮助台以报告此错误。"
};

export const validationTypes = [{
        id: 1,
        label: "未完成的独立性合规",
        altLabel: "Incomplete form",
        errorLabel: "未完成的独立性合规事项"
    },
    {
        id: 2,
        label: "独立性表格版本不是当前的版本",
        altLabel: "Out of date form",
        errorLabel: "独立性表格版本不是最新版本"
    },
    {
        id: 3,
        label: "不合格角色授予的访问权限",
        altLabel: "Not approved by PPEDD",
        errorLabel: "不合格角色授予的访问权限"
    },
    {
        id: 4,
        label: "被不合格角色覆盖",
        altLabel: "Not overridden by PPEDD",
        errorLabel: "不合格角色的越权"
    },
    {
        id: 5,
        label: "不相关重大交易类别（无账户）",
        errorLabel: "非相关重大交易类别"
    },
    {
        id: 6,
        label: "不相关控制（无可能出错项）",
        errorLabel: "非相关控制"
    },
    {
        id: 7,
        label: "未选择相关可能出错项的控制策略",
        errorLabel: "选择的控制策略没有相关可能出错项"
    },
    {
        id: 8,
        label: "未选择相关控制的控制策略",
        errorLabel: "选择的控制策略没有相关控制"
    },
    {
        id: 9,
        label: "选择控制策略，但未选择相关控制进行测试",
        errorLabel: "选择的控制策略没有选择用于测试的相关控制"
    },
    {
        id: 10,
        label: "选择控制策略，并且有一个可能出错项，没有选择相关的控制进行测试",
        errorLabel: "选择的控制策略有可能出错项，没有选择用于测试的相关控制"
    },
    {
        id: 11,
        label: "不相关的风险",
        errorLabel: "非相关的风险"
    },
    {
        id: 12,
        label: "完成该认定的综合风险评估",
        errorLabel: "完成该认定的综合风险评估"
    },
    {
        id: 13,
        label: "不相关的可能出错项",
        errorLabel: "非相关的可能出错项"
    },
    {
        id: 14,
        label: "重大账户没有相关的重大交易类别",
        errorLabel: "重大账户没有相关的重大交易类别"
    },
    {
        id: 15,
        label: "未选择相关可能出错项的依赖策略",
        errorLabel: "选择的依赖策略没有可能出错项"
    },
    {
        id: 16,
        label: "未选择相关控制的依赖策略",
        errorLabel: "选择的依赖策略没有相关控制"
    },
    {
        id: 17,
        label: "选择了依赖策略，但未选择相关控制进行测试",
        errorLabel: "选择的依赖策略没有选择用于测试的相关控制"
    },
    {
        id: 18,
        label: "选择依赖策略，并且有一个可能出错项，没有选择相关的控制进行测试",
        errorLabel: "选择的依赖策略有可能出错项，没有选择用于测试的相关控制"
    },
    {
        id: 19,
        label: "不相关的IT App/SO",
        errorLabel: "非相关的IT应用程序/SO"
    },
    {
        id: 20,
        label: "不相关的控制/IT实质性程序",
        errorLabel: "非相关的控制/IT实质性程序"
    },
    {
        id: 21,
        label: "无相关的IT App/SO",
        errorLabel: "无相关的IT应用程序/SO"
    },
    {
        id: 22,
        label: "无相关的风险",
        errorLabel: "无相关的风险"
    },
    {
        id: 23,
        label: "无相关的控制/IT实质性程序",
        errorLabel: "无相关的控制/IT实质性程序"
    },
    {
        id: 24,
        label: "无相关的控制/选定用于测试的IT实质性程序",
        errorLabel: "无相关的控制/选定用于测试的IT实质性程序"
    },
    {
        id: 25,
        label: "如果没有选择相关的控制/IT实质性程序进行测试，则存在风险",
        errorLabel: "存在没有选择相关控制/选择用于测试的IT实质性程序的风险"
    },
    {
        id: 26,
        label: "有限风险账户没有任何相关的实质性任务",
        errorLabel: "有限风险账户没有任何相关的实质性任务"
    },
    {
        id: 27,
        label: "与认定无关的实质性任务",
        errorLabel: "没有与认定相关的实质性任务"
    },
    {
        id: 28,
        label: "不相关的控制测试（TOC）",
        errorLabel: "非相关控制测试"
    },
    {
        id: 29,
        label: "不相关的穿行测试",
        errorLabel: "非相关穿行测试"
    },
    {
        id: 30,
        label: "没有与重大交易类别相关的穿行测试任务",
        errorLabel: "没有与重大交易类别相关的穿行测试任务"
    },
    {
        id: 31,
        label: "没有与选择用于测试的控制相关的控制任务",
        errorLabel: "没有与选择进行测试的控制相关的控制任务"
    },
    {
        id: 32,
        label: "不相关的IT/SO穿行测试",
        errorLabel: "非相关的IT/SO穿行测试"
    },
    {
        id: 33,
        label: "不相关的IT/SO控制测试（TOC）",
        errorLabel: "非相关的IT/SO控制测试"
    },
    {
        id: 34,
        label: "不相关的IT/SO其他实质性程序（OSP）",
        errorLabel: "非相关的IT/SO其他实质性程序"
    },
    {
        id: 35,
        label: "IT/SO过程无相关穿行测试任务",
        errorLabel: "IT/SO流程无相关穿行测试任务"
    },
    {
        id: 36,
        label: "控制无相关控制测试（TOC）",
        errorLabel: "控制无相关控制测试"
    },
    {
        id: 37,
        label: "IT实质性程序没有相关的其他实质性程序（OSP）",
        errorLabel: "IT实质性程序没有相关的其他实质性程序"
    },
    {
        id: 38,
        label: "文件冲突",
        errorLabel: "未解决冲突"
    },
    {
        id: 39,
        label: "同步冲突-共享证据-未在Canvas显示验证计数",
        errorLabel: "共享证据——同步冲突"
    },
    {
        id: 40,
        label: "证据缺失签署",
        errorLabel: "签署所有证据"
    },
    {
        id: 41,
        label: "无证据的任务",
        errorLabel: "将证据添加至未开始任务中"
    },
    {
        id: 42,
        label: "无效项目代码",
        errorLabel: "无效项目代码"
    },
    {
        id: 43,
        label: "无效客户代码",
        errorLabel: "无效客户代码"
    },
    {
        id: 44,
        label: "重复文件名称",
        errorLabel: "重复文件名称"
    },
    {
        id: 45,
        label: "不一致的IT评估",
        errorLabel: "IT流程评估未完成"
    },
    {
        id: 46,
        label: "IT流程评估未完成",
        errorLabel: "IT流程评估未完成"
    },
    {
        id: 47,
        label: "不完整的汇总IT评估",
        errorLabel: "汇总IT评估未完成"
    },
    {
        id: 48,
        label: "回复不完整",
        errorLabel: "支持性理由未完成"
    },
    {
        id: 49,
        label: "不相关错报",
        errorLabel: "非相关错报"
    },
    {
        id: 50,
        label: "无关联缺陷",
        errorLabel: "无关缺陷"
    },
    {
        id: 51,
        label: "无相关实质性任务的可能出错项",
        errorLabel: "无相关实质性任务的可能出错项"
    },
    {
        id: 52,
        label: "无相关可能出错项的风险",
        errorLabel: "无可能出错项的风险"
    },
    {
        id: 53,
        label: "无估计主要实质性程序索引的估计账户",
        errorLabel: "无估计主要实质性程序索引的估计账户"
    },
    {
        id: 54,
        label: "无估计重大交易类别的估计账户",
        errorLabel: "无估计重大交易类别的估计账户"
    },
    {
        id: 55,
        label: "无估计账户的估计重大交易类别",
        errorLabel: "无估计账户的估计重大交易类别"
    },
    {
        id: 56,
        label: "具有依赖控制风险，但无应对响应性控制测试的认定",
        errorLabel: "认定具有依赖控制风险，但无应对应对性控制测试"
    },
    {
        id: 57,
        label: "具有依赖控制风险的认定，其不具有至少一项关联至有效设计控制的应对性控制测试（其应对的风险不属于较低风险）",
        errorLabel: "认定具有依赖控制风险，该风险为非低风险，但不具有至少一项应对该风险的针对控制设计有效性的应对性控制测试"
    },
    {
        id: 58,
        label: "无响应实质性任务的认定",
        errorLabel: "没有应对性的实质性任务的认定"
    },
    {
        id: 59,
        label: "无响应控制的认定",
        errorLabel: "没有应对性控制的认定"
    },
    {
        id: 60,
        label: "Canvas表格批注",
        errorLabel: "Canvas表格批注"
    },
    {
        id: 61,
        label: "Canvas表格回复未完成",
        errorLabel: "Canvas表格回复未完成"
    },
    {
        id: 62,
        label: "应关闭或删除的未处理或已清除的复核注释",
        errorLabel: "应关闭或删除的未处理或已清除的复核注释"
    },
    {
        id: 63,
        label: "具有追踪修订的证据",
        errorLabel: "具有追踪修订的证据"
    },
    {
        id: 64,
        label: "未标记完成的任务",
        errorLabel: "将任务标记为已完成"
    },
    {
        id: 65,
        label: "不关联的共享证据",
        errorLabel: "删除共享证据的链接"
    },
    {
        id: 66,
        label: "未选择修改类型的文档",
        errorLabel: "文档未选择修改类型"
    },
    {
        id: 67,
        label: "没有变更原因（依据）的非管理性变更",
        errorLabel: "没有变更原因（依据）的非管理性变更"
    },
    {
        id: 68,
        label: "按适当角色对非管理型变更进行未经批准的修改",
        errorLabel: "适当角色对非管理性变更的未经批准的修改"
    },
    {
        id: 69,
        label: "440GL缺少项目组管理层人员复核签字",
        errorLabel: "440 GL缺少管理人员复核签字"
    },
    {
        id: 70,
        label: "尚未取消关联的集团项目",
        errorLabel: "从项目组删除该项目链接"
    },
    {
        id: 71,
        label: "没有任何标题的Canvas表格",
        altLabel: "没有任何标题的Canvas表格",
        errorLabel: "没有任何标题的Canvas表格"
    },
    {
        id: 72,
        label: "小组组成部分汇总文档缺少内容",
        errorLabel: "小组组成部分汇总文档缺少内容"
    },
    {
        id: 73,
        label: "未完成的Canvas表格回复（无论是否批准）",
        errorLabel: "Canvas表格anvas表格未完成"
    },
    {
        id: 74,
        label: "配置文件V2更改未提交",
        errorLabel: "未提交配置文档变更"
    },
    {
        id: 75,
        label: "0字节电子文件",
        errorLabel: "0字节电子文件"
    },
    {
        id: 76,
        label: "独立性表格在提交后发生了编辑",
        altLabel: "表格未提交",
        errorLabel: "独立性表格在提交后发生了编辑"
    },
    {
        id: 77,
        label: "不同人的独立性模板有差异",
        altLabel: "不同人的独立性模板有差异",
        errorLabel: "不同人的独立性模板有差异"
    },
    {
        id: 78,
        label: "没有至少一个相关IT流程的IT应用程序（非SO）",
        errorLabel: "非相关的IT应用程序"
    },
    {
        id: 79,
        label: "IT一般控制有非相关的IT风险，或者与HasNoITGC=1的IT风险相关",
        errorLabel: "非相关的IT一般控制"
    },
    {
        id: 80,
        label: "IT实质性程序没有相关的IT风险",
        errorLabel: "非相关的IT实质性程序"
    },
    {
        id: 81,
        label: "IT流程没有相关的IT应用程序",
        errorLabel: "非相关IT流程"
    },
    {
        id: 82,
        label: "没有IT风险的IT流程，其中有通过IT应用程序相关的ITAC或ITDM（无例外情况）",
        errorLabel: "缺少IT风险"
    },
    {
        id: 83,
        label: "IT风险（没有ITGC=0）没有相关的IT一般控制",
        errorLabel: "缺少ITGC或标记不存在ITGC"
    },
    {
        id: 84,
        label: "无相关IT应用程序的ITDM/ITAC",
        errorLabel: "无IT应用程序的应用程序/ITDM控制"
    },
    {
        id: 85,
        label: "未显示相应正文时未删除ITSP",
        errorLabel: "待删除ITSP"
    },
    {
        id: 86,
        label: "未显示相应正文时未删除ITGC",
        errorLabel: "待删除ITGC"
    },
    {
        id: 87,
        label: "未显示相应正文时未删除IT风险",
        errorLabel: "待删除IT风险"
    },
    {
        id: 88,
        label: "未显示相应正文时存在IT控制测试=1的ITGC",
        errorLabel: "带有无效测试策略的ITGC"
    },
    {
        id: 89,
        label: "没有已选的设计有效性的ITGC",
        errorLabel: "缺少ITGC设计评估"
    },
    {
        id: 90,
        label: "没有已选的设计有效性的控制",
        errorLabel: "没有已选的设计有效性的控制"
    },
    {
        id: 91,
        label: "没有IT应用程序的SCOT，其中HasNoITApplication=0",
        errorLabel: "非相关重大交易类别"
    },
    {
        id: 92,
        label: "对特别风险做出应对，但不对风险的已关联可能出错项作出应对的实质性程序和控制测试",
        errorLabel: "不一致风险任务关系与风险 > 可能出错项 > 任务关系"
    },
    {
        id: 93,
        label: "对测试控制的不一致应对",
        errorLabel: "对测试控制的不一致应对"
    },
    {
        id: 94,
        label: "HasNoITApplication=0的重大交易类别具有ITDM或应用程序控制",
        errorLabel: "重大交易类别中的IT应用程序缺失"
    },
    {
        id: 95,
        label: "未委派任何项目组成员总体负责",
        altLabel: "未委派任何项目组成员总体负责",
        errorLabel: "未委派任何项目组成员总体负责"
    },
    {
        id: 96,
        label: "与风险无关或未标记为非ROMM的风险因素",
        errorLabel: "与风险无关或未标记为非ROMM的风险因素"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "计量基础预测金额未完成",
        errorLabel: "计量基础预测金额未完成"
    },
    {
        id: 99,
        label: "计量基础预测金额依据未完成",
        errorLabel: "计量基础预测金额依据未完成"
    },
    {
        id: 100,
        label: "计量基础调整金额未完成",
        errorLabel: "计量基础调整金额未完成"
    },
    {
        id: 101,
        label: "计划重要性水平未完成",
        errorLabel: "计划重要性水平未完成"
    },
    {
        id: 102,
        label: "计划重要性水平（PM）大于最大值",
        errorLabel: "计划重要性水平（PM）大于最大值"
    },
    {
        id: 103,
        label: "计划重要性水平依据未完成",
        errorLabel: "计划重要性水平依据未完成"
    },
    {
        id: 104,
        label: "可容忍误差未完成",
        errorLabel: "可容忍误差未完成"
    },
    {
        id: 105,
        label: "可容忍误差不在允许值范围之内",
        errorLabel: "可容忍误差不在允许值范围之内"
    },
    {
        id: 106,
        label: "可容忍误差依据未完成",
        errorLabel: "可容忍误差依据未完成"
    },
    {
        id: 107,
        label: "SAD未完成",
        errorLabel: "SAD未完成"
    },
    {
        id: 108,
        label: "SAD大于最大值",
        errorLabel: "SAD大于最大值"
    },
    {
        id: 109,
        label: "SAD依据未完成",
        errorLabel: "SAD依据未完成"
    },
    {
        id: 110,
        label: "PACE选择未完成",
        errorLabel: "PACE选择未完成"
    },
    {
        id: 111,
        label: "无相关文档",
        errorLabel: "无相关文档"
    },
    {
        id: 112,
        label: "PIC任务没有至少一个相关PIC证据",
        errorLabel: "PIC任务没有至少一个相关PIC证据"
    },
    {
        id: 113,
        label: "EQR任务没有至少一个相关EQR证据",
        errorLabel: "EQR任务没有至少一个相关EQR证据"
    },
    {
        id: 114,
        label: "PIC证据没有至少一个相关PIC任务",
        errorLabel: "PIC证据没有至少一个相关PIC任务"
    },
    {
        id: 115,
        label: "EQR证据没有至少一个相关EQR任务",
        errorLabel: "EQR证据没有至少一个相关EQR任务"
    },
    {
        id: 116,
        label: "PIC证据没有至少一个PIC签字",
        errorLabel: "PIC证据没有至少一个PIC签字"
    },
    {
        id: 117,
        label: "EQR证据没有至少一个EQR签字",
        errorLabel: "EQR证据没有至少一个EQR签字"
    },
    {
        id: 118,
        label: "仍存在未归档的证据",
        errorLabel: "仍存在未归档的证据"
    },
    {
        id: 119,
        label: "具有编制人和复核人签字的临时文件",
        errorLabel: "具有编制人和复核人签字的临时文件"
    },
    {
        id: 120,
        label: "所有未开始或已清除的Canvas表格批注",
        errorLabel: "所有未开始或已清除的Canvas表格批注"
    },
    {
        id: 121,
        label: "具有PIC要求的临时文件",
        errorLabel: "具有PIC要求的临时文件"
    },
    {
        id: 122,
        label: "具有EQR要求的临时文件",
        errorLabel: "具有EQR要求的临时文件"
    },
    {
        id: 123,
        label: "具有PIC要求的已删除文件",
        errorLabel: "具有PIC要求的已删除文件"
    },
    {
        id: 124,
        label: "具有EQR要求的已删除文件",
        errorLabel: "具有EQR要求的已删除文件"
    },
    {
        id: 125,
        label: "复核受保护的文档",
        errorLabel: "复核受保护的文档"
    },
    {
        id: 126,
        label: "文件内容不可用",
        errorLabel: "文件内容不可用"
    },
    {
        id: 127,
        label: "利润表没有数据",
        errorLabel: "利润表没有数据"
    },
    {
        id: 128,
        label: "资产负债表没有数据",
        errorLabel: "资产负债表没有数据"
    },
    {
        id: 129,
        label: "多实体——未关联至相关账户所有主要实质性程序/审计结论模板的多实体",
        errorLabel: "多实体——未关联至相关账户所有主要实质性程序/审计结论模板的多实体"
    },
    {
        id: 130,
        label: "无单个风险评估表格的账户表格",
        errorLabel: "无单个风险评估表格的账户表格"
    },
    {
        id: 131,
        label: "无估计文档记录的估计",
        errorLabel: "无估计文档记录的估计"
    },
    {
        id: 132,
        label: "无单个分析工具表格的账户",
        errorLabel: "无单个分析工具表格的账户"
    },
    {
        id: 133,
        label: "无单个配置文档表格的多实体",
        errorLabel: "无单个配置文档表格的多实体"
    },
    {
        id: 134,
        label: "账户——账户类型ID与操作不匹配",
        errorLabel: "账户——账户类型ID与操作不匹配"
    },
    {
        id: 135,
        label: "账户——存在估计与操作不匹配",
        errorLabel: "账户——存在估计与操作不匹配"
    },
    {
        id: 136,
        label: "账户——账户表格选择有相关风险未关联至账户",
        errorLabel: "账户——账户表格选择有相关风险未关联至账户"
    },
    {
        id: 137,
        label: "账户——较高固有风险认定无较高风险",
        errorLabel: "账户——较高固有风险认定无较高风险"
    },
    {
        id: 138,
        label: "多实体——多实体无相关账户的任何相关实质性程序",
        errorLabel: "多实体——多实体无相关账户的任何相关实质性程序"
    },
    {
        id: 139,
        label: "无集团参与表格的组成部分（仅供参考的组成部分除外）",
        errorLabel: "无集团参与表格的组成部分（仅供参考的组成部分除外）"
    },
    {
        id: 140,
        label: "无相关集团风险评估指引的（全面范围/特定范围）组成部分（仅供参考的组成部分除外）",
        errorLabel: "无相关集团风险评估指引的（全面范围/特定范围）组成部分（仅供参考的组成部分除外）"
    },
    {
        id: 141,
        label: "多实体——账户无任何相关多实体",
        errorLabel: "多实体——账户无任何相关多实体"
    },
    {
        id: 142,
        label: "无效对象关联文档.智能证据来源ID",
        errorLabel: "无效对象关联文档.智能证据来源ID"
    },
    {
        id: 143,
        label: "账户——较高固有风险认定无较高风险",
        errorLabel: "账户——较高固有风险认定无较高风险"
    },
    {
        id: 144,
        label: "集团——账户（已在其他项目中执行）无相关组成部分",
        errorLabel: "集团——账户（已在其他项目中执行）无相关组成部分"
    },
    {
        id: 145,
        label: "账户——估计账户无估计主要实质性程序索引",
        errorLabel: "账户——估计账户无估计主要实质性程序索引"
    },
    {
        id: 146,
        label: "多实体——多实体单个配置文件变更未提交（单个文档）",
        errorLabel: "多实体——多实体单个配置文件变更未提交（单个文档）"
    },
    {
        id: 147,
        label: "多实体——多实体单个配置文件变更未提交（单个文档）",
        errorLabel: "多实体——多实体单个配置文件变更未提交（单个文档）"
    },
    {
        id: 148,
        label: "账户——账户属性不完整或无效",
        errorLabel: "账户——账户属性不完整或无效"
    },
    {
        id: 149,
        label: "文件上传-缺少所需的PIC/EQR签字",
        errorLabel: "文件上传-缺少所需的PIC/EQR签字"
    },
    {
        id: 150,
        label: "文件上传-缺少所需的PIC/EQR签署要求",
        errorLabel: "文件上传-缺少所需的PIC/EQR签署要求"
    },
    {
        id: 151,
        label: "账户——无任何相关认定的重大账户/披露",
        errorLabel: "账户——无任何相关认定的重大账户/披露"
    },
    {
        id: 152,
        label: "文档上传-缺少编制人或复核人签名",
        errorLabel: "文档上传-缺少编制人或复核人签名"
    },
    {
        id: 153,
        label: "无证据调整",
        errorLabel: "无证据调整"
    },
    {
        id: 154,
        label: "无相关账户的估计",
        errorLabel: "无相关账户的估计"
    },
    {
        id: 155,
        label: "与非估计账户相关的较高/较低风险估计",
        errorLabel: "与非估计账户相关的较高/较低风险估计"
    },
    {
        id: 156,
        label: "回复的估计类别与“编辑估计”中的指定不一致",
        errorLabel: "回复的估计类别与“编辑估计”中的指定不一致"
    },
    {
        id: 157,
        label: "没有有效重大交易类别的估计",
        errorLabel: "没有有效重大交易类别的估计"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "无较高或较低风险估计的估计账户",
        errorLabel: "无较高或较低风险估计的估计账户"
    },
    {
        id: 160,
        label: "没有较高或较低风险估计的估计重大交易类别",
        errorLabel: "没有较高或较低风险估计的估计重大交易类别"
    },
    {
        id: 161,
        label: "非净额调整",
        errorLabel: "非净额调整"
    },
    {
        id: 162,
        label: "无有效相关风险的较高风险估计",
        errorLabel: "无有效相关风险的较高风险估计"
    },
    {
        id: 163,
        label: "文档 - 已签出或正在签出文档以进行协作",
        errorLabel: "文档 - 已签出或正在签出文档以进行协作"
    },
    {
        id: 164,
        label: "缺乏证据的非项目任务",
        errorLabel: "缺乏证据的非项目任务"
    },
    {
        id: 165,
        label: "EP或EQR签署要求与回复不匹配",
        errorLabel: "EP或EQR签署要求与回复不匹配"
    },
    {
        id: 166,
        label: "与非较高风险的估计相关的重大/舞弊风险",
        errorLabel: "与非较高风险的估计相关的重大/舞弊风险"
    }
];

export const contentType = {
    1: "主要标准任务（PST）",
    2: "主要实质性程序索引（PSP索引）",
    3: "主要实质性程序（PSP）",
    4: "集团审计指引",
    5: "审计方法论所需的Cnavas表格",
    6: "由用户创建的Canvas表格（示例：重大交易类别表格）",
    7: "独立性",
    9: "配置文件",
    10: "Canvas映射"
};

export const contentTypeByName = {
    'PST': "主要标准任务（PST）",
    'PSPIndex': "主要实质性程序索引（PSP索引）",
    'PSP': "主要实质性程序（PSP）",
    'GAInstructions': "集团审计指引",
    'CanvasFormKnowledge': "知识库中Canvas表格",
    'CanvasFormUserAdded': "用户创建的Canvas表格（示例：重大交易类别表格）",
    'IndependenceForm': "独立性",
    'Profile': "配置文件",
    'Maps': "Canvas映射"
};

export const reportTypes = {
    1: "无保留——有强调事项",
    2: "无保留——无强调事项",
    3: "保留——无强调事项",
    4: "保留——无强调事项",
    5: "否定意见——有强调事项",
    6: "否定意见——无强调事项",
    7: "无法表示意见——有强调事项",
    8: "无法表示意见——无强调事项",
    100: "否",
    101: "不适用",
    102: "尚未选定"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "归档项目",
        displayName: "归档项目",
        roleDisplayOrder: 2,
        tooltipText: "能够归档项目"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "管理项目",
        displayName: "管理项目",
        roleDisplayOrder: 1,
        tooltipText: "能够邀请内部和外部成员并为内部成员分配权限"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "更新内容",
        displayName: "更新内容",
        roleDisplayOrder: 6,
        tooltipText: "能够编辑个人资料并接受更新内容"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "创建服务请求",
        displayName: "管理服务请求",
        roleDisplayOrder: 4,
        tooltipText: "创建服务请求并将服务请求标记为已完成的权限"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "管理集团",
        displayName: "管理集团",
        roleDisplayOrder: 5,
        tooltipText: "接受或拒绝主审小组或地区小组的集团指引"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "复制、后推并恢复项目",
        displayName: "复制、后推并恢复项目",
        roleDisplayOrder: 3,
        tooltipText: "能够复制项目、后推和恢复其存档",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "机密性",
        roleNameUI: "默认",
        displayName: "无（默认）",
        roleDisplayOrder: 1,
        tooltipText: "默认机密性文档角色"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "机密性",
        roleNameUI: "低",
        displayName: "低",
        roleDisplayOrder: 8,
        tooltipText: "低机密性文档角色"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "机密性",
        roleNameUI: "高",
        displayName: "高",
        roleDisplayOrder: 10,
        tooltipText: "高机密性文档角色"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "机密性",
        roleNameUI: "中等",
        displayName: "中等",
        roleDisplayOrder: 9,
        tooltipText: "中等机密性文档角色"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "机密性",
    // roleNameUI: "机密",
    // displayName: "机密",
    // roleDisplayOrder: 11,
    // tooltipText: "绝密文档角色"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "限制",
        roleNameUI: "只读",
        displayName: "只读",
        roleDisplayOrder: 12,
        tooltipText: "此功能应仅用于向第三方复核人授予本EY Canvas项目的权限。应从专业业务部获得适当的批准和授权。"
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "限制",
        roleNameUI: "只复核",
        displayName: "只复核",
        roleDisplayOrder: 13,
        tooltipText: "复核仅允许该用户查看EY Canvas项目中的信息、进行签名和使用复核注释功能。当其他安永用户需要查看此项目但不进行编辑时，应使用此权限。"
    },
  {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "限制",
        roleNameUI: "仅独立性",
        displayName: "仅独立性",
        roleDisplayOrder: 14,
        tooltipText: "仅独立性选项为用户提供了可以完成项目独立性表格，但无法完全访问EY Canvas项目的权限。当用户为项目执行了工作但不需要拥有对EY Canvas的访问权限时，可以使用此选项。",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "撤销编辑",
        displayName: "恢复/批量删除文档",
        roleDisplayOrder: 7,
        tooltipText: "如果在报告发布日之后不小心更改了文档，能够撤回更改并将文档从440 Canvas表格中删除"
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "管理EY Canvas FIT促进工具的共享",
        displayName: "管理员工作流指导",
        roleDisplayOrder: 14,
        tooltipText: "能够在EY Canvas项目之间共享工作流指导"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "权限",
        roleNameUI: "导入EY Helix数据",
        displayName: "导入EY Helix数据",
        roleDisplayOrder: 15,
        tooltipText: "能够导入EY Helix数据"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "独立性合规"
    },
    {
        id: 9001,
        label: "账户汇总"
    },
    {
        id: 9002,
        label: "SCOT汇总"
    },
    {
        id: 9004,
        label: "IT汇总"
    },
    {
        id: 9003,
        label: "CRA汇总"
    },
    {
        id: 9005,
        label: "审计计划"
    },
    {
        id: 9011,
        label: "实质性评估矩阵"
    },
    {
        id: 9012,
        label: "Canvas表格的验证"
    },
    {
        id: 9009,
        label: "IT评估"
    },
    {
        id: 49,
        label: "不相关错报"
    },
    {
        id: 50,
        label: "不相关缺陷"
    },
    {
        id: 44,
        label: "重复文件名称"
    },
    {
        id: 38,
        label: "未解决的冲突"
    },
    {
        id: 9013,
        label: "报告发布日之后的修改"
    },
    {
        id: 9014,
        label: "IT流"
    },
    {
        id: 9015,
        label: "EY Canvas FIT促进工具"
    },
    {
        id: 71,
        label: "没有内容的表格"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    }
];

export const engagementIndustry = {
    116: "非特定行业",
    61: "航空航天和国防——航空航天制造",
    112: "航空航天和国防——国防合同制造",
    59: "航空公司——航空运输",
    92: "资产管理——期货基金",
    57: "资产管理——其他基金",
    43: "资产管理——私募股权/风险资本",
    85: "资产管理——注册/上市基金",
    53: "资产管理——结构性金融产品",
    60: "资产管理——非监管性对冲基金",
    10: "资产管理——非监管独立账户",
    90: "合规管理系统审计",
    51: "汽车——汽车经销商和维修",
    101: "汽车——汽车制造",
    5: "汽车——汽车供应商",
    71: "银行与资本市场——银行",
    89: "银行与资本市场——经纪人",
    27: "银行与资本市场——信贷联盟",
    54: "银行和资本市场——多种投资和其他金融机构",
    32: "银行与资本市场——投资银行业务",
    4: "生物技术——生物技术——新兴成长型市场",
    109: "生物技术——健康研究与测试",
    66: "化学品——化工制造",
    41: "清洁技术",
    37: "合并",
    130: "建筑——工程与建筑服务",
    68: "建筑——公路和重型建筑",
    65: "建筑——专业承包商",
    82: "消费品-非耐用消费品制造业",
    17: "消费品——食品和饮料制造业",
    35: "消费品——粮食作物、畜牧业、渔业",
    33: "消费品——家用电器和电子制造",
    75: "消费品——其他消费耐用品制造",
    39: "消费品——纺织和服装制造",
    21: "各种工业产品——金属制品",
    31: "各种工业产品——林业、纸浆和造纸",
    29: "各种工业产品——工业仪器制造",
    40: "各种工业产品——工业机械制造",
    26: "各种工业产品——工业包装",
    42: "各种工业产品——木材和木材制造",
    105: "各种工业产品——其他工业产品",
    100: "各种工业产品——原生金属",
    45: "各种工业产品——印刷",
    1: "各种工业产品——橡胶和塑料制造",
    118: "各种工业产品——石材、粘土和玻璃制造",
    76: "通用",
    79: "政府和公共部门——教育",
    78: "政府和公共部门——联邦、国家和国际政府",
    131: "政府和公共部门——卫生专员",
    132: "政府和公共部门——卫生提供者",
    97: "政府和公共部门——地方政府，包括州或国家以下的其他级别",
    2: "健康——学术医疗中心",
    72: "健康——政府医院",
    74: "健康——管理医疗",
    8: "健康——多医院系统",
    128: "健康——非系统医院",
    94: "健康——其他医疗保健实体",
    73: "健康——内科医院组",
    121: "健康——急性后护理",
    58: "健康——专科医院",
    16: "娱乐与休闲——博彩与赌博",
    7: "娱乐和休闲——酒店、汽车旅馆和住宿",
    126: "娱乐——餐馆/饮食场所",
    84: "国际财务报告准则",
    55: "保险——医疗保险",
    111: "保险——保险代理人和经纪人",
    69: "保险——人寿保险公司",
    96: "保险——其他保险",
    11: "保险——财产和伤亡保险公司",
    117: "保险——再保险公司",
    23: "生命科学——医疗技术",
    48: "媒体和娱乐——广告",
    14: "媒体和娱乐——广播、有线网络、在线视频",
    18: "媒体和娱乐_有线电视提供商、卫星、MVPD",
    86: "媒体和娱乐——电影",
    46: "媒体和娱乐——综合媒体和娱乐",
    15: "媒体和娱乐——音乐产业",
    25: "媒体和娱乐——其他媒体和娱乐",
    20: "媒体和娱乐——出版",
    30: "媒体和娱乐——体育",
    28: "采矿——采矿业务",
    3: "非复杂中小企业",
    120: "非营利组织——基金会和慈善信托",
    107: "非营利组织——其他非营利组织",
    70: "石油和天然气——能源交易",
    22: "石油和天然气——勘探与生产",
    67: "石油和天然气——炼油",
    113: "其他运输——城镇和市区运输",
    38: "其他运输——其他运输",
    83: "其他运输——铁路运输",
    88: "其他运输——公路运输和仓储",
    6: "其他运输——水路运输",
    87: "养老基金/福利计划",
    95: "制药——医疗器械制造",
    123: "制药——制药生产和批发",
    115: "电力和公用事业——电力",
    119: "电力和公用事业——天然气",
    110: "电力和公用事业——其他公用事业",
    102: "电力和公用事业——废物和水",
    125: "专业公司和服务——商业服务",
    34: "专业公司和服务——其他服务",
    47: "专业公司和服务——个人服务",
    124: "专业公司和服务——专业服务公司",
    127: "专业公司和服务——租赁服务",
    108: "专业公司和服务——旅游服务",
    49: "房地产——商业房地产业主/开发商",
    56: "房地产——其他房地产业主/开发商",
    62: "房地产——房地产投资信托",
    122: "房地产——房地产投资者",
    12: "房地产——房地产服务公司",
    91: "房地产——住宅房地产业主/开发商",
    24: "零售和批发——百货商店",
    93: "零售和批发——互联网零售和邮购",
    80: "零售和批发——超级市场/折扣商店",
    9: "零售和批发——其他专业零售商",
    77: "零售和批发——零售服装和配件店",
    114: "零售和批发——超市、杂货店和便利店",
    36: "零售和批发——耐用品批发",
    64: "零售和批发——非耐用品批发",
    104: "可持续发展",
    63: "技术——通信和网络设备",
    52: "技术——计算机和电子产品",
    138: "技术——互联网和社交商务",
    103: "技术——IT服务",
    19: "技术——其他技术",
    98: "技术——半导体",
    13: "技术——软件/ SaaS /应用",
    81: "电信——有线通信服务",
    106: "电信——综合通信提供商",
    129: "电信——互联网服务提供商",
    99: "电信——移动无线通信服务",
    50: "电信——其他通信",
    44: "电信——卫星通信服务"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "显示全部"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "分配到我"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "由我编辑"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "草稿"
    },
    {
        id: 2,
        label: "无客户联络"
    },
    {
        id: 3,
        label: "已发送"
    },
    {
        id: 4,
        label: "系统错误"
    },
    {
        id: 5,
        label: "无效客户联络"
    },
    {
        id: 6,
        label: "待回应"
    },
    {
        id: 7,
        label: "已接收"
    },
    {
        id: 8,
        label: "已接受"
    },
    {
        id: 9,
        label: "已退回"
    },
    {
        id: 10,
        label: "已撤销"
    },
    {
        id: 11,
        label: "发送中"
    },
    {
        id: 12,
        label: "接受中"
    },
    {
        id: 13,
        label: "撤销中"
    },
    {
        id: 14,
        label: "删除中"
    },
    {
        id: 15,
        label: "退回中"
    },
    {
        id: 16,
        label: "响应中"
    },
    {
        id: 17,
        label: "已删除"
    },
    {
        id: 18,
        label: "已退回无效客户联络"
    },
    {
        id: 19,
        label: "召回中"
    },
    {
        id: 20,
        label: "已召回"
    },
    {
        id: 21,
        label: "完成中"
    },
    {
        id: 22,
        label: "召回中"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "Group instructions sent by the primary team"
    },
    {
        id: 37,
        label: "Documents returned from the primary team"
    }
];

export const engagementUserStatus = {
    1: "活跃",
    2: "待定",
    3: "已拒绝",
    4: "停用",
    5: "存档访问请求",
    6: "拒绝存档访问",
    7: "复制项目——不活跃",
    8: "未关联——不活跃",
    9: "模板——不活跃",
    10: "后推——不活跃",
    11: "从本地化至单独的全球化",
    12: "邀请中",
    13: "已预订——不活跃"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "未发送"
    },
    {
        id: 2,
        label: "传送中文档"
    },
    {
        id: 3,
        label: "已发送草稿版"
    },
    {
        id: 4,
        label: "已退回"
    },
    {
        id: 5,
        label: "复核中"
    },
    {
        id: 6,
        label: "完成"
    },
    {
        id: 7,
        label: "已驳回"
    },
    {
        id: 8,
        label: "拒绝中"
    },
    {
        id: 9,
        label: "已发送终稿版"
    },
    {
        id: 999,
        label: "发送失败"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "已接受"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "已发送"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "已取消"
    },
    {
        id: 14,
        statusLabel: "草稿"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "已完成"
    },
    {
        id: 16,
        statusLabel: "之前期间已完成"
    },
    {
        id: 17,
        statusLabel: "提交错误"
    },
    {
        id: 22,
        statusLabel: "不适用"
    },
    {
        id: 24,
        statusLabel: "需要采取的行动"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "工作分配"
    },
    {
        id: bulkAssignment.timephase,
        label: "时间段"
    },
    {
        id: bulkAssignment.tag,
        label: "标签"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "工作分配"
    },
    {
        id: bulkAssignment.timephase,
        label: "时间段"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "编制人"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "详细复核人"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "一般复核人"
    },
    {
        id: assignmentTypes.partner,
        label: "合伙人"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "其他"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "添加"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "删除"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "替换"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "更新到期日"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "添加"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "删除"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "编辑"
    },
    {
        id: actionTypes.delete,
        label: "删除"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "默认",
    [confidentialityTypes.LOW]: "低",
    [confidentialityTypes.MODERATE]: "中等",
    [confidentialityTypes.HIGH]: "高"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "账户流任务"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "重大交易类别流任务"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "IT/SO流任务"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "综合风险评估流任务"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "审计计划流任务"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "集团结构流任务"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "集团指引流任务"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "复核流任务"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "范围",
    teamName: "项目组名称",
    groupStructure: "集团结构",
    region: "地区",
    component: "组成部分"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "自定义"
    },
    {
        value: '2',
        label: "知识库"
    },
    {
        value: '3',
        label: "独立性"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "创建独立性表格"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "移除项目组成员"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "移除覆盖"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "注释记录",
    singleNoteInstructionalText: "在下方查看选定批注并回复。",
    emptyNoteDetailsMessage: "选择一项注释查看详细信息。如想批量处理，按住control键或shift键，然后选择多个复核批注。如想单独处理一项批注，则在列表上选中该批注。",
    documentReviewNotesLabel: "文档注释",
    addNewReviewNoteButtonText: "新注释",
    noNotesAssociatedWithDocumentLabel: "使用以下输入信息添加注释。将注释分配至用户并指定优先级和到期日。",
    noNotesFound: "未发现注释",
    noNotesAssociatedWithTaskLabel: "无与此任务相关的{0}注释。",
    allNotesLabel: "所有注释",
    charactersLabel: "字符",
    myNotesLabel: "我的注释",
    showClearedLabel: "显示已清除注释",
    showClosedLabel: "显示已关闭注释",
    assignedToLabel: "分配至",

    ofLabel: "的",
    enterNoteText: "输入注释",
    addNewNoteModalClose: "关闭",
    addNewNoteModalTitleLabel: "添加新注释",
    editNoteModalTitleLabel: "编辑注释",
    deleteIconHoverText: "删除",
    deleteIconModalAcceptText: "删除",
    deleteIconModalConfirmMessage: "是否确定删除对此批注的回复？",
    deleteIconModalConfirmMessageParent: "是否确定删除选定批注?",
    deleteIconModalTitleLabel: "删除注释",
    deleteReplyIconModalTitle: "删除回复",
    emptyRepliesMessage: "没有回复",
    replyInputPlaceholder: "回复此注释",
    replyInputPlaceholderEdit: "编辑对复核注释的回复",
    noteInputPlaceholderEdit: "编辑复核注释",
    replyText: "回复文本",
    editReplyModelTitle: "编辑回复",
    editReplyPlaceholder: "输入回复",
    noteDueDateLabel: "到期",

    priorityLabel: "优先级",
    dueDateLabel: "到期日",
    dueLabel: "到期",
    status: "状态",
    noteModifiedDateLabel: "已修改",
    cancelLabel: "取消",
    saveLabel: "保存",
    clearedBy: "被xxx清除",
    closedBy: "被xxx关闭",
    reopenedBy: "被xxx重新打开",
    reply: "回复",
    editIconHoverTextLabel: "编辑",
    required: "必填",
    closeTitle: "关闭",
    otherEngagementNotes: "其他项目注释",
    closeLabel: "关闭",
    showMore: "显示更多",
    showLess: "显示更少",
    showMoreEllipsis: "显示更多……",
    showLessEllipsis: "显示更少……",
    noResultFound: "未找到结果",
    engagementNameLabel: "项目名称：",
    taskReviewNotesLabel: "任务注释",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "数据包类型",
    categories: "类别",
    itemsToCopy: "待复制项",
    createPackage: "创建数据包",
    selectPackageType: "选择数据包类型",
    selectPackageTypeTitle: "选择数据包类型",
    selectCategoriesTitle: "选择类别",
    selectEntitiesTitle: "选择实体",
    relateCanvasFormsTitle: "关联文档",
    relateAnObjectTitle: "关联一个对象",
    step1InstructionalText: "选择数据包类型并命名，选择接收人。创建或发送数据包副本前，请确保符合与数据隐私、管辖区之间的数据传输以及机密性信息保护相关的所有适用法律、法规和安永政策。",
    packageTypes: [{
        value: 21,
        text: "项目"
    }, {
        value: 20,
        text: "证据"
    }, {
        value: 24,
        text: "自当前执行后推"
    }, {
        value: 22,
        text: "账户"
    }, {
        value: 23,
        text: "重大交易类别"
    }, {
        value: 26,
        text: "批量导出"
    }, {
        value: 25,
        text: "模板"
    }, {
        value: 27,
        text: "外部文档"
    }, {
        value: 28,
        text: "引导式工作流"
    }, {
        value: 29,
        text: "按实体划分的项目"
    }],

    packageName: "数据包名称",
    packageDetailsText: "合并报告资料详细信息",
    required: "必填",
    sendTo: "发送至",
    nameOrEmail: "姓名或邮箱",
    sendToName: "姓名",
    sendToEmail: "邮箱",
    clearAllValues: "清除所有值",
    engagementIdErrorMessage: "未指定项目ID",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "创建数据包副本权限不足。请与你的项目管理员联系，并请求权限以创建数据包副本。",
    CopyHubCanvasFormTooltip: "仅适用于EY Canvas表格",
    CopyEngagementInProgress: "一次只能处理一个项目副本。",

    //Step 3 labels
    step3Header: "选择复制{0}",
    selectAllText: "选择全部",
    delectAllText: "取消选择全部",
    documentsSelectedText: "已选定的文档",
    scotsSelectedText: "已选择的重大交易类别",
    accountsSelectedText: "已选择账户",
    entitiesSelectedText: "选定的实体",
    step3InstructionText: "创建或发送数据包前，请确保符合与数据隐私、管辖区之间的数据传输以及机密性信息保护相关的所有适用法律、法规和安永政策。",
    step3InstructionTextEvidence: "发送项目数据前，请确保符合与数据隐私、管辖区之间的数据传输以及机密性信息保护相关的所有适用法律、法规和安永政策。",
    step3InstructionTextWarning: "EY Canvas表格不包括关联对象（例如，重大交易类别、控制）。",
    step3InstructionTextWarningFIT: "引导式工作流程副本可以包括已识别的相关事件和情况及其相关描述。此副本不包括其他相关对象（例如账户、风险）。",
    availableCanvasFormsColumnName: "可用文档",
    availableFITDocuments: "可用的引导式工作流",
    availableAccountsColumnName: "可用账户",
    availableSCOTsColumnName: "可用重大交易类别",
    availableExternalDocumentsColumnName: "可用的外部文档",
    step3NoItemeSelectedError: "至少选择一个项目以继续",
    searchPackagePlaceholder: "搜索",
    searchPackageClearHoverText: "清空",

    //step2:
    step2Header: "选择{0}数据包类别",
    step2AccountsHdr: "选择纳入数据包副本的类别。核心数据包包括所有相关认定、主要实质性程序和其他实质性程序。",
    step2scotshdr: "选择纳入数据包副本的类别。核心数据包包括所有相关可能出错项、控制和任务",
    step2canformhdr: "选择纳入数据包副本的类别",
    step2InstructionTextEngagementByEntity: "选择要包括在合并报告资料副本中的实体",
    availableEntitiesColumnName: "可用实体",
    step2HeaderEntities: "为项目合并报告资料选择 {0}",
    entitiesLabel: "实体",

    scots: "重大交易类别",
    itso: "IT应用程序/SO结构",
    evidence: "证据",
    realtedevidence: "已关联证据",
    signoffs: "签署",
    tempfiles: "临时文件",
    priorperiodevidence: "上期证据",
    recentlydeletedfiles: "最近删除文件",
    historyfiles: "历史文件",
    extgrp: "外部工作组和外部项目组成员",
    eydocument: "安永文档",
    extdoc: "外部文档",
    totalfilesize: "所有选择项目的总文件大小为",
    requestandexernaltasks: "请求和外部任务",
    rollForwardFromExisting: "自当前执行后推",
    template: "模板",
    bulkExport: "批量输出",

    fileSizeWaring: "选择的类别包括{0}文档。EY Canvas不支持超过此限制的数据包副本。",
    fileSizeWarningline2: "考虑删除文档类别，降低数据包副本文件总体大小。",
    coloredExceedLable: "超过{0}GB",
    step2EngHdr: "选择要纳入复制包中的类别。复制包基本包括项目配置文件、所有知识文档、主要标准任务、其他标准任务、时间阶段；账户/披露、认定及其相关任务；重大交易类别、可能出错项、控制及其相关任务；IT应用程序/服务机构、风险、IT一般控制/IT实质性程序和相关任务。如果是集团审计业务，复制包资料还将包括集团审计数据。",
    step2EngByEntityHdr: "选择要包括在合并报告资料副本中的类别。基本合并报告资料包括项目概况、所有知识文档、主要标准任务、其他标准任务、时间阶段；账户/披露、认定及其相关任务；重大交易类别、可能出错项、控制及其相关任务；IT应用程序/服务机构、风险、ITGC/ITSP和相关任务；匹配。如果是集团审计项目，合并报告资料还将包括集团审计数据。",
    step2BulkExpHdr: "选择要导出的文档类别。",
    gb: "GB",
    step2And: "和",
    step2Files: "文档",
    lessThanMinGB: "小于0.01 GB",
    CategoryFileSizeCount: " 大小为{0}GB，{0}份文档。",

    cancelLabel: "取消",
    showSelected: "显示已选择项目",
    showSelectedDocuments: "显示{0}个选定文档",
    showSelectedEntities: "显示{0}个选定实体",
    showSelectedGuidedWorflows: "显示{0}个选定的工作流指导",
    showSelectedAccounts: "显示{0}个选定账户",
    showSelectedSCOTs: "显示{0}个选定重大交易类别",
    noDataFoundLabel: "未找到数据",
    copyPackageSuccessMessage: "已发起{0}数据导出。",
    copyPackageWarningLabel: "警告：因信息无效，数据包不能发送至以下成员:- {0}",
    noResultFound: "未找到结果",
    canvasForms: "EY Canvas表格",
    canvasFormsInformationText: "Canvas表格只能作为证据和/或临时文件导出。<br/>请选择其中一个选项，以下载Canvas表格。",
    coEditSelectAllWarningMessage: "某些文档当前处于活跃的多用户编辑模式，无法包含在副本资料包中",
    coEditDocumentTooltip: "文档处于活跃的多用户编辑模式，无法复制。请签入文档以将其作为此资料包的一部分进行复制",
    coEditCopyWarningMessage: "{1}类别中的{0}个文档处于活跃的多用户编辑模式。请签入每个类别下的所有文档，以便将它们加入此资料包"
};

export const documentTypes = [{
        id: 1,
        label: "证据"
    },
    {
        id: 2,
        label: "临时"
    },
    {
        id: 3,
        label: "上年度证据"
    },
    {
        id: 4,
        label: "客户文件"
    },
    {
        id: 5,
        label: "截图"
    },
    {
        id: 6,
        label: "智能表格"
    },
    {
        id: 29,
        label: "纸质档案"
    },
    {
        id: 47,
        label: "批量导出文档"
    },
    {
        id: 48,
        label: "Canvas表格"
    },
    {
        id: 51,
        label: "自动化中心"
    },
    {
        id: 59,
        label: "资料包"
    },
    {
        id: 72,
        label: "智能工作底稿"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "{0}接受的关联请求"
    },
    {
        id: activityType.primaryLinkReject,
        label: "{0}拒绝的关联请求"
    },
    {
        id: activityType.primaryUnlink,
        label: "{0}取消项目与集团的关联"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "{0}取消项目与集团的关联"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "{0}取消项目与集团的关联"
    },
    {
        id: activityType.primarySendLink,
        label: "{0}发送至{1}的关联请求"
    },
    {
        id: activityType.documentsReceived,
        label: "{0}收到的文档"
    },
    {
        id: activityType.primarySendInstruction,
        label: "{0}发送至{1}的指引"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "{0}退回的指引"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "{0}接受的指引"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "收到的说明"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "{0}接受的指引"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "{0}退回的指引"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "{0}接受的指引"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "{0}退回的指引"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "{0}收到的版本"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "{0}解决的冲突"
    },
    {
        id: activityType.documentOverwrite,
        label: "文档内容由{0}覆盖"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "分配给{0}的文档"
    },
    {
        id: activityType.componentUnassigned,
        label: "没有从{0}分配的文档"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "{0}最终确定的版本"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "{0}解决的版本"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "{0}退回的版本"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "{0}发送的版本"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "{0}退回的版本"
    },
    {
        id: activityType.createReviewNote,
        label: "{0}打开的注释"
    },
    {
        id: activityType.openReviewNote,
        label: "{0}打开的注释"
    },
    {
        id: activityType.clearReviewNote,
        label: "{0}清除的注释"
    },
    {
        id: activityType.closeReviewNote,
        label: "{0}关闭的注释"
    },
    {
        id: activityType.reviewerSignOff,
        label: "由{0}签字"
    },
    {
        id: activityType.preparerSignOff,
        label: "由{0}签字"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "已回复"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "已删除"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "已召回"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "未定义"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "无联系人"
    },
    {
        id: GALinkStatus.Pending,
        label: "未完成"
    },
    {
        id: GALinkStatus.Accepted,
        label: "已接受"
    },
    {
        id: GALinkStatus.Rejected,
        label: "已拒绝"
    },
    {
        id: GALinkStatus.Expired,
        label: "已到期"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "未关联"
    },
    {
        id: GALinkStatus.Delegated,
        label: "已委托"
    },
    {
        id: GALinkStatus.SystemError,
        label: "系统错误"
    },
    {
        id: GALinkStatus.Sent,
        label: "已发送"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "无效联系人"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "没使用Canvas的组成部分"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "未发送"
    },
    {
        id: instructionStatus.pending,
        label: "未完成"
    },
    {
        id: instructionStatus.accepted,
        label: "已接受"
    },
    {
        id: instructionStatus.rejected,
        label: "已退回"
    },
    {
        id: instructionStatus.systemError,
        label: "系统错误"
    },
    {
        id: instructionStatus.expired,
        label: "已到期"
    },
    {
        id: instructionStatus.sent,
        label: "已发送"
    },
    {
        id: instructionStatus.unlinked,
        label: "未关联"
    },
    {
        id: instructionStatus.queued,
        label: "已排队"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "空"
    },
    {
        id: snapshotComparisonIds.new,
        value: "新建"
    },
    {
        id: snapshotComparisonIds.added,
        value: "已添加"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "已修改"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "已更新"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "已删除"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "项目已移除"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "主要"
    },
    {
        id: GARoleTypeId.Region,
        label: "区域"
    },
    {
        id: GARoleTypeId.Component,
        label: "组成部分"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "已发送"
    },
    {
        id: linkType.unlinked,
        label: "未关联"
    },
    {
        id: linkType.accepted,
        label: "已接受"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "已发送"
    },
    {
        id: instructionType.rejected,
        label: "已退回"
    },
    {
        id: instructionType.received,
        label: "已接收"
    },
    {
        id: instructionType.accepted,
        label: "已接受"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "未同步"
    },
    {
        id: syncStatus.syncInTransit,
        label: "同步中转中"
    },
    {
        id: syncStatus.syncInProcess,
        label: "同步中"
    },
    {
        id: syncStatus.synchronized,
        label: "已同步"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "删除中转中"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "删除中"
    },
    {
        id: syncStatus.deleted,
        label: "已删除"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "无主项目"
    },
    {
        id: syncStatus.syncError,
        label: "同步错误"
    }
];

export const colorOptionsLabels = {
    Red: "红色",
    Orange: "橙色",
    Teal: "青色",
    Blue: "蓝色",
    Purple: "紫色",
    Green: "绿色",
    Yellow: "黄色",
    Gray: "灰色"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "按天"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "按周"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "按月"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "全部"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "逾期"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "草稿"
    },
    {
        value: 'Pending',
        label: "待回应"
    },
    {
        value: 'Received',
        label: "已接收"
    },
    {
        value: 'Accepted',
        label: "已接受"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "必须签字"
    },
    {
        value: 'NotRequired',
        label: "无须签字"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "正常"
    },
    {
        value: 'High',
        label: "高"
    },
    {
        value: 'Critical',
        label: "关键"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "分析"
    },
    {
        value: 'ExternalAttachments',
        label: "外部附件"
    },
    {
        value: 'EyAttachments',
        label: "安永附件"
    },
    {
        value: 'None',
        label: "无"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "客户"
    },
    {
        value: 'EY',
        label: "安永"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "无时间段"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "是"
    },
    {
        value: 0,
        label: "否"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "是"
    },
    {
        value: true,
        label: "否"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "有效"
    },
    {
        value: 'false',
        label: "无效"
    },
    {
        value: 'null',
        label: "未被选中"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "有效"
    },
    {
        value: '2',
        label: "无效"
    },
    {
        value: '0',
        label: "未被选中"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "批注"
    },
    {
        id: clientRequestNoteTab.history,
        label: "历史"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "特别风险"
    },
    {
        id: 2,
        name: "舞弊风险"
    },
    {
        id: 3,
        name: "重大错报风险"
    }
];

export const months = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
export const longDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
export const shortDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "全部"
    },
    {
        id: gaScopes.specific,
        label: "特定"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "指定的审计程序"
    },
    {
        id: gaScopes.review,
        label: "复核"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "必填"
    },
    {
        id: gaRecommendationType.optional,
        label: "可选"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "不适用"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "分配的项目组"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "指引"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "任务"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "新建",
        instructional: "一份新"
    },
    false: {
        title: "已更新",
        instructional: "一份更新"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "请求已发送至",
    accepted: "已接受请求",
    received: "已收到请求",
    returned: "已退回请求",
    withdrawn: "已撤回请求",
    complete: "请求已由安永完成",
    recalled: "已召回请求",
    notification_submit: "请求已提交至自动化",
    notification_success: "请求已成功提交至自动化",
    notification_error: "在提交至自动化时出现错误。单击提交至自动化以重试。",
    restore_document: "已恢复文档——",
    delete_document: "已删除文档——",
	assignedto: "项目已重新分配给",
    editrequest: "已编辑请求",
    prioritychange: "请求优先等级更新至"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "已发送外部任务至",
    accepted: "已接受外部任务",
    received: "已收到回复",
    returned: "已退回外部任务",
    withdrawn: "已撤回外部任务",
    complete: "外部任务已通过EY Canvas完成",
    recalled: "已召回外部任务",
    restore_document: "已恢复文档——",
    delete_document: "已删除文档——",
	assignedto: "项目已重新分配给",
    editrequest: "外部任务已编辑",
    prioritychange: "外部任务优先等级更新至"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "IP地址"
    },
    {
        id: ipInputType.ipRange,
        label: "IP范围"
    },
    {
        id: ipInputType.cidrBlock,
        label: "CIDR地址块"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "IP地址",
    [ipFilterType.ipRange]: "IP范围",
    [ipFilterType.cidrBlock]: "CIDR地址块"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "未定义",
    [GALinkStatus.NoPointOfContact]: "无联系人",
    [GALinkStatus.NotSent]: "未发送",
    [GALinkStatus.Pending]: "待完成关联请求",
    [GALinkStatus.Accepted]: "接受的关联请求",
    [GALinkStatus.Rejected]: "已拒绝",
    [GALinkStatus.Expired]: "已到期",
    [GALinkStatus.Unlinked]: "未关联",
    [GALinkStatus.Delegated]: "委托人",
    [GALinkStatus.SystemError]: "系统错误",
    [GALinkStatus.Sent]: "已发送",
    [GALinkStatus.InvalidPointOfContact]: "无效联系方式",
    [GALinkStatus.ComponentNotUsingCanvas]: "未使用EY Canvas",
    [GALinkStatus.ComponentReferenceOnly]: "仅供参考"
};

export const epTasksObj = [{
        value: '3',
        label: "没有已签署文档"
    },
    {
        value: '2',
        label: "部分文档已签署"
    },
    {
        value: '1',
        label: "所有文档均已签署"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "没有已签署文档"
    },
    {
        value: '5',
        label: "部分文档已签署"
    },
    {
        value: '4',
        label: "所有文档均已签署"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "任务"
    },
    {
        id: 2,
        label: "文档"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "全面范围"
    },
    {
        id: 2,
        label: "特定范围"
    },
    {
        id: 3,
        label: "指定的审计程序"
    },
    {
        id: 4,
        label: "复核"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "全部注释"
    },
    {
        id: notesFilter.myNotes,
        label: "我的注释"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "分配给我的批注"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "左对齐",
    alignRight: "右对齐",
    alignCenter: "居中对齐",
    alignFull: "两端对齐",
    addComment: "添加注释",
    addColumnBefore: "左侧插入列",
    addColumnAfter: "右侧插入列",
    addRowAbove: "上方插入行",
    addRowBelow: "下方插入行",
    bulletList: "插入无序列表",
    bold: "加粗",
    backColor: "高亮",
    createLink: "插入超链接",
    createTable: "创建表格",
    cleanFormatting: "清除格式",
    deleteRow: "删除整行",
    deleteColumn: "删除整列",
    deleteTable: "删除表格",
    fontSizeInherit: "字体大小",
    foreColor: "颜色",
    format: "格式",
    fontSize: "字体大小",
    hyperlink: "插入网络链接",
    italic: "斜体",
    indent: "缩进",
    insertTableHint: "创建一个{0}x{1}表格",
    'hyperlink-dialog-content-address': "网络地址",
    "hyperlink-dialog-title": "插入超链接",
    "hyperlink-dialog-content-title": "标题",
    "hyperlink-dialog-content-newwindow": "在新窗口中打开链接",
    "hyperlink-dialog-cancel": "取消",
    "hyperlink-dialog-insert": "插入",
    outdent: "减少缩进",
    orderedList: "插入有序列表",
    print: "打印",
    pdf: "导出至PDF",
    redo: "重做",
    strikethrough: "删除线",
    subscript: "下标",
    superscript: "上标",
    underline: "下划线",
    undo: "撤销"
};

export const kendoFormatOptions = [{
        text: "段落",
        value: "p"
    },
    {
        text: "标题1",
        value: "h1"
    },
    {
        text: "标题2",
        value: "h2"
    },
    {
        text: "标题3",
        value: "h3"
    },
    {
        text: "标题4",
        value: "h4"
    },
    {
        text: "标题5",
        value: "h5"
    },
    {
        text: "标题6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"一月",
	"二月",
	"三月",
	"四月",
	"五月",
	"六月",
	"七月",
	"八月",
	"九月",
	"十月",
	"十一月",
	"十二月"
];

export const pspContentStatus = {
    1: "必须更新",
    2: "更新中",
    3: "更新完成",
    4: "更新错误"
}

export const handOffLabels = {
    handoff: "移交",
    handOffTitleTip: "移交以进行复核",
    markCompleteTitleTip: "标记完成",
    handoffModalTitle: "移交给下一位项目组成员",
    handoffConfirmButtonText: "移交",
    return: "退回",
    handModalDescription: "如想签署证据文档，请在以下选项进行选择。",
    markCompleteTextLine1: "将此任务移交给下一位项目组成员。",
    markCompleteTextLine2: "如想签署证据文档，请在以下选项进行选择。如果您已被分配此任务并且已完成此任务，请选择<b>是</b>，将此任务关闭。如果此任务需要PIC或EQR签字，请在以下选项进行选择。",
    closeLabel: "关闭",
    handoffto: "移交给",
    missingToUserError: "必填",
    markCompleteConfirm: "标记为已完成",
    markCompleteModalHeaderTextPart1: "此任务将被标记为已完成。",
    markCompleteModalHeaderTextPart2: "如想签署证据文档，请在以下选项进行选择。如果您已被分配此任务并且已完成此任务，请选择<b>是</b>，将此任务关闭。如果此任务需要PIC或EQR签字，请在以下选项进行选择。",
    signOffOnAllAs: "全部签名为",
    preparer: "编制人",
    reviewer: "复核人",
    none: "无",
    noSignOffsByMe: "没有我的签字",
    myPreparerSignOffs: "我的编制人签字",
    myReviewerSignOffs: "我的复核人签字",
    myPreparerAndReviewerSignOffs: "我的编制人和复核人的签字",
    preparerTitle: "编制人签字",
    reviewerTitle: "复核人签字",
    autoAssignmentMessage: "此项目组成员没有任务分配。将创建{0}个到期日为{1}的任务分配。请{2}，以编辑此任务分配。",
    clickHere: "请点击此处",
    noTaskEvidencesHandoffModal: "没有与该任务相关的证据文档。",
    // Create Assignment
    createAssignment: "创建任务分配",
    create: "创建",
    cancelLabel: "取消",
    createassignmentheader1: "所选项目组成员没有该任务项下的任务分配。",
    createassignmentheader2: "在此创建任务分配。",
    dueDate: "到期日",
    teamMemberAssigmentLabel: "项目组成员",
    daysPriorToEndDate: "到期日前天数",
    // Add Assignment
    addAssignmentTitle: "添加任务分配名称",
    confirmButtonLabel: "添加",
    cancelButtonLabel: "取消",
    assignmentTypeInstructionalText: "选择任务分配类型并在下方输入名称。完成后点击<b>添加</b>。",
    assignmentType: "任务分配类型",
    required: "必填",
    clearHoverText: "清除",
    unmarkcomplete: "取消已完成标记",
    markCompleteErrorMessage: "任务无法标记为已完成。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    // Assignment Dropdown
    noResultFound: "未找到结果",
    addTaskGroupLabel: "添加任务组",
    addAssignmentName: "添加任务分配名称",
    assignmentName: "任务分配名称",
    additionalSignOff: "其他必须完成签名",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "关闭我的任务分配",
    filterYes: "是",
    filterNo: "否",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "编制人"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "详细复核人"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "一般复核人"
        },
        {
            id: assignmentTypes.partner,
            label: "合伙人"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "其他"
        }
    ]
};

export const displayedOn = {
    "Account": "账户",
    "SCOT": "重大交易类别",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "范围和策略",
    "Execution": "执行",
    "Conclusion": "结论"
}

export const auditPlanReportLabels = {
    adc: "关联对象",
    secondaryObject: "二级关联对象",
    taskTypeColumn: "任务类型",
    taskNamePrefix: "任务前缀",
    taskName: "任务名称",
    taskNameSuffix: "任务后缀",
    taskDescription: "任务描述",
    auditTaskStatus: "任务状态",
    rationaleForRejection: "拒绝理由",
    knowledgeTaskTitle: "信息库任务名称",
    knowledgeTaskDescription: "信息库任务描述",
    assignedTo: "被分配人",
    engagementTagGroupName: "标签组",
    engagementTagName: "标签",
    prioritized: "已优先",
    viewDisplayedOn: "视图显示于",
    engagementPhase: "项目阶段",
    milestone: "里程碑",
    periodName: "时间段",
    riskTypeAbbr: "关联风险类型",
    riskName: "关联风险名称",
    relatedMESTEntityName: "关联MEST实体",
    scheduledNextWaveservices: "集中服务",
    taskID: "任务ID",
    timephaseID: "时间段ID",
    taskTypeID: "任务类型ID",
    timephaseTypeID: "时间段类型ID"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "信息库任务名称",
    knowledge_Task_Description: "信息库任务描述",
    rejected: labels.rejected,
    rationale_for_Rejection: "拒绝理由",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "时间段开始日（UTC中）",
    timephaseduedateinutc: "时间段到期日（UTC中）",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "上个任务状态变更日（UTC中）",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "关联MEST实体",
    multiEntityType: "多实体类型",
    taskID: "任务ID",
    taskTypeID: "任务类型ID",
    taskStatusID: "任务状态ID",
    auditPhaseID: "审计阶段ID",
    timephaseTypeID: "里程碑ID",
    taskSourceTypeID: "任务来源ID",
    taskNatureTypeID: "任务性质ID",
    cgTaskID: "知识库任务ID",
    knowledgeContentID: "知识库内容ID"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "PIC必须签字",
    EQRSignoffRequired: "EQR必须签字",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "任务到期日（UTC中）",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "任务分配汇总",
    closedTaskAssignmentPercent: "已关闭任务分配百分比",
    assignmentOrder: "任务分配排序",
    firstNameVal: "任务分配项目组成员名字",
    lastNameVal: "任务分配项目组成员姓氏",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "项目用户角色",
    assignmentStatusVal: "任务分配状态",
    dueDays: "逾期天数",
    completedDateInUTC: "完成日（UTC中）",
    assignmentDueDateInUTC: "任务分配到期日（UTC中）",
    daysCompleteBeforeDueDate: "任务分配到期日前剩余天数",
    daysCompleteAfterDueDate: "任务分配到期日后逾期天数",
    closedEarlyOrLate: "提前/逾期关闭",
    closedDaysEarly: "提前关闭天数",
    closedDaysLate: "逾期关闭天数",
    oldTaskName: "之前的任务名称",
    oldTaskDetail: "之前的任务描述",
    taskID: "任务ID",
    assignmentID: "工作分配ID",
    roleID: "角色ID",
    userID: "用户ID"
}

export const reportingMultiEntityTask = {
    engagementID: "项目ID",
    taskID: "任务ID",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "相关实体",
    multiEntityType: "多实体类型",
    taskTypeID: "任务类型ID",
    taskStatusID: "任务状态ID"
}

export const reportingManageteamInternal = {
        firstName: labels.firstnameLabel,
        lastName: labels.lastnameLabel,
        userInitials: labels.initialsLabel,
        emailAddress: labels.editExternalEmailLabel,
        gui: "GUI",
        engagementRole: labels.engagementrole,
        hasOverallResponsability: "承担总体责任",
        userStatus: "状态",
        independenceStatus: "独立性状态",
        grantedAccess: "归档后授权访问权限",
        primaryOffice: "主办事处",
        preferredContactPhone: "电话号码",
        engagementUserStatusID: "项目用户状态ID",
        engagementRoleID: "项目角色ID",
        independenceStatusID: "独立性状态ID"
    }

export const reportingManageteamExternal = {
    clientGroupName: "集团名称",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "用户域名",
    validDomainWithinGroup: "集团内有效域名",
    userStatus: "用户状态",
    preferredContactPhone: "首选电话号码"
};

export const controlDesignEffectivenessType = {
    1: "有效",
    2: "无效"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "IT应用程序/服务机构",
    strategyTypeName: "IT策略",
    typeName: "类型",
    itProcessName: "IT流程",
    itRiskName: "IT风险",
    itControlName: "IT一般控制/IT实质性程序",
    natureOfTest: "测试性质",
    controlFrequencyTypeNameColumn: "频率",
    testing: "测试",
    designEffectiveness: "设计有效性",
    evaluation: "IT流程评估"
};

export const ArchiveReportLabels = {
    engagementDescription: "项目描述",
    archiveReportQualifiedNameSection: "保留意见报告",
    archiveReportQualifiedTypeNameSection: "报告保留意见类型",
    archiveFolderDescription: "归档文件夹描述",
    archiveFolderTypeNameSection: "文件夹类型",
    location: "位置",
    archiveComments: "归档批注",
    engagementID: "项目ID",
    archiveCountryOfficeRegionID: "归档国家办事处地区ID",
    archiveReportQualifiedID: "归档保留意见报告ID",
    archiveReportQualifiedTypeID: "归档报告保留意见类型ID"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Canvas表格名称",
    order1: "标题顺序",
    formHeaderName: "标题",
    order2: "章节顺序",
    order3: "正文顺序",
    formBodyResponseValue: "回复",
    commentNumber: "批注编号",
    author: "作者",
    assignedTo: "分配至",
    createDateSection: "创建日期",
    commentStatusSection: "状态",
    commentText: "批注",
    commentVoiceNote: "有语音注释",
    reply: "回复",
    replyVoiceNote: "有语音注释"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Canvas表格名称",
    order1: "标题顺序",
    formHeaderName: "标题",
    formHeaderID: "表格标题ID",
    order2: "章节顺序",
    formSectionID: "表格章节ID",
    formSectionName: "章节",
    firstLevelEntityColumn: "一级实体",
    firstLevelRelatedObject: "一级关联对象",
    secondLevelEntityColumn: "二级实体",
    secondLevelRelatedObject: "二级关联对象"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Canvas表格名称",
    order1: "标题顺序",
    formHeaderName: "标题",
    knowledgeFormHeaderID: "标题知识ID",
    headerKnowledgeContentID: "标题知识内容ID",
    order2: "章节顺序",
    formSectionName: "章节",
    knowledgeFormSectionID: "章节知识ID",
    sectionKnowledgeContentID: "章节知识内容ID",
    order3: "正文顺序",
    formBody: "正文",
    knowledgeFormBodyID: "正文知识ID",
    bodyKnowledgeContentID: "正文知识内容ID",
    formBodyResponse_Value: "回复"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Canvas表格名称",
    header: "标题",
    headerOrder: "标题顺序",
    sectionOrder: "章节顺序",
    bodyOrder: "正文顺序",
    body: "正文",
    formHeaderID: "表格标题ID",
    formSectionID: "表格章节ID",
    formBodyID: "表格正文ID"
};

export const controlFormResponseLabels = {
    controlName: "控制",
    documentName: "文件",
    engagementDescription: "项目描述",
    formHeader: "标题",
    headerKnowledgeDisplayOrder: "标题知识库显示顺序",
    formSection: "章节",
    sectionKnowledgeDisplayOrder: "章节知识库显示顺序",
    formBodyVal: "正文",
    bodyKnowledgeDisplayOrder: "正文知识库显示顺序",
    ControlTesting: "是否进行控制测试",
    controlFrequencyType: "控制频率",
    Effective: "是否有效",
    formBodyOptionVal: "表格选项正文值",
    controlType: "控制类型",
    controlDesignEffectivenessType: "控制设计有效性类型"
};

export const itProcessSummaryLabels = {
    itProcessName: "IT流程",
    itProcessEvaluation: "IT流程评估",
    itProcesSupportingRationale: "支持性理由",
    itRiskName: "IT风险",
    itControlName: "IT一般控制/IT实质性程序",
    natureOfTest: "测试性质",
    controlFrequencyTypeId: "频率",
    testing: "测试",
    designEffectiveness: "设计有效性",
    operatingEffectiveness: "运行有效性"
}

export const itProcessScotControlsLabels = {
    itProcessName: "IT流程",
    scotName: "重大交易类别",
    controlName: "控制",
    controlDesignEffectivenessTypeName: "设计有效性",
    testing: "测试",
    operatingEffectiveness: "运行有效性",
    controlTypeName: "控制类型",
    isIPEManuallyTestedName: "IPE是否经过手动测试？",
    itApplicationName: "IT应用程序",
    aggregateITEvaluationTypeName: "综合IT评估"
};

export const scotsControlsReportLabels = {
    scotName: "重大交易类别",
    controlName: "控制",
    operatingEffectiveness: "运行有效性",
    itApplicationName: "IT应用程序",
    aggregateITEvaluation: "综合IT评估",
    supportingRationaleControlLabel: "支持性理由"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "重大交易类别",
    scotTypeName: "交易类型",
    strategyTypeName: "重大交易类别策略",
    itApplicationName: "重大交易类别 IT App/SO",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "控制类型",
    testing: "测试",
    operatingEffectiveness: "运行有效性",
    controlITApplication: "控制 IT App/SO",
    aggregateITEvaluationTypeName: "综合IT评估",
    supportingRationale: "支持理由",
    scotId: "重大交易类别ID",
    strategyTypeID: "策略类型ID",
    scotTypeID: "重大交易类别类型ID",
    wcgwid: "可能出错项ID",
    controlID: "控制ID",
    controlFrequencyTypeID: "控制频率类型ID",
    controlTypeID: "控制类型ID",
    aggregateITEvaluationTypeID: "综合IT评估类型ID"
};

export const findingsDeficiencyHeaderLabels = {
    description: "缺陷描述",
    controls: "控制",
    controlsIsEffective: "控制运行有效性",
    type: "缺陷类型",
    magnitude: "程度",
    responseText: "回复文本",
    remediatedAtYearEnd: "年末已补救",
    mitigatingControls: "补偿性控制",
    mitigatingControlsIsEffective: "补偿性控制运行有效性",
    mitigatingTasks: "补救性任务",
    foundIn: "已在文档中找到",
    accountsAndAssertions: "账户和认定",
    scoTs: "重大交易类别",
    deficiencyID: "缺陷ID",
    controlID: "控制ID",
    mitigatedControlID: "已补救控制ID",
    mitigatedTaskID: "已补救任务ID",
    documentID: "文档ID",
    accountID: "账户ID",
    scotID: "重大交易类别ID"
};

export const findingsMisstatementHeaderLabels = {
    description: "错报描述",
    type: "错报类型",
    trialBalance: "试算平衡表",
    period: "期间",
    accountNumber: "账户编号",
    accountName: "账户名称",
    accountType: "账户类型",
    debit: "借记",
    credit: "贷记",
    responseText: "回复文本",
    correctedUncorrected: "更正/未更正",
    mitigatingTasks: "补救性任务",
    foundInDocument: "已在文档中找到",
    accountsAndAssertions: "账户和认定",
    misstatementID: "错报ID",
    trialBalanceID: "试算平衡表ID",
    misstatementAdjustmentID: "错报调整ID"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "IT应用程序名称",
    itProcessName: "IT流程名称",
    itControlName: "IT控制名称",
    itApproachTypeName: "IT方法类型",
    isEffective: "控制有效性",
    referenceNumber: "索引编号",
    description: "缺陷描述",
    deficiencyMagnitudeName: "缺陷程度",
    deficiencyTypeName: "缺陷类型"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "关联对象",
    secondaryObject: "相关控制/实质性程序",
    taskName: "任务名称",
    taskDescription: "任务描述",
    taskTypeColumn: "任务类型",
    taskStatusValue: "任务状态",
    rationaleForRejection: "拒绝理由",
    engagementPhase: "项目阶段",
    milestone: "里程碑",
    periodName: "时间段",
    assignedTo: "被分配人",
    engagementTagGroupName: "标签组",
    engagementTagName: "标签",
    displayedOn: "查看显示内容",
    documentName: "文档名称",
    preparersValue: "编制人（UIC中的日期）",
    reviewersValue: "复核人（UIC中的日期）",
    openReviewNotes: "未解决复核注释",
    closedReviewNotes: "已清除复核注释",
    trackChangesValue: "追踪修订",
    lastModifiedBy: "最后修改人",
    lastModifiedDateValue: "最后修改日期（UIC中）",
    taskID: "任务ID",
    timephaseID: "时间段ID",
    taskTypeID: "任务类型ID",
    documentTypeID: "文档类型ID",
    parentDocumentTypeID: "母公司文档类型ID",
    timePhaseTypeID: "时间段类型ID"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "章节",
    gaInstructionName: "指引名称",
    gaInstructionDescription: "指引描述",
    documents: "文档名称",
    knowledgeInstructionName: "信息库指引名称",
    knowledgeInstructionDescription: "信息库指引描述",
    gaScopeName: "相关范围/子范围",
    componentOnly: "范围/单个指引",
    shortName: "地区/组成部分名称",
    cSection: "定制章节",
    customInstruction: "定制指引",
    gAinstructionID: "GA指引ID"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "项目ID",
    gaScopeID: "集团审计范围ID",
    gaScopeName: "范围",
    gaComponentID: "集团审计组成部分ID",
    shortName: "组成部分名称",
    lastPublishedDateInUTC: "最后发布日期",
    lastSentDateInUTC: "最后发送日期",
    gaLinkStatusId: "关联状态",
    gaInstructionStatusId: "指引状态"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "项目ID",
    gaScopeID: "集团审计范围ID",
    gaScopeName: "范围",
    gaComponentID: "集团审计组成部分ID",
    shortName: "组成部分名称",
    gaLinkStatusId: "关联状态",
    accountID: "账户ID",
    accountName: "账户名称",
    accountType: "账户指定",
    activityTypeID: "活动类型ID",
    activityTypeText: "活动类型",
    modifyDateInUTC: "修改日期",
    modifyUser: "修改用户",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "项目ID",
    accountID: "账户ID",
    accountName: "账户名称",
    accountTypeID: "账户类型ID",
    accountTypeId: "账户指定",
    knowledgeAssertionId: "认定简称",
    inherentRiskTypeId: "固有风险评估",
    controlRiskTypeId: "控制风险评估",
    craValue: "综合风险评估",
    riskID: "风险ID",
    riskTypeID: "风险类型ID",
    riskType: "风险类型",
    riskName: "风险名称",
    isHigherRiskValue: "为较高风险",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "账户",
    accountTypeName: "账户类型",
    rationale: "依据",
    pspIndex: "主要实质性程序索引",
    conclusionStatement: "账户结论表",
    scotName: "重大交易类别",
    transactionType: "交易类型",
    strategyTypeName: "重大交易类别策略",
    wcgwName: "可能出错项",
    controlName: "控制",
    controlFrequencyTypeName: "频率",
    controlTypeName: "控制类型",
    testing: "测试",
    operatingEffectiveness: "运行有效性",
    itApplicationName: "重大交易类别IT App/SO",
    controlITApplication: "控制IT App/SO"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "账户",
    accountTypeName: "账户类型",
    rationale: "依据",
    pspIndex: "主要实质性程序索引",
    assertionAbbreviation: "认定",
    riskName: "风险",
    inherentRiskTypeName: "固有风险评估",
    controlRiskTypeName: "控制风险评估",
    craValue: "综合风险评估",
    wcgwName: "可能出错项",
    controlName: "控制",
    controLFrequencyTypeName: "频率",
    controlTypeName: "控制类型",
    testing: "测试",
    isLowerR: "较低风险",
    operatingEffectiveness: "运行有效性",
    itApplicationName: "IT App/SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "可能出错项",
    controlName: "控制",
    controLFrequencyTypeName: "控制频率",
    controlTypeName: "控制类型",
    itApplicationName: "IT应用程序",
    assertionName: "认定",
    statementTypeName: "报表类型",
    accountTypeName: "账户类型",
    assertionAbbreviation: "认定简称",
    inherentRiskTypeName: "固有风险",
    controlRiskTypeName: "控制风险",
    craValue: "综合风险评估",
    riskTypeAbbreviation: "风险简称",
    frequency: "频率",
    accountName: "账户",
    riskName: "风险",
    pspIndex: "主要实质性程序索引",
    testing: "测试",
    operatingEffectiveness: "运行有效性",
    isLowerRiskColumn: "是否为较低风险",
    scotName: "重大交易类别",
    controlitApplicationName: "控制IT应用程序",
    rationale: "依据",
    accountID: "账户ID",
    riskID: "风险ID",
    scotid: "重大交易类别ID",
    wcgwid: "可能出错项ID",
    controlID: "控制ID",
    itApplicationID: "IT应用程序ID",
    knowledgeAssertionID: "知识库认定ID",
    controlTypeID: "控制类型ID",
    controlFrequencyTypeID: "控制频率类型ID",
    accountTypeID: "账户类型ID",
    riskTypeID: "风险类型ID",
    inherentRiskTypeID: "固有风险类型ID",
    controlRiskTypeID: "控制风险类型ID",
    statementTypeID: "报表类型ID",
    conclusionStatement: "账户结论"
};

export const reportingRequestsAndTasks = {
    requestTitle: "请求/任务名称",
    request_Description: "请求/任务描述",
    type: "类型",
    tasks: "任务名称",
    engagementTagName: "标签",
    eyAssigned: "安永分配用户",
    clientGroupName: "外部工作组",
    externalAssignedUser: "外部分配用户",
    periodName: "时间段",
    dueDateInUTC: "到期日（UTC中）",
    requestStatus: "请求/任务状态",
    documentType: "文档类型",
    documentName: "当前年度文档名称",
    priorYearDocumentName: "上一年度文档名称",
    externalDocumentSignOffInUTC: "外部文档签字（UTC中）",
    clientRequestReferenceNumber: "客户请求索引编号"
};

export const reportingRequestComment = {
    requestTitle: "请求/任务名称",
    request_Description: "请求/任务描述",
    type: "类型",
    tasks: "任务名称",
    engagementTagName: "标签",
    eyAssigned: "安永分配用户",
    clientGroupName: "外部分组",
    externalAssignedUser: "外部分配用户",
    periodName: "时间段",
    dueDateInUTC: "到期日（UTC中）",
    requestStatus: "请求/任务状态",
    externalDocumentSignOffInUTC: "外部文档签字（UTC中）",
    annotationTextData: "批注",
    createDateInUTC: "批注日（UTC中）",
    annotationUserInitials: "批注人"
};

export const reportingAllDocuments = {
    documentName: "文档名称",
    fileExt: "文件扩展名",
    canvasFormType: "Canvas表格类型",
    docType: "文档类型",
    confidentiality: "机密性",
    docFileSize: "文件大小（KB）",
    preparers: "编制人（UTC中）",
    reviewers: "复核人（UTC中）",
    relatedTask: "关联任务",
    openReviewNote: "未解决复核注释",
    clearedReviewNote: "已清除复核注释",
    trackChanges: "追踪修订",
    hiddenSheets: "隐藏工作表",
    comments: "批注",
    highlighted: "高亮",
    conflicted: "冲突",
    docModifyUser: "最后修改人",
    docModifyDateInUTC: "最后修改日期（UTC中）",
    documentID: "文档ID"
};

export const signOffDocuments = {
    documentName: "文档名称",
    fileExt: "文件扩展名",
    canvasFormType: "Canvas表格类型",
    docType: "文档类型",
    confidentiality: "机密性",
    docFileSize: "文件大小（KB）",
    docModifyUser: "最后修改人",
    docModifyDateInUTC: "最后修改日期（UTC中）",
    signOffDate: "签字日（UTC中）",
    signedOffBy: "签字人",
    role: "角色",
    preparerReviewer: "编制人/复核人"
};

export const reportingDocumentsModified = {
    documentName: "文档名称",
    lastModifiedDateInUTC: "最后修改日期（UTC中）",
    lastModifiedUser: "最后修改用户",
    reason: "原因",
    documentChangeComment: "依据",
    preparersInUTC: "编制人（UTC中）",
    reviewersInUTC: "复核人（UTC中）",
    approver: "批准（UTC中）"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "任务名称",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "任务描述",
    taskTypeAbbreviation: "任务类型",
    taskSourceType: "任务来源",
    taskNatureType: "任务性质",
    last_Modified_By: "最后修改人",
    modifyDateInUTC: "最后修改日期（UTC中）",
    oldTaskName: "之前的任务名称",
    oldTaskDetail: "之前的任务描述"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "账户/认定",
    craValue: "综合风险评估",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "关联风险",
    taskType: "任务类型",
    taskTitle: "任务名称",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "任务类型ID",
    taskSourceTypeID: "任务来源类型ID",
    taskNatureTypeID: "任务性质类型ID"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "当前里程碑",
    correctTimephase: "正确里程碑"
}

export const MilestonesReportHeader = {
    milestone: "里程碑",
    status: "里程碑状态",
    taskStatus: "任务状态",
    taskTitle: "任务标题",
    taskTypeAbbreviationColumn: "任务类型简称",
    taskType: "任务类型",
    timePhase: "时间阶段",
    assignedTo: "分配至",
    taskName: "任务名称",
    task_Detail: "任务详细信息",
    due_Date: "到期日",
    documentName: "文件名称",
    preparers: "编制人",
    reviewers: "复核人",
    tagGroup: "标签组",
    tags: "标签",
    engagementID: "项目ID",
    taskID: "任务ID",
    taskTypeID: "任务类型ID",
    taskStatusID: "任务状态ID",
    timephaseID: "时间阶段ID",
    timephaseTypeID: "时间阶段类型ID",
    documentID: "文档ID"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "范围描述",
    gaScopeDescription: "范围/子范围名称",
    shortName: "地区/组成部分名称",
    legalName: "法定名称",
    gaRoleTypeName: "集团角色",
    relatedRegion: "关联地区",
    pocText: "联系人",
    gaLinkStatusName: "关联状态",
    gaInstructionStatusName: "指引状态",
    engagementID: "项目ID",
    gaRoleTypeID: "GA角色类型ID",
    gaLinkStatusID: "GA关联状态ID",
    gaInstructionStatusID: "GA指引状态ID"
}

export const collaborationSummary = {
    clientRequestID: "请求数",
    requestTitle: "标题",
    requestType: "类型",
    engagementTagName: "标签",
    clientUser: "分配至",
    clientEmail: "客户邮件",
    clientStatusName: "状态",
    isOverDue: "逾期",
    dueDateInUTC: "到期日（UTC中）",
    eySentDateInUTC: "安永发送日（UTC中）",
    eyReceivedDateInUTC: "接收日（UTC中）",
    deliveredLate: "逾期交付",
    daysLate: "逾期天数",
    timesReturned: "退回次数"
}

export const collaborationActivity = {
    clientRequestID: "请求数",
    requestTitle: "标题",
    requestType: "类型",
    engagementTagName: "标签",
    clientUser: "分配至",
    clientEmail: "客户邮件",
    clientStatusName: "状态",
    isOverDue: "逾期",
    dueDateInUTC: "到期日（UTC中）",
    eySentDateInUTC: "安永发送日（UTC中）",
    eyReceivedDateInUTC: "接收日（UTC中）",
    deliveredLate: "逾期交付",
    daysLate: "逾期天数",
    timesReturned: "退回次数",
    activity: "活动",
    activityDateInUTC: "活动日（UTC中）",
    historicalDueDateInUTC: "历史到期日（UTC中）"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "指引名称",
    gascopeTypeIDName: labels.scope,
    componentName: "组成部分名称",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "到期日（UTC中）",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "签字日（UTC中）",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "编制人/复核人",
    documentID: "文档ID",
    gaStatusID: "GA状态ID",
    engagementRoleID: "项目角色ID"
}

export const wcgwSummaryHeaders = {
    wcgwName: "可能出错项",
    scotName: "重大交易类别",
    controlName: "相关控制",
    itApplications: "关联IT App/SO",
    testing: "测试选择",
    isLowerR: "较低风险",
    controlFrequencyTypeName: "控制频率",
    controlTypeName: "控制类型",
    wcgwCount: "其他相关可能出错项数量"
}

export const allControlsHeaders = {
    engagementID: "项目ID",
    scotid: "重大交易类别ID",
    controlID: "控制ID",
    scotName: "重大交易类别名称",
    controlName: "控制描述",
    hasControlTesting: "测试选择",
    isLowerRisk: "为较低风险",
    controlTypeID: "控制类型",
    relatedITApplicationNames: "相关IT应用程序/服务机构",
    responsiveToSR: "应对特别风险",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "项目ID",
    itemName: "项目名称",
    qualityChecks: "质量检查",
    validationDescription: "验证描述",
    buildGroup: "创建组",
    impactedItem: "受影响项目",
    type: "类型"
}

export const statisticsHeaders = {
    scotname: "重大交易类别",
    strategyTypeId: "重大交易类别策略",
    wcgwName: "可能出错项",
    controlName: "控制",
    operatingEvaluation: "运行评价",
    itApplicationName: "相关IT应用程序/SO",
    assertions: "认定",
    controlTypeId: "控制类型",
    testingSelection: "测试选择",
    controlFrequencyTypeId: "频率",
    itApplications: "IT应用程序",
    scotTypeId: "重大交易类别类型",
    itType: "IT应用程序类型",
    isLowerR: "风险是否较低",
    engagementID: "项目ID",
    workspaceID: "工作区ID",
    scotID: "重大交易类别ID",
    scotTypeID: "重大交易类别类型ID",
    wcgwid: "可能出错项ID",
    controlID: "控制ID"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "账户",
    assertion: "认定",
    controlName: "控制",
    ControlTypeName: "控制类型",
    ControlFrequencyTypeName: "频率",
    Testing: "测试",
    OperatingEvaluation: "运行评价",
    assertionControlCount: "认定控制数",
    assertionAbbreviation: "认定简称",
    wcgwName: "可能出错项",
    engagementID: "项目ID",
    workspaceID: "工作区ID",
    assertionID: "认定ID",
    wcgwid: "可能出错项ID",
    controlID: "控制ID"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "IT应用程序控制",
    'IT Dependent Manual Control': "依赖IT的手动控制",
    'Manual Prevent': "手动预防",
    'Manual Detect': "手动发现"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "每天多次",
    'Daily': "每日",
    'Weekly': "每周",
    'Monthly': "每月",
    'Quarterly': "每季度",
    'Annually': "每年",
    'IT Application Control': "IT应用程序控制",
    'Other': "其他"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "工作底稿",
    'Perm File Active': "活跃永久性文件",
    'Perm File Superseded': "被取代永久性文件",
    'Working Papers - CD/DVD': "工作底稿 - CD/DVD",
    'Perm File Active - CD/DVD': "活跃永久性文件 - CD/DVD",
    'Perm File Superseded - CD/DVD': "被取代永久性文件 - CD/DVD",
    'Data Storage Devices': "数据存储设备"
};

export const operatingEvaluationType = {
    'Effective': "有效",
    'Ineffective': "无效",
    'Not Selected': "未选择"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "重大交易类别",
    strategyTypeName: "重大交易类别策略",
    wcgwName: "相关可能出错项",
    controlName: "相关控制",
    operatingEvaluation: "运行评价",
    itApplicationName: "相关IT应用程序/SO",
    assertions: "认定",
    controlTypeName: "控制类型",
    testing: "测试选择",
    controlFrequencyTypeName: "频率",
    itApplications: "IT应用程序",
    itAppType: "IT应用程序类型",
    scotTypeName: "重大交易类别类型",
    soctisLowerRisk: "较低风险控制",
    engagementID: "项目ID",
    workspaceID: "工作区ID",
    scotID: "重大交易类别ID",
    scottypeid: "重大交易类别类型ID",
    wcgwid: "可能出错项ID",
    controlID: "控制ID"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "项目ID",
    DocumentID: "文档ID",
    ControlID: "控制ID"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "项目ID",
    scotName: "重大交易类别名称",
    strategyTypeName: "策略类型名称",
    wcgwName: "可能出错项名称",
    controlID: "控制ID",
    controlName: "控制名称",
    controlFrequencyTypeName: "控制频率类型名称",
    controlTypeName: "控制类型名称",
    isLowerRiskHeader: "低风险",
    hasControlTestingHeader: "有控制测试",
    operativeEffectiveness: "运行有效性"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "项目ID",
    accountId: "账户ID",
    accountName: "账户名称",
    accountTypeId: "账户类型ID",
    accountDesignation: "账户指定",
    pspIndexTitle: "主要实质性程序索引",
    knowledgeAssertion: "认定简称",
    inherentRiskType: "固有风险评估",
    controlRiskType: "控制风险评估",
    craValue: "综合风险评估",
    riskId: "风险ID",
    riskTypeId: "风险类型ID",
    riskTypeEnum: "风险类型",
    riskName: "风险名称",
    isHigherRiskText: "为较高风险",
    rejectedTaskId: "任务ID",
    rejectedTaskName: "拒绝的主要实质性程序",
    rejectedTaskRationale: "拒绝主要实质性程序的理由"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "项目ID",
    controlID: "控制ID",
    itApplicationID: "IT应用程序ID",
    controlITApplication: "控制IT应用程序"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "项目ID",
    controlID: "控制ID",
    Accountname: "账户名称",
    AssertionAbbreviation: "认定简称"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "项目ID",
    accountName: "账户名称",
    accountId: "账户ID",
    knowledgeAssertion: "认定",
    CRA: "综合风险评估",
    RelatedRisk: "已关联风险",
    riskId: "风险ID",
    riskType: "风险类型",
    WCGW: "可能出错项",
    wcgwId: "可能出错项ID",
    RelatedSCOT: "已关联重大交易类别",
    scotId: "重大交易类别ID"
};

export const ipeControlsHeaders = {
    EngagementID: "项目ID",
    DocumentID: "文档ID"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "项目ID",
    DocumentID: "文档ID"
};

export const ipeITGCHeaders = {
    EngagementID: "项目ID",
    DocumentID: "文档ID"
};

export const iTAppSOReport = {
    relatedITSO: "相关IT应用程序/SO",
    iTAppType: "IT应用程序类型",
    iTAppControl: "IT应用控制控制",
    testingSelection: "测试选择",
    relatedSCOTs: "相关重大交易类别",
    relatedSCOTStrategy: "相关重大交易类别策略",
    itdm: "依赖IT的手动控制",
    manualPrevent: "手动预防",
    manualDetect: "手动发现",
    noRelatedControls: "无相关的控制",
    controlsStatistics: "控制（按类型）",
    relatedSCOTType: "相关重大交易类别类型",
    controlType: "控制类型",
    grandTotal: "合计",
    yes: "是",
    no: "否",
    notSelected: "未选择",
    controls: "控制",
    substantive: "实质性",
    routine: "常规",
    nonRoutine: "非常规",
    estimation: "估计"
};

export const IndependenceSummaryReport = {
    id: "ID",
    userName: "用户名",
    order: "顺序",
    questionFormatted: "问题",
    answer: "回复",
    actionTypeID: "操作类型ID",
    independenceStatusID: "独立性状态ID",
    EngagementUserStatusName: "项目用户状态",
    engagementUserStatusID: "项目用户状态ID",
    IndependenceStatusName: "独立性状态",
    requiresExecutiveClearance: "需要负责人批准"
};

export const additionalInfoBasedOnValidationTypeId = {
    1: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    2: "项目组未使用最新版本的《表格109——项目组成员独立性表》",
    3: "在授予具有独立性事项的另一项目组成员访问权限后，项目组成员更改了其PPEDD角色",
    4: "在覆盖具有独立性事项的另一项目组成员后，项目组成员的PPEDD角色发生变化",
    5: "点击验证链接，识别旁边没有编号标识的重大交易类别。将重大交易类别与账户关联",
    6: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    7: "识别相关可能出错项数量为零的重大交易类别。前往相应的生成任务。展开重大交易类别并酌情添加可能出错项",
    8: "识别相关控制数量为零的重大交易类别。前往相应的生成任务。展开重大交易类别并向可能出错项添加一个控制",
    9: "通过验证识别重大交易类别，展开重大交易类别详细信息，并核实每个可能出错项至少有一个控制在是否测试上选择了“是”",
    10: "通过验证识别重大交易类别，展开重大交易类别详细信息。核实每个可能出错项至少有一个控制在是否测试上选择了“是”",
    11: "点击验证链接，识别旁边没有编号标识的风险。将适当的认定与风险关联",
    12: "识别缺少固有风险和/或控制风险的认定。填写缺失的信息栏",
    13: "点击验证链接，并打开“添加可能出错项”抽屉式菜单。一次选择一个重大交易类别，并识别旁边没有编号标识的可能出错项。将可能出错项与适当的认定关联",
    14: "识别旁边没有编号标识的账户。前往重大交易类别生成流程，并将重大交易类别与账户关联",
    15: "通过验证识别账户/认定，点击“添加可能出错项”按钮，并将可能出错项与认定关联",
    16: "此验证检查验证与依赖控制策略的认定相关的所有可能出错项是否都包含在将要测试的控制中。通过验证识别认定，点击“添加可能出错项”按钮，并将可能出错项与认定关联",
    17: "复核关联至认定的每个可能出错项，并确认其是否被至少一个在是否有测试策略上为“是”的控制涵盖",
    18: "具有“依赖”策略的认定的所有可能出错项必须由测试值设置为“是”的控制覆盖",
    19: "IT/SO的依赖策略未被删除且与IT/SO流程未关联",
    20: "IT/SO控制/IT实质性程序没有关联至IT/SO风险",
    21: "创建IT/SO流程后，策略从“依赖”变为“不依赖”",
    22: "风险与认定未关联",
    23: "IT/SO控制/IT实质性程序没有关联至IT/SO风险",
    24: "未选择与IT/SO风险关联的IT/SO控制/实质性程序进行测试 ",
    25: "IT/SO控制/IT实质性程序没有关联至IT/SO风险",
    26: "识别没有任何任务的有限风险账户。添加一个或多个OSP",
    27: "确认您是否已导入PSP。如果尚未导入，请点击导入PSP。如果认定没有PSP，请创建一个OSP",
    28: "前往重大交易类别生成流程，打开“添加控制测试”抽屉式菜单，识别旁边没有编号标识的控制测试任务。将控制测试任务与控制关联",
    29: "项目至少包含一个尚未关联重大交易类别的穿行测试任务",
    30: "重大交易类别没有至少与一项穿行测试任务关联",
    31: "前往重大交易类别生成流程，打开“添加控制测试”抽屉式菜单，识别旁边没有编号标识的控制测试任务。将控制测试任务与控制关联",
    32: "IT/SO穿行测试没有至少与一项IT/SO流程关联",
    33: "IT/SO控制测试没有至少与一项测试值设置为“是”的IT/SO控制/实质性程序相关联",
    34: "IT/SO其他实质性程序没有至少和一项测试值设置为“是”的IT/SO控制/实质性程序相关联",
    35: "IT/SO流程没有至少与一项穿行测试任务相关联",
    36: "测试值设置为“是”的控制没有与之关联的控制测试任务",
    37: "IT/SO其他实质性程序没有至少和一项测试值设置为“是”的IT/SO控制/实质性程序相关联",
    38: "点击验证链接，在证据列表中点击冲突图标以解决冲突",
    39: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    40: "点击验证链接，在证据列表中缺少编制人或复核人签字的文档上签字。只在您编制或复核的文件上签字",
    41: "点击验证链接，在筛选的任务列表中复核每个任务并关联适当的证据文件",
    42: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    43: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    44: "点击验证链接，在证据列表中重命名具有重复名称的文档",
    45: "尚未选择IT流程评估，或IT流程评估与IT一般控制/IT实质性测试程序运行有效性评估不一致",
    46: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    47: "尚未为一个或多个应用程序/依赖IT的手动控制选择综合IT评估",
    48: "Canvas表格至少有一个尚未填写的信息栏 ",
    49: "点击验证链接，然后点击“添加认定”以关联认定或有限风险账户",
    50: "无关联的认定或有限风险账户的任务。点击“添加认定”以关联认定或有限风险账户",
    51: "可能出错项未与实质性任务关联",
    52: "项目至少有一项固有风险、特别风险或舞弊风险没有与至少一项可能出错项关联",
    53: "缺少EST会计估计索引的估计账户。请从PSP索引列表中添加。",
    54: "识别具有估计的账户，并打开该账户以查看其是否具有与之相关的估计重大交易类别。一旦识别出缺少估计重大交易类别的账户，则需要为账户关联估计重大交易类别",
    55: "识别未与估计账户关联的估计重大交易类别。一旦识别出缺少估计账户的估计重大交易类别，则需要将估计重大交易类别与估计账户关联起来",
    56: "特别风险或舞弊风险必须至少有一个实质性程序、一项控制和一项控制测试任务（如适用）",
    57: "特别风险或舞弊风险必须至少有一个实质性程序、一项控制和一项控制测试任务（如适用）",
    58: "点击需要验证的风险，并展开认定。确认是否至少有一个任务选择了“是”",
    59: "点击需要验证的风险，并扩展认定。确认是否至少有一个控制选择了“是”。还需要完成控制的设计有效性",
    60: "点击验证链接“解决Canvas表格批注”。打开每个Canvas表格，并选择“显示未解决的批注”。必须清除或关闭所有批注",
    61: "点击验证链接“最终确定未完成的Canvas表格回复”。打开每个Canvas表格，并选择显示未完成的回复。需要完成所有Canvas表格问题",
    62: "点击验证链接，复核未处理批注，并清除或关闭所有未处理批注。",
    63: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    64: "点击验证链接，在筛选的任务列表中复核每个任务并将未处理任务标记完成",
    65: "点击“删除所有链接”按钮以删除所有共享证据的链接",
    66: "《表格440》中至少有一份未选择变更原因的文件 ",
    67: "《表格440》中至少有一份对变更选择了“非管理性”原因的文件未填写理由",
    68: "《表格440》中至少有一份对变更选择了“非管理性”原因的文件，尚未经过经理或更高级别人员批准",
    69: "项目合伙人或审计负责合伙人未签署《表格440》",
    70: "点击归档核对表上的“从分组中删除链接”按钮",
    71: "Canvas表格没有标题或标准内容",
    72: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    73: "点击Canvas表格中的验证检查图标，查看未完成回复的数量 ",
    74: "点击链接并提交项目简介.smt的更新版本",
    75: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    76: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    77: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    78: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    79: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    80: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    81: "识别IT流程，并与IT应用程序相关联",
    82: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    83: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    84: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    85: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    86: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    87: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    88: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    89: "尚未选择IT流程评估，或IT流程评估与IT一般控制/IT实质性测试程序运行有效性评估不一致",
    90: "控制未选择设计有效性",
    91: "查看重大交易类别以及与审计相关的IT应用程序",
    92: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    93: "使用“如何在EY Canvas中记录IT流”促进工具中的逐步指引来解决此验证问题",
    94: "使用“如何在EY Canvas中记录IT流”促进工具中的逐步指引来解决此验证问题",
    95: "项目未将特定项目组成员指定为管理团队的负责人",
    96: "风险因素未与风险关联或未标记为“非重大错报风险”",
    97: "风险未与认定关联",
    98: "请在“预测基础”处输入一项金额",
    99: "请为“预测基础”提供理由",
    100: "请在“调整基础”处输入一项金额",
    101: "未选择计划重要性水平百分比",
    102: "计划重要性水平百分比不在允许的范围内",
    103: "需要为所选计划重要性水平百分比提供理由",
    104: "未输入可容忍误差",
    105: "可容忍误差百分比不在允许的范围内",
    106: "需要为所选可容忍误差百分比提供理由",
    107: "未选择SAD百分比",
    108: "SAD百分比不在允许的范围内",
    109: "需要为所选SAD百分比提供理由",
    110: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    111: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    112: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    113: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    114: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    115: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    116: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    117: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    118: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    119: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    120: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    121: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    122: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    123: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    124: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    125: "若非必要，受保护的文档不得保留在项目文件中",
    126: "删除文档并重新上传",
    127: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    128: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    129: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    130: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    131: "进入估计列表表格，并使用“创建文档”选项",
    132: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    133: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    134: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    135: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    136: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    137: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    138: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    139: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    140: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    141: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    142: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    143: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    144: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    145: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    146: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    147: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    148: "使用“如何在EY Canvas中清除验证检查”促进工具中的逐步指引来解决此验证问题",
    149: " 点击验证链接“完成不完整的Canvas表格回复”。打开每个Canvas表格，验证与需求相关的所有必需文档是否具有相关PIC/EQR签字。只在您编制或复核的文档上签字",
    150: "点击验证链接“完成不完整的Canvas表格回复”。打开每个Canvas表格，验证与需求相关的所有必需文档是否具有相关PIC/EQR签字要求。",
    151: "请检查所有重大账户和披露是否至少有一项认定。",
    152: "打开每个Canvas表格，验证与需求相关的所有必需文档是否已由编制人和复核人签字。只在您编制或复核的文档上签字",
    153: "进入调整并使用“添加证据”选项关联适当的证据",
    154: "进入估计文档，并检查较高/较低风险估计是否与估计账户相关。非常低的风险估计应至少有一个相关账户。",
    155: "进入估计文档并检查是否存在相关账户。根据审计文档记录，取消非估计账户的关联，或将其修改为估计账户。",
    156: "进入估计文档并检查回复。",
    157: "进入估计文档，并检查较高/较低风险估计是否与估计重大交易类别相关。非常低的风险估计应至少有一个相关重大交易类别。",
    158: "进入账户文档，检查是否至少有一个较高或较低相关风险估计。",
    159: "进入账户文档，检查是否至少有一个较高或较低相关风险估计。",
    160: "进入估计引导表，识别没有任何相关估计的估计重大交易类别。根据审计文档记录，将这些重大交易类别修改为非估计或将估计与这些重大交易类别关联起来",
    161: "进入调整，检查借方分录的总和是否等于贷方分录的总和。",
    162: "导航至估计文档和c，检查是否至少存在一个相关的特别风险或舞弊风险。",
    163: "使用“如何在EY Canvas中清除验证检查“中的分步指南解决此验证",
    164: "使用“如何在EY Canvas中清除验证检查“中的分步指南解决此验证",
    165: "使用“如何在EY Canvas中清除验证检查“中的分步指南解决此验证",
    166: "进入估计文档并检查是否存在相关风险。根据审计文档记录，取消特别风险/舞弊风险关联，或将估计类别更新为较高风险。"
};

export const validationChecksReportHeaderLabels = {
    validationType: "验证类型",
    validationDescription: "验证描述",
    itemName: "项目名称",
    auditPhase: "审计阶段",
    additionalInformation: "额外信息",
    localization: "本地化",
    itemType: "项目类型",
    location: labels.location,
    count: "数量",
    validationCount: "验证数",
    itemID: "项目ID",
    validationTypeID: "验证类型ID",
    category: "类别",
    auditPhaseID: "审计阶段ID",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "注解ID",
    assignToUserID: "分配至用户ID",
    assignedtoUser: labels.assignedTo,
    createUserID: "作者ID",
    createdBy: "作者",
    createdDate: "创建日期",
    dueDateLabel: "到期日",
    relatedEvidence: "相关证据",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "上次修改人",
    modifyUserID: "修改人的用户ID",
    lastModifiedOnLabel: "上次修改日期",
    priorityType: labels.priorityLabel,
    annotationParentID: "总注解ID",
    referenceNumber: "索引",
    relatedTasks: "相关任务",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "更改状态的人员的用户ID",
    statusChangedBy: "状态变更人",
    statusChangedDateLabel: "更改状态的人员",
    startDateLabel: "首次创建（世界标准时间）",
    clearedDateLabel: "上次清除（世界标准时间）",
    closedDateLabel: "上次关闭（世界标准时间）",
    documentTypeID: "状态更改日期",
    childAnnotationID: "文档类型ID"
};

export const taskDueDateCategoryIdLabels = {
    0: "过去的数周",
    1: "本周",
    2: "下周",
    3: "未来的数周"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "项目ID",
    taskID: "任务ID",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "任务前缀",
    taskNameSuffix: "任务后缀",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "任务分配类型ID",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "已分配未解决复核注释",
    reviewNoteAssignedCleared: "已分配已清除的复核注释",
    reviewNoteAuthoredOpen: "已编辑未完成复核注释",
    reviewNoteAuthoredCleared: "已编辑已清除的复核注释",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "任务状态ID",
    taskType: labels.taskType,
    taskTypeID: "任务类型ID",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "里程碑ID",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "相关对象",
    relatedEntityID: "相关对象ID",
    openAssignmentsOverdue: "未完成任务分配——已逾期",
    openAssignmentsThisWeek: "未完成任务分配——本周",
    openAssignmentsNextWeek: "未完成任务分配——下周",
    openAssignmentsTotal: "未完成任务分配——合计",
    inProgressAssignmentsOverdue: "进行中任务分配——已逾期",
    inProgressAssignmentsThisWeek: "进行中任务分配——本周",
    inProgressAssignmentsNextWeek: "进行中任务分配——下周",
    inProgressAssignmentsTotal: "进行中任务分配——合计"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "重大交易类别ID",
    scotName: "重大交易类别",
    strategyTypeName: "策略类型",
    wcgwID: "可能出错项ID",
    wcgwName: "可能出错项",
    controlID: "控制ID",
    controlName: "控制",
    operatingEvaluation: "运行评价",
    assertions: "认定",
    controlTypeName: "控制类型",
    testingFormatted: "测试选择",
    scotStrategy: "重大交易类别策略",
    itApplicationName: "相关IT应用程序/SO",
    controlFrequencyTypeName: "频率",
    scotTypeID: "重大交易类别类型ID",
    scotTypeName: "重大交易类别类型",
    itAppType: "IT/SO应用程序",
    lowerRiskControl: "较低风险控制"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "项目ID",
    trialBalanceID: "试算表ID",
    trialBalanceTypeID: "试算表类型ID",
    trialBalanceTypeName: "试算表类型名称",
    financialStatementID: "财务报表ID",
    financialStatementName: "财务报表名称",
    financialStatementTypeID: "财务报表类型ID",
    financialStatementTypeName: "财务报表类型名称",
    financialStatementSubTypeID: "财务报表子类型ID",
    financialStatementSubTypeName: "财务报表子类型名称",
    analysisPeriodBalance: "分析日期余额",
    comparativePeriodBalance: "比较日期余额",
    analysisComparativeBalanceChange: "分析比较余额变动",
    analysisComparativeBalanceChangePercent: "分析比较余额变动百分比",
    secondComparativePeriodBalance: "第二比较日期余额",
    analysisSecondComparativeBalanceChange: "分析第二比较期间余额变动",
    analysisSecondComparativeBalanceChangePercent: "分析第二比较期间余额变动百分比",
    parentFinancialStatementID: "母公司财务报表ID",
    displayOrder: "显示顺序",
    eyCanvasAccountName: "EY Canvas账户名称",
    relatedEntities: "相关实体"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "正常"
    },
    {
        value: 3,
        label: "高"
    },
    {
        value: 4,
        label: "关键"
    }
];

export const StatementType = [{
    id: 1,
    value: "利润表"
}, {
    id: 2,
    value: "资产负债表"
}, {
    id: 3,
    value: "两者"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "特别风险"
    },
    {
        id: 2,
        accountTypeName: "有限风险"
    },
    {
        id: 3,
        accountTypeName: "非特别风险"
    },
    {
        id: 4,
        accountTypeName: "其他"
    },
    {
        id: 5,
        accountTypeName: "重大披露"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "测试选择"
}, {
    id: 2,
    value: "相关IT应用程序/SO"
}, {
    id: 3,
    value: "相关重大交易类别"
}, {
    id: 4,
    value: "相关重大交易类别策略"
}, {
    id: 5,
    value: "相关重大交易类别类型"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "抽屉菜单视图下无法使用语音注释和录屏。请切换到全屏视图以使用这些功能。",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "关闭",
    cancel: "取消",
    repNoRecordMessage: "未找到结果",
    edit: "编辑",
    delete: "删除",
    actions: "操作",
    show: "显示",
    first: "首页",
    last: "最后一页",
    prev: "上一页",
    next: "下一页",

    [Entity.Account]: {
        manageEntity: "管理账户和披露",
        searchEntity: "搜索账户",
        createEntity: "新账户",
        entityName: "账户",
        entityNameCaps: "账户",
        entityNamePlural: "账户",
        placeholderText: "新建账户和披露，或编辑和删除下方现有账户和披露。",
        deleteConfirmLabel: "是否确认删除此账户？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.Estimate]: {
        manageEntity: "管理估计",
        searchEntity: "查找估计",
        createEntity: "新估计",
        entityName: "估计",
        entityNameCaps: "估计",
        entityNamePlural: "估计",
        placeholderText: "创建新估计或编辑并删除以下已有估计。",
        deleteConfirmLabel: "是否确认删除此估计？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.Risk]: {
        manageEntity: "管理风险",
        searchEntity: "查找风险",
        createEntity: "新风险",
        entityName: "风险",
        entityNameCaps: "风险",
        entityNamePlural: "风险",
        placeholderText: "创建新风险或编辑并删除以下已有风险。",
        deleteConfirmLabel: "是否确实要删除此风险？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.STEntity]: {
        manageEntity: "管理实体",
        searchEntity: "搜索实体",
        createEntity: "新实体",
        entityName: "实体",
        entityNameCaps: "实体",
        entityNamePlural: "实体",
        placeholderText: "创建新实体或编辑和删除下面的现有实体。",
        deleteEntity: "删除实体",
        deleteConfirmLabel: "是否确认删除此实体？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.Control]: {
        manageEntity: "管理控制",
        searchEntity: "搜索控制",
        createEntity: "新控制",
        entityName: "控制",
        entityNameCaps: "控制",
        entityNamePlural: "控制",
        placeholderText: "创建新控制或编辑和删除下面的现有控制。",
        deleteEntity: "删除控制",
        deleteConfirmLabel: "是否确认删除此控制？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.SCOT]: {
        manageEntity: "管理重大交易类别",
        searchEntity: "搜索重大交易类别",
        createEntity: "新重大交易类别",
        entityName: "重大交易类别",
        entityNameCaps: "重大交易类别",
        entityNamePlural: "重大交易类别",
        placeholderText: "创建新的重大交易类别或编辑和删除下面的现有重大交易类别。",
        deleteEntity: "删除重大交易类别",
        deleteConfirmLabel: "是否确认删除此重大交易类别？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.ITApplication]: {
        manageEntity: "管理IT应用程序",
        searchEntity: "搜索",
        createEntity: "新IT应用程序",
        entityName: "IT应用程序",
        entityNameCaps: "IT应用程序",
        entityNamePlural: "IT应用程序",
        placeholderText: "创建新的IT应用程序或编辑和删除下面的现有IT应用程序。",
        deleteEntity: "删除IT应用程序",
        deleteConfirmLabel: "是否确定删除此IT应用程序? 所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.TaskSection]: {
        manageEntity: "管理任务组",
        searchEntity: "搜索任务组",
        createEntity: "新建任务组",
        entityName: "任务组",
        entityNameCaps: "任务组",
        entityNamePlural: "任务组",
        placeholderText: "创建新任务组或编辑并删除下面的现有任务组。",
        deleteEntity: "删除任务组",
        deleteConfirmLabel: "是否确实要删除所选调整？此操作无法撤消。"
    },
    [Entity.WCGW]: {
        manageEntity: "管理可能出错项",
        searchEntity: "搜索可能出错项",
        createEntity: "新可能出错项",
        entityName: "可能出错项",
        entityNameCaps: "可能出错项",
        entityNamePlural: "可能出错项",
        placeholderText: "创建新可能出错项或编辑并删除以下已有可能出错项。",
        deleteEntity: "删除可能出错项",
        deleteConfirmLabel: "是否确认删除此可能出错项？所有现有关联都将取消。此操作无法撤销。"
    },
    [Entity.Misstatement]: {
        manageEntity: "管理调整",
        searchEntity: "搜索调整",
        createEntity: "新调整",
        entityName: "调整",
        entityNameCaps: "调整",
        entityNamePlural: "调整",
        placeholderText: "创建新调整或编辑并删除下方的现有调整。",
        deleteConfirmLabel: "是否确实要删除所选调整？此操作无法撤消。"
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "管理具有验证检查的调整",
        searchEntity: "搜索",
        entityName: "调整",
        entityNameCaps: "调整",
        entityNamePlural: "调整",
        placeholderText: "每项调整必须至少有一个关联证据，并且对于每项调整，借方分录总和应等于贷方分录总和。以下调整存在一个或多个验证问题。点击<b>“编辑”</b>以解决这些问题。",
        deleteConfirmLabel: "是否确实要删除所选调整？此操作无法撤消。",
        adjustmentHeader: "调整",
        validationTyeHeader: "验证类型",
        validationTypeAmtMissmatch: "借方分录总和与贷方分录不相等",
        validationTypeNoEvidence: "无关联证据"
    },
    [Entity.SampleItem]: {
        manageEntity: "管理样本标签",
        searchEntity: "搜索标签",
        createEntity: "新建标签",
        createManageTagEntity: "管理标签组",
        entityName: "标签",
        entityNamePlural: "标签",
        entityNameForTagGroupPlural: "标签组",
        placeholderText: "创建新标记或编辑并删除以下已有标记。"
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "管理样本标签组",
        searchEntity: "搜索",
        createEntity: "新建标签组",
        entityName: "标签组",
        entityNameCaps: "标签组",
        entityNamePlural: "标签组",
        placeholderText: "创建新的样本标记组或编辑并删除下面的现有样本标记组。",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "在此项目中"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "其他项目中的程序[仅适用于主审小组]",
        value: "在其他项目中[仅适用于主审小组]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "在此项目和其他项目中的程序[仅适用于主审小组]",
        value: "在此项目和其他项目中[仅适用于主审小组]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "重大账户"
    },
    {
        id: 2,
        accounttypename: "有限风险账户"
    },
    {
        id: 3,
        accounttypename: "不重大账户"
    },
    {
        id: 4,
        accounttypename: "其他账户"
    },
    {
        id: 5,
        accounttypename: "重大披露"
    }
];

export const statementTypes = [{
        id: 1,
        name: "利润表"
    },
    {
        id: 2,
        name: "资产负债表"
    },
    {
        id: 3,
        name: "两者"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "在下方输入账户详情，然后点击“<b>{0}</b>”完成。如想另外创建账户，请点击“<b>{1}</b>”。",
    editModalDescription: "在下方编辑账户详情，然后点击“<b>{0}</b>”。",
    close: "关闭",
    cancel: "取消",
    yes: "是",
    no: "否",
    createAccount: "新账户",
    editAccount: "编辑账户",
    delete: "删除",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并另外创建账户",
    accountNameLabel: "账户名称（必填）",
    accountDesignationLabel: "指定",
    accountExecutionTypeLabel: "将在哪个Canvas项目中执行并记录针对该账户的程序？",
    accountEstimateLabel: "此账户是否受估计影响？",
    accountStatementTypeLabel: "报表类型",
    pspIndexDropdownLabel: "主要实质性程序索引（必填，最多可填5个）",
    removePSPIndexLabel: "删除主要实质性程序索引",
    assertionsLabel: "选择相关认定",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "确认",
    pspIndexErrorMsg: "必填",
    assertionWarningMessage: "您不能修改具有相关特别风险、或舞弊风险或重大错报风险或相关估计的认定。您需要先删除这些关联。",
    confirmChanges: "确认更改",
    executionTypeWarningMessage: "您要保存到此账户的更改将影响现有的认定和主要实质性程序，链接将断开。是否确认继续？此操作无法撤消。",
    contentUpdateToastMessage: " {0} 可以进行内容更新。请从“内容更新”页面启动内容更新。",
    assertionsRequired: "应至少选择一个认定",
    pspIndexDisabledLabel: "最多只能选择五个主要实质性程序索引。请取消选择一个或多个选项以继续。",
    newSignificantDisclosure: "新重大披露",
    noOptionsMessage: "未找到结果",
    accountNameErrorMsg: "必填"
};

export const CreateMestLabels = {
    createModalTitle: "新实体",
    createModalDescription: "在下方输入实体，然后选择“<b>{0}</b>”完成。如想另外创建实体，点击“<b>{1}</b>”。  实体是我们计划执行审计的对象，可能不是法律实体，而是业务单元或其他组合。",
    close: "关闭",
    cancel: "取消",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    entityNameLabel: "实体名称",
    entityStandardIndexLabel: "实体所用准则索引",
    entityDescriptionLabel: "实体描述（可选填）",
    entityNameErrorMsg: "必填",
    entityStandardIndexErrorMsg: "必填"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "新重大交易类别",
    editModalTitle: "编辑重大交易类别",
    createModalDescription: "在下方输入新的重大交易类别详情，然后点击“<b>{0}</b>”完成。如想另外创建重大交易类别，点击“<b>{1}</b>”。",
    editModalDescription: "编辑下方重大交易类别详情，然后点击“<b>{0}</b>”完成。",
    close: "关闭",
    cancel: "取消",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    scotNameLabel: "重大交易类别名称（必填）",
    scotStrategyLabel: "重大交易类别策略",
    scotTypeLabel: "重大交易类别类型",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "该重大交易类别是否受到估计的影响？",
    itAPPUsedLabel: "未使用IT应用程序",
    routine: "常规",
    nonRoutine: "非常规",
    controls: "控制",
    substantive: "实质性",
    yes: "是",
    scotNameErrorMsg: "必填",
    remove: "删除",
    noOptionsMessage: "未找到结果",
    wtDetailPrefix: "<p>对于所有常规和非常规重大交易类别以及重大披露流程，我们在每个期间通过执行穿行测试程序确认我们的了解。此外，对于PCAOB审计，我们对估计重大交易类别执行穿行测试程序。<br/>对于采取控制依赖策略的所有重大交易类别，以及应对特别风险的控制，我们确认已适当设计并实施了相关控制。我们确认，我们采取控制依赖策略的决定仍然适当。<br/><br/>我们得出结论认为，我们的文档记录准确描述了重大交易类别的运行，并且我们已经识别了所有适当的可能出错项，包括因使用IT产生的风险和相关控制（如适用）。<br/><br/>对于使用唯实质性策略的估计重大交易类别，我们根据实质性程序确定我们对估计重大交易类别的了解是否适当。</p>",
    disabledTabTooltipMessage: "取消选择“未使用IT应用程序”以关联IT应用程序",
    itAppLabels: {
        tabLabel: "IT应用程序",
        dropdownLabel: "关联IT应用程序",
        noRelatedItems: "无已关联IT应用程序",
        itApplications: "IT应用程序"
    },
    soLabels: {
        tabLabel: "服务机构",
        dropdownLabel: "关联服务机构",
        noRelatedItems: "无已关联服务机构",
        serviceOrganizations: "服务机构"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "可能出错项名称（必填）",
    editWCGW: "编辑可能出错项",
    editTheWCGW: "编辑下方可能出错项详情，然后点击“<b>{0}</b>”完成。",
    createNewWCGW: "在下方输入新的可能出错项详情，然后点击“<b>{0}</b>”完成。如想另外创建可能出错项，点击“<b>{1}</b>”。",
    createEditWCGWModelScot: "重大交易类别",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "保存",
    editWCGWClose: "取消",
    closeTitle: "关闭",
    wcgwNameIsRequired: "必填",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "每日多次"
    },
    {
        value: 2,
        label: "每日"
    },
    {
        value: 3,
        label: "每周"
    },
    {
        value: 4,
        label: "每月"
    },
    {
        value: 5,
        label: "每季度"
    },
    {
        value: 6,
        label: "每年"
    },
    {
        value: 8,
        label: "其他"
    }
];

export const controlTypes = [{
        value: 1,
        label: "IT应用程序控制"
    },
    {
        value: 2,
        label: "依赖IT的手动控制"
    },
    {
        value: 3,
        label: "手动预防"
    },
    {
        value: 4,
        label: "手动发现"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "新建控制",
    editModalTitle: "编辑控制",
    close: "关闭",
    cancel: "取消",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    controlNameLabel: "控制名称（必填）",
    frequency: "频率",
    controlType: "控制类型",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "设计有效性",
    operatingEffectiveness: "运行有效性",
    testingLabel: "测试",
    lowerRiskLabel: "控制为低风险？",
    ITDMControlSubstantiveTestingOptionLabel: "本ITDM控制的自动化部分只是使用经过实质性测试的系统生成报告",
    effective: "有效",
    ineffective: "无效",
    yes: "是",
    no: "否",
    required: "必填",
    remove: "删除",
    noOptionsMessage: "未找到结果",
    disabledTabTooltipMessage: "将“控制类型”选为“IT应用程序控制”或“依赖IT的手动控制”以关联IT应用程序",
    itAppLabels: {
        tabLabel: "IT应用程序",
        dropdownLabel: "关联IT应用程序",
        noRelatedItems: "无已关联IT应用程序",
        itApplications: "IT应用程序"
    },
    soLabels: {
        tabLabel: "服务机构",
        dropdownLabel: "关联服务机构",
        noRelatedItems: "无已关联服务机构",
        serviceOrganizations: "服务机构"
    },
    controlNameErrorMsg: "必填",
    createModalDescriptionLabel: "在下方输入新的控制详情，然后点击“<b>{0}</b>”完成。如想另外创建控制，点击“<b>{1}</b>”。",
    editModalDescriptionLabel: "编辑下方控制详情，然后点击“<b>{0}</b>”完成。",
    wcgwLabel: "可能出错项"
};

export const CreateEditITApplicationLabels = {
    close: "关闭",
    cancel: "取消",
    yes: "是",
    no: "否",
    delete: "删除",
    save: "保存",
    closeTitle: "关闭",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    iTApplicationNameLabel: "IT应用程序名称（必填）",
    iTSOApplicationNameLabel: "服务机构名称",
    newITApplicationLabel: "新建IT应用程序",
    newITSOApplicationLabel: "新服务机构",
    editITApplicationLabel: "编辑IT应用程序",
    confirm: "确认",
    confirmChanges: "确认更改",
    noOptionsMessage: "未找到结果",
    iTAppNameErrorMsg: "必填",
    iTSOAppNameErrorMsg: "必填",
    controls: "控制",
    substantive: "实质性",
    remove: "删除",
    iTApplicationStrategyLabel: "IT应用程序策略",
    SCOTsLabel: "重大交易类别名称",
    StrategyLabel: "策略",
    ControlsLabel: "控制名称",
    ControlTypeLabel: "类型",
    addDescriptionLabel: "在下方输入新IT应用程序详情，然后点击“<b>{0}</b>”完成。如想另外创建IT应用程序，点击“<b>{1}</b>”。",

    editDescriptionLabel: "编辑下方IT应用程序详情，然后点击“<b>{0}</b>”完成。",

    addSODescriptionLabel: "在下方输入新的服务机构详情，然后点击“保存并关闭”结束。如想另外创建服务机构，请选择“<b>保存并添加其他</b>”。",

    scotErrorMessage: "重大交易类别并非和IT应用程序无关联，因为存在相关联的控制",
    SCOTsLabels: {
        tabLabel: "重大交易类别",
        dropdownLabel: "关联重大交易类别",
        noRelatedItems: "无已关联重大交易类别"
    },
    ControlsLabels: {
        tabLabel: "控制",
        dropdownLabel: "关联控制",
        noRelatedItems: "未关联控制"
    },
    strategyType: {
        1: "控制",
        2: "实质性",
        3: "依赖",
        4: "不依赖"
    },
    controlType: {
        1: "IT应用程序",
        2: "依赖IT的手动控制",
        3: "手动预防",
        4: "手动发现"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "项目ID",
    gaScopeName: "范围",
    gaComponentId: "GA组成部分ID",
    shortName: "组成部分名称",
    pocText: "联系人",
    accountId: "账户ID",
    accountName: "账户名称",
    accountType: "账户指定",
    knowledgeAssertion: "认定",
    inherentRiskType: "固有风险",
    riskId: "风险ID",
    riskType: "风险类型",
    riskName: "风险名称",
    isHigherRiskText: "为较高风险"
};

export const AccountTypeIDs = {
    1: "重大账户",
    2: "有限风险账户",
    3: "不重大账户",
    4: "账户—其他",
    5: "重大披露"
};

export const InherentRiskTypeIDs = {
    1: "较高",
    2: "较低",
    3: "非常低"
};

export const riskTypeIDs = {
    1: "特别风险",
    2: "舞弊风险",
    3: "重大错报风险"
};

export const riskTypeIDsShortForm = {
    1: "特别风险",
    2: "舞弊风险",
    3: "重大错报风险"
};

export const ControlRiskTypeIDs = {
    1: "依赖",
    2: "不依赖",
    3: "测试管理程序"
};

export const knowledgeAssertions = {
    1: "完整性",
    2: "存在",
    3: "计价",
    4: "权利和义务",
    5: "列报和披露",
    6: "完整性",
    7: "发生",
    8: "计量",
    9: "列报和披露",
    10: "完整性",
    11: "存在性/发生",
    12: "计量/计价",
    13: "权利和义务",
    14: "列报和披露"
};

export const gaInstructionStatuslabels = {
    0: "未定义",
    [instructionStatus.notSent]: "未发送",
    [instructionStatus.pending]: "待处理",
    [instructionStatus.accepted]: "已接受",
    [instructionStatus.rejected]: "已退回",
    [instructionStatus.systemError]: "系统错误",
    [instructionStatus.expired]: "已到期",
    [instructionStatus.sent]: "已发送",
    [instructionStatus.unlinked]: "未关联",
    [instructionStatus.queued]: "已排队"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "资产",
    [financialStatementType.CurrentAsset]: "流动资产",
    [financialStatementType.NonCurrentAsset]: "非流动资产",
    [financialStatementType.Liability]: "负债",
    [financialStatementType.CurrentLiability]: "流动负债",
    [financialStatementType.NonCurrentLiability]: "非流动负债",
    [financialStatementType.Equity]: "权益",
    [financialStatementType.Revenue]: "收入",
    [financialStatementType.Expense]: "费用",
    [financialStatementType.NonOperatingIncome]: "营业外收入/（费用）",
    [financialStatementType.OtherComprehensiveIncome]: "其他综合收益",
    [financialStatementType.Other]: "其他",
    [financialStatementType.AccountType]: "账户类型",
    [financialStatementType.AccountSubType]: "账户子类型",
    [financialStatementType.AccountClass]: "账户类别",
    [financialStatementType.AccountSubClass]: "账户子类别",
    [financialStatementType.NetIncomeExpense]: "净（利润）/亏损",
    18: "总账账户"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "计划"
};

export const createEditRiskModalLabels = {
    createModalDescription: "在下方输入新的风险详请，然后选择“<b>{0}</b>”完成。如想另外创建风险，请选择“<b>{1}</b>”。",
    editModalDescription: "请编辑下面的风险详细信息，然后点击<b> {0} </b>完成。",
    close: "关闭",
    cancel: "取消",
    createRisk: "新建风险",
    editRisk: "编辑风险",
    riskType: "风险类型（必填）",

    riskTypeOptions: [{
            value: 1,
            label: "特别风险"
        },
        {
            value: 2,
            label: "舞弊风险"
        },
        {
            value: 3,
            label: "重大错报风险"
        }
    ],
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    riskNameLabel: "风险名称（必填）",
    relatedAccountsAssertionsLabel: "关联账户及认定（可选）",
    relateAccounts: "关联账户和认定（可选）",
    assertionsLabel: "选择相关认定",
    riskNameErrorMsg: "必填",
    riskTypeErrorMsg: "必填",
    assertionOptions: assertions,
    removeAccountLabel: "删除账户",
    required: "必填",
    assertionsRequired: "应至少选择一个认定"
};

export const activityTypeLabels = {
    104: "已添加",
    105: "已删除"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "识别账户和披露",
    identifySCOTs: "识别重大交易类别并与账户关联",
    determineSCOTStrategy: "确定重大交易类别策略",
    identifyWCGWAndControls: "识别可能出错项和控制",
    selectControlToTest: "选择要测试的控制",
    identifyRisks: "识别风险",
    relateWCGWsToAssertions: "将可能出错项与认定关联",
    relateRisksToWCGWs: "将风险与可能出错项关联",
    determineCRA: "确定综合风险评估",
    timephase: "时间阶段",
    SCOTWT: "创建穿行测试",
    controlTOC: "创建控制测试",
    ITProcessUDP: "创建UDP",
    ITGC_ITSP_TOC_OSP: "创建IT控制测试/其他实质性程序",
    accountPSP: "创建主要实质性程序",
    accountOSP: "创建其他实质性程序",
    relateWCGWTo: "将可能出错项关联至",
    relatedWCGWToTask: "将可能出错项与任务关联",
    respondToSignificant_fraudRisks: "应对特别/舞弊风险",
    OST: "其他实质性测试",
    accountSummary: "账户汇总",
    SCOTSummary: "重大交易类别汇总",
    ITSummary: "IT汇总",
    understandITProcesses: "了解IT流程",
    evaluateIT: "评估IT",
    CRASummary: "综合风险评估汇总",
    auditPlan: "审计计划",
    workplanSummary: "工作计划汇总",
    buildSteps: "创建步骤",
    ITApplicationsAndITProcesses: "IT应用程序和IT流程",
    workPlan: "工作计划",
    accounts: " 账户",
    scots: " 重大交易类别",
    cra: "综合风险评估",
    openInNewTab: "在新标签页打开"
}

export const auditPlanITProcessLabels = {
    itProcess: "IT流程",
    itProcesses: "IT流程",
    tasks: "任务",
    sectionHeading: "IT流程及已关联了解流程（UDP）任务",
    subHeader: "了解IT流程",
	visualDistinctMessage: "每个IT流程必须至少有一个关联的UDP。请创建 {0} 或 {1} 。",
    addUdp: "新建UDP",
    relatedUdp: "关联UDP",
    toggleFilter: "仅显示无任何相关UDP的IT流程",
    noResultsFound: "未找到结果",
	taskTitle: "了解并记录IT流程： {0}",
    taskDescription: "记录我们对IT流程的了解。附上相关表格作为证据支持我们对IT流程的了解。当IT一般控制出现在“任务属性”部分时，执行穿行测试程序以确认我们对IT一般控制的了解并评估其设计和实施。附上所执行程序的证据。",
    noRecordsAvailable: "没有可用的IT流程",
    unrelatedLabel: "查看未关联的UDP",
    unrelatedModalHeader: "未关联的UDP任务",
    noUnrelatedTaskPlaceholder: "没有未关联的UDP任务可用",
    noTaskselectedLabel: "必须至少选择一个任务进行删除",
    relateITProcessTaskTitle: "将UDP与IT流程相关联",
    understandITProcesses: "了解IT流程",
    unrelatedTasksMustBeAssociated: "未关联任务必须与IT流程关联或删除。"
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "非重要：余额/活动不符合测试范围 - 放弃进一步调查    ",
    strikethroughMText: "m",
    waivedReason: "放弃：金额低于SAD - 放弃进一步调查    ",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "重大交易类别",
    scots: " 重大交易类别",
    tasks: "任务",
    sectionHeading: "重大交易类别及已关联穿行测试任务",
    subHeader: "穿行测试任务",
	visualDistinctMessage: "每个重大交易类别必须至少有一个关联的穿行测试。请创建 {0} 或 {1} 。",
    newWT: "新建穿行测试",
    relatedWT: "关联穿行测试",
    toggleFilter: "仅显示无任何相关穿行测试的重大交易类别",
    noResultsFound: "未找到结果",
    noRecordsAvailable: "无可用重大交易类别",
    relateScotTaskTitle: "将穿行测试与重大交易类别相关联",
    taskTitle: "穿行测试：{0}",
    taskDescription: "<p>对于所有常规和非常规重大交易类别以及重大披露流程，我们在每个期间通过执行穿行测试程序确认我们的了解。此外，对于PCAOB审计，我们对估计重大交易类别执行穿行测试程序。<br/>对于采取控制依赖策略的所有重大交易类别，以及应对特别风险的控制，我们确认已适当设计并实施了相关控制。我们确认，我们采取控制依赖策略的决定仍然适当。<br/><br/>我们得出结论认为，我们的文档记录准确描述了重大交易类别的运行，并且我们已经识别了所有适当的可能出错项，包括因使用IT产生的风险和相关控制（如适用）。<br/><br/>对于使用唯实质性策略的估计重大交易类别，我们根据实质性程序确定我们对估计重大交易类别的了解是否适当。</p>",
    unrelatedLabel: "查看不相关的穿行测试",
    unrelatedModalHeader: "不相关的穿行测试任务",
    noUnrelatedTaskPlaceholder: "无可用的不相关穿行测试任务",
    noTaskselectedLabel: "必须至少选择一个任务进行删除。",
    manageScots: "管理重大交易类别",
    unrelatedTasksMustBeAssociated: "未关联任务必须与重大交易类别关联或删除。"
}

export const auditPlanControlsLabels = {
    control: "控制",
    controls: "选择用于测试的控制",
    tasks: "任务",
    sectionHeading: "控制和已关联控制测试",
    subHeader: "控制测试任务",
	visualDistinctMessage: "每个控制必须至少有一个关联的控制测试。请创建 {0} 或 {1} 。",
    addToc: "新建控制测试",
    relatedToc: "关联控制测试",
    toggleFilter: "仅显示无任何相关控制测试的控制",
    noResultsFound: "未找到结果",
    noRecordsAvailable: "未选择用于测试的控制",
    unrelatedLabel: "查看未关联的控制测试",
    unrelatedModalHeader: "不相关的控制测试任务",
    noUnrelatedTaskPlaceholder: "没有可用的未关联控制测试",
    noTaskselectedLabel: "必须至少选择一个任务进行删除。",
    relateControlTaskTitle: "将控制测试与控制关联",
    manageControl: "管理控制",
    taskTitleTOC: "控制测试：{0}",
    taskDescriptionTOC: "设计我们的控制测试的性质、时间和范围，以获得充分、适当的审计证据，证明控制在整个依赖期内按照设计有效运行，以预防或发现和更正认定层面的重大错报。<br/>通过评估我们的控制测试结果（包括我们扩大样本量和执行补偿性控制测试的情况），得出控制运行有效性的结论。",
    manageControls: "管理控制",
    unrelatedTasksMustBeAssociated: "未关联任务必须与控制关联或删除。"
}

export const industrySelectionGroupLabels = {
    1: "已选行业",
    2: "其他行业"
}

export const knowledgeDataLabels = {
    industry: "行业",
    showSelected: "仅显示选定项",
    noContent: "所选行业的知识库中没有可用的内容",
    importFromKnowledge: "从知识库导入",
    importAccounts: "导入账户",
    importAccountsAndDisclosures: "导入账户和披露",
    accountBuild1: "账户创建步骤1",
    import: "导入",
    close: "关闭",
    cancel: "取消",
    selected: "已选择",
    scotTitle: "重大交易类别构建1",
    importScots: "导入重大交易类别",
    noKnowledgeDataResult: "没有可供选择的内容",
    showOnlySelectedLabel: "仅显示选定项",
    scot: "重大交易类别",
    scotDropdownLabel: "选定行业的重大交易类别",
    importWcgw: "导入可能出错项",
    importFailedLabel: "导入失败。请尝试重新导入。",
    wtDetailPrefix: "<p>对于所有常规和非常规重大交易类别以及重大披露流程，我们在每个期间通过执行穿行测试程序确认我们的了解。此外，对于PCAOB审计，我们对估计重大交易类别执行穿行测试程序。<br/>对于采取控制依赖策略的所有重大交易类别，以及应对特别风险的控制，我们确认已适当设计并实施了相关控制。我们确认，我们采取控制依赖策略的决定仍然适当。<br/><br/>我们得出结论认为，我们的文档记录准确描述了重大交易类别的运行，并且我们已经识别了所有适当的可能出错项，包括因使用IT产生的风险和相关控制（如适用）。<br/><br/>对于使用唯实质性策略的估计重大交易类别，我们根据实质性程序确定我们对估计重大交易类别的了解是否适当。</p>",
    importOSP: "导入其他实质性程序",
    auditPlanBuild7: "审计计划构建7",
    account: "账户",
    accountName: "主要实质性程序索引",
    wcgwName: "可能出错项",
    selectScot: "选择重大交易类别",
    wcgwTitle: "重大交易类别构建3",
    noResultFound: "未找到结果",
    importValidationMessage: "必须选择",
    searchIconHoverLabel: "搜索",
    scotsHeader: "重大交易类别",
    controlsHeader: "控制",
    ospsHeader: "其他实质性程序",
    wcgw: "可能出错项",
    importControls: "导入控制",
    accountAssertionsValidationMessage: "无任务认定",
    accountsAndDisclosures: "账户和披露",
}

export const auditPlanITControlsLabels = {
    itcontrol: "IT控制",
    itcontrols: "选择用于测试的IT控制",
    tasks: "任务",
    type: "类型",
    sectionHeading: "IT一般控制的IT实质性程序以及关联的控制测试和实质性任务",
    subHeader: "控制测试/其他实质性程序任务",
	visualTOCDistinctMessage: "每个IT一般控制必须至少有一个关联的控制测试。请创建 {0} 或 {2} 。",
	visualOSPDistinctMessage: "每个IT实质性程序必须至少有一个关联的实质性程序。请创建 {1} 或 {3} 。",
    addTOC: "新控制测试",
    addOSP: "新建其他实质性程序",
    relatedTOCOSP: "关联控制测试/其他实质性程序",
    relatedTOC: "关联控制测试",
    relatedOSP: "关联其他实质性程序",
    toggleFilter: "仅显示无任何关联的控制测试/其他实质性程序的IT控制",
    noResultsFound: "未找到结果",
    noRecordsAvailable: "未选择用于测试的IT一般控制",
    taskTitleTOC: "控制测试：{0}",
    taskDescriptionTOC: "执行我们设计的IT一般控制测试，以获得充分、适当的审计证据，证明其在整个依赖期间的运行有效性。",
    taskTitleOSP: "其他实质性程序：{0}",
    taskDescriptionOSP: "自行确定关于IT实质性程序的性质、时间和范围设计的任务描述，以获得充分、适当的审计证据，证明IT风险在整个依赖期间得到有效应对。<br>当IT实质性程序在中期日执行时，设计和执行程序，以获得额外的证据证明我们对从中期程序所涵盖的期间到期末期间的IT风险进行了应对。<br>我们对IT实质性程序的结果得出结论。",
    relateITControlTaskTitle: "将控制测试/其他实质性程序与IT控制关联",
    relateITControlTOCTaskTitle: "将控制测试与IT一般控制关联",
    relateITControlOSPTaskTitle: "将其他实质性程序与IT实质性程序关联",
    unrelatedModalHeader: "不相关的控制测试/其他实质性程序任务",
    noUnrelatedTaskPlaceholder: "无可用的不相关控制测试/其他实质性程序任务",
    noTaskselectedLabel: "必须至少选择一个任务进行删除。",
    unrelatedLabel: "查看不相关的控制测试/其他实质性程序",
    understandITProcesses: "了解IT流程",
    unrelatedTasksMustBeAssociated: "未关联任务必须与IT控制关联或删除。"
}

export const generalLabelsForMobile = {
    noRecordsFound: "在此任务类别中未找到结果",
    taskListTitle: "我的任务",
    taskEvidenceTitle: "证据",
    cameraPagesTitle: "页",
    cameraTitle: "摄像头",
    taskDetailsTitle: "任务详细信息",
    invalidPage: "未找到页面",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "页码",
    ofLabel: "的",
    noTasksAvailable: "无可用的任务",
    searchLabel: "搜索...",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "任务详细信息",
    unassigned: "未分配",
    assignTo: "分配至",
    signOffLabel: "签署",
    evidenceNoteLabel: "证据注释",
    attributeLabel: "属性",
    addNoteLabel: "新注释",
    addCommentLabel: "添加批注",
    editCommentLabel: "更新批注",
    addReplyNoteLabel: "回复此注释",
    replyNoteLabel: "回复",
    replyEditNoteLabel: "编辑回复",
    enterReplyPlaceholder: "输入回复",
    editNoteLabel: "编辑",
    deleteNoteLabel: "删除",
    reopenNoteLabel: "重新打开",
    closeNoteLabel: "关闭",
    clearNoteLabel: "清除",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "上传照片",
    noEvidenceFound: "没有证据与任务关联",
    noRegionComponentFound: "未收到地区或组成部分项目小组的文档",
    noEvidenceMessage: "点击“上传照片”上传证据",
    noNotesFound: "未找到注释",
    noNotesStatement: "使用以下输入信息留下注释。将注释分配给用户，并注明优先等级和到期日。",
    regionComponentEvidence: "地区和组成部分的证据",
    documentWarning: "下载的文档将是只读的。完成后请处理该文件。",
    preparerTitle: "编制人签字",
    reviewerTitle: "复核人签字",
    teamLabel: "审计小组",
    saveEvidenceTitle: "保存证据",
    saveButton: "保存",
    cancelButton: "取消",
    confirmButtonLabel: "确认",
    previewButton: "预览",
    evidenceLable: "证据名称",
    mergingTitleLable: "图像合并为PDF。",
    showErrFileExistMsg: "文件名已存在。请重新命名。",
    showErrForNoImgExist: "没有可用于生成PDF的图像。",
    showErrBlankFileNameMsg: "文件名不能为空。",
    showIsCompletedMessage: "文件上传成功。",
    uploadingTitle: "处理中",
    showErrImgContext: "“使用图像”必须在“图像提供工具”中使用",
    PagePreviewTitle: "页",
    regionComponentEvidenceLabel: "地区和组成部分证据",
    downloadProcessLabel: "下载中……",
    downloadCompleteLabel: "下载完成",
    taskNotes: "任务注释",
    documentNotes: "文档注释",
    dueDateLabel: "到期日",
    view: "查看：",
    documentNotes: "文档注释",
    newNote: "添加注释",
    editNote: "编辑注释",
    assignedTo: "分配给",
    priority: "优先等级",
    select: "选择",
    dueDate: "到期日",
    addNewNote: "添加新注释",
    addNote: "添加注释",
    updateNote: "更新注释",
    enterDescription: "输入描述...",
    allnotes: "所有注释",
    mynotes: "我的注释",
    assignedToMe: "分配到我",
    hashValue: "#",
    showLessToggle: "显示较少",
    showMoreToggle: "显示更多",
    delete: "删除",
    deleteNoteModalTitle: "删除邮件",
    deleteReplyModalTitle: "删除回复",
    confirmDeleteNoteLabel: "是否确认删除所选注释？",
    confirmDeleteReplyLabel: "是否确认删除对此注释的回复？",
    downloadInfo: "不允许下载包含#字符的文件",
	evidenceFileValidationInfo: '文件名不能包含*/：<>\?| "字符',
    previewPageTitle: "预览",
    redirecting: "几秒钟后将重新前往登录页……",
    redirectingToTask: "几秒钟后将重新前往\'我的任务\'页面……",
    errorApplyingConstraints: "应用限制条件时出错：",
    zoomIsNotSupported: "此设备不支持缩放。",
    errorCheckingCameraCapability: "检查摄像头功能时出错：",
    previous: "上一页",
    next: "下一页",
    after: "之后",
    redirectingToTaskDetails: "几秒钟后重新进入任务详细信息",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "未完成"
    },
    {
        value: 2,
        label: "已清除"
    },
    {
        value: 3,
        label: "已关闭"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "范围和策略"
    },
    {
        value: 2,
        label: "执行"
    },
    {
        value: 3,
        label: "结论"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "新建任务组",
    editModalTitle: "编辑任务组",
    createModalDescription: "在下方输入任务组详细信息，然后选择'<b>{0}</b>'完成。若要创建另一个任务组，请选择 '<b>{1}</b>’。",
    editModalDescription: "编辑下方任务组详细信息，然后选择 '<b>{0}</b>’完成。",
    close: "关闭",
    cancel: "取消",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并另外创建账户",
    taskSectionNameLabel: "任务组名称（必填）",
    taskSectionNameErrorMsg: "必填",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "项目阶段（必填）",
    engagementPhaseErrorMsg: "必填",
};

export const auditPhaseLabels = {
    1: "范围和策略",
    2: "执行",
    3: "结论",
    4: "执行初步项目活动",
    5: "识别和评估风险",
    6: "应对风险",
    7: "总结和报告"
};

export const ITApproachType = {
    1: "IT一般控制",
    2: "IT实质性程序"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "新调整",
    editModalTitle: "编辑调整",
    createModalDescription: "在下方输入调整详细信息，然后选择“<b> {0} </b>”完成。若要创建另一个调整，请选择“<b> {1} </b>”。",
    editModalDescription: "在下方编辑调整详细信息，然后选择“<b> {0} </b>”完成。若要删除该调整，请单击“<b> {1} </b>”。",
    close: "关闭",
    cancel: "取消",
    save: "保存",
    saveAndCloseLabel: "保存并关闭",
    saveAndCreateLabel: "保存并新建",
    delete: "删除",
    adjustmentNameLabel: "调整指标（必填）",
    adjustmentDescriptionLabel: "调整描述（必填）",
    adjustmentDescriptionPlaceholder: "调整描述（必填）",
    required: "必填",
    editDescriptionModal: "编辑调整说明",
    descriptionRequired: "调整描述为必填",
    uploadDocumentPlaceholder: "调整必须保存后才能与证据关联。",
    generalLedgerAccount: "总账账户（必填）",
    documentHeader: "文件（必填）",
    addDocumentButton: "添加证据",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "调整指标",
    addglaccountbutton: "添加总账账户",
    descriptionMaxLengthError: "回复字数超过了允许的最大值。",
    glaccountTotalError: "借方分录的合计应等于贷方分录的合计",
    glaccountIdDuplicate: "每个总账账户只能在调整中使用一次",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "编辑调整说明",
    editAdjustmentDescriptionSubHead: "编辑下方调整描述详情，然后点击\'<b>保存</b>\'完成。"
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "添加总账账户",
    glaccountDescription: "在下方输入总账账户详情，然后点击'<b>{0}</b>'完成。如想另外添加总账账户，请点击'<b>{1}</b>'。",
    addAndClose: "添加并关闭",
    addAnother: "添加另一个",
    accountSubClassPlaceholder: "账户子类别",
    glAccountsPlaceholder: "选择账户子类别以查看可用的总账账户。",
    glAccountListHeaderColumn: "总账账户",
    amountLabel: "金额（必填）",
    debitCreditOptions: [{
            id: 1,
            label: "借方"
        },
        {
            id: 2,
            label: "贷方"
        }
    ],
    searchPlaceholder: "搜索",
    newGlAccount: "新调节账户",
    noResultsFound: "未找到结果",
    noRecordsPlaceholder: "未找到所选账户子类别的调节账户。选择其他子类别，或点击{0} 将调节账户添加到所选账户子类别。",
    editTitleTip: "编辑调节账户",
    removeTitleTip: "删除调节账户",
    custom: "自定义",
    duplicateGLAccount: "每个总账账户只能在调整中使用一次",
    updateModalTitle: "更新调节账户",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "更新",
    updateGlAccountModalTitle: "更新总账账户",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "删除调节账户",
    deleteConfirmationModalBodyHeader: "是否确定删除选定调节账户? 此操作无法撤销。",
    deleteConfirmationModalAccountSubClass: "账户子类别：",
    deleteConfirmationModalAccountName: "账户名称：",
    deleteConfirmationModalGLAccountName: "调节账户名称：",
    closeButtonTitle: "取消",
    confirmBtnTitle: "删除"
}

export const glAccountListLabel = {
    accountClass: "账户类别",
    accountSubClass: "账户子类别",
    glAccount: "总账账户",
    debit: "借方",
    credit: "贷方",
    actions: "操作",
    editTitleTip: "编辑总账账户",
    removeTitleTip: "删除总账账户"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "没有可用的映射。",
    takeContentUpdateMessage: "进行内容更新以获取最新映射。",
    noRecordsLabel: "未发现记录",
    auditTopic: "审计主题",
    auditTopicPlaceholder: "选择要查看的主题",
    numberSelected: "已选择 {0} 主题",
    refreshMapTitletip: "点击此处启动项目地图更新",
    mapUpdateInProgress: "正在更新。完成更新需要10分钟。",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "新调节账户",
    editModalTitle: "编辑调节账户",
    createModalDescription: "在下方输入调节账户详情，然后点击“<b>{0}</b>”完成。如想另外创建调节账户，请点击“<b>{1}</b>”。",
    editModalDescription: "编辑下方调节账户详情，然后点击“<b>{0}</b>”完成。",
    accountSubClass: "账户子类别",
    accountName: "账户名称（必填）",
    glAccountName: "调节账户名称（必填）",
    cancelbtn: "取消",
    saveAndAddbtn: "保存并另外添加",
    saveAndClosebtn: "保存并关闭",
    save: "保存",
    required: "必填",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "集团指引",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "集团风险评估",
    [receiveInstructionSwitcherIds.documents]: "文档"
};

export const misstatementEvidenceLabels = {
	placeholderText: "无相关联证据。必须至少关联一个支持性证据。若要关联证据，请单击 {0} 。",
    addEvidenceBtn: "添加证据",
};

export const misstatementTempLabels = {
    placeholderText: "无相关临时文档。若要关联临时文档，请点击{0}。",
    addEvidenceBtn: "添加临时文件",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "复杂性",
        displayOrder: 1
    },
    {
        id: 2,
        label: "主观性 不确定性",
        displayOrder: 2
    },
    {
        id: 3,
        label: "舞弊或错误",
        displayOrder: 3
    },
    {
        id: 4,
        label: "变化",
        displayOrder: 4
    },
    {
        id: 5,
        label: "账户性质",
        displayOrder: 5
    },
    {
        id: 6,
        label: "关联方",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "定义连接设置",
    subTitle: "选择分析工具连接的设置。",
    connectionNameLabel: "连接名称",
    connectionNamePlaceholder: "连接名称（必填）",
    connetionTypesLabel: "连接类型",
    connectionTypeScopeAndStrategy: "范围和策略",
    connectionTypeFinancionStatement: "财务报表",
    includeAllBusinessUnitsField: "是否要包含所有业务单元？",
    yes: "是",
    no: "否",
    businessUnitsLabel: "业务单元",
    businessUnitsPlaceholder: "业务单元",
    analysisPeriodLabel: "分析日期",
    analysisPeriodPlaceholder: "分析日期",
    comparativePeriod1Label: "比较日期1",
    comparativePeriod1Placeholder: "比较日期1（可选）",
    comparativePeriod2Label: "比较日期2",
    comparativePeriod2Placeholder: "比较日期2（可选）",
    currencyTypeField: "货币类型",
    reporting: "报告",
    functional: "记账",
    currencyCodeField: "货币代码",
    currencyCodePlaceholder: "货币代码（必填）",
    scopeAndStrategyLabel: "范围与策略",
    financialStatementLabel: "财务报表",

    required: "必填",
    comparativePeriodError: "无效日期。选择分析日期之前的日期。",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "日期{0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "已选择{0}",
    allBusinessUnitsLabel: "所有业务部门"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "实体",
        trialBalanceName: "试算表名称",
        reporting: "报告货币",
        functional: "记账本位币",
        analysisPeriod: "分析日期",
        comparativePeriod: "比较日期",
        secondComparativePeriod: "第二个比较日（可选）",
        includeFinancialStatements: "加入财务报表",
        carryForwardReferencesAndAdjustments: "是否将索引和调整沿用到新的导入？",
        import: buttonLabel,
        businessUnitSelectedCount: "{0}业务单元",
        businessUnitsSelectedCount: "{0}业务单元",
        allBusinessUnitsLabel: "所有业务单元",
        businessUnitsPlaceholder: "业务单元",
        required: "必填",
        comparativePeriodError: "无效日期。选择分析日期之前的日期。",
        secondComparativePeriodError: "第二个比较日应大于或等于比较日。",
        equalComparativePeriodError: "日期不能相同。",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    403: "您不是关联的分析工具的授权项目组成员。请联系EY Helix项目管理员获取访问权限。",
    405: "分析在链接的关联中不可用。请转到EY Helix并完成数据和分析处理步骤以继续。",
    406: "选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    408: "选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    411: "所选分析工具没有所有必需的参数。有关详细信息，请联系EY Helix管理员。",
    430: "所选分析工具没有所有必需的参数。有关详细信息，请联系EY Helix管理员。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    800: "您以前没有访问过EY Helix应用程序。请进入EY Helix，登录并按照说明设置您的帐户。",
    801: "您不是链接的项目的授权成员。请联系EY Helix项目管理员以获取访问权限。",
    901: "选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如果想永久删除关联，请在“更多”菜单中点击下面的“删除”。请考虑是否应关联另一个分析工具。",
    902: "选定关联的EY Helix项目已标记为删除。有关详细信息，请联系EY Helix管理员。如果想永久删除关联，请在“更多”菜单中点击下面的“删除”。请考虑是否应关联另一个分析工具。",
    903: "选定关联的EY Helix项目已标记为存储。有关详细信息，请联系EY Helix管理员。如果想永久删除关联，请在“更多”菜单中点击下面的“删除”。请考虑是否应关联另一个分析工具。",
    926: "所选分析工具在EY Helix中不可用。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    927: "分析在链接的项目中不可用。请转到EY Helix并完成数据和分析处理步骤以继续。",
    928: "EY Helix中的分析工具无效或缺失。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    929: "发生与链接的EY Helix项目相关的错误。无法导入数据。"
};

export const validationLabels = {
    viewAdjustmentWithValidations: "查看带有验证的调整{0}",
    validationTypeAmtMissmatch: "借方分录之和不等于贷方分录之和",
    validationTypeNoEvidence: "无关联证据"
};

export const canavsImportErrors = {
    400: "导入失败。选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    403: "导入失败。您不是关联的分析工具的授权项目组成员。请联系EY Helix项目管理员获取访问权限，然后刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    405: "导入失败。分析在链接的关联中不可用。请转到EY Helix并完成数据和分析处理步骤以继续。然后刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    406: "导入失败。所选关联的EY Helix分析工具不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    408: "导入失败。选定关联的EY Helix项目不再可用。有关详细信息，请联系EY Helix管理员。如想永久删除关联，请首先删除与该关联相关的所有导入。然后，点击更多菜单中的“断开分析工具的关联”。请考虑是否应关联其他分析工具。",
    411: "导入失败。所选分析工具没有所有必需的参数。有关详细信息，请与EY Helix管理员联系，然后刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    430: "导入失败。所选分析工具没有所有必需的参数。有关详细信息，请联系EY Helix管理员。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
    113082: "分析期间不能为空。"
};
